/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(39);
	module.exports = __webpack_require__(12);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(55);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 4 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.3.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2018-01-20T17:24Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			noModule: true
		};
	
		function DOMEval( code, doc, node ) {
			doc = doc || document;
	
			var i,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
					if ( node[ i ] ) {
						script[ i ] = node[ i ];
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.3.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			div.style.position = "absolute";
			scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
			) );
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
			val = curCSS( elem, dimension, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox;
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = valueIsBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ dimension ] );
	
		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		if ( val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {
	
			val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];
	
			// offsetWidth/offsetHeight provide border-box values
			valueIsBorderBox = true;
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
					isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra && boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					);
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && support.scrollboxSize() === styles.position ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = Date.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(38);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(10);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  GLOBAL: {
	    HIDE: '__react_tooltip_hide_event',
	    REBUILD: '__react_tooltip_rebuild_event',
	    SHOW: '__react_tooltip_show_event'
	  }
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _simpleReactModal = __webpack_require__(56);
	
	var _simpleReactModal2 = _interopRequireDefault(_simpleReactModal);
	
	__webpack_require__(15);
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactTooltip = __webpack_require__(49);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _video_diary = __webpack_require__(31);
	
	var _video_diary2 = _interopRequireDefault(_video_diary);
	
	var _aloe_vera = __webpack_require__(23);
	
	var _aloe_vera2 = _interopRequireDefault(_aloe_vera);
	
	var _jeff_introduction = __webpack_require__(27);
	
	var _jeff_introduction2 = _interopRequireDefault(_jeff_introduction);
	
	var _vlog_competition = __webpack_require__(32);
	
	var _vlog_competition2 = _interopRequireDefault(_vlog_competition);
	
	var _sports = __webpack_require__(29);
	
	var _sports2 = _interopRequireDefault(_sports);
	
	var _anxiety = __webpack_require__(24);
	
	var _anxiety2 = _interopRequireDefault(_anxiety);
	
	var _struggling = __webpack_require__(30);
	
	var _struggling2 = _interopRequireDefault(_struggling);
	
	var _yoga_vibe = __webpack_require__(33);
	
	var _yoga_vibe2 = _interopRequireDefault(_yoga_vibe);
	
	var _fit_traveler = __webpack_require__(26);
	
	var _fit_traveler2 = _interopRequireDefault(_fit_traveler);
	
	var _dog_adoption_audio = __webpack_require__(25);
	
	var _dog_adoption_audio2 = _interopRequireDefault(_dog_adoption_audio);
	
	var _shantanu_trimmed = __webpack_require__(28);
	
	var _shantanu_trimmed2 = _interopRequireDefault(_shantanu_trimmed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	//import economics from './economics.json'
	
	
	function HeaderPanel(props) {
	  return null;
	  var thiz = props.context;
	  return _react2.default.createElement(
	    'nav',
	    { className: 'navbar navbar-expand-lg navbar-dark bg-dark' },
	    _react2.default.createElement(
	      'button',
	      { className: 'navbar-toggler', type: 'button', 'data-toggle': 'collapse', 'data-target': '#navbarTogglerDemo03', 'aria-controls': 'navbarTogglerDemo03', 'aria-expanded': 'false', 'aria-label': 'Toggle navigation' },
	      _react2.default.createElement('span', { className: 'navbar-toggler-icon' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'navbar-brand', style: { cursor: 'pointer' } },
	      'B-creative',
	      thiz.state.doing_experiment && thiz.state.page === 4 ? _react2.default.createElement(
	        'button',
	        { onClick: thiz.goToNextExperimentPage(), className: 'btn btn-primary text-center', style: { marginLeft: '30px' } },
	        'Done and Next'
	      ) : null,
	      thiz.state.doing_experiment && thiz.state.page === 6 ? _react2.default.createElement(
	        'label',
	        { htmlFor: 'submit-form', tabIndex: '0', className: 'btn btn-primary text-center', style: { marginLeft: '30px' } },
	        'Done With Survey and Next'
	      ) : null,
	      thiz.state.doing_experiment && thiz.state.page === 7 ? _react2.default.createElement(
	        'label',
	        { htmlFor: 'submit-form', tabIndex: '0', className: 'btn btn-primary text-center', style: { marginLeft: '30px' } },
	        'Start First Task'
	      ) : null
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'collapse navbar-collapse', id: 'navbarTogglerDemo03' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'navbar-nav mr-auto mt-2 mt-lg-0' },
	        _react2.default.createElement('li', { className: 'nav-item' })
	      ),
	      _react2.default.createElement('div', { className: 'my-2 my-lg-0 navbar-dark navbar-nav nav-link' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'my-2 my-lg-0' },
	        _react2.default.createElement('img', { alt: '', src: './trash_white.png', width: '40', height: '40', draggable: 'true', onDragOver: thiz.preventDefault(), 'data-tip': "Drag B-roll to here to delete", onDrop: thiz.brollDelete() })
	      )
	    )
	  );
	}
	
	function FooterPanel(props) {
	  return null;
	  var thiz = props.context;
	  if (thiz.state.page == 4) {
	    return _react2.default.createElement(
	      'nav',
	      { className: 'navbar fixed-bottom navbar-expand-lg navbar-dark bg-dark' },
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-collapse center-block', id: 'navbarTogglerDemo03' },
	        _react2.default.createElement(
	          'div',
	          { className: 'navbar-nav mr-auto mt-2 mt-lg-0 text-light', style: { color: "rgba(255,255,255,.5)" } },
	          'B-creative'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'my-2 my-lg-0 btn btn-sm btn-warning helptext', onClick: thiz.toggleHelptext() },
	        thiz.state.show_helptext ? "Hide Instructions" : "Show Detailed Instructions"
	      )
	    );
	  } else {
	    return _react2.default.createElement(
	      'nav',
	      { className: 'navbar fixed-bottom navbar-expand-lg navbar-dark bg-dark' },
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-collapse center-block', id: 'navbarTogglerDemo03' },
	        _react2.default.createElement(
	          'div',
	          { className: 'navbar-nav mr-auto mt-2 mt-lg-0 text-light', style: { color: "rgba(255,255,255,.5)" } },
	          'B-creative'
	        )
	      )
	    );
	  }
	}
	
	function CollaborativeFilters(props) {
	  var thiz = props.context;
	  if (thiz.state.uitype === "i") {
	    return _react2.default.createElement(
	      'div',
	      { style: { paddingLeft: "0px", textAlign: "left" } },
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-outline-info btn-filter', onClick: thiz.changeRecommendationStyle("off") },
	        'Off'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-outline-info btn-filter', onClick: thiz.changeRecommendationStyle("audio") },
	        'Audio'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-outline-info btn-filter', onClick: thiz.changeRecommendationStyle("visual") },
	        'Visual'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-outline-info btn-filter', onClick: thiz.changeRecommendationStyle("text") },
	        'Text'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-outline-info btn-filter', onClick: thiz.changeRecommendationStyle("fast") },
	        'Fast'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-outline-info btn-filter', onClick: thiz.changeRecommendationStyle("magic") },
	        'Magic'
	      )
	    );
	  } else {
	    return null;
	  }
	}
	
	function shuffle(a) {
	  for (var i = a.length - 1; i > 0; i--) {
	    var j = Math.floor(Math.random() * (i + 1));
	    var _ref = [a[j], a[i]];
	    a[i] = _ref[0];
	    a[j] = _ref[1];
	  }
	  return a;
	}
	
	function uploadDataToServer(thiz) {
	  console.log("uploading data");
	  var d = new Date();
	  var n = d.getTime();
	  var ztate = thiz.state;
	  var version = n - thiz.state.sessionstarttime;
	  var participantid = thiz.state.participantid;
	  var broll_list = JSON.stringify(thiz.state.broll_list);
	  console.log(broll_list);
	  var queries = JSON.stringify({ queries: thiz.state.queries });
	  var usertype = ztate.usertype;
	  var uitype = ztate.uitype;
	  var videotype = ztate.videotype;
	  var apiURL = 'https://dapptalk.org/bcreate.php';
	  var formData = {
	    version: version,
	    participantid: participantid % 10000000,
	    sessionid: thiz.state.experiment_index,
	    broll_list: broll_list,
	    queries: queries,
	    usertype: usertype,
	    uitype: uitype,
	    videotype: videotype
	  };
	  fetch(apiURL, {
	    method: 'POST',
	    mode: 'no-cors',
	    headers: {
	      'Accept': 'application/json',
	      'Content-Type': 'application/json',
	      'Access-Control-Allow-Origin': '*'
	    },
	    body: JSON.stringify({
	      formData: formData
	    })
	  }).then(function (response) {
	    return response.text();
	  }).then(function (responseData) {
	    console.log("response: ");console.log(responseData);
	  }).catch(function (err) {
	    console.log(err);
	  });
	}
	
	function RecommendationQuestions(props) {
	  var thiz = props.context;
	  console.log(thiz.state.ui_order[thiz.state.experiment_index - 1]);
	  if (thiz.state.ui_order[thiz.state.experiment_index - 1] !== 'i') {
	    return null;
	  }
	  //we only ask this in condition intelligent
	  return _react2.default.createElement(
	    'span',
	    null,
	    thiz.state.recommendation_questions.map(function (question, idx) {
	      return _react2.default.createElement(Likert, { key: 'rec_' + idx, question: question, name: 'q' + (idx + thiz.state.twenty_questions.length + thiz.state.five_questions.length), labels: thiz.state.five_point_likert, context: thiz });
	    })
	  );
	}
	
	function Likert(props) {
	  var name = props.name;
	  var thiz = props.context;
	  var labels = props.labels;
	  if (name == 'q12' && thiz.state.experiment_index > 0) {
	    return null;
	  }
	  var question = props.question;
	  //console.log(name)
	  return _react2.default.createElement(
	    'fieldset',
	    { className: 'form-group' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row border-bottom' },
	      _react2.default.createElement(
	        'legend',
	        { className: 'col-form-label col-sm-2 pt-0' },
	        question
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-10' },
	        name === 'q4' ? _react2.default.createElement(
	          'span',
	          { style: { marginRight: '20px' } },
	          'Perfect'
	        ) : _react2.default.createElement(
	          'span',
	          { style: { marginRight: '20px' } },
	          labels[0]
	        ),
	        labels.map(function (lab, idx) {
	          return _react2.default.createElement(
	            'div',
	            { key: name + idx, className: 'custom-control custom-radio custom-control-inline big' },
	            _react2.default.createElement('input', { type: 'radio', id: name + idx, name: name, value: idx + 1, className: 'custom-control-input' }),
	            _react2.default.createElement(
	              'label',
	              { className: 'custom-control-label big', htmlFor: name + idx },
	              idx + 1
	            )
	          );
	        }),
	        name === 'q4' ? _react2.default.createElement(
	          'span',
	          null,
	          'Failure'
	        ) : _react2.default.createElement(
	          'span',
	          null,
	          labels[labels.length - 1]
	        )
	      )
	    )
	  );
	}
	
	function generateRandomizedExperiment(thiz, u) {
	  var _thiz$setState;
	
	  console.log('generateRandomizedExperiment');
	  var possible_videos = [6, 8, 9]; //[2,4,6,8,9]
	  var possible_uis = ['b', 'i', 't']; //this should be counterbalanced??
	  var possible_recommendation_types = ['random', 'experts'];
	  possible_recommendation_types = ['algorithm'];
	  shuffle(possible_videos);
	  shuffle(possible_uis);
	  shuffle(possible_recommendation_types);
	  var instructions_order = [['b', 'i', 't'].indexOf(possible_uis[0]), ['b', 'i', 't'].indexOf(possible_uis[1]), ['b', 'i', 't'].indexOf(possible_uis[2])];
	  var transcripts = [_video_diary2.default, _aloe_vera2.default, _jeff_introduction2.default, _vlog_competition2.default, _sports2.default, _anxiety2.default, _struggling2.default, _yoga_vibe2.default, _fit_traveler2.default, _shantanu_trimmed2.default];
	  var v = possible_videos[0]; //because we start with first element
	  var words = transcripts[v].words;
	  var videotype = thiz.state.videotypes[v];
	  console.log(instructions_order[0], "INSTRUCTIONS NUM", possible_uis, instructions_order);
	  thiz.setState((_thiz$setState = { usertype: u, uitype: possible_uis[0], videotype: videotype, v: v, words: words, page: 4, video_order: possible_videos, ui_order: possible_uis, recommendation_type: possible_recommendation_types[0], doing_experiment: true, experiment_index: 0, show_helptext: true, instructions_order: instructions_order }, _defineProperty(_thiz$setState, 'show_helptext', true), _defineProperty(_thiz$setState, 'helptext', thiz.state.helptexts[instructions_order[0]]), _thiz$setState));
	  return;
	}
	
	function getVideoIndex(thiz, u, c) {
	  if (u !== 'e' && u !== 'n') {
	    var vind = Math.floor(Math.random() * [2, 4, 6, 8, 9].length);
	    var v = [2, 4, 6, 8, 9][vind] + "";
	    var transcripts = [_video_diary2.default, _aloe_vera2.default, _jeff_introduction2.default, _vlog_competition2.default, _sports2.default, _anxiety2.default, _struggling2.default, _yoga_vibe2.default, _fit_traveler2.default, _shantanu_trimmed2.default];
	    var words = transcripts[v].words;
	    var videotype = thiz.state.videotypes[v];
	    console.log(videotype);
	    thiz.setState({ usertype: u, uitype: c, videotype: videotype, v: v, words: words, page: 4 });
	    return;
	  }
	  console.log('getVideoIndex');
	  thiz.setState({ page: 10 }); //means we are loading
	  var apiURL = 'https://cors.io/?https://dapptalk.org/counterdatabase.php?c=' + c + '&u=' + u;
	  fetch(apiURL, {
	    method: 'GET',
	    dataType: "json"
	  }).then(function (response) {
	    return response.json();
	  }).then(function (responseData) {
	    var vind = responseData.session_id;
	    var session_id = responseData.session_id;
	    //here we randomly assign: UI order,video order,recommendation type
	    var possible_videos = [6, 8, 9];
	    var possible_uis = ['t', 'b', 'i']; //this should be counterbalanced
	    var possible_recommendation_types = ['random', 'experts'];
	    possible_recommendation_types = ['algorithm'];
	    shuffle(possible_videos);
	    shuffle(possible_uis);
	    shuffle(possible_recommendation_types);
	    vind = vind % 5;
	    var v = [2, 4, 6, 8, 9][vind] + "";
	    var transcripts = [_video_diary2.default, _aloe_vera2.default, _jeff_introduction2.default, _vlog_competition2.default, _sports2.default, _anxiety2.default, _struggling2.default, _yoga_vibe2.default, _fit_traveler2.default, _shantanu_trimmed2.default];
	    var words = transcripts[v].words;
	    var videotype = thiz.state.videotypes[v];
	    console.log(videotype);
	    thiz.setState({ usertype: u, uitype: c, videotype: videotype, v: v, words: words, page: 4 });
	  }).catch(function (err) {
	    console.log(err);
	  });
	}
	
	function TranscriptViewVeryIntelligent(props) {
	  var thiz = props.context;
	  var table = [];
	  var words = props.context.state.words;
	  var N = words.length;
	  var counter_nonbreak = 0;
	  var show_recommendations = props.context.state.uitype === "i";
	
	  var broll_list = props.context.state.broll_list;
	  var num_added_broll = broll_list.length;
	
	  var current_recommendation_style = thiz.state.current_recommendation_style;
	  var videoname = thiz.state.videotype;
	  var concepts = thiz.state.concepts_magic[videoname];
	
	  if (thiz.state.recommendation_type === 'random') {
	    concepts = thiz.state.concepts_magic[videoname];
	  } else if (thiz.state.recommendation_type === 'algorithm') {
	    concepts = thiz.state.concepts_magic[videoname];
	  }
	
	  if (current_recommendation_style === "off") {
	    concepts = [];
	  }
	  if (current_recommendation_style === "audio") {
	    concepts = thiz.state.concepts_audio[videoname];
	  }
	  if (current_recommendation_style === "visual") {
	    concepts = [];
	  }
	  if (current_recommendation_style === "text") {
	    concepts = thiz.state.concepts_text[videoname];
	  }
	  if (current_recommendation_style === "fast") {
	    concepts = thiz.state.concepts_fast[videoname];
	  }
	
	  for (var i = 0; i < N; i++) {
	    var word = words[i];
	    var future_time = parseFloat(words[Math.min(N - 1, i + 1)].time);
	    var prev_time = parseFloat(words[Math.max(0, i - 1)].time);
	    var current_time = parseFloat(word.time);
	    var text = word.name;
	    var this_concept = "";
	    var currently_in_concept = false;
	    var concept_start = 0;
	    var suggested_duration = 4000;
	    var first_in_concept = false;
	    for (var j = 0; j < concepts.length; j++) {
	      var start_concept = concepts[j][1];
	      var end_concept = concepts[j][1] + concepts[j][2];
	      if (current_time > start_concept && current_time < end_concept) {
	        concept_start = start_concept * 1000;
	        currently_in_concept = true;
	        this_concept = concepts[j][0];
	        suggested_duration = concepts[j][2] * 1000;
	        if (prev_time <= start_concept) {
	          first_in_concept = true;
	        }
	        break;
	      }
	    }
	    if (!show_recommendations) {
	      currently_in_concept = false;
	    }
	    var currently_in_broll = false;
	    var broll_id = 0;
	    var first_broll_word = false;
	    var broll_thumbnail = "";
	    var last_broll_word = false;
	
	    for (var _j = 0; _j < num_added_broll; _j++) {
	      var start_broll = broll_list[_j].start;
	      var end_broll = start_broll + broll_list[_j].duration / 1000;
	      if (current_time > start_broll && (current_time <= end_broll || prev_time <= start_broll)) {
	        broll_thumbnail = broll_list[_j].thumbnail;
	        broll_id = broll_list[_j].id;
	        currently_in_broll = true;
	        if (prev_time <= start_broll) {
	          first_broll_word = true;
	        }
	        if (!(future_time > start_broll && (future_time <= end_broll || current_time <= start_broll))) {
	          last_broll_word = true;
	        }
	        break;
	      }
	    }
	
	    if (!("." === text)) text = " " + text;
	
	    if (future_time > thiz.state.currentTimeAroll / 1000 && current_time <= thiz.state.currentTimeAroll / 1000) {
	      /*
	        CURRENT POSITION
	      */
	      if (first_broll_word) {
	        //on mouse down it should register current broll index
	        //on mouse up it should update the position of the currently registered broll
	        table.push(_react2.default.createElement('img', { src: broll_thumbnail, className: 'grab', alt: 'Broll thumbnail', width: '20', height: '20', draggable: 'true', onDragStart: thiz.brollDragStartHandler(broll_id), key: i + "a" }));
	      }
	      table.push(_react2.default.createElement(
	        'span',
	        { key: i + "b", className: 'bg-primary text-white text-transcript', onClick: props.context.clickTranscriptIntelligent(current_time * 1000, i, ""), onContextMenu: thiz.firstMethod(text) },
	        text
	      ));
	    } else {
	      /*
	        B-ROLL
	      */
	      if (currently_in_broll) {
	        if (first_broll_word) {
	          //on mouse down it should register current broll index
	          //on mouse up it should update the position of the currently registered broll
	          table.push(_react2.default.createElement('img', { src: broll_thumbnail, className: 'grab-timeline-move', alt: 'Broll thumbnail', width: '20', height: '20', draggable: 'true', onDragStart: thiz.brollDragStartHandler(broll_id), key: i + "c" }));
	        }
	        if (last_broll_word) {
	          table.push(_react2.default.createElement(
	            'span',
	            { className: 'bg-success text-transcript border-4 border-right border-dark grab-timeline-resize', draggable: 'true', onDragStart: thiz.brollDragDurationHandler(broll_id), key: i + "d" },
	            text
	          ));
	        } else {
	          table.push(_react2.default.createElement(
	            'span',
	            { draggable: 'true', className: 'bg-success text-transcript', onDragOver: thiz.preventDefault(), onDrop: thiz.brollDropHandler2(current_time, "onlydurationchange", broll_id), key: i + "e" },
	            text
	          ));
	        }
	      } else if (currently_in_concept) {
	        table.push(_react2.default.createElement(
	          'span',
	          { className: 'bg-info text-transcript', 'data-tip': this_concept, onClick: props.context.getImagesByQueryTerm(this_concept, concept_start / 1000, suggested_duration), draggable: 'true', onDragOver: thiz.preventDefault(), onDrop: thiz.brollDropHandler(current_time), key: i + "f" },
	          text
	        ));
	        if (first_in_concept) {
	          table.push(_react2.default.createElement(
	            'button',
	            { className: 'btn btn-outline-secondary btn-concept', onClick: props.context.getImagesByQueryTerm(this_concept, concept_start / 1000, suggested_duration), key: i + "g" },
	            this_concept
	          ));
	        }
	      } else {
	        /*
	          UNHIGHLIGHTED
	        */
	        table.push(_react2.default.createElement(
	          'span',
	          { draggable: 'true', className: 'text-transcript', onDragOver: thiz.preventDefault(), onDrop: thiz.brollDropHandler(current_time), onClick: props.context.clickTranscriptIntelligent(current_time * 1000, i, ""), onContextMenu: thiz.firstMethod(text), key: i + "h" },
	          text
	        ));
	      }
	    }
	    if (word.name === ".") {
	      if (counter_nonbreak > 15) {
	        table.push(_react2.default.createElement('div', { className: 'textbreak', key: i + "i" }));
	        counter_nonbreak = 0;
	      }
	    }
	    counter_nonbreak += 1;
	  }
	  return table;
	}
	
	function TimelineView(props) {
	  var thiz = props.context;
	  var broll_list = props.context.state.broll_list;
	  var num_added_broll = broll_list.length;
	
	  var table = [];
	  var words = props.context.state.words;
	  var N = words.length;
	  if (N < 1) {
	    return table;
	  }
	
	  var totalDuration = parseFloat(words[N - 1].duration) + parseFloat(words[N - 1].time);
	
	  var timestep = totalDuration / N;
	
	  for (var i = 0; i < N; i++) {
	    var word = words[i];
	    var future_time = timestep * (i + 1);
	    var prev_time = timestep * Math.max(0, i - 1);
	    var current_time = timestep * i;
	
	    var currently_in_broll = false;
	    var broll_id = 0;
	    var first_broll_word = false;
	    var broll_thumbnail = "";
	    var last_broll_word = false;
	
	    for (var j = 0; j < num_added_broll; j++) {
	      var start_broll = broll_list[j].start;
	      var end_broll = start_broll + broll_list[j].duration / 1000;
	      if (current_time > start_broll && (current_time <= end_broll || prev_time <= start_broll)) {
	        broll_id = broll_list[j].id;
	        currently_in_broll = true;
	        if (current_time - start_broll <= end_broll - current_time) {
	          first_broll_word = true;
	        } else {
	          last_broll_word = true;
	        }
	        break;
	      }
	    }
	
	    var word_width = 100.0 / N + '%';
	
	    /*
	      RENDERING STARTS
	    */
	    if (future_time > thiz.state.currentTimeAroll / 1000 && current_time <= thiz.state.currentTimeAroll / 1000) {
	      /*
	        CURRENT POSITION
	      */
	      table.push(_react2.default.createElement('span', { key: i, className: 'bg-primary word-timeline', style: { width: word_width, cursor: 'pointer' }, draggable: 'true', onDragOver: thiz.preventDefault(), onDrop: thiz.brollDropHandler(current_time), onClick: thiz.clickTranscriptIntelligent(current_time * 1000, i, "") }));
	    } else if (currently_in_broll) {
	      /*
	        INSIDE B-ROLL
	      */
	      if (first_broll_word) {
	        table.push(_react2.default.createElement('span', { key: i, className: 'bg-success word-timeline grab-timeline-move', style: { width: word_width }, draggable: 'true', onDragStart: thiz.brollDragStartHandler(broll_id), onDragOver: thiz.preventDefault(), onDrop: thiz.brollDropHandler2(current_time, "onlydurationchange", broll_id) }));
	      } else if (last_broll_word) {
	        table.push(_react2.default.createElement('span', { key: i, className: 'bg-success word-timeline grab-timeline-resize', style: { width: word_width }, draggable: 'true', onDragStart: thiz.brollDragDurationHandler(broll_id), onDragOver: thiz.preventDefault(), onDrop: thiz.brollDropHandler2(current_time, "onlydurationchange", broll_id) }));
	      } else {
	        table.push(_react2.default.createElement('span', { draggable: 'true', className: 'bg-success word-timeline', style: { width: word_width }, onDragOver: thiz.preventDefault(), onDrop: thiz.brollDropHandler2(current_time, "onlydurationchange", broll_id), key: i }));
	      }
	    } else {
	      /*
	        NOTHING
	      */
	      table.push(_react2.default.createElement('span', { key: i, className: 'bg-white word-timeline', style: { width: word_width }, draggable: 'true', onDragOver: thiz.preventDefault(), onDrop: thiz.brollDropHandler(current_time), onClick: thiz.clickTranscriptIntelligent(current_time * 1000, i, "") }));
	    }
	  }
	  return table;
	}
	
	function EditingViewBaseline(props) {
	  var thiz = props.context;
	  var aroll_videofile = "./" + thiz.state.videotype + ".mp4";
	  var totaltimestamp = "03:05";
	  if (document.getElementById("aroll") != null) {
	    var dur = document.getElementById("aroll").duration;
	    totaltimestamp = ("00" + parseInt(dur / 60, 10)).slice(-2) + ":" + ("00" + parseInt(dur % 60, 10)).slice(-2);
	  }
	  if ("aN:aN" === totaltimestamp) {
	    totaltimestamp = "03:05";
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    thiz.state.broll_list.map(function (broll_obj, idx) {
	      return _react2.default.createElement(
	        'video',
	        { width: '600', height: '360', className: 'broll', style: { display: 'none' }, id: "broll_" + idx, loop: true },
	        _react2.default.createElement('source', { src: broll_obj.url, type: 'video/mp4' }),
	        'Your browser does not support the video tag.'
	      );
	    }),
	    _react2.default.createElement(
	      'video',
	      { width: '600', height: '360', id: 'aroll', onClick: thiz.arollPlay(), onTimeUpdate: thiz.callingUpdate(), key: aroll_videofile },
	      _react2.default.createElement('source', { src: aroll_videofile, type: 'video/mp4' }),
	      'Your browser does not support the video tag.'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'button',
	        { type: 'button', onClick: thiz.arollPlay(), className: 'btn btn-secondary left-buffer' },
	        'Play / Pause'
	      ),
	      _react2.default.createElement(
	        'button',
	        { type: 'button', onClick: thiz.arollReplay(), className: 'btn btn-secondary' },
	        'Replay'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'left-buffer top-buffer-sm' },
	        thiz.state.timestamp,
	        '/',
	        totaltimestamp
	      )
	    )
	  );
	}
	
	function RenderBrollResultIntelligent(props) {
	  var thiz = props.context;
	  var type = props.type;
	  var table1 = [];
	  var broll_footage = thiz.state.broll_footage.social;
	  var broll_thumbnail = thiz.state.broll_thumbnail.social;
	  if (type === "professional") {
	    var broll_footage = thiz.state.broll_footage.professional;
	    var broll_thumbnail = thiz.state.broll_thumbnail.professional;
	  }
	  var N = broll_footage.length;
	  var maxindex = Math.min(N, thiz.state.maxindex);
	  if (maxindex < 1) {
	    return table1;
	  }
	  var per_row = 4;
	  // Outer loop to creaSearte parent
	  for (var i = 0; i < maxindex; i += per_row) {
	    var children = [];
	    //Inner loop to create children
	    for (var j = 0; j < per_row; j++) {
	      children.push(_react2.default.createElement(
	        'div',
	        { className: 'col-3', key: broll_footage[i + j] + "_col" },
	        _react2.default.createElement(
	          'video',
	          { width: '200', height: '200', key: broll_footage[i + j], id: broll_footage[i + j], name: 'broll', controls: true, autoPlay: true, loop: true, muted: true },
	          _react2.default.createElement('source', { src: broll_footage[i + j], type: 'video/mp4' }),
	          'Your browser does not support the video tag.'
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: thiz.addNow(broll_footage[i + j], broll_thumbnail[i + j], i + j), className: 'btn btn-primary' },
	          'Add Now'
	        )
	      ));
	    }
	    //Create the parent and add the children
	    table1.push(_react2.default.createElement(
	      'div',
	      { key: i, className: 'row top-buffer' },
	      children
	    ));
	  }
	  return table1;
	}
	
	function showThisBroll(name, duration) {
	  if (document.readyState === "complete") {
	    (0, _jquery2.default)("#" + name).show();
	    document.getElementById(name).currentTime = 0;
	    document.getElementById(name).play();
	    (0, _jquery2.default)("#aroll").hide();
	    setTimeout(function () {
	      (0, _jquery2.default)("#" + name).hide();
	      (0, _jquery2.default)("#aroll").show();
	    }, duration);
	  }
	}
	
	function generateStockToken(thiz) {
	  console.log('generateStockToken');
	  var apiURL = 'https://cors.io/?https://ims-na1-stg1.adobelogin.com/ims/login/v1/token?client_id=ImageServicesTestAutomation1&username=bhuber%2B1%40adobe.com&password=Bcreate123!&scope=AdobeID,creative_sdk&response_type=token&remember_me=false';
	  fetch(apiURL, {
	    method: 'GET',
	    dataType: "json"
	  }).then(function (response) {
	    return response.json();
	  }).then(function (responseData) {
	    var access_token = responseData.access_token;
	    console.log(access_token);
	    if (access_token.length > 100) {
	      thiz.setState({ token: access_token });
	    }
	  }).catch(function (err) {
	    console.log(err);
	  });
	}
	
	var prev_pos = 0;
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	    _this.toggleHelptext = function () {
	      return function (event) {
	        _this.setState({ show_helptext: !_this.state.show_helptext });
	      };
	    };
	
	    _this.spaceFunction = function () {
	      return function (event) {
	        if (event.keyCode === 32 && !document.activeElement.id) {
	          //space was pressed so toggle video
	          if (document.getElementById("aroll").paused) {
	            document.getElementById("aroll").play();
	          } else {
	            document.getElementById("aroll").pause();
	          }
	          event.preventDefault();
	          event.returnValue = false;
	        }
	      };
	    };
	
	    _this.brollDragStartHandler = function (broll_id) {
	      return function (event) {
	        var text = JSON.stringify({ "broll_id": broll_id, "action": 0 });
	        event.dataTransfer.setData('text', text);
	      };
	    };
	
	    _this.brollDragDurationHandler = function (broll_id) {
	      return function (event) {
	        var text = JSON.stringify({ "broll_id": broll_id, "action": 1 });
	        event.dataTransfer.setData('text', text);
	      };
	    };
	
	    _this.brollDropHandler = function (current_time) {
	      return function (event) {
	        event.preventDefault();
	        var drag_raw_obj = event.dataTransfer.getData('text');
	        if (drag_raw_obj) {
	          var drag_obj = JSON.parse(drag_raw_obj);
	          var dragged_broll_id = drag_obj.broll_id;
	          var drag_action = drag_obj.action;
	          var broll_list = _this.state.broll_list;
	          var N = broll_list.length;
	          if (drag_action === 0) {
	            //this updates the starting point of this specific added broll
	            for (var i = 0; i < N; i++) {
	              if (broll_list[i].id === dragged_broll_id) {
	                broll_list[i].start = current_time;
	                break;
	              }
	            }
	            _this.setState({ broll_list: broll_list });
	            uploadDataToServer(_this);
	          } else if (drag_action === 1) {
	            //this updates the duration of this specific added broll
	            for (var _i = 0; _i < N; _i++) {
	              if (broll_list[_i].id === dragged_broll_id) {
	                var new_duration = current_time - broll_list[_i].start;
	                console.log(new_duration, "new duration");
	                if (new_duration > 0) {
	                  broll_list[_i].duration = new_duration * 1000;
	                  console.log(broll_list);
	                  _this.setState({ broll_list: broll_list });
	                  uploadDataToServer(_this);
	                }
	                break;
	              }
	            }
	          }
	        } else {
	          //then we just go there in the video
	          console.log('triggered drop event');
	          document.getElementById("aroll").currentTime = current_time;
	          document.getElementById("aroll").pause();
	          _this.setState({ justclicked: true });
	        }
	      };
	    };
	
	    _this.brollDropHandler2 = function (current_time, onlydurationchange, this_broll_id) {
	      return function (event) {
	        event.preventDefault();
	        var drag_obj = JSON.parse(event.dataTransfer.getData('text'));
	        var dragged_broll_id = drag_obj.broll_id;
	        var drag_action = drag_obj.action;
	        var broll_list = _this.state.broll_list;
	        var N = broll_list.length;
	
	        console.log("received drop event with data", dragged_broll_id);
	        console.log("the drop location is", current_time);
	        if (drag_action === 0 && dragged_broll_id === this_broll_id) {
	          //this updates the starting point of this specific added broll
	          for (var i = 0; i < N; i++) {
	            if (broll_list[i].id === dragged_broll_id) {
	              broll_list[i].start = current_time;
	              break;
	            }
	          }
	          _this.setState({ broll_list: broll_list });
	          uploadDataToServer(_this);
	        } else if (drag_action === 1) {
	          //this updates the duration of this specific added broll
	          for (var _i2 = 0; _i2 < N; _i2++) {
	            if (broll_list[_i2].id === dragged_broll_id) {
	              var new_duration = current_time - broll_list[_i2].start;
	              console.log(new_duration, "new duration");
	              if (new_duration > 0) {
	                broll_list[_i2].duration = new_duration * 1000;
	                console.log(broll_list);
	                _this.setState({ broll_list: broll_list });
	                uploadDataToServer(_this);
	              }
	              break;
	            }
	          }
	        }
	      };
	    };
	
	    _this.brollDelete = function () {
	      return function (event) {
	        var drag_obj = JSON.parse(event.dataTransfer.getData('text'));
	        var dragged_broll_id = drag_obj.broll_id;
	        var broll_list = _this.state.broll_list;
	        broll_list = broll_list.filter(function (e) {
	          return e.id !== dragged_broll_id;
	        });
	        _this.setState({ broll_list: broll_list });
	        uploadDataToServer(_this);
	      };
	    };
	
	    _this.preventDefault = function () {
	      return function (event) {
	        event.stopPropagation();
	        event.preventDefault();
	        return false;
	      };
	    };
	
	    _this.preventDefault2 = function () {
	      return function (event) {
	        event.preventDefault();
	      };
	    };
	
	    _this.submitGeneralSurvey = function () {
	      return function (event) {
	        event.preventDefault();
	        var data = new FormData(event.target);
	        var object = {};
	        data.forEach(function (value, key) {
	          object[key] = value;
	        });
	        object['participantid'] = _this.state.participantid % 10000000;
	        _this.setState({ q0_b: parseInt(object['q0_b']), page: 4, broll_footage: { "social": [], "professional": [] }, broll_thumbnail: { "social": [], "professional": [] }, sessionstarttime: Date.now(), broll_list: [], queries: [], searchkey: '' });
	        var json = JSON.stringify(object);
	        console.log(json);
	        fetch('https://dapptalk.org/demographicsquestionnaire.php', {
	          method: 'POST',
	          body: json,
	          mode: 'no-cors'
	        });
	      };
	    };
	
	    _this.goToNextExperimentPage = function () {
	      return function (event) {
	        event.preventDefault();
	        if (_this.state.page === 4 && _this.state.broll_list.length < 1) {
	          alert("It seems like you did not insert any B-Roll yet. Please insert B-Roll before going to the next task.");
	          return;
	        }
	        //broll_footage: {"social":[],"professional":[]},broll_thumbnail,sessionstarttime,broll_list,queries
	        _this.setState({ broll_footage: { "social": [], "professional": [] }, broll_thumbnail: { "social": [], "professional": [] }, sessionstarttime: Date.now(), broll_list: [], queries: [], searchkey: '', currentTimeAroll: 0 });
	        if (_this.state.page === 4) {
	          event.preventDefault();
	          var experiment_index = _this.state.experiment_index;
	          experiment_index += 1;
	          if (experiment_index < 3) {
	            console.log(experiment_index, _this.state.ui_order);
	            var c = _this.state.ui_order[experiment_index];
	            var v = _this.state.video_order[experiment_index];
	            var transcripts = [_video_diary2.default, _aloe_vera2.default, _jeff_introduction2.default, _vlog_competition2.default, _sports2.default, _anxiety2.default, _struggling2.default, _yoga_vibe2.default, _fit_traveler2.default, _shantanu_trimmed2.default];
	            var words = transcripts[v].words;
	            var videotype = _this.state.videotypes[v];
	            var instructions_index = _this.state.instructions_order[experiment_index];
	            _this.setState({ uitype: c, videotype: videotype, v: v, words: words, experiment_index: experiment_index, show_helptext: true, helptext: _this.state.helptexts[_this.state.instructions_order[experiment_index]], page: 6 });
	          } else {
	            _this.setState({ page: 6, experiment_index: experiment_index });
	          }
	        } else {
	          //this means we go back to UI from questionnaire
	          event.preventDefault();
	          console.log("event.preventDefault()");
	          var data = new FormData(event.target);
	          if (_this.state.experiment_index < 3) {
	            _this.setState({ page: 4 });
	          } else {
	            console.log("done with experiment");
	            //done with experiment
	            _this.setState({ page: 5 });
	          }
	          var object = {};
	          data.forEach(function (value, key) {
	            object[key] = value;
	          });
	
	          object['uitype'] = _this.state.u;
	          object['uitype'] = _this.state.ui_order[_this.state.experiment_index - 1];
	          object['uinumber'] = _this.state.experiment_index - 1;
	          object['uiorder'] = _this.state.ui_order.join('-');
	          object['videoorder'] = _this.state.video_order.join('-');
	          object['videotype'] = _this.state.video_order[_this.state.experiment_index - 1];
	          object['videoname'] = _this.state.videotypes[object['videotype']];
	          object['recommendationtype'] = _this.state.recommendation_type;
	          object['participantid'] = _this.state.participantid % 10000000;
	          if (object.hasOwnProperty('q0')) {
	            object['gain_self_efficacy'] = parseInt(object['q0']) - _this.state.q0_b;
	          }
	
	          var json = JSON.stringify(object);
	          console.log(json);
	          fetch('https://dapptalk.org/withinsubjectquestionnaire.php', {
	            method: 'POST',
	            body: json,
	            mode: 'no-cors'
	          });
	        }
	      };
	    };
	
	    _this.brollDragStopHandler = function (broll_index) {
	      return function (event) {
	        console.log(broll_index, "called drop");
	      };
	    };
	
	    _this.changeRecommendationStyle = function (name) {
	      return function (event) {
	        _this.setState({ current_recommendation_style: name });
	      };
	    };
	
	    _this.handleTokenChange = function () {
	      return function (event) {
	        _this.setState({ token: event.target.value });
	      };
	    };
	
	    _this.firstMethod = function (word) {
	      return function (event) {
	        event.preventDefault();
	        console.log("button clicked", word, event.type);
	        _this.setState({ searchkey: word });
	        console.log(_this.state.queries);
	        _this.getImagesByQuery(word);
	        return false;
	      };
	    };
	
	    _this.clickTranscriptIntelligent = function (startOffset, idx, keyword) {
	      return function (event) {
	        var selectedTime = startOffset;
	        var thiz = _this;
	        document.getElementById("aroll").currentTime = selectedTime / 1000.0;
	        //this.callingUpdate();
	        if (keyword.length < 1) {
	          document.getElementById("aroll").pause();
	          thiz.setState({ justclicked: true });
	          return;
	        }
	        var searchkey = keyword;
	        thiz.setState({ searchkey: keyword, justclicked: true });
	        var queries = thiz.state.queries;
	        queries.push(searchkey);
	        _this.setState({ broll_thumbnail: { "social": [], "professional": [] }, broll_footage: { "social": [], "professional": [] }, loadingBroll: true, queries: queries, suggested_duration: 4000, suggested_start_time: -1 });
	        uploadDataToServer(_this);
	        thiz.imageAPIcalls(searchkey, _this);
	      };
	    };
	
	    _this.arollPlay = function () {
	      return function (event) {
	        if (document.getElementById("aroll").paused) {
	          document.getElementById("aroll").play();
	        } else {
	          document.getElementById("aroll").pause();
	        }
	      };
	    };
	
	    _this.onKeyPress = function () {
	      return function (event) {
	        if (event.key === 'Enter') {
	          //do something
	          console.log("detected enter!");
	          var thiz = _this;
	          var searchkey = thiz.state.searchkey;
	          var queries = thiz.state.queries;
	          queries.push(searchkey);
	          _this.setState({ sbroll_thumbnail: { "social": [], "professional": [] }, broll_footage: { "social": [], "professional": [] }, loadingBroll: true, queries: queries, suggested_duration: 4000, suggested_start_time: -1 });
	          uploadDataToServer(_this);
	          queries.push(searchkey);
	          _this.imageAPIcalls(searchkey, _this);
	        }
	      };
	    };
	
	    _this.arollReplay = function () {
	      return function (event) {
	        document.getElementById("aroll").currentTime = 0;
	        document.getElementById("aroll").play();
	      };
	    };
	
	    _this.showMoreBroll = function () {
	      return function (event) {
	        _this.setState({ maxindex: _this.state.maxindex + 12 });
	      };
	    };
	
	    _this.handleSearchChange = function () {
	      return function (event) {
	        _this.setState({ searchkey: event.target.value });
	      };
	    };
	
	    _this.callingUpdate = function () {
	      return function (event) {
	        console.log("callingUpdate");
	        var broll_list = _this.state.broll_list;
	        if (_this.state.justclicked) {
	          prev_pos = event.target.currentTime;
	        }
	        var N = broll_list.length;
	        for (var i = 0; i < N; i++) {
	          if (broll_list[i].start >= prev_pos && broll_list[i].start <= event.target.currentTime) {
	            showThisBroll("broll_" + i, broll_list[i].duration);
	            break;
	          }
	        }
	        prev_pos = event.target.currentTime;
	        var date = new Date(null);
	        date.setSeconds(event.target.currentTime); // specify value for SECONDS here
	        var timestamp = date.toISOString().substr(14, 5);
	        _this.setState({ timestamp: timestamp, currentTimeAroll: event.target.currentTime * 1000, justclicked: false });
	      };
	    };
	
	    _this.addNow = function (url, thumbnail, thisranking) {
	      return function (event) {
	        var current_time = _this.state.currentTimeAroll;
	        //check if we are currently in b-roll, then don't do anything
	        var broll_list = _this.state.broll_list;
	        console.log("broll length", broll_list.length);
	        for (var i = 0; i < broll_list.length; i++) {
	          var start = broll_list[i].start;
	          var end = start + broll_list[i].duration / 1000;
	          console.log(current_time, start, end);
	          if (current_time / 1000 >= start && current_time / 1000 < end) {
	            console.log('we are currently in a B=roll so wont add this new broll. end.');
	            return;
	          }
	        }
	        var actual_duration = _this.state.suggested_duration;
	        var actual_position = _this.state.suggested_start_time;
	        if (actual_duration === 4000) {
	          //because otherwise there is a recommended time so we use that
	          var broll_duration = document.getElementById(url).duration * 1000;
	          actual_duration = Math.max(1000, Math.min(8000, broll_duration));
	        }
	        if (actual_position === -1) {
	          actual_position = current_time;
	        } else {
	          actual_position *= 1000;
	        }
	        var query = _this.state.searchkey;
	        var broll_obj = { "start": actual_position / 1000, "duration": actual_duration, "rank": thisranking, "url": url, "thumbnail": thumbnail, "id": url, "query": query, "from_recommendation": _this.state.in_recommendation_session };
	        broll_list.push(broll_obj);
	        _this.setState({ broll_list: broll_list });
	        uploadDataToServer(_this);
	      };
	    };
	
	    _this.getImagesByQuery = function () {
	      var searchquery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      var thiz = _this;
	      var searchkey = thiz.state.searchkey;
	      if (searchquery.length > 0) {
	        searchkey = searchquery;
	      }
	      var queries = thiz.state.queries;
	      queries.push(searchkey);
	      _this.setState({ loadingBroll: true, queries: queries, suggested_duration: 4000, suggested_start_time: -1 });
	      uploadDataToServer(_this);
	      _this.imageAPIcalls(searchkey, _this);
	    };
	
	    _this.imageAPIcalls = function (searchkey, thiz) {
	      thiz.setState({ in_recommendation_session: false });
	      var num_broll_cached = thiz.state.num_broll_cached;
	      var apiURL = 'https://adobesearch-stage.adobe.io/universal-search/v2/search';
	      var token = thiz.state.token;
	      var formData = {
	        "q": searchkey,
	        "scope": ["stock"],
	        "asset_type": ["video"],
	        "limit": num_broll_cached
	      };
	      /*
	      fetch(apiURL, {
	        method: 'POST',
	        headers: {
	          'Authorization': 'Bearer ' + token,
	          'x-api-key': 'AdobeSearchService1',
	          'x-product': 'Federer tests',
	          'x-product-location': 'Federer container tests',
	          'Content-Type': 'application/vnd.adobe.search-request+json'
	        },
	        body: JSON.stringify(formData)
	      }).then((response) => response.json())
	        .then((responseData) => { 
	          var out = []//footage
	          var out2 = []//thumbnail
	          for (var i = 0; i < responseData.result_sets[0].items.length;i++) {
	            out2.push(responseData.result_sets[0].items[i]._links.rendition[0].href)
	            out.push(responseData.result_sets[0].items[i]._links.original.href)
	          }
	          var broll_footage = thiz.state.broll_footage
	          var broll_thumbnail = thiz.state.broll_thumbnail
	          broll_footage.professional = out
	          broll_thumbnail.professional = out2
	          thiz.setState({broll_footage: broll_footage, loadingBroll: false, broll_thumbnail: broll_thumbnail})
	        }).catch((err) => { 
	          thiz.setState({loadingBroll: false})
	          console.log("something went wrong!");
	          console.log(err);
	        }); 
	        */
	      apiURL = 'https://api.giphy.com/v1/gifs/search?q=' + searchkey + '&api_key=slZG5tNDBkUfSpd7q8V7le8DLnRaBuZw&limit=' + num_broll_cached;
	      formData = { email: "testme" };
	      fetch(apiURL, {
	        method: 'GET',
	        dataType: "json",
	        data: formData
	      }).then(function (response) {
	        return response.json();
	      }).then(function (responseData) {
	        var N = responseData.data.length;
	        var out = []; //footage
	        var out2 = []; //thumbnail
	        for (var i = 0; i < N; i++) {
	          var video = responseData.data[i].images.original.mp4;
	          var thumb = responseData.data[i].images.original_still.url;
	          out2.push(thumb);
	          out.push(video);
	        }
	        var broll_footage = thiz.state.broll_footage;
	        var broll_thumbnail = thiz.state.broll_thumbnail;
	        broll_footage.social = out;
	        broll_thumbnail.social = out2;
	        thiz.setState({ broll_footage: broll_footage, broll_thumbnail: broll_thumbnail, loadingBroll: false });
	      }).catch(function (err) {
	        console.log("something went wrong!");
	        console.log(err);
	      });
	    };
	
	    _this.getImagesByQueryTerm = function (kw, start_time, suggested_duration) {
	      return function (event) {
	        //this is only called by recommendations so we can track here if we are in recommendation currently
	        document.getElementById("aroll").currentTime = start_time;
	        var thiz = _this;
	        var searchkey = kw;
	        var queries = thiz.state.queries;
	        console.log(queries);
	        queries.push(searchkey);
	        _this.setState({ loadingBroll: true, queries: queries, searchkey: kw, suggested_duration: suggested_duration, suggested_start_time: start_time, justclicked: true });
	        uploadDataToServer(_this);
	        _this.imageAPIcalls(searchkey, _this);
	        _this.setState({ in_recommendation_session: true });
	      };
	    };
	
	    _this.state = {
	      page: 4,
	      participantid: Date.now(),
	      broll_footage: { "social": [], "professional": [] },
	      justclicked: false,
	      searchkey: "",
	      broll_list: [],
	      timestamp: "00:00",
	      sessionstarttime: Date.now(),
	      suggested_start_time: -1,
	      token: "eyJ4NXUiOiJpbXNfbmExLXN0ZzEta2V5LTEuY2VyIiwiYWxnIjoiUlMyNTYifQ.eyJpZCI6IjE1Mzc0NjM1NjQ3MzhfZDU0MWFmNDAtMjU5OC00NmY2LWEwODMtMmM5Y2Y0YjkyOTJhX3VlMSIsImNsaWVudF9pZCI6IkltYWdlU2VydmljZXNUZXN0QXV0b21hdGlvbjEiLCJ1c2VyX2lkIjoiMzg1NDQxQjM1QjI0MUYzMTBBNDk0MDBFQEFkb2JlSUQiLCJ0eXBlIjoiYWNjZXNzX3Rva2VuIiwiYXMiOiJpbXMtbmExLXN0ZzEiLCJmZyI6IlNZN0NST0xEV1Y3Rzc1N0ROV0xNT1NJQVNBPT09PT09Iiwic2lkIjoiMTUzNzQ2MzU2NDc0MV8wZTEzMWFmNy1mYzM2LTQ4Y2EtODA4OS0yODAwMmEzMzVlYjFfdWUxIiwibW9pIjoiYWE4MmE2NmIiLCJjIjoiZzdncnRuRk1aLzBPUkdBQmRJQ1BjUT09IiwiZXhwaXJlc19pbiI6Ijg2NDAwMDAwIiwic2NvcGUiOiJBZG9iZUlELGNyZWF0aXZlX3NkayIsImNyZWF0ZWRfYXQiOiIxNTM3NDYzNTY0NzM4In0.SW1X-LWLAakB6oMnY29s_NHLrYOaiGZqgNw49imEG2GCBHWBlrOEL8cQxFlfVVRZxjjYIx28DMtwxlfm4-SbsAAhNomKkEEqJ3pwJZU-5POelXXUTNil_uKW8ItXAPinWVkksMCrvHUJrk2mj0UDuZFmL8AAOubdP2zCRmG_334gCuUR30NxA7dp1jv7OeNjAiM6scVnikfLAIIh4IDW5a1hCeEmWJCR2vOLv-K7QkvsvSfFDEGA2-ZddJCFmsrVKgS24WxXWAYQO-_ws87SZySBWDooFL15SEXAizrvh0gOrAXnP9gQnVrHgx7XHv1sQWeJn95Qb3c4sdo0nMMT0w",
	      loadingBroll: false,
	      words: [],
	      queries: [],
	      suggested_duration: 4000,
	      concepts_algorithm: { 'jeff_introduction': [['jeff', 4.58, 2.0], ['series', 15.59, 2.0], ['solutions', 24.83, 2.0], ['variety', 33.47, 2.0], ['people', 42.95, 2.0], ['asian culture', 55.98, 2.0], ['hip hop', 67.08, 2.0], ['spin', 85.38, 2.0], ['subgroups', 93.81, 2.0], ['main influences', 107.37, 2.0], ['religions', 120.84, 2.0], ['date', 128.97, 2.0], ['problem', 138.15, 2.0], ['people', 148.17, 2.0], ['everybody', 159.0, 2.0], ['booty', 168.51, 2.0], ['table', 177.87, 2.0]], 'struggling': [['mornings', 7.68, 2.0], ['care', 16.35, 2.0], ['people', 24.35, 2.0], ['people', 32.88, 2.0], ['life', 42.78, 2.0], ['passion', 53.76, 2.0], ['thing', 63.96, 2.0], ['somebody', 75.51, 2.0], ['break', 84.06, 2.0], ['guy', 94.17, 2.0], ['rest', 103.44, 2.0], ['aspects', 115.35, 2.0], ['periods', 124.11, 2.0], ['school', 132.42, 2.0], ['break', 141.66, 2.0], ['lessons', 149.91, 2.0], ['creativity', 162.3, 2.0], ['youtube', 172.68, 2.0]], 'economics': [['hand', 9.79, 2.0], ['video', 2.8, 2.0], ['transcript', 15.06, 2.0], ['edit', 21.32, 2.0], ['position', 27.91, 2.0], ['positions', 35.9, 2.0], ['insert', 41.18, 2.0], ['example', 46.47, 2.0], ['style', 51.69, 2.0], ['user', 59.12, 2.0]], 'fit_traveler': [['episode number', 1.24, 2.0], ['business', 11.59, 2.0], ['session', 20.41, 2.0], ['weekends', 33.01, 2.0], ['years', 42.91, 2.0], ['events', 55.3, 2.0], ['type', 68.32, 2.0], ['beast', 76.39, 2.0], ['invitation', 87.1, 2.0], ['drinks', 95.17, 2.0], ['business travelers', 105.04, 2.0], ['vendors', 114.34, 2.0], ['purposes', 131.5, 2.0], ['drink', 140.68, 2.0], ['times', 150.04, 2.0], ['picture', 161.26, 2.0], ['tips', 174.82, 2.0]], 'sports': [['world', 11.94, 2.0], ['breakfast', 26.65, 2.0], ['shot', 40.26, 2.0], ['breakfast', 49.53, 2.0], ['history', 63.96, 2.0], ['basilica', 75.48, 2.0], ['river', 83.79, 2.0], ['noon', 100.26, 2.0], ['pizza', 114.48, 2.0], ['lunch', 123.24, 2.0], ['match', 131.43, 2.0], ['girls', 141.0, 2.0], ['guys', 149.13, 2.0], ['floor', 158.94, 2.0], ['air conditioning', 168.37, 2.0], ['language', 179.55, 2.0]] },
	      concepts_magic: { 'struggling': [['stress', 4.6, 2.1], ['public figure', 22.0, 7.9], ['working', 38.4, 4.9], ['passion', 53.8, 4.0], ['happiness', 64.5, 0.5], ['lifting weights', 76.5, 7.5], ['injured', 94.8, 1.6], ['stronger', 108.1, 1.5], ['school', 132.5, 2.3], ['break', 141.6, 0.6], ['burned out', 158.3, 0.5], ['stressed', 165.1, 3.0], ['YouTube', 175.4, 1.3]], 'jeff_introduction': [['dating', 6.4, 4.3], ['address', 21.5, 0.5], ['pregnancy', 29.1, 4.1], ['coach', 37.6, 0.7], ['society', 44.1, 2.1], ['martial arts', 56.6, 3.3], ['peace', 65.3, 0.5], ['culture', 77.6, 1.4], ['culture', 88.0, 4.0], ['religions', 121.1, 1.6], ['Christianity', 135.2, 2.8], ['attracted', 152.1, 0.5], ['dating', 156.9, 0.5], ['booty', 168.6, 4.0]], 'economics': [['war', 8.54, 2.0], ['truth', 35.28, 2.0], ['embrace', 70.69, 2.0], ['share', 26.06, 2.0], ['dream', 54.45, 2.0], ['today', 0.86, 2.0], ['images', 14.06, 2.0], ['technology', 42.15, 2.0], ['hamas', 48.39, 2.0], ['economy', 59.64, 2.0]], 'fit_traveler': [['bar', 9.6, 4.0], ['alcohol', 25.4, 3.2], ['weekends', 33.0, 2.3], ['business', 49.3, 4.0], ['business traveler', 70.5, 4.0], ['business meeting', 80.7, 0.5], ['bar', 91.2, 4.5], ['happy hour', 111.7, 1.9], ['bar', 126.9, 0.5], ['business healthy', 167.1, 0.5]], 'sports': [['fathers day', 6.9, 2.3], ['morning', 24.3, 0.5], ['hot dogs', 31.7, 4.7], ['cinnamon', 45.2, 2.1], ['tram', 52.2, 4.0], ['basilica', 75.5, 4.0], ['pizza', 115.7, 4.5]] },
	      concepts_random: { 'struggling': [["I'm", 11.0, 2.0], ['unhealthy', 22.0, 2.0], ['people', 33.0, 2.0], ['always', 44.0, 2.0], ['and', 55.0, 2.0], ['that', 66.0, 2.0], ['weights', 77.0, 2.0], ['lifts', 88.0, 2.0], ['hard', 110.0, 2.0], ['I came', 132.0, 2.0], ['been going', 143.0, 2.0], ['out', 154.0, 2.0], ['and', 165.0, 2.0], ['analytics', 176.0, 2.0]], 'jeff_introduction': [['basic', 11.0, 2.0], ['problem', 22.0, 2.0], ['flu', 55.0, 2.0], ['expressions', 77.0, 2.0], ['culture', 88.0, 2.0], ['because', 99.0, 2.0], ['our', 110.0, 2.0], ['Many', 121.0, 2.0], ['thing', 132.0, 2.0], ['that', 143.0, 2.0], ['talk', 154.0, 2.0], ['the', 176.0, 2.0]], 'economics': [['like', 22.0, 2.0], ['chaos', 44.0, 2.0], ['people', 55.0, 2.0], ['religion', 66.0, 2.0], ['like', 99.0, 2.0], ['like', 110.0, 2.0], ['choices', 132.0, 2.0], ['their', 143.0, 2.0], ['make', 165.0, 2.0]], 'fit_traveler': [['as', 11.0, 2.0], ['expectations', 22.0, 2.0], ['the weekends', 33.0, 2.0], ['that', 44.0, 2.0], ['up', 55.0, 2.0], ['nightcap', 99.0, 2.0], ['companies', 110.0, 2.0], ['business', 121.0, 2.0], ['purposes', 132.0, 2.0], ['participate', 143.0, 2.0], ['the', 154.0, 2.0], ['in', 165.0, 2.0], ['or', 176.0, 2.0]], 'sports': [['Budapest', 11.0, 2.0], ['and', 33.0, 2.0], ['then', 55.0, 2.0], ['around', 88.0, 2.0], ['got', 99.0, 2.0], ['match', 132.0, 2.0], ['street from', 143.0, 2.0], ['hope', 154.0, 2.0], ['and', 176.0, 2.0]] },
	      concepts_audio: { 'struggling': [['because', 12.3, 4.0], ['.', 24.7, 4.0], ['example', 36.5, 4.0], ['.', 48.4, 4.0], ["that's", 58.5, 4.0], ['.', 69.0, 4.0], ['okay', 79.8, 4.0], ['.', 90.3, 4.0], ['example', 101.2, 4.0], ['grow', 113.5, 4.0], ['after', 125.5, 4.0], ['work', 137.1, 4.0], ['in', 148.7, 4.0], ['.', 159.0, 4.0], ['YouTube', 170.1, 4.0], ['.', 180.5, 4.0]], 'jeff_introduction': [['on', 14.0, 4.0], ['dating', 24.4, 4.0], ['And', 35.3, 4.0], ['hop', 46.6, 4.0], ['movies', 58.6, 4.0], ['where', 69.0, 4.0], ['Arab', 79.1, 4.0], ['to', 89.2, 4.0], ['because', 99.3, 4.0], ['influences', 109.6, 4.0], ['religions', 121.8, 4.0], ['the', 132.4, 4.0], ['that', 143.1, 4.0], ['them', 154.6, 4.0], ["that's", 165.0, 4.0], ['table', 175.7, 4.0]], 'economics': [['about', 10.9, 4.0], ['.', 21.0, 4.0], ['and', 31.2, 4.0], ['chaotic element to it', 41.9, 4.0], ['cannot', 52.1, 4.0], ['family', 65.5, 4.0], ['Like', 77.3, 4.0], ['.', 88.8, 4.0], ['road', 98.9, 4.0], ['like', 109.5, 4.0], ['consumption', 119.7, 4.0], ["don't", 130.0, 4.0], ['family', 140.5, 4.0], ['.', 152.8, 4.0], ['crime', 163.6, 4.0], ['normal', 174.3, 4.0]], 'fit_traveler': [['scene', 10.2, 4.0], ['drink', 26.2, 4.0], ['not', 37.4, 4.0], ['.', 47.9, 4.0], ['business', 59.9, 4.0], ['traveler', 71.7, 4.0], ['meeting', 82.6, 4.0], ['drinks', 95.6, 4.0], ['.', 108.4, 4.0], ['is', 120.1, 4.0], ['this', 132.9, 4.0], ['participate', 143.3, 4.0], ['OK', 154.8, 4.0], ['existence', 166.0, 4.0], ['or', 176.3, 4.0]], 'sports': [['world', 12.3, 4.0], ['830', 26.1, 4.0], ['But', 37.7, 4.0], ['yeah', 49.4, 4.0], ['.', 59.9, 4.0], ['building', 70.9, 4.0], ['War', 82.4, 4.0], ['especially', 92.5, 4.0], ['Budapest', 103.1, 4.0], ["let's", 113.7, 4.0], ['up', 124.3, 4.0], ['team', 135.2, 4.0], ['because', 147.1, 4.0], ['the', 159.1, 4.0], ['awesome', 169.8, 4.0], ['language', 180.1, 4.0]] },
	      concepts_text: { 'struggling': [['want', 12.8, 4.0], ['themselves', 29.8, 4.0], ['squeeze', 45.3, 4.0], ['the', 58.9, 4.0], ['explain', 70.1, 4.0], ['lifting', 82.9, 4.0], ['it', 96.7, 4.0], ['lifting', 107.9, 4.0], ['the', 120.7, 4.0], ['took', 134.5, 4.0], ['straighten', 153.1, 4.0], ['lost', 163.2, 4.0], ['checking', 174.8, 4.0]], 'jeff_introduction': [['get', 10.7, 4.0], ['the', 21.6, 4.0], ['call', 35.8, 4.0], ['the', 49.9, 4.0], ['the', 60.3, 4.0], ['bring', 75.4, 4.0], ['lose', 87.6, 4.0], ['influence', 100.9, 4.0], ['us', 118.7, 4.0], ['marry', 129.8, 4.0], ['address', 142.3, 4.0], ['a', 155.8, 4.0], ['the', 176.0, 4.0]], 'economics': [['swallow', 52.2, 4.0], ['their', 63.2, 4.0], ['addiction', 90.1, 4.0], ['addiction', 100.3, 4.0], ['addiction', 116.1, 4.0], ['the', 127.9, 4.0], ['their', 139.5, 4.0], ['breaking', 150.9, 4.0], ['make', 165.0, 4.0]], 'fit_traveler': [['the', 12.4, 4.0], ['that', 26.7, 4.0], ['addressing', 37.5, 4.0], ['the', 49.3, 4.0], ['some', 62.2, 4.0], ['this', 73.4, 4.0], ['the', 90.2, 4.0], ['a', 108.9, 4.0], ['a', 120.6, 4.0], ['the', 131.5, 4.0], ['have', 144.6, 4.0], ['that', 155.7, 4.0], ['healthy', 167.5, 4.0], ['adopt', 179.2, 4.0]], 'sports': [['day', 14.3, 4.0], ['had', 26.4, 4.0], ['breakfast', 36.6, 4.0], ['breakfast', 49.7, 4.0], ['the', 60.6, 4.0], ['saw', 71.4, 4.0], ['the', 83.7, 4.0], ['got', 98.9, 4.0], ['had', 113.0, 4.0], ['lunch', 123.5, 4.0], ['a', 134.1, 4.0], ['judge', 145.9, 4.0], ['the', 158.9, 4.0], ['the', 173.4, 4.0]] },
	      concepts_fast: { 'struggling': [['because', 20.0, 2.0], ['themselves', 30.0, 2.0], ['24/7', 40.0, 2.0], ['I', 50.0, 2.0], ['I', 60.0, 2.0], ['me', 70.0, 2.0], ['from', 80.0, 2.0], ["It's", 100.0, 2.0], ['hard', 110.0, 2.0], ["It's", 120.0, 2.0], ['rest', 130.0, 2.0], ['those', 150.0, 2.0], ['YouTube', 170.0, 2.0], ['worrying', 180.0, 2.0]], 'jeff_introduction': [['I', 10.0, 2.0], ['I', 20.0, 2.0], ['pregnancy', 30.0, 2.0], ['African-American', 50.0, 2.0], ['you', 60.0, 2.0], ['race', 70.0, 2.0], ['culture', 90.0, 2.0], ['subgroups', 100.0, 2.0], ['our', 110.0, 2.0], ['us', 120.0, 2.0], ['marry', 130.0, 2.0], ['one', 140.0, 2.0], ['most', 150.0, 2.0], ['goes', 160.0, 2.0], ['nice person', 170.0, 2.0], ['So', 180.0, 2.0]], 'economics': [['so', 20.0, 2.0], ['psychology', 30.0, 2.0], ['people', 60.0, 2.0], ['their', 70.0, 2.0], ['go', 80.0, 2.0], ['really', 90.0, 2.0], ['drug', 100.0, 2.0], ['like', 110.0, 2.0], ['economics', 120.0, 2.0], ['family', 140.0, 2.0], ['not', 150.0, 2.0], ['addiction', 160.0, 2.0], ['like', 170.0, 2.0]], 'fit_traveler': [['scene', 10.0, 2.0], ['talking', 30.0, 2.0], ['talking', 40.0, 2.0], ['setting', 50.0, 2.0], ['If', 70.0, 2.0], ['a', 80.0, 2.0], ['to', 100.0, 2.0], ['companies', 110.0, 2.0], ['is', 120.0, 2.0], ['going', 130.0, 2.0], ['to', 140.0, 2.0], ['the', 150.0, 2.0], ["Let's", 160.0, 2.0], ['new', 180.0, 2.0]], 'sports': [['so', 20.0, 2.0], ['had', 30.0, 2.0], ['everything', 40.0, 2.0], ['breakfast', 50.0, 2.0], ['Never', 60.0, 2.0], ['parliament', 70.0, 2.0], ['someone', 90.0, 2.0], ['was', 120.0, 2.0], ['and', 130.0, 2.0], ['Terra', 160.0, 2.0], ['language', 180.0, 2.0]] },
	      concepts_video: [],
	      current_recommendation_style: "magic",
	      broll_thumbnail: { "social": [], "professional": [] },
	      clickedBroll: -1,
	      usertype: "e",
	      uitype: "i",
	      videotype: "dog_adoption",
	      helptext: '<h4>What is my task?</h4><p>You will be given a video of a person talking. You are asked to insert short videos (“B-roll”) to make the video more engaging. The task will consist of you watching the video of the person talking, to select moments where to insert B-roll footage, and to select which B-roll footage to insert. Please insert a total of 8-10 B-roll.</p><h4>How should I edit the video?</h4><p>We will provide you a video editor in the browser. Here is how to use this video editor:</p><h4>Video navigation:</h4><p>A transcript of the video on the right is the main navigation tool. Click on a word in the transcript to go to that position in the video. The blue highlighted text shows you the current position in the video.</p><h4>B-roll search:</h4><p>There is a search interface at the bottom-left that allows you to search for B-roll. You can also right click on a word in the transcript to search for that word in the transcript. The results will show social media style B-roll and professionally shot B-roll video clips. You are free to choose any clip you want for the search term.</p><h4>B-roll insertion:</h4><p>To insert a B-roll, click on the ‘Add Now’ button appearing below the desired B-roll video clip. The B-roll will be added to the current position in the video.</p><h4>B-roll modification:</h4><p>You can move, change the duration, and delete every inserted B-roll. Move it by dragging the thumbnail on a word in the transcript to where you want to move the video. Drag the last word of the B-roll to change the duration. Drag the thumbnail onto the trashcan at the top right to delete the clip.</p>',
	      helptexts: ['<p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 14pt;"><strong><span style="font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">Video navigation:</span></strong></span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">A transcript of the video on the right is the main navigation tool. Click on a word in the transcript to go to that position in the video. </span><span style="font-size: 12pt; font-family: Arial; color: #000000; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">The blue highlighted text shows you the current position in the video. You can also use &lsquo;space&rsquo; to pause/play the video. <br/><img src="tutorial_navigate.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br> You can also right click on a word to search B-Roll with that word. <br/><img src="tutorial_search.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br></span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;">&nbsp;</p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><strong><span style="font-size: 14pt; font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">B-roll modification:</span></strong></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">You can move, change the duration, and delete every inserted B-roll. Move it by dragging the thumbnail on a word in the transcript to where you want to move the video. Drag the last word of the B-roll to change the duration. Drag the thumbnail onto the trashcan at the top right to delete the clip. <br/><img src="tutorial_modify.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br></span></p><p>Click anywhere on this text to hide this text and start the task.</p>', '<p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 14pt;"><strong><span style="font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">Video navigation:</span></strong></span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">A transcript of the video on the right is the main navigation tool. Click on a word in the transcript to go to that position in the video. <br/><img src="tutorial_navigate.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br> </span><span style="font-size: 12pt; font-family: Arial; color: #000000; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">The blue highlighted text shows you the current position in the video. You can also use &lsquo;space&rsquo; to pause/play the video. You can also right click on a word to search B-Roll with that word. <br/><img src="tutorial_search.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br> </span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;">&nbsp;</p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><strong><span style="font-size: 14pt; font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">B-roll modification:</span></strong></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">You can move, change the duration, and delete every inserted B-roll. Move it by dragging the thumbnail on a word in the transcript to where you want to move the video. Drag the last word of the B-roll to change the duration. Drag the thumbnail onto the trashcan at the top right to delete the clip. <br/><img src="tutorial_modify.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br> </span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 14pt;"><strong><span style="font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">B-Roll recommendations:</span></strong></span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">This tool provides you recommendations for where you could insert B-roll, a recommended duration, and a potentially relevant query term. If you like one of the recommended videos, click \'Add Now\' to insert it in the recommended position with the recommended duration. <br/><img src="tutorial_recommend.gif" alt="Navigation Tutorial Image" height="200" width="350"></img></br> </span></p><p>Click anywhere on this text to hide this text and start the task.</p>', '<p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 14pt;"><strong><span style="font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">Video navigation:</span></strong></span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">A timeline below the video is the main navigation tool. Click on a position in the timeline to go to that position in the video. </span><span style="font-size: 12pt; font-family: Arial; color: #000000; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">The blue highlighted line shows you the current position in the video.</span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;">&nbsp;</p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 14pt;"><strong><span style="font-family: Arial; color: #212529; background-color: transparent; font-variant: normal; text-decoration-skip-ink: none; vertical-align: baseline; white-space: pre-wrap;">B-roll modification:</span></strong></span></p><p style="line-height: 1.38; margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 12pt; font-family: Arial; color: #212529; background-color: transparent; font-weight: 400; font-variant: normal; text-decoration: none; vertical-align: baseline; white-space: pre-wrap;">You can move, change the duration, and delete every inserted B-roll. Move it by dragging the highlighted inserted B-Roll in the timeline to where you want to move the video. Drag the end of the B-roll to change the duration. Drag the beginning of the B-Roll onto the trashcan at the top right to delete the clip.</span></p><p>Click anywhere on this text to hide this text and start the task.</p>'],
	      show_helptext: false,
	      v: 0,
	      videotypes: ["video_diary", "aloe_vera", "jeff_introduction", "vlog_competition", "sports", "anxiety", "struggling", "yoga_vibe", "fit_traveler", "economics"],
	      maxindex: 12,
	      num_broll_cached: 30,
	      video_order: [],
	      ui_order: [],
	      instructions_order: [],
	      recommendation_type: '',
	      experiment_index: -1,
	      doing_experiment: false,
	      five_point_likert: ['Strongly Disagree', 'Slightly Disagree', 'Neutral', 'Slightly Agree', 'Strongly Agree'],
	      twenty_scale_low_high: ['Very Low', '2', '3', '4', '5', '6', '7', '8', '9', 'Very High'],
	      twenty_questions: ["How confident are you with editing videos with B-Roll?", "How mentally demanding was the task?", "How physically demanding was the task?", "How hurried or rushed was the pace of the task?", "How successful were you in accomplishing what you were asked to do?", "How hard did you have to work to accomplish your level of performance?", "How insecure, discouraged, stressed and annoyed were you?"],
	      five_questions: ["The video editing tool was generally helpful to edit the video as I was asked to do.", "The video editing tool was helpful with finding relevant B-Roll videos.", "The video editing tool was helpful with editing the starting point of an inserted B-Roll", "The video editing tool was helpful with editing the duration of an inserted B-Roll", "The B-Roll videos that showed up in the search tool were generally relevant.", "The separation of B-Roll videos by categories professional and social media style was helpful"],
	      recommendation_questions: ["The B-Roll position recommendations were generally helpful", "The B-Roll duration recommendations were generally helpful", "The B-Roll content recommendations were generally helpful"],
	      q0_b: 0,
	      showModal: true,
	      in_recommendation_session: false
	    };
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'showModal',
	    value: function showModal() {
	      this.setState({ showModal: true });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.setState({ showModal: false });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var url = new URL(window.location.href);
	      var usertype = url.searchParams.get("u"); //u===user (e===expert,b=beginner)
	      var uitype = url.searchParams.get("c"); //c===condition (b===baseline,i===intelligent,t===timeline)
	      var v = url.searchParams.get("v"); //v===video 1: dog_adoption, 2: economics, 
	      var e = url.searchParams.get("e"); //is this an experiment or not (1=yes)
	      var videotype = "dog_adoption"; //that's the default right now
	
	      generateStockToken(this);
	
	      var words = _dog_adoption_audio2.default.words;
	      if (v) {
	        v = parseInt(v, 10);
	        var transcripts = [_video_diary2.default, _aloe_vera2.default, _jeff_introduction2.default, _vlog_competition2.default, _sports2.default, _anxiety2.default, _struggling2.default, _yoga_vibe2.default, _fit_traveler2.default, _shantanu_trimmed2.default];
	        words = transcripts[v].words;
	        videotype = this.state.videotypes[v];
	        this.setState({ usertype: usertype, uitype: uitype, videotype: videotype, v: v, words: words });
	      } else if (e === '1') {
	        generateRandomizedExperiment(this, usertype);
	      } else {
	        getVideoIndex(this, usertype, uitype);
	      }
	
	      document.addEventListener("keydown", this.spaceFunction(), false);
	      this.setState({ page: 4 });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.spaceFunction(), false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.state.page === 10) {
	        return _react2.default.createElement('div', { className: 'loader top-buffer', style: { textAlign: 'center', marginLeft: '50%' } });
	      } else if (this.state.page === 4 && this.state.uitype === "t") {
	        return _react2.default.createElement(
	          'div',
	          { className: 'App' },
	          _react2.default.createElement(HeaderPanel, { context: this }),
	          this.state.show_helptext ? _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info helpnotification big', role: 'alert' },
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.helptext }, onClick: this.toggleHelptext() })
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid bottom-buffer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row top-buffer' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12 video-renderer border-right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-12' },
	                    _react2.default.createElement(EditingViewBaseline, { context: this })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row top-buffer' },
	                  _react2.default.createElement('div', { className: 'col-2' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-7' },
	                    _react2.default.createElement('input', { className: 'form-control', ref: 'searchInput', id: 'dappname', onChange: this.handleSearchChange(), onKeyPress: this.onKeyPress(), placeholder: 'Search B-roll', value: this.state.searchkey })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-1' },
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: function onClick() {
	                          return _this2.getImagesByQuery();
	                        }, className: 'btn btn-secondary' },
	                      'Search'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row top-buffer bottom-buffer' },
	                  _react2.default.createElement('div', { className: 'col-1' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-10 timeline-renderer border border-dark', style: { width: '100%' } },
	                    _react2.default.createElement(TimelineView, { context: this })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-12' },
	                    this.state.loadingBroll === true ? _react2.default.createElement('div', { className: 'loader top-buffer', style: { textAlign: 'center', marginLeft: '50%' } }) : null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'container' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row top-buffer' },
	                        _react2.default.createElement(
	                          'div',
	                          { key: "first_result", className: 'col-6 bg-light' },
	                          this.state.broll_footage.social.length > 0 ? _react2.default.createElement(
	                            'b',
	                            null,
	                            "Social Media"
	                          ) : null,
	                          _react2.default.createElement(RenderBrollResultIntelligent, { context: this, type: "social" })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { key: "second_result", className: 'col-6' },
	                          this.state.broll_footage.professional.length > 0 ? _react2.default.createElement(
	                            'b',
	                            null,
	                            "Professional"
	                          ) : null,
	                          _react2.default.createElement(RenderBrollResultIntelligent, { context: this, type: "professional" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row top-buffer text-center left-buffer', style: { textAlign: 'center' } },
	                        this.state.broll_footage.social.length > 0 && this.state.maxindex < this.state.broll_footage.social.length ? _react2.default.createElement(
	                          'button',
	                          { onClick: this.showMoreBroll(), className: 'btn btn-secondary' },
	                          'Show More B-Roll'
	                        ) : null
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(FooterPanel, { context: this })
	        );
	      } else if (this.state.page === 4) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'App' },
	          _react2.default.createElement(HeaderPanel, { context: this }),
	          this.state.show_helptext ? _react2.default.createElement(
	            'div',
	            { className: 'alert alert-info helpnotification big', role: 'alert' },
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.helptext }, onClick: this.toggleHelptext() })
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid bottom-buffer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row top-buffer' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-8 video-renderer border-right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-12' },
	                    _react2.default.createElement(EditingViewBaseline, { context: this })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row top-buffer' },
	                  _react2.default.createElement('div', { className: 'col-2' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-7' },
	                    _react2.default.createElement('input', { className: 'form-control', ref: 'searchInput', id: 'dappname', onChange: this.handleSearchChange(), onKeyPress: this.onKeyPress(), placeholder: 'Search B-roll', value: this.state.searchkey })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-1' },
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: function onClick() {
	                          return _this2.getImagesByQuery();
	                        }, className: 'btn btn-secondary' },
	                      'Search'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-12' },
	                    this.state.loadingBroll === true ? _react2.default.createElement('div', { className: 'loader top-buffer', style: { textAlign: 'center', marginLeft: '50%' } }) : null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'container' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row top-buffer' },
	                        _react2.default.createElement(
	                          'div',
	                          { key: "first_result", className: 'col-12 bg-light' },
	                          _react2.default.createElement(RenderBrollResultIntelligent, { context: this, type: "social" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'row top-buffer text-center left-buffer', style: { textAlign: 'center' } },
	                        this.state.broll_footage.social.length > 0 && this.state.maxindex < this.state.broll_footage.social.length ? _react2.default.createElement(
	                          'button',
	                          { onClick: this.showMoreBroll(), className: 'btn btn-secondary' },
	                          'Show More B-Roll'
	                        ) : null
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-4 overflow-me' },
	                _react2.default.createElement(_reactTooltip2.default, null),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'transcript-renderer text-justify absolute-fix', id: 'transcript-renderer' },
	                  _react2.default.createElement(TranscriptViewVeryIntelligent, { context: this })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(FooterPanel, { context: this })
	        );
	        /*
	                            {this.state.broll_footage.social.length > 0 ? <b>{"Social Media"}</b> : null}
	          
	                          <div key={"second_result"} className="col-6">
	                            {this.state.broll_footage.professional.length > 0 ? <b>{"Professional"}</b> : null}
	                            <RenderBrollResultIntelligent context={this} type={"professional"} />
	                          </div>
	        */
	      } else if (this.state.page === 5) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'App' },
	          _react2.default.createElement(HeaderPanel, { context: this }),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Done, you can close this window now. Thanks for participating!'
	          ),
	          _react2.default.createElement(FooterPanel, { context: this })
	        );
	      } else if (this.state.page === 6) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'App' },
	          _react2.default.createElement(HeaderPanel, { context: this }),
	          _react2.default.createElement(
	            'div',
	            { className: 'container overflow-me always-scrollbar', key: this.state.experiment_index + "_q_container" },
	            _react2.default.createElement(
	              'h4',
	              { className: 'bottom-buffer' },
	              'Please answer the following questions about the task you just finished:'
	            ),
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this.goToNextExperimentPage() },
	              _react2.default.createElement(
	                'h5',
	                { className: '' },
	                'Video related:'
	              ),
	              _react2.default.createElement(Likert, { question: 'I am generally satisfied with the video that I created', name: 'qv', labels: this.state.five_point_likert, context: this }),
	              _react2.default.createElement(
	                'h5',
	                { className: '' },
	                'Task related:'
	              ),
	              this.state.twenty_questions.map(function (question, idx) {
	                return _react2.default.createElement(Likert, { question: question, name: 'q' + idx, labels: _this2.state.twenty_scale_low_high, context: _this2 });
	              }),
	              _react2.default.createElement(
	                'h5',
	                { className: '' },
	                'Tool related:'
	              ),
	              this.state.five_questions.map(function (question, idx) {
	                return _react2.default.createElement(Likert, { question: question, name: 'q' + (idx + _this2.state.twenty_questions.length), labels: _this2.state.five_point_likert, context: _this2 });
	              }),
	              _react2.default.createElement(RecommendationQuestions, { context: this }),
	              _react2.default.createElement(
	                'h5',
	                { className: '' },
	                'General:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'comment1' },
	                  'Was there anything that you wanted to do with the tool but couldnt do?'
	                ),
	                _react2.default.createElement('textarea', { className: 'form-control', rows: '2', id: 'comment1', name: 'qq1' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'comment2' },
	                  'Additional comments or suggestions:'
	                ),
	                _react2.default.createElement('textarea', { className: 'form-control', rows: '2', id: 'comment2', name: 'qq2' })
	              ),
	              _react2.default.createElement('input', { type: 'submit', id: 'submit-form', hidden: true }),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'submit', className: 'btn btn-primary' },
	                    'Done With Survey and Next'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(FooterPanel, { context: this })
	        );
	      } else if (this.state.page === 7) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'App' },
	          _react2.default.createElement(HeaderPanel, { context: this }),
	          _react2.default.createElement(
	            'div',
	            { className: 'container overflow-me always-scrollbar' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'bottom-buffer' },
	              'Please answer the following questions before you start:'
	            ),
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this.submitGeneralSurvey() },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'age' },
	                  'Age:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-control', id: 'age', name: 'age' },
	                  [''].concat(Array.from({ length: 99 }, function (v, k) {
	                    return k + 1;
	                  })).map(function (age, idx) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: idx + "_age" },
	                      idx === 0 ? '' : idx
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group text-center' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'gender' },
	                  'Gender:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-control', id: 'gender', name: 'gender' },
	                  ['', 'Female', 'Male', 'Non-Binary'].map(function (gender, idx) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: idx + "_gender" },
	                      gender
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(Likert, { question: 'Compared to your friends and family, how good are you at editing videos?', name: 'skill', labels: ['Much Worse', 'Slightly Worse', 'Similar', 'Slightly Better', 'Much Better'], context: this }),
	              _react2.default.createElement(Likert, { question: 'How confident are you at editing videos with B-Roll?', name: 'q0_b', labels: this.state.twenty_scale_low_high, context: this }),
	              _react2.default.createElement('input', { type: 'submit', id: 'submit-form', hidden: true }),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-12' },
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'submit', className: 'btn btn-primary' },
	                    'Start First Task'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(FooterPanel, { context: this })
	        );
	      } else {
	        //Compared to your friends and family, how good are you at editing videos? [much worse - much better]
	        return null;
	      }
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(7);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(11);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(16);
	
	__webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	  * Bootstrap v4.1.1 (https://getbootstrap.com/)
	  * Copyright 2011-2018 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
	  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	  */
	!function(t,e){ true?e(exports,__webpack_require__(6),__webpack_require__(34)):"function"==typeof define&&define.amd?define(["exports","jquery","popper.js"],e):e(t.bootstrap={},t.jQuery,t.Popper)}(this,function(t,e,c){"use strict";function i(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function o(t,e,n){return e&&i(t.prototype,e),n&&i(t,n),t}function h(r){for(var t=1;t<arguments.length;t++){var s=null!=arguments[t]?arguments[t]:{},e=Object.keys(s);"function"==typeof Object.getOwnPropertySymbols&&(e=e.concat(Object.getOwnPropertySymbols(s).filter(function(t){return Object.getOwnPropertyDescriptor(s,t).enumerable}))),e.forEach(function(t){var e,n,i;e=r,i=s[n=t],n in e?Object.defineProperty(e,n,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[n]=i})}return r}e=e&&e.hasOwnProperty("default")?e.default:e,c=c&&c.hasOwnProperty("default")?c.default:c;var r,n,s,a,l,u,f,d,_,g,m,p,v,E,y,T,C,I,A,D,b,S,w,N,O,k,P,L,j,R,H,W,M,x,U,K,F,V,Q,B,Y,G,q,z,X,J,Z,$,tt,et,nt,it,rt,st,ot,at,lt,ht,ct,ut,ft,dt,_t,gt,mt,pt,vt,Et,yt,Tt,Ct,It,At,Dt,bt,St,wt,Nt,Ot,kt,Pt,Lt,jt,Rt,Ht,Wt,Mt,xt,Ut,Kt,Ft,Vt,Qt,Bt,Yt,Gt,qt,zt,Xt,Jt,Zt,$t,te,ee,ne,ie,re,se,oe,ae,le,he,ce,ue,fe,de,_e,ge,me,pe,ve,Ee,ye,Te,Ce,Ie,Ae,De,be,Se,we,Ne,Oe,ke,Pe,Le,je,Re,He,We,Me,xe,Ue,Ke,Fe,Ve,Qe,Be,Ye,Ge,qe,ze,Xe,Je,Ze,$e,tn,en,nn,rn,sn,on,an,ln,hn,cn,un,fn,dn,_n,gn,mn,pn,vn,En,yn,Tn,Cn=function(i){var e="transitionend";function t(t){var e=this,n=!1;return i(this).one(l.TRANSITION_END,function(){n=!0}),setTimeout(function(){n||l.triggerTransitionEnd(e)},t),this}var l={TRANSITION_END:"bsTransitionEnd",getUID:function(t){for(;t+=~~(1e6*Math.random()),document.getElementById(t););return t},getSelectorFromElement:function(t){var e=t.getAttribute("data-target");e&&"#"!==e||(e=t.getAttribute("href")||"");try{return 0<i(document).find(e).length?e:null}catch(t){return null}},getTransitionDurationFromElement:function(t){if(!t)return 0;var e=i(t).css("transition-duration");return parseFloat(e)?(e=e.split(",")[0],1e3*parseFloat(e)):0},reflow:function(t){return t.offsetHeight},triggerTransitionEnd:function(t){i(t).trigger(e)},supportsTransitionEnd:function(){return Boolean(e)},isElement:function(t){return(t[0]||t).nodeType},typeCheckConfig:function(t,e,n){for(var i in n)if(Object.prototype.hasOwnProperty.call(n,i)){var r=n[i],s=e[i],o=s&&l.isElement(s)?"element":(a=s,{}.toString.call(a).match(/\s([a-z]+)/i)[1].toLowerCase());if(!new RegExp(r).test(o))throw new Error(t.toUpperCase()+': Option "'+i+'" provided type "'+o+'" but expected type "'+r+'".')}var a}};return i.fn.emulateTransitionEnd=t,i.event.special[l.TRANSITION_END]={bindType:e,delegateType:e,handle:function(t){if(i(t.target).is(this))return t.handleObj.handler.apply(this,arguments)}},l}(e),In=(n="alert",a="."+(s="bs.alert"),l=(r=e).fn[n],u={CLOSE:"close"+a,CLOSED:"closed"+a,CLICK_DATA_API:"click"+a+".data-api"},f="alert",d="fade",_="show",g=function(){function i(t){this._element=t}var t=i.prototype;return t.close=function(t){var e=this._element;t&&(e=this._getRootElement(t)),this._triggerCloseEvent(e).isDefaultPrevented()||this._removeElement(e)},t.dispose=function(){r.removeData(this._element,s),this._element=null},t._getRootElement=function(t){var e=Cn.getSelectorFromElement(t),n=!1;return e&&(n=r(e)[0]),n||(n=r(t).closest("."+f)[0]),n},t._triggerCloseEvent=function(t){var e=r.Event(u.CLOSE);return r(t).trigger(e),e},t._removeElement=function(e){var n=this;if(r(e).removeClass(_),r(e).hasClass(d)){var t=Cn.getTransitionDurationFromElement(e);r(e).one(Cn.TRANSITION_END,function(t){return n._destroyElement(e,t)}).emulateTransitionEnd(t)}else this._destroyElement(e)},t._destroyElement=function(t){r(t).detach().trigger(u.CLOSED).remove()},i._jQueryInterface=function(n){return this.each(function(){var t=r(this),e=t.data(s);e||(e=new i(this),t.data(s,e)),"close"===n&&e[n](this)})},i._handleDismiss=function(e){return function(t){t&&t.preventDefault(),e.close(this)}},o(i,null,[{key:"VERSION",get:function(){return"4.1.1"}}]),i}(),r(document).on(u.CLICK_DATA_API,'[data-dismiss="alert"]',g._handleDismiss(new g)),r.fn[n]=g._jQueryInterface,r.fn[n].Constructor=g,r.fn[n].noConflict=function(){return r.fn[n]=l,g._jQueryInterface},g),An=(p="button",E="."+(v="bs.button"),y=".data-api",T=(m=e).fn[p],C="active",I="btn",D='[data-toggle^="button"]',b='[data-toggle="buttons"]',S="input",w=".active",N=".btn",O={CLICK_DATA_API:"click"+E+y,FOCUS_BLUR_DATA_API:(A="focus")+E+y+" blur"+E+y},k=function(){function n(t){this._element=t}var t=n.prototype;return t.toggle=function(){var t=!0,e=!0,n=m(this._element).closest(b)[0];if(n){var i=m(this._element).find(S)[0];if(i){if("radio"===i.type)if(i.checked&&m(this._element).hasClass(C))t=!1;else{var r=m(n).find(w)[0];r&&m(r).removeClass(C)}if(t){if(i.hasAttribute("disabled")||n.hasAttribute("disabled")||i.classList.contains("disabled")||n.classList.contains("disabled"))return;i.checked=!m(this._element).hasClass(C),m(i).trigger("change")}i.focus(),e=!1}}e&&this._element.setAttribute("aria-pressed",!m(this._element).hasClass(C)),t&&m(this._element).toggleClass(C)},t.dispose=function(){m.removeData(this._element,v),this._element=null},n._jQueryInterface=function(e){return this.each(function(){var t=m(this).data(v);t||(t=new n(this),m(this).data(v,t)),"toggle"===e&&t[e]()})},o(n,null,[{key:"VERSION",get:function(){return"4.1.1"}}]),n}(),m(document).on(O.CLICK_DATA_API,D,function(t){t.preventDefault();var e=t.target;m(e).hasClass(I)||(e=m(e).closest(N)),k._jQueryInterface.call(m(e),"toggle")}).on(O.FOCUS_BLUR_DATA_API,D,function(t){var e=m(t.target).closest(N)[0];m(e).toggleClass(A,/^focus(in)?$/.test(t.type))}),m.fn[p]=k._jQueryInterface,m.fn[p].Constructor=k,m.fn[p].noConflict=function(){return m.fn[p]=T,k._jQueryInterface},k),Dn=(L="carousel",R="."+(j="bs.carousel"),H=".data-api",W=(P=e).fn[L],M={interval:5e3,keyboard:!0,slide:!1,pause:"hover",wrap:!0},x={interval:"(number|boolean)",keyboard:"boolean",slide:"(boolean|string)",pause:"(string|boolean)",wrap:"boolean"},U="next",K="prev",F="left",V="right",Q={SLIDE:"slide"+R,SLID:"slid"+R,KEYDOWN:"keydown"+R,MOUSEENTER:"mouseenter"+R,MOUSELEAVE:"mouseleave"+R,TOUCHEND:"touchend"+R,LOAD_DATA_API:"load"+R+H,CLICK_DATA_API:"click"+R+H},B="carousel",Y="active",G="slide",q="carousel-item-right",z="carousel-item-left",X="carousel-item-next",J="carousel-item-prev",Z={ACTIVE:".active",ACTIVE_ITEM:".active.carousel-item",ITEM:".carousel-item",NEXT_PREV:".carousel-item-next, .carousel-item-prev",INDICATORS:".carousel-indicators",DATA_SLIDE:"[data-slide], [data-slide-to]",DATA_RIDE:'[data-ride="carousel"]'},$=function(){function s(t,e){this._items=null,this._interval=null,this._activeElement=null,this._isPaused=!1,this._isSliding=!1,this.touchTimeout=null,this._config=this._getConfig(e),this._element=P(t)[0],this._indicatorsElement=P(this._element).find(Z.INDICATORS)[0],this._addEventListeners()}var t=s.prototype;return t.next=function(){this._isSliding||this._slide(U)},t.nextWhenVisible=function(){!document.hidden&&P(this._element).is(":visible")&&"hidden"!==P(this._element).css("visibility")&&this.next()},t.prev=function(){this._isSliding||this._slide(K)},t.pause=function(t){t||(this._isPaused=!0),P(this._element).find(Z.NEXT_PREV)[0]&&(Cn.triggerTransitionEnd(this._element),this.cycle(!0)),clearInterval(this._interval),this._interval=null},t.cycle=function(t){t||(this._isPaused=!1),this._interval&&(clearInterval(this._interval),this._interval=null),this._config.interval&&!this._isPaused&&(this._interval=setInterval((document.visibilityState?this.nextWhenVisible:this.next).bind(this),this._config.interval))},t.to=function(t){var e=this;this._activeElement=P(this._element).find(Z.ACTIVE_ITEM)[0];var n=this._getItemIndex(this._activeElement);if(!(t>this._items.length-1||t<0))if(this._isSliding)P(this._element).one(Q.SLID,function(){return e.to(t)});else{if(n===t)return this.pause(),void this.cycle();var i=n<t?U:K;this._slide(i,this._items[t])}},t.dispose=function(){P(this._element).off(R),P.removeData(this._element,j),this._items=null,this._config=null,this._element=null,this._interval=null,this._isPaused=null,this._isSliding=null,this._activeElement=null,this._indicatorsElement=null},t._getConfig=function(t){return t=h({},M,t),Cn.typeCheckConfig(L,t,x),t},t._addEventListeners=function(){var e=this;this._config.keyboard&&P(this._element).on(Q.KEYDOWN,function(t){return e._keydown(t)}),"hover"===this._config.pause&&(P(this._element).on(Q.MOUSEENTER,function(t){return e.pause(t)}).on(Q.MOUSELEAVE,function(t){return e.cycle(t)}),"ontouchstart"in document.documentElement&&P(this._element).on(Q.TOUCHEND,function(){e.pause(),e.touchTimeout&&clearTimeout(e.touchTimeout),e.touchTimeout=setTimeout(function(t){return e.cycle(t)},500+e._config.interval)}))},t._keydown=function(t){if(!/input|textarea/i.test(t.target.tagName))switch(t.which){case 37:t.preventDefault(),this.prev();break;case 39:t.preventDefault(),this.next()}},t._getItemIndex=function(t){return this._items=P.makeArray(P(t).parent().find(Z.ITEM)),this._items.indexOf(t)},t._getItemByDirection=function(t,e){var n=t===U,i=t===K,r=this._getItemIndex(e),s=this._items.length-1;if((i&&0===r||n&&r===s)&&!this._config.wrap)return e;var o=(r+(t===K?-1:1))%this._items.length;return-1===o?this._items[this._items.length-1]:this._items[o]},t._triggerSlideEvent=function(t,e){var n=this._getItemIndex(t),i=this._getItemIndex(P(this._element).find(Z.ACTIVE_ITEM)[0]),r=P.Event(Q.SLIDE,{relatedTarget:t,direction:e,from:i,to:n});return P(this._element).trigger(r),r},t._setActiveIndicatorElement=function(t){if(this._indicatorsElement){P(this._indicatorsElement).find(Z.ACTIVE).removeClass(Y);var e=this._indicatorsElement.children[this._getItemIndex(t)];e&&P(e).addClass(Y)}},t._slide=function(t,e){var n,i,r,s=this,o=P(this._element).find(Z.ACTIVE_ITEM)[0],a=this._getItemIndex(o),l=e||o&&this._getItemByDirection(t,o),h=this._getItemIndex(l),c=Boolean(this._interval);if(t===U?(n=z,i=X,r=F):(n=q,i=J,r=V),l&&P(l).hasClass(Y))this._isSliding=!1;else if(!this._triggerSlideEvent(l,r).isDefaultPrevented()&&o&&l){this._isSliding=!0,c&&this.pause(),this._setActiveIndicatorElement(l);var u=P.Event(Q.SLID,{relatedTarget:l,direction:r,from:a,to:h});if(P(this._element).hasClass(G)){P(l).addClass(i),Cn.reflow(l),P(o).addClass(n),P(l).addClass(n);var f=Cn.getTransitionDurationFromElement(o);P(o).one(Cn.TRANSITION_END,function(){P(l).removeClass(n+" "+i).addClass(Y),P(o).removeClass(Y+" "+i+" "+n),s._isSliding=!1,setTimeout(function(){return P(s._element).trigger(u)},0)}).emulateTransitionEnd(f)}else P(o).removeClass(Y),P(l).addClass(Y),this._isSliding=!1,P(this._element).trigger(u);c&&this.cycle()}},s._jQueryInterface=function(i){return this.each(function(){var t=P(this).data(j),e=h({},M,P(this).data());"object"==typeof i&&(e=h({},e,i));var n="string"==typeof i?i:e.slide;if(t||(t=new s(this,e),P(this).data(j,t)),"number"==typeof i)t.to(i);else if("string"==typeof n){if("undefined"==typeof t[n])throw new TypeError('No method named "'+n+'"');t[n]()}else e.interval&&(t.pause(),t.cycle())})},s._dataApiClickHandler=function(t){var e=Cn.getSelectorFromElement(this);if(e){var n=P(e)[0];if(n&&P(n).hasClass(B)){var i=h({},P(n).data(),P(this).data()),r=this.getAttribute("data-slide-to");r&&(i.interval=!1),s._jQueryInterface.call(P(n),i),r&&P(n).data(j).to(r),t.preventDefault()}}},o(s,null,[{key:"VERSION",get:function(){return"4.1.1"}},{key:"Default",get:function(){return M}}]),s}(),P(document).on(Q.CLICK_DATA_API,Z.DATA_SLIDE,$._dataApiClickHandler),P(window).on(Q.LOAD_DATA_API,function(){P(Z.DATA_RIDE).each(function(){var t=P(this);$._jQueryInterface.call(t,t.data())})}),P.fn[L]=$._jQueryInterface,P.fn[L].Constructor=$,P.fn[L].noConflict=function(){return P.fn[L]=W,$._jQueryInterface},$),bn=(et="collapse",it="."+(nt="bs.collapse"),rt=(tt=e).fn[et],st={toggle:!0,parent:""},ot={toggle:"boolean",parent:"(string|element)"},at={SHOW:"show"+it,SHOWN:"shown"+it,HIDE:"hide"+it,HIDDEN:"hidden"+it,CLICK_DATA_API:"click"+it+".data-api"},lt="show",ht="collapse",ct="collapsing",ut="collapsed",ft="width",dt="height",_t={ACTIVES:".show, .collapsing",DATA_TOGGLE:'[data-toggle="collapse"]'},gt=function(){function a(t,e){this._isTransitioning=!1,this._element=t,this._config=this._getConfig(e),this._triggerArray=tt.makeArray(tt('[data-toggle="collapse"][href="#'+t.id+'"],[data-toggle="collapse"][data-target="#'+t.id+'"]'));for(var n=tt(_t.DATA_TOGGLE),i=0;i<n.length;i++){var r=n[i],s=Cn.getSelectorFromElement(r);null!==s&&0<tt(s).filter(t).length&&(this._selector=s,this._triggerArray.push(r))}this._parent=this._config.parent?this._getParent():null,this._config.parent||this._addAriaAndCollapsedClass(this._element,this._triggerArray),this._config.toggle&&this.toggle()}var t=a.prototype;return t.toggle=function(){tt(this._element).hasClass(lt)?this.hide():this.show()},t.show=function(){var t,e,n=this;if(!this._isTransitioning&&!tt(this._element).hasClass(lt)&&(this._parent&&0===(t=tt.makeArray(tt(this._parent).find(_t.ACTIVES).filter('[data-parent="'+this._config.parent+'"]'))).length&&(t=null),!(t&&(e=tt(t).not(this._selector).data(nt))&&e._isTransitioning))){var i=tt.Event(at.SHOW);if(tt(this._element).trigger(i),!i.isDefaultPrevented()){t&&(a._jQueryInterface.call(tt(t).not(this._selector),"hide"),e||tt(t).data(nt,null));var r=this._getDimension();tt(this._element).removeClass(ht).addClass(ct),(this._element.style[r]=0)<this._triggerArray.length&&tt(this._triggerArray).removeClass(ut).attr("aria-expanded",!0),this.setTransitioning(!0);var s="scroll"+(r[0].toUpperCase()+r.slice(1)),o=Cn.getTransitionDurationFromElement(this._element);tt(this._element).one(Cn.TRANSITION_END,function(){tt(n._element).removeClass(ct).addClass(ht).addClass(lt),n._element.style[r]="",n.setTransitioning(!1),tt(n._element).trigger(at.SHOWN)}).emulateTransitionEnd(o),this._element.style[r]=this._element[s]+"px"}}},t.hide=function(){var t=this;if(!this._isTransitioning&&tt(this._element).hasClass(lt)){var e=tt.Event(at.HIDE);if(tt(this._element).trigger(e),!e.isDefaultPrevented()){var n=this._getDimension();if(this._element.style[n]=this._element.getBoundingClientRect()[n]+"px",Cn.reflow(this._element),tt(this._element).addClass(ct).removeClass(ht).removeClass(lt),0<this._triggerArray.length)for(var i=0;i<this._triggerArray.length;i++){var r=this._triggerArray[i],s=Cn.getSelectorFromElement(r);if(null!==s)tt(s).hasClass(lt)||tt(r).addClass(ut).attr("aria-expanded",!1)}this.setTransitioning(!0);this._element.style[n]="";var o=Cn.getTransitionDurationFromElement(this._element);tt(this._element).one(Cn.TRANSITION_END,function(){t.setTransitioning(!1),tt(t._element).removeClass(ct).addClass(ht).trigger(at.HIDDEN)}).emulateTransitionEnd(o)}}},t.setTransitioning=function(t){this._isTransitioning=t},t.dispose=function(){tt.removeData(this._element,nt),this._config=null,this._parent=null,this._element=null,this._triggerArray=null,this._isTransitioning=null},t._getConfig=function(t){return(t=h({},st,t)).toggle=Boolean(t.toggle),Cn.typeCheckConfig(et,t,ot),t},t._getDimension=function(){return tt(this._element).hasClass(ft)?ft:dt},t._getParent=function(){var n=this,t=null;Cn.isElement(this._config.parent)?(t=this._config.parent,"undefined"!=typeof this._config.parent.jquery&&(t=this._config.parent[0])):t=tt(this._config.parent)[0];var e='[data-toggle="collapse"][data-parent="'+this._config.parent+'"]';return tt(t).find(e).each(function(t,e){n._addAriaAndCollapsedClass(a._getTargetFromElement(e),[e])}),t},t._addAriaAndCollapsedClass=function(t,e){if(t){var n=tt(t).hasClass(lt);0<e.length&&tt(e).toggleClass(ut,!n).attr("aria-expanded",n)}},a._getTargetFromElement=function(t){var e=Cn.getSelectorFromElement(t);return e?tt(e)[0]:null},a._jQueryInterface=function(i){return this.each(function(){var t=tt(this),e=t.data(nt),n=h({},st,t.data(),"object"==typeof i&&i?i:{});if(!e&&n.toggle&&/show|hide/.test(i)&&(n.toggle=!1),e||(e=new a(this,n),t.data(nt,e)),"string"==typeof i){if("undefined"==typeof e[i])throw new TypeError('No method named "'+i+'"');e[i]()}})},o(a,null,[{key:"VERSION",get:function(){return"4.1.1"}},{key:"Default",get:function(){return st}}]),a}(),tt(document).on(at.CLICK_DATA_API,_t.DATA_TOGGLE,function(t){"A"===t.currentTarget.tagName&&t.preventDefault();var n=tt(this),e=Cn.getSelectorFromElement(this);tt(e).each(function(){var t=tt(this),e=t.data(nt)?"toggle":n.data();gt._jQueryInterface.call(t,e)})}),tt.fn[et]=gt._jQueryInterface,tt.fn[et].Constructor=gt,tt.fn[et].noConflict=function(){return tt.fn[et]=rt,gt._jQueryInterface},gt),Sn=(pt="dropdown",Et="."+(vt="bs.dropdown"),yt=".data-api",Tt=(mt=e).fn[pt],Ct=new RegExp("38|40|27"),It={HIDE:"hide"+Et,HIDDEN:"hidden"+Et,SHOW:"show"+Et,SHOWN:"shown"+Et,CLICK:"click"+Et,CLICK_DATA_API:"click"+Et+yt,KEYDOWN_DATA_API:"keydown"+Et+yt,KEYUP_DATA_API:"keyup"+Et+yt},At="disabled",Dt="show",bt="dropup",St="dropright",wt="dropleft",Nt="dropdown-menu-right",Ot="position-static",kt='[data-toggle="dropdown"]',Pt=".dropdown form",Lt=".dropdown-menu",jt=".navbar-nav",Rt=".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)",Ht="top-start",Wt="top-end",Mt="bottom-start",xt="bottom-end",Ut="right-start",Kt="left-start",Ft={offset:0,flip:!0,boundary:"scrollParent",reference:"toggle",display:"dynamic"},Vt={offset:"(number|string|function)",flip:"boolean",boundary:"(string|element)",reference:"(string|element)",display:"string"},Qt=function(){function l(t,e){this._element=t,this._popper=null,this._config=this._getConfig(e),this._menu=this._getMenuElement(),this._inNavbar=this._detectNavbar(),this._addEventListeners()}var t=l.prototype;return t.toggle=function(){if(!this._element.disabled&&!mt(this._element).hasClass(At)){var t=l._getParentFromElement(this._element),e=mt(this._menu).hasClass(Dt);if(l._clearMenus(),!e){var n={relatedTarget:this._element},i=mt.Event(It.SHOW,n);if(mt(t).trigger(i),!i.isDefaultPrevented()){if(!this._inNavbar){if("undefined"==typeof c)throw new TypeError("Bootstrap dropdown require Popper.js (https://popper.js.org)");var r=this._element;"parent"===this._config.reference?r=t:Cn.isElement(this._config.reference)&&(r=this._config.reference,"undefined"!=typeof this._config.reference.jquery&&(r=this._config.reference[0])),"scrollParent"!==this._config.boundary&&mt(t).addClass(Ot),this._popper=new c(r,this._menu,this._getPopperConfig())}"ontouchstart"in document.documentElement&&0===mt(t).closest(jt).length&&mt(document.body).children().on("mouseover",null,mt.noop),this._element.focus(),this._element.setAttribute("aria-expanded",!0),mt(this._menu).toggleClass(Dt),mt(t).toggleClass(Dt).trigger(mt.Event(It.SHOWN,n))}}}},t.dispose=function(){mt.removeData(this._element,vt),mt(this._element).off(Et),this._element=null,(this._menu=null)!==this._popper&&(this._popper.destroy(),this._popper=null)},t.update=function(){this._inNavbar=this._detectNavbar(),null!==this._popper&&this._popper.scheduleUpdate()},t._addEventListeners=function(){var e=this;mt(this._element).on(It.CLICK,function(t){t.preventDefault(),t.stopPropagation(),e.toggle()})},t._getConfig=function(t){return t=h({},this.constructor.Default,mt(this._element).data(),t),Cn.typeCheckConfig(pt,t,this.constructor.DefaultType),t},t._getMenuElement=function(){if(!this._menu){var t=l._getParentFromElement(this._element);this._menu=mt(t).find(Lt)[0]}return this._menu},t._getPlacement=function(){var t=mt(this._element).parent(),e=Mt;return t.hasClass(bt)?(e=Ht,mt(this._menu).hasClass(Nt)&&(e=Wt)):t.hasClass(St)?e=Ut:t.hasClass(wt)?e=Kt:mt(this._menu).hasClass(Nt)&&(e=xt),e},t._detectNavbar=function(){return 0<mt(this._element).closest(".navbar").length},t._getPopperConfig=function(){var e=this,t={};"function"==typeof this._config.offset?t.fn=function(t){return t.offsets=h({},t.offsets,e._config.offset(t.offsets)||{}),t}:t.offset=this._config.offset;var n={placement:this._getPlacement(),modifiers:{offset:t,flip:{enabled:this._config.flip},preventOverflow:{boundariesElement:this._config.boundary}}};return"static"===this._config.display&&(n.modifiers.applyStyle={enabled:!1}),n},l._jQueryInterface=function(e){return this.each(function(){var t=mt(this).data(vt);if(t||(t=new l(this,"object"==typeof e?e:null),mt(this).data(vt,t)),"string"==typeof e){if("undefined"==typeof t[e])throw new TypeError('No method named "'+e+'"');t[e]()}})},l._clearMenus=function(t){if(!t||3!==t.which&&("keyup"!==t.type||9===t.which))for(var e=mt.makeArray(mt(kt)),n=0;n<e.length;n++){var i=l._getParentFromElement(e[n]),r=mt(e[n]).data(vt),s={relatedTarget:e[n]};if(r){var o=r._menu;if(mt(i).hasClass(Dt)&&!(t&&("click"===t.type&&/input|textarea/i.test(t.target.tagName)||"keyup"===t.type&&9===t.which)&&mt.contains(i,t.target))){var a=mt.Event(It.HIDE,s);mt(i).trigger(a),a.isDefaultPrevented()||("ontouchstart"in document.documentElement&&mt(document.body).children().off("mouseover",null,mt.noop),e[n].setAttribute("aria-expanded","false"),mt(o).removeClass(Dt),mt(i).removeClass(Dt).trigger(mt.Event(It.HIDDEN,s)))}}}},l._getParentFromElement=function(t){var e,n=Cn.getSelectorFromElement(t);return n&&(e=mt(n)[0]),e||t.parentNode},l._dataApiKeydownHandler=function(t){if((/input|textarea/i.test(t.target.tagName)?!(32===t.which||27!==t.which&&(40!==t.which&&38!==t.which||mt(t.target).closest(Lt).length)):Ct.test(t.which))&&(t.preventDefault(),t.stopPropagation(),!this.disabled&&!mt(this).hasClass(At))){var e=l._getParentFromElement(this),n=mt(e).hasClass(Dt);if((n||27===t.which&&32===t.which)&&(!n||27!==t.which&&32!==t.which)){var i=mt(e).find(Rt).get();if(0!==i.length){var r=i.indexOf(t.target);38===t.which&&0<r&&r--,40===t.which&&r<i.length-1&&r++,r<0&&(r=0),i[r].focus()}}else{if(27===t.which){var s=mt(e).find(kt)[0];mt(s).trigger("focus")}mt(this).trigger("click")}}},o(l,null,[{key:"VERSION",get:function(){return"4.1.1"}},{key:"Default",get:function(){return Ft}},{key:"DefaultType",get:function(){return Vt}}]),l}(),mt(document).on(It.KEYDOWN_DATA_API,kt,Qt._dataApiKeydownHandler).on(It.KEYDOWN_DATA_API,Lt,Qt._dataApiKeydownHandler).on(It.CLICK_DATA_API+" "+It.KEYUP_DATA_API,Qt._clearMenus).on(It.CLICK_DATA_API,kt,function(t){t.preventDefault(),t.stopPropagation(),Qt._jQueryInterface.call(mt(this),"toggle")}).on(It.CLICK_DATA_API,Pt,function(t){t.stopPropagation()}),mt.fn[pt]=Qt._jQueryInterface,mt.fn[pt].Constructor=Qt,mt.fn[pt].noConflict=function(){return mt.fn[pt]=Tt,Qt._jQueryInterface},Qt),wn=(Yt="modal",qt="."+(Gt="bs.modal"),zt=(Bt=e).fn[Yt],Xt={backdrop:!0,keyboard:!0,focus:!0,show:!0},Jt={backdrop:"(boolean|string)",keyboard:"boolean",focus:"boolean",show:"boolean"},Zt={HIDE:"hide"+qt,HIDDEN:"hidden"+qt,SHOW:"show"+qt,SHOWN:"shown"+qt,FOCUSIN:"focusin"+qt,RESIZE:"resize"+qt,CLICK_DISMISS:"click.dismiss"+qt,KEYDOWN_DISMISS:"keydown.dismiss"+qt,MOUSEUP_DISMISS:"mouseup.dismiss"+qt,MOUSEDOWN_DISMISS:"mousedown.dismiss"+qt,CLICK_DATA_API:"click"+qt+".data-api"},$t="modal-scrollbar-measure",te="modal-backdrop",ee="modal-open",ne="fade",ie="show",re={DIALOG:".modal-dialog",DATA_TOGGLE:'[data-toggle="modal"]',DATA_DISMISS:'[data-dismiss="modal"]',FIXED_CONTENT:".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",STICKY_CONTENT:".sticky-top",NAVBAR_TOGGLER:".navbar-toggler"},se=function(){function r(t,e){this._config=this._getConfig(e),this._element=t,this._dialog=Bt(t).find(re.DIALOG)[0],this._backdrop=null,this._isShown=!1,this._isBodyOverflowing=!1,this._ignoreBackdropClick=!1,this._scrollbarWidth=0}var t=r.prototype;return t.toggle=function(t){return this._isShown?this.hide():this.show(t)},t.show=function(t){var e=this;if(!this._isTransitioning&&!this._isShown){Bt(this._element).hasClass(ne)&&(this._isTransitioning=!0);var n=Bt.Event(Zt.SHOW,{relatedTarget:t});Bt(this._element).trigger(n),this._isShown||n.isDefaultPrevented()||(this._isShown=!0,this._checkScrollbar(),this._setScrollbar(),this._adjustDialog(),Bt(document.body).addClass(ee),this._setEscapeEvent(),this._setResizeEvent(),Bt(this._element).on(Zt.CLICK_DISMISS,re.DATA_DISMISS,function(t){return e.hide(t)}),Bt(this._dialog).on(Zt.MOUSEDOWN_DISMISS,function(){Bt(e._element).one(Zt.MOUSEUP_DISMISS,function(t){Bt(t.target).is(e._element)&&(e._ignoreBackdropClick=!0)})}),this._showBackdrop(function(){return e._showElement(t)}))}},t.hide=function(t){var e=this;if(t&&t.preventDefault(),!this._isTransitioning&&this._isShown){var n=Bt.Event(Zt.HIDE);if(Bt(this._element).trigger(n),this._isShown&&!n.isDefaultPrevented()){this._isShown=!1;var i=Bt(this._element).hasClass(ne);if(i&&(this._isTransitioning=!0),this._setEscapeEvent(),this._setResizeEvent(),Bt(document).off(Zt.FOCUSIN),Bt(this._element).removeClass(ie),Bt(this._element).off(Zt.CLICK_DISMISS),Bt(this._dialog).off(Zt.MOUSEDOWN_DISMISS),i){var r=Cn.getTransitionDurationFromElement(this._element);Bt(this._element).one(Cn.TRANSITION_END,function(t){return e._hideModal(t)}).emulateTransitionEnd(r)}else this._hideModal()}}},t.dispose=function(){Bt.removeData(this._element,Gt),Bt(window,document,this._element,this._backdrop).off(qt),this._config=null,this._element=null,this._dialog=null,this._backdrop=null,this._isShown=null,this._isBodyOverflowing=null,this._ignoreBackdropClick=null,this._scrollbarWidth=null},t.handleUpdate=function(){this._adjustDialog()},t._getConfig=function(t){return t=h({},Xt,t),Cn.typeCheckConfig(Yt,t,Jt),t},t._showElement=function(t){var e=this,n=Bt(this._element).hasClass(ne);this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE||document.body.appendChild(this._element),this._element.style.display="block",this._element.removeAttribute("aria-hidden"),this._element.scrollTop=0,n&&Cn.reflow(this._element),Bt(this._element).addClass(ie),this._config.focus&&this._enforceFocus();var i=Bt.Event(Zt.SHOWN,{relatedTarget:t}),r=function(){e._config.focus&&e._element.focus(),e._isTransitioning=!1,Bt(e._element).trigger(i)};if(n){var s=Cn.getTransitionDurationFromElement(this._element);Bt(this._dialog).one(Cn.TRANSITION_END,r).emulateTransitionEnd(s)}else r()},t._enforceFocus=function(){var e=this;Bt(document).off(Zt.FOCUSIN).on(Zt.FOCUSIN,function(t){document!==t.target&&e._element!==t.target&&0===Bt(e._element).has(t.target).length&&e._element.focus()})},t._setEscapeEvent=function(){var e=this;this._isShown&&this._config.keyboard?Bt(this._element).on(Zt.KEYDOWN_DISMISS,function(t){27===t.which&&(t.preventDefault(),e.hide())}):this._isShown||Bt(this._element).off(Zt.KEYDOWN_DISMISS)},t._setResizeEvent=function(){var e=this;this._isShown?Bt(window).on(Zt.RESIZE,function(t){return e.handleUpdate(t)}):Bt(window).off(Zt.RESIZE)},t._hideModal=function(){var t=this;this._element.style.display="none",this._element.setAttribute("aria-hidden",!0),this._isTransitioning=!1,this._showBackdrop(function(){Bt(document.body).removeClass(ee),t._resetAdjustments(),t._resetScrollbar(),Bt(t._element).trigger(Zt.HIDDEN)})},t._removeBackdrop=function(){this._backdrop&&(Bt(this._backdrop).remove(),this._backdrop=null)},t._showBackdrop=function(t){var e=this,n=Bt(this._element).hasClass(ne)?ne:"";if(this._isShown&&this._config.backdrop){if(this._backdrop=document.createElement("div"),this._backdrop.className=te,n&&Bt(this._backdrop).addClass(n),Bt(this._backdrop).appendTo(document.body),Bt(this._element).on(Zt.CLICK_DISMISS,function(t){e._ignoreBackdropClick?e._ignoreBackdropClick=!1:t.target===t.currentTarget&&("static"===e._config.backdrop?e._element.focus():e.hide())}),n&&Cn.reflow(this._backdrop),Bt(this._backdrop).addClass(ie),!t)return;if(!n)return void t();var i=Cn.getTransitionDurationFromElement(this._backdrop);Bt(this._backdrop).one(Cn.TRANSITION_END,t).emulateTransitionEnd(i)}else if(!this._isShown&&this._backdrop){Bt(this._backdrop).removeClass(ie);var r=function(){e._removeBackdrop(),t&&t()};if(Bt(this._element).hasClass(ne)){var s=Cn.getTransitionDurationFromElement(this._backdrop);Bt(this._backdrop).one(Cn.TRANSITION_END,r).emulateTransitionEnd(s)}else r()}else t&&t()},t._adjustDialog=function(){var t=this._element.scrollHeight>document.documentElement.clientHeight;!this._isBodyOverflowing&&t&&(this._element.style.paddingLeft=this._scrollbarWidth+"px"),this._isBodyOverflowing&&!t&&(this._element.style.paddingRight=this._scrollbarWidth+"px")},t._resetAdjustments=function(){this._element.style.paddingLeft="",this._element.style.paddingRight=""},t._checkScrollbar=function(){var t=document.body.getBoundingClientRect();this._isBodyOverflowing=t.left+t.right<window.innerWidth,this._scrollbarWidth=this._getScrollbarWidth()},t._setScrollbar=function(){var r=this;if(this._isBodyOverflowing){Bt(re.FIXED_CONTENT).each(function(t,e){var n=Bt(e)[0].style.paddingRight,i=Bt(e).css("padding-right");Bt(e).data("padding-right",n).css("padding-right",parseFloat(i)+r._scrollbarWidth+"px")}),Bt(re.STICKY_CONTENT).each(function(t,e){var n=Bt(e)[0].style.marginRight,i=Bt(e).css("margin-right");Bt(e).data("margin-right",n).css("margin-right",parseFloat(i)-r._scrollbarWidth+"px")}),Bt(re.NAVBAR_TOGGLER).each(function(t,e){var n=Bt(e)[0].style.marginRight,i=Bt(e).css("margin-right");Bt(e).data("margin-right",n).css("margin-right",parseFloat(i)+r._scrollbarWidth+"px")});var t=document.body.style.paddingRight,e=Bt(document.body).css("padding-right");Bt(document.body).data("padding-right",t).css("padding-right",parseFloat(e)+this._scrollbarWidth+"px")}},t._resetScrollbar=function(){Bt(re.FIXED_CONTENT).each(function(t,e){var n=Bt(e).data("padding-right");"undefined"!=typeof n&&Bt(e).css("padding-right",n).removeData("padding-right")}),Bt(re.STICKY_CONTENT+", "+re.NAVBAR_TOGGLER).each(function(t,e){var n=Bt(e).data("margin-right");"undefined"!=typeof n&&Bt(e).css("margin-right",n).removeData("margin-right")});var t=Bt(document.body).data("padding-right");"undefined"!=typeof t&&Bt(document.body).css("padding-right",t).removeData("padding-right")},t._getScrollbarWidth=function(){var t=document.createElement("div");t.className=$t,document.body.appendChild(t);var e=t.getBoundingClientRect().width-t.clientWidth;return document.body.removeChild(t),e},r._jQueryInterface=function(n,i){return this.each(function(){var t=Bt(this).data(Gt),e=h({},Xt,Bt(this).data(),"object"==typeof n&&n?n:{});if(t||(t=new r(this,e),Bt(this).data(Gt,t)),"string"==typeof n){if("undefined"==typeof t[n])throw new TypeError('No method named "'+n+'"');t[n](i)}else e.show&&t.show(i)})},o(r,null,[{key:"VERSION",get:function(){return"4.1.1"}},{key:"Default",get:function(){return Xt}}]),r}(),Bt(document).on(Zt.CLICK_DATA_API,re.DATA_TOGGLE,function(t){var e,n=this,i=Cn.getSelectorFromElement(this);i&&(e=Bt(i)[0]);var r=Bt(e).data(Gt)?"toggle":h({},Bt(e).data(),Bt(this).data());"A"!==this.tagName&&"AREA"!==this.tagName||t.preventDefault();var s=Bt(e).one(Zt.SHOW,function(t){t.isDefaultPrevented()||s.one(Zt.HIDDEN,function(){Bt(n).is(":visible")&&n.focus()})});se._jQueryInterface.call(Bt(e),r,this)}),Bt.fn[Yt]=se._jQueryInterface,Bt.fn[Yt].Constructor=se,Bt.fn[Yt].noConflict=function(){return Bt.fn[Yt]=zt,se._jQueryInterface},se),Nn=(ae="tooltip",he="."+(le="bs.tooltip"),ce=(oe=e).fn[ae],ue="bs-tooltip",fe=new RegExp("(^|\\s)"+ue+"\\S+","g"),ge={animation:!0,template:'<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!(_e={AUTO:"auto",TOP:"top",RIGHT:"right",BOTTOM:"bottom",LEFT:"left"}),selector:!(de={animation:"boolean",template:"string",title:"(string|element|function)",trigger:"string",delay:"(number|object)",html:"boolean",selector:"(string|boolean)",placement:"(string|function)",offset:"(number|string)",container:"(string|element|boolean)",fallbackPlacement:"(string|array)",boundary:"(string|element)"}),placement:"top",offset:0,container:!1,fallbackPlacement:"flip",boundary:"scrollParent"},pe="out",ve={HIDE:"hide"+he,HIDDEN:"hidden"+he,SHOW:(me="show")+he,SHOWN:"shown"+he,INSERTED:"inserted"+he,CLICK:"click"+he,FOCUSIN:"focusin"+he,FOCUSOUT:"focusout"+he,MOUSEENTER:"mouseenter"+he,MOUSELEAVE:"mouseleave"+he},Ee="fade",ye="show",Te=".tooltip-inner",Ce=".arrow",Ie="hover",Ae="focus",De="click",be="manual",Se=function(){function i(t,e){if("undefined"==typeof c)throw new TypeError("Bootstrap tooltips require Popper.js (https://popper.js.org)");this._isEnabled=!0,this._timeout=0,this._hoverState="",this._activeTrigger={},this._popper=null,this.element=t,this.config=this._getConfig(e),this.tip=null,this._setListeners()}var t=i.prototype;return t.enable=function(){this._isEnabled=!0},t.disable=function(){this._isEnabled=!1},t.toggleEnabled=function(){this._isEnabled=!this._isEnabled},t.toggle=function(t){if(this._isEnabled)if(t){var e=this.constructor.DATA_KEY,n=oe(t.currentTarget).data(e);n||(n=new this.constructor(t.currentTarget,this._getDelegateConfig()),oe(t.currentTarget).data(e,n)),n._activeTrigger.click=!n._activeTrigger.click,n._isWithActiveTrigger()?n._enter(null,n):n._leave(null,n)}else{if(oe(this.getTipElement()).hasClass(ye))return void this._leave(null,this);this._enter(null,this)}},t.dispose=function(){clearTimeout(this._timeout),oe.removeData(this.element,this.constructor.DATA_KEY),oe(this.element).off(this.constructor.EVENT_KEY),oe(this.element).closest(".modal").off("hide.bs.modal"),this.tip&&oe(this.tip).remove(),this._isEnabled=null,this._timeout=null,this._hoverState=null,(this._activeTrigger=null)!==this._popper&&this._popper.destroy(),this._popper=null,this.element=null,this.config=null,this.tip=null},t.show=function(){var e=this;if("none"===oe(this.element).css("display"))throw new Error("Please use show on visible elements");var t=oe.Event(this.constructor.Event.SHOW);if(this.isWithContent()&&this._isEnabled){oe(this.element).trigger(t);var n=oe.contains(this.element.ownerDocument.documentElement,this.element);if(t.isDefaultPrevented()||!n)return;var i=this.getTipElement(),r=Cn.getUID(this.constructor.NAME);i.setAttribute("id",r),this.element.setAttribute("aria-describedby",r),this.setContent(),this.config.animation&&oe(i).addClass(Ee);var s="function"==typeof this.config.placement?this.config.placement.call(this,i,this.element):this.config.placement,o=this._getAttachment(s);this.addAttachmentClass(o);var a=!1===this.config.container?document.body:oe(this.config.container);oe(i).data(this.constructor.DATA_KEY,this),oe.contains(this.element.ownerDocument.documentElement,this.tip)||oe(i).appendTo(a),oe(this.element).trigger(this.constructor.Event.INSERTED),this._popper=new c(this.element,i,{placement:o,modifiers:{offset:{offset:this.config.offset},flip:{behavior:this.config.fallbackPlacement},arrow:{element:Ce},preventOverflow:{boundariesElement:this.config.boundary}},onCreate:function(t){t.originalPlacement!==t.placement&&e._handlePopperPlacementChange(t)},onUpdate:function(t){e._handlePopperPlacementChange(t)}}),oe(i).addClass(ye),"ontouchstart"in document.documentElement&&oe(document.body).children().on("mouseover",null,oe.noop);var l=function(){e.config.animation&&e._fixTransition();var t=e._hoverState;e._hoverState=null,oe(e.element).trigger(e.constructor.Event.SHOWN),t===pe&&e._leave(null,e)};if(oe(this.tip).hasClass(Ee)){var h=Cn.getTransitionDurationFromElement(this.tip);oe(this.tip).one(Cn.TRANSITION_END,l).emulateTransitionEnd(h)}else l()}},t.hide=function(t){var e=this,n=this.getTipElement(),i=oe.Event(this.constructor.Event.HIDE),r=function(){e._hoverState!==me&&n.parentNode&&n.parentNode.removeChild(n),e._cleanTipClass(),e.element.removeAttribute("aria-describedby"),oe(e.element).trigger(e.constructor.Event.HIDDEN),null!==e._popper&&e._popper.destroy(),t&&t()};if(oe(this.element).trigger(i),!i.isDefaultPrevented()){if(oe(n).removeClass(ye),"ontouchstart"in document.documentElement&&oe(document.body).children().off("mouseover",null,oe.noop),this._activeTrigger[De]=!1,this._activeTrigger[Ae]=!1,this._activeTrigger[Ie]=!1,oe(this.tip).hasClass(Ee)){var s=Cn.getTransitionDurationFromElement(n);oe(n).one(Cn.TRANSITION_END,r).emulateTransitionEnd(s)}else r();this._hoverState=""}},t.update=function(){null!==this._popper&&this._popper.scheduleUpdate()},t.isWithContent=function(){return Boolean(this.getTitle())},t.addAttachmentClass=function(t){oe(this.getTipElement()).addClass(ue+"-"+t)},t.getTipElement=function(){return this.tip=this.tip||oe(this.config.template)[0],this.tip},t.setContent=function(){var t=oe(this.getTipElement());this.setElementContent(t.find(Te),this.getTitle()),t.removeClass(Ee+" "+ye)},t.setElementContent=function(t,e){var n=this.config.html;"object"==typeof e&&(e.nodeType||e.jquery)?n?oe(e).parent().is(t)||t.empty().append(e):t.text(oe(e).text()):t[n?"html":"text"](e)},t.getTitle=function(){var t=this.element.getAttribute("data-original-title");return t||(t="function"==typeof this.config.title?this.config.title.call(this.element):this.config.title),t},t._getAttachment=function(t){return _e[t.toUpperCase()]},t._setListeners=function(){var i=this;this.config.trigger.split(" ").forEach(function(t){if("click"===t)oe(i.element).on(i.constructor.Event.CLICK,i.config.selector,function(t){return i.toggle(t)});else if(t!==be){var e=t===Ie?i.constructor.Event.MOUSEENTER:i.constructor.Event.FOCUSIN,n=t===Ie?i.constructor.Event.MOUSELEAVE:i.constructor.Event.FOCUSOUT;oe(i.element).on(e,i.config.selector,function(t){return i._enter(t)}).on(n,i.config.selector,function(t){return i._leave(t)})}oe(i.element).closest(".modal").on("hide.bs.modal",function(){return i.hide()})}),this.config.selector?this.config=h({},this.config,{trigger:"manual",selector:""}):this._fixTitle()},t._fixTitle=function(){var t=typeof this.element.getAttribute("data-original-title");(this.element.getAttribute("title")||"string"!==t)&&(this.element.setAttribute("data-original-title",this.element.getAttribute("title")||""),this.element.setAttribute("title",""))},t._enter=function(t,e){var n=this.constructor.DATA_KEY;(e=e||oe(t.currentTarget).data(n))||(e=new this.constructor(t.currentTarget,this._getDelegateConfig()),oe(t.currentTarget).data(n,e)),t&&(e._activeTrigger["focusin"===t.type?Ae:Ie]=!0),oe(e.getTipElement()).hasClass(ye)||e._hoverState===me?e._hoverState=me:(clearTimeout(e._timeout),e._hoverState=me,e.config.delay&&e.config.delay.show?e._timeout=setTimeout(function(){e._hoverState===me&&e.show()},e.config.delay.show):e.show())},t._leave=function(t,e){var n=this.constructor.DATA_KEY;(e=e||oe(t.currentTarget).data(n))||(e=new this.constructor(t.currentTarget,this._getDelegateConfig()),oe(t.currentTarget).data(n,e)),t&&(e._activeTrigger["focusout"===t.type?Ae:Ie]=!1),e._isWithActiveTrigger()||(clearTimeout(e._timeout),e._hoverState=pe,e.config.delay&&e.config.delay.hide?e._timeout=setTimeout(function(){e._hoverState===pe&&e.hide()},e.config.delay.hide):e.hide())},t._isWithActiveTrigger=function(){for(var t in this._activeTrigger)if(this._activeTrigger[t])return!0;return!1},t._getConfig=function(t){return"number"==typeof(t=h({},this.constructor.Default,oe(this.element).data(),"object"==typeof t&&t?t:{})).delay&&(t.delay={show:t.delay,hide:t.delay}),"number"==typeof t.title&&(t.title=t.title.toString()),"number"==typeof t.content&&(t.content=t.content.toString()),Cn.typeCheckConfig(ae,t,this.constructor.DefaultType),t},t._getDelegateConfig=function(){var t={};if(this.config)for(var e in this.config)this.constructor.Default[e]!==this.config[e]&&(t[e]=this.config[e]);return t},t._cleanTipClass=function(){var t=oe(this.getTipElement()),e=t.attr("class").match(fe);null!==e&&0<e.length&&t.removeClass(e.join(""))},t._handlePopperPlacementChange=function(t){this._cleanTipClass(),this.addAttachmentClass(this._getAttachment(t.placement))},t._fixTransition=function(){var t=this.getTipElement(),e=this.config.animation;null===t.getAttribute("x-placement")&&(oe(t).removeClass(Ee),this.config.animation=!1,this.hide(),this.show(),this.config.animation=e)},i._jQueryInterface=function(n){return this.each(function(){var t=oe(this).data(le),e="object"==typeof n&&n;if((t||!/dispose|hide/.test(n))&&(t||(t=new i(this,e),oe(this).data(le,t)),"string"==typeof n)){if("undefined"==typeof t[n])throw new TypeError('No method named "'+n+'"');t[n]()}})},o(i,null,[{key:"VERSION",get:function(){return"4.1.1"}},{key:"Default",get:function(){return ge}},{key:"NAME",get:function(){return ae}},{key:"DATA_KEY",get:function(){return le}},{key:"Event",get:function(){return ve}},{key:"EVENT_KEY",get:function(){return he}},{key:"DefaultType",get:function(){return de}}]),i}(),oe.fn[ae]=Se._jQueryInterface,oe.fn[ae].Constructor=Se,oe.fn[ae].noConflict=function(){return oe.fn[ae]=ce,Se._jQueryInterface},Se),On=(Ne="popover",ke="."+(Oe="bs.popover"),Pe=(we=e).fn[Ne],Le="bs-popover",je=new RegExp("(^|\\s)"+Le+"\\S+","g"),Re=h({},Nn.Default,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'}),He=h({},Nn.DefaultType,{content:"(string|element|function)"}),We="fade",xe=".popover-header",Ue=".popover-body",Ke={HIDE:"hide"+ke,HIDDEN:"hidden"+ke,SHOW:(Me="show")+ke,SHOWN:"shown"+ke,INSERTED:"inserted"+ke,CLICK:"click"+ke,FOCUSIN:"focusin"+ke,FOCUSOUT:"focusout"+ke,MOUSEENTER:"mouseenter"+ke,MOUSELEAVE:"mouseleave"+ke},Fe=function(t){var e,n;function i(){return t.apply(this,arguments)||this}n=t,(e=i).prototype=Object.create(n.prototype),(e.prototype.constructor=e).__proto__=n;var r=i.prototype;return r.isWithContent=function(){return this.getTitle()||this._getContent()},r.addAttachmentClass=function(t){we(this.getTipElement()).addClass(Le+"-"+t)},r.getTipElement=function(){return this.tip=this.tip||we(this.config.template)[0],this.tip},r.setContent=function(){var t=we(this.getTipElement());this.setElementContent(t.find(xe),this.getTitle());var e=this._getContent();"function"==typeof e&&(e=e.call(this.element)),this.setElementContent(t.find(Ue),e),t.removeClass(We+" "+Me)},r._getContent=function(){return this.element.getAttribute("data-content")||this.config.content},r._cleanTipClass=function(){var t=we(this.getTipElement()),e=t.attr("class").match(je);null!==e&&0<e.length&&t.removeClass(e.join(""))},i._jQueryInterface=function(n){return this.each(function(){var t=we(this).data(Oe),e="object"==typeof n?n:null;if((t||!/destroy|hide/.test(n))&&(t||(t=new i(this,e),we(this).data(Oe,t)),"string"==typeof n)){if("undefined"==typeof t[n])throw new TypeError('No method named "'+n+'"');t[n]()}})},o(i,null,[{key:"VERSION",get:function(){return"4.1.1"}},{key:"Default",get:function(){return Re}},{key:"NAME",get:function(){return Ne}},{key:"DATA_KEY",get:function(){return Oe}},{key:"Event",get:function(){return Ke}},{key:"EVENT_KEY",get:function(){return ke}},{key:"DefaultType",get:function(){return He}}]),i}(Nn),we.fn[Ne]=Fe._jQueryInterface,we.fn[Ne].Constructor=Fe,we.fn[Ne].noConflict=function(){return we.fn[Ne]=Pe,Fe._jQueryInterface},Fe),kn=(Qe="scrollspy",Ye="."+(Be="bs.scrollspy"),Ge=(Ve=e).fn[Qe],qe={offset:10,method:"auto",target:""},ze={offset:"number",method:"string",target:"(string|element)"},Xe={ACTIVATE:"activate"+Ye,SCROLL:"scroll"+Ye,LOAD_DATA_API:"load"+Ye+".data-api"},Je="dropdown-item",Ze="active",$e={DATA_SPY:'[data-spy="scroll"]',ACTIVE:".active",NAV_LIST_GROUP:".nav, .list-group",NAV_LINKS:".nav-link",NAV_ITEMS:".nav-item",LIST_ITEMS:".list-group-item",DROPDOWN:".dropdown",DROPDOWN_ITEMS:".dropdown-item",DROPDOWN_TOGGLE:".dropdown-toggle"},tn="offset",en="position",nn=function(){function n(t,e){var n=this;this._element=t,this._scrollElement="BODY"===t.tagName?window:t,this._config=this._getConfig(e),this._selector=this._config.target+" "+$e.NAV_LINKS+","+this._config.target+" "+$e.LIST_ITEMS+","+this._config.target+" "+$e.DROPDOWN_ITEMS,this._offsets=[],this._targets=[],this._activeTarget=null,this._scrollHeight=0,Ve(this._scrollElement).on(Xe.SCROLL,function(t){return n._process(t)}),this.refresh(),this._process()}var t=n.prototype;return t.refresh=function(){var e=this,t=this._scrollElement===this._scrollElement.window?tn:en,r="auto"===this._config.method?t:this._config.method,s=r===en?this._getScrollTop():0;this._offsets=[],this._targets=[],this._scrollHeight=this._getScrollHeight(),Ve.makeArray(Ve(this._selector)).map(function(t){var e,n=Cn.getSelectorFromElement(t);if(n&&(e=Ve(n)[0]),e){var i=e.getBoundingClientRect();if(i.width||i.height)return[Ve(e)[r]().top+s,n]}return null}).filter(function(t){return t}).sort(function(t,e){return t[0]-e[0]}).forEach(function(t){e._offsets.push(t[0]),e._targets.push(t[1])})},t.dispose=function(){Ve.removeData(this._element,Be),Ve(this._scrollElement).off(Ye),this._element=null,this._scrollElement=null,this._config=null,this._selector=null,this._offsets=null,this._targets=null,this._activeTarget=null,this._scrollHeight=null},t._getConfig=function(t){if("string"!=typeof(t=h({},qe,"object"==typeof t&&t?t:{})).target){var e=Ve(t.target).attr("id");e||(e=Cn.getUID(Qe),Ve(t.target).attr("id",e)),t.target="#"+e}return Cn.typeCheckConfig(Qe,t,ze),t},t._getScrollTop=function(){return this._scrollElement===window?this._scrollElement.pageYOffset:this._scrollElement.scrollTop},t._getScrollHeight=function(){return this._scrollElement.scrollHeight||Math.max(document.body.scrollHeight,document.documentElement.scrollHeight)},t._getOffsetHeight=function(){return this._scrollElement===window?window.innerHeight:this._scrollElement.getBoundingClientRect().height},t._process=function(){var t=this._getScrollTop()+this._config.offset,e=this._getScrollHeight(),n=this._config.offset+e-this._getOffsetHeight();if(this._scrollHeight!==e&&this.refresh(),n<=t){var i=this._targets[this._targets.length-1];this._activeTarget!==i&&this._activate(i)}else{if(this._activeTarget&&t<this._offsets[0]&&0<this._offsets[0])return this._activeTarget=null,void this._clear();for(var r=this._offsets.length;r--;){this._activeTarget!==this._targets[r]&&t>=this._offsets[r]&&("undefined"==typeof this._offsets[r+1]||t<this._offsets[r+1])&&this._activate(this._targets[r])}}},t._activate=function(e){this._activeTarget=e,this._clear();var t=this._selector.split(",");t=t.map(function(t){return t+'[data-target="'+e+'"],'+t+'[href="'+e+'"]'});var n=Ve(t.join(","));n.hasClass(Je)?(n.closest($e.DROPDOWN).find($e.DROPDOWN_TOGGLE).addClass(Ze),n.addClass(Ze)):(n.addClass(Ze),n.parents($e.NAV_LIST_GROUP).prev($e.NAV_LINKS+", "+$e.LIST_ITEMS).addClass(Ze),n.parents($e.NAV_LIST_GROUP).prev($e.NAV_ITEMS).children($e.NAV_LINKS).addClass(Ze)),Ve(this._scrollElement).trigger(Xe.ACTIVATE,{relatedTarget:e})},t._clear=function(){Ve(this._selector).filter($e.ACTIVE).removeClass(Ze)},n._jQueryInterface=function(e){return this.each(function(){var t=Ve(this).data(Be);if(t||(t=new n(this,"object"==typeof e&&e),Ve(this).data(Be,t)),"string"==typeof e){if("undefined"==typeof t[e])throw new TypeError('No method named "'+e+'"');t[e]()}})},o(n,null,[{key:"VERSION",get:function(){return"4.1.1"}},{key:"Default",get:function(){return qe}}]),n}(),Ve(window).on(Xe.LOAD_DATA_API,function(){for(var t=Ve.makeArray(Ve($e.DATA_SPY)),e=t.length;e--;){var n=Ve(t[e]);nn._jQueryInterface.call(n,n.data())}}),Ve.fn[Qe]=nn._jQueryInterface,Ve.fn[Qe].Constructor=nn,Ve.fn[Qe].noConflict=function(){return Ve.fn[Qe]=Ge,nn._jQueryInterface},nn),Pn=(on="."+(sn="bs.tab"),an=(rn=e).fn.tab,ln={HIDE:"hide"+on,HIDDEN:"hidden"+on,SHOW:"show"+on,SHOWN:"shown"+on,CLICK_DATA_API:"click"+on+".data-api"},hn="dropdown-menu",cn="active",un="disabled",fn="fade",dn="show",_n=".dropdown",gn=".nav, .list-group",mn=".active",pn="> li > .active",vn='[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',En=".dropdown-toggle",yn="> .dropdown-menu .active",Tn=function(){function i(t){this._element=t}var t=i.prototype;return t.show=function(){var n=this;if(!(this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE&&rn(this._element).hasClass(cn)||rn(this._element).hasClass(un))){var t,i,e=rn(this._element).closest(gn)[0],r=Cn.getSelectorFromElement(this._element);if(e){var s="UL"===e.nodeName?pn:mn;i=(i=rn.makeArray(rn(e).find(s)))[i.length-1]}var o=rn.Event(ln.HIDE,{relatedTarget:this._element}),a=rn.Event(ln.SHOW,{relatedTarget:i});if(i&&rn(i).trigger(o),rn(this._element).trigger(a),!a.isDefaultPrevented()&&!o.isDefaultPrevented()){r&&(t=rn(r)[0]),this._activate(this._element,e);var l=function(){var t=rn.Event(ln.HIDDEN,{relatedTarget:n._element}),e=rn.Event(ln.SHOWN,{relatedTarget:i});rn(i).trigger(t),rn(n._element).trigger(e)};t?this._activate(t,t.parentNode,l):l()}}},t.dispose=function(){rn.removeData(this._element,sn),this._element=null},t._activate=function(t,e,n){var i=this,r=("UL"===e.nodeName?rn(e).find(pn):rn(e).children(mn))[0],s=n&&r&&rn(r).hasClass(fn),o=function(){return i._transitionComplete(t,r,n)};if(r&&s){var a=Cn.getTransitionDurationFromElement(r);rn(r).one(Cn.TRANSITION_END,o).emulateTransitionEnd(a)}else o()},t._transitionComplete=function(t,e,n){if(e){rn(e).removeClass(dn+" "+cn);var i=rn(e.parentNode).find(yn)[0];i&&rn(i).removeClass(cn),"tab"===e.getAttribute("role")&&e.setAttribute("aria-selected",!1)}if(rn(t).addClass(cn),"tab"===t.getAttribute("role")&&t.setAttribute("aria-selected",!0),Cn.reflow(t),rn(t).addClass(dn),t.parentNode&&rn(t.parentNode).hasClass(hn)){var r=rn(t).closest(_n)[0];r&&rn(r).find(En).addClass(cn),t.setAttribute("aria-expanded",!0)}n&&n()},i._jQueryInterface=function(n){return this.each(function(){var t=rn(this),e=t.data(sn);if(e||(e=new i(this),t.data(sn,e)),"string"==typeof n){if("undefined"==typeof e[n])throw new TypeError('No method named "'+n+'"');e[n]()}})},o(i,null,[{key:"VERSION",get:function(){return"4.1.1"}}]),i}(),rn(document).on(ln.CLICK_DATA_API,vn,function(t){t.preventDefault(),Tn._jQueryInterface.call(rn(this),"show")}),rn.fn.tab=Tn._jQueryInterface,rn.fn.tab.Constructor=Tn,rn.fn.tab.noConflict=function(){return rn.fn.tab=an,Tn._jQueryInterface},Tn);!function(t){if("undefined"==typeof t)throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");var e=t.fn.jquery.split(" ")[0].split(".");if(e[0]<2&&e[1]<9||1===e[0]&&9===e[1]&&e[2]<1||4<=e[0])throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0")}(e),t.Util=Cn,t.Alert=In,t.Button=An,t.Carousel=Dn,t.Collapse=bn,t.Dropdown=Sn,t.Modal=wn,t.Popover=On,t.Scrollspy=kn,t.Tab=Pn,t.Tooltip=Nn,Object.defineProperty(t,"__esModule",{value:!0})});
	//# sourceMappingURL=bootstrap.min.js.map

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 15 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 16 */
15,
/* 17 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(21);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 19 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(20);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 22 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = {
		"job": {
			"lang": "en",
			"user_id": 46548,
			"name": "aloe_vera.mp3",
			"duration": 185,
			"created_at": "Fri Jul 27 20:12:14 2018",
			"id": 8856521
		},
		"speakers": [
			{
				"duration": "56.85",
				"confidence": null,
				"name": "F1",
				"time": "0.08"
			},
			{
				"duration": "55.66",
				"confidence": null,
				"name": "F2",
				"time": "57.67"
			},
			{
				"duration": "27.96",
				"confidence": null,
				"name": "F1",
				"time": "114.75"
			},
			{
				"duration": "39.80",
				"confidence": null,
				"name": "F3",
				"time": "144.21"
			}
		],
		"words": [
			{
				"duration": "0.06",
				"confidence": "0.940",
				"name": "You",
				"time": "0.08"
			},
			{
				"duration": "0.36",
				"confidence": "0.950",
				"name": "guys",
				"time": "0.14"
			},
			{
				"duration": "0.42",
				"confidence": "0.490",
				"name": "too",
				"time": "0.59"
			},
			{
				"duration": "0.72",
				"confidence": "0.730",
				"name": ".",
				"time": "1.09"
			},
			{
				"duration": "0.37",
				"confidence": "0.600",
				"name": "Today's",
				"time": "2.04"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "the",
				"time": "2.43"
			},
			{
				"duration": "0.66",
				"confidence": "0.990",
				"name": "14th",
				"time": "3.51"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "4.17"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "July",
				"time": "4.26"
			},
			{
				"duration": "0.39",
				"confidence": "0.970",
				"name": ".",
				"time": "5.68"
			},
			{
				"duration": "0.43",
				"confidence": "0.870",
				"name": "Yes",
				"time": "7.03"
			},
			{
				"duration": "0.79",
				"confidence": "0.800",
				"name": ".",
				"time": "8.03"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "I",
				"time": "9.46"
			},
			{
				"duration": "0.28",
				"confidence": "0.700",
				"name": "also",
				"time": "9.58"
			},
			{
				"duration": "0.43",
				"confidence": "0.900",
				"name": "think",
				"time": "9.89"
			},
			{
				"duration": "0.18",
				"confidence": "0.590",
				"name": "because",
				"time": "10.32"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "it's",
				"time": "10.56"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "like",
				"time": "10.74"
			},
			{
				"duration": "0.27",
				"confidence": "0.370",
				"name": ".",
				"time": "12.47"
			},
			{
				"duration": "0.28",
				"confidence": "0.960",
				"name": "But",
				"time": "12.77"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "13.05"
			},
			{
				"duration": "0.48",
				"confidence": "0.970",
				"name": "Anybody",
				"time": "13.47"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "else",
				"time": "13.95"
			},
			{
				"duration": "0.24",
				"confidence": "0.960",
				"name": "like",
				"time": "14.22"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "born",
				"time": "14.46"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "in",
				"time": "14.76"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "14.85"
			},
			{
				"duration": "0.69",
				"confidence": "0.850",
				"name": "90s",
				"time": "14.94"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "grew",
				"time": "16.02"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "up",
				"time": "16.20"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "with",
				"time": "16.35"
			},
			{
				"duration": "0.16",
				"confidence": "1.000",
				"name": "like",
				"time": "16.47"
			},
			{
				"duration": "0.63",
				"confidence": "0.770",
				"name": "VHS",
				"time": "16.67"
			},
			{
				"duration": "0.31",
				"confidence": "0.830",
				"name": ".",
				"time": "17.33"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "This",
				"time": "18.00"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "is",
				"time": "18.18"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "just",
				"time": "18.30"
			},
			{
				"duration": "0.21",
				"confidence": "0.870",
				"name": "one",
				"time": "18.54"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": "I",
				"time": "18.75"
			},
			{
				"duration": "0.42",
				"confidence": "0.950",
				"name": "have",
				"time": "18.84"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "the",
				"time": "19.52"
			},
			{
				"duration": "0.38",
				"confidence": "0.760",
				"name": "items",
				"time": "19.66"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "family",
				"time": "20.04"
			},
			{
				"duration": "0.22",
				"confidence": "0.490",
				"name": "I",
				"time": "21.96"
			},
			{
				"duration": "0.19",
				"confidence": "0.280",
				"name": "was",
				"time": "22.29"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "really",
				"time": "22.53"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "scary",
				"time": "22.77"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "as",
				"time": "23.19"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "23.31"
			},
			{
				"duration": "0.44",
				"confidence": "1.000",
				"name": "kid",
				"time": "23.37"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "23.81"
			},
			{
				"duration": "0.29",
				"confidence": "0.700",
				"name": "Anyway",
				"time": "24.31"
			},
			{
				"duration": "0.09",
				"confidence": "0.690",
				"name": ".",
				"time": "24.75"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "Literally",
				"time": "24.84"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "25.38"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "grew",
				"time": "25.50"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "up",
				"time": "25.80"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "on",
				"time": "26.01"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "VHS",
				"time": "26.16"
			},
			{
				"duration": "0.10",
				"confidence": "0.960",
				"name": "and",
				"time": "26.90"
			},
			{
				"duration": "0.15",
				"confidence": "0.970",
				"name": "then",
				"time": "27.00"
			},
			{
				"duration": "0.44",
				"confidence": "1.000",
				"name": "eventually",
				"time": "27.15"
			},
			{
				"duration": "0.63",
				"confidence": "0.410",
				"name": "DVDs",
				"time": "27.59"
			},
			{
				"duration": "0.81",
				"confidence": "0.630",
				"name": ".",
				"time": "28.25"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "A",
				"time": "29.46"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "lot",
				"time": "29.52"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "29.76"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "good",
				"time": "29.82"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "memories",
				"time": "30.06"
			},
			{
				"duration": "0.12",
				"confidence": "0.890",
				"name": "of",
				"time": "30.51"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "VHS",
				"time": "30.63"
			},
			{
				"duration": "0.27",
				"confidence": "0.900",
				"name": "as",
				"time": "31.23"
			},
			{
				"duration": "0.13",
				"confidence": "0.900",
				"name": "well",
				"time": "31.88"
			},
			{
				"duration": "0.16",
				"confidence": "0.890",
				"name": "as",
				"time": "32.05"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "my",
				"time": "32.22"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "good",
				"time": "32.40"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "memories",
				"time": "32.61"
			},
			{
				"duration": "0.09",
				"confidence": "0.500",
				"name": "and",
				"time": "33.11"
			},
			{
				"duration": "0.28",
				"confidence": "0.510",
				"name": "my",
				"time": "33.20"
			},
			{
				"duration": "0.22",
				"confidence": "0.400",
				"name": "father",
				"time": "33.49"
			},
			{
				"duration": "0.54",
				"confidence": "0.520",
				"name": "frowns",
				"time": "33.75"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "when",
				"time": "34.74"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "technology",
				"time": "34.92"
			},
			{
				"duration": "0.22",
				"confidence": "0.510",
				"name": "wasn't",
				"time": "35.58"
			},
			{
				"duration": "0.18",
				"confidence": "0.370",
				"name": "used",
				"time": "35.80"
			},
			{
				"duration": "0.65",
				"confidence": "0.970",
				"name": ".",
				"time": "35.99"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "So",
				"time": "36.72"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "37.23"
			},
			{
				"duration": "0.39",
				"confidence": "0.980",
				"name": "Anyway",
				"time": "37.71"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "this",
				"time": "38.13"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "video",
				"time": "38.37"
			},
			{
				"duration": "0.15",
				"confidence": "0.960",
				"name": "is",
				"time": "38.85"
			},
			{
				"duration": "0.07",
				"confidence": "0.530",
				"name": "going",
				"time": "39.00"
			},
			{
				"duration": "0.15",
				"confidence": "0.530",
				"name": "to",
				"time": "39.06"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "be",
				"time": "39.21"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "about",
				"time": "39.51"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "39.99"
			},
			{
				"duration": "0.44",
				"confidence": "0.530",
				"name": "Alvare",
				"time": "40.89"
			},
			{
				"duration": "0.48",
				"confidence": "0.640",
				"name": "juice",
				"time": "41.46"
			},
			{
				"duration": "0.45",
				"confidence": "0.860",
				"name": ".",
				"time": "41.95"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "So",
				"time": "43.80"
			},
			{
				"duration": "0.15",
				"confidence": "0.530",
				"name": "I",
				"time": "44.04"
			},
			{
				"duration": "0.42",
				"confidence": "0.520",
				"name": "then",
				"time": "44.19"
			},
			{
				"duration": "0.05",
				"confidence": "0.900",
				"name": "I",
				"time": "44.75"
			},
			{
				"duration": "0.27",
				"confidence": "0.900",
				"name": "wanted",
				"time": "44.82"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "45.09"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "wait",
				"time": "45.24"
			},
			{
				"duration": "0.21",
				"confidence": "0.760",
				"name": "till",
				"time": "45.48"
			},
			{
				"duration": "0.09",
				"confidence": "0.920",
				"name": "I",
				"time": "45.69"
			},
			{
				"duration": "0.35",
				"confidence": "1.000",
				"name": "used",
				"time": "45.79"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "it",
				"time": "46.14"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "for",
				"time": "46.29"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "46.44"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "little",
				"time": "46.50"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "while",
				"time": "46.74"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "before",
				"time": "47.70"
			},
			{
				"duration": "0.42",
				"confidence": "0.850",
				"name": "I",
				"time": "48.15"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "48.57"
			},
			{
				"duration": "0.33",
				"confidence": "0.980",
				"name": "Talked",
				"time": "48.84"
			},
			{
				"duration": "0.24",
				"confidence": "0.960",
				"name": "about",
				"time": "49.17"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "what",
				"time": "49.47"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "I",
				"time": "49.68"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "49.95"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "Found",
				"time": "50.61"
			},
			{
				"duration": "0.05",
				"confidence": "0.730",
				"name": ".",
				"time": "51.10"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "So",
				"time": "51.84"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "52.83"
			},
			{
				"duration": "0.18",
				"confidence": "0.890",
				"name": "get",
				"time": "52.92"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "this",
				"time": "53.10"
			},
			{
				"duration": "0.15",
				"confidence": "0.960",
				"name": "at",
				"time": "53.28"
			},
			{
				"duration": "0.50",
				"confidence": "0.630",
				"name": "Wal-Mart",
				"time": "53.44"
			},
			{
				"duration": "0.15",
				"confidence": "0.950",
				"name": "it's",
				"time": "53.94"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "like",
				"time": "54.09"
			},
			{
				"duration": "0.33",
				"confidence": "0.670",
				"name": "nine",
				"time": "54.24"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "dollars",
				"time": "54.57"
			},
			{
				"duration": "1.71",
				"confidence": "0.830",
				"name": ".",
				"time": "55.22"
			},
			{
				"duration": "0.34",
				"confidence": "0.850",
				"name": "Yeah",
				"time": "57.67"
			},
			{
				"duration": "0.35",
				"confidence": "0.690",
				"name": ".",
				"time": "58.09"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "Ninety",
				"time": "58.59"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "nine",
				"time": "58.95"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "point",
				"time": "59.22"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "eight",
				"time": "59.52"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "percent",
				"time": "59.73"
			},
			{
				"duration": "0.29",
				"confidence": "0.570",
				"name": "here",
				"time": "60.20"
			},
			{
				"duration": "0.45",
				"confidence": "0.430",
				"name": "elo",
				"time": "60.49"
			},
			{
				"duration": "0.14",
				"confidence": "0.700",
				"name": ".",
				"time": "60.97"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "No",
				"time": "61.29"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "sugars",
				"time": "61.47"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "starches",
				"time": "61.95"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "are",
				"time": "62.49"
			},
			{
				"duration": "0.71",
				"confidence": "0.800",
				"name": "signatories",
				"time": "62.61"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "made",
				"time": "63.33"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "with",
				"time": "63.57"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "naturally",
				"time": "63.72"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "grown",
				"time": "64.23"
			},
			{
				"duration": "0.58",
				"confidence": "0.710",
				"name": "aloe",
				"time": "64.59"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "65.17"
			},
			{
				"duration": "0.27",
				"confidence": "0.860",
				"name": "Says",
				"time": "67.75"
			},
			{
				"duration": "0.06",
				"confidence": "0.980",
				"name": "a",
				"time": "68.40"
			},
			{
				"duration": "0.42",
				"confidence": "0.770",
				"name": "Crinum",
				"time": "68.46"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "full",
				"time": "68.88"
			},
			{
				"duration": "0.34",
				"confidence": "1.000",
				"name": "strength",
				"time": "69.09"
			},
			{
				"duration": "0.48",
				"confidence": "0.630",
				"name": "virtual",
				"time": "69.43"
			},
			{
				"duration": "0.35",
				"confidence": "0.850",
				"name": "juice",
				"time": "69.94"
			},
			{
				"duration": "0.27",
				"confidence": "0.390",
				"name": "fruit",
				"time": "70.34"
			},
			{
				"duration": "0.15",
				"confidence": "0.800",
				"name": "the",
				"time": "70.64"
			},
			{
				"duration": "0.30",
				"confidence": "0.990",
				"name": "Earth",
				"time": "70.80"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "uses",
				"time": "71.10"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "only",
				"time": "71.43"
			},
			{
				"duration": "0.36",
				"confidence": "0.980",
				"name": "fresh",
				"time": "71.67"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "aloe",
				"time": "72.12"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "vera",
				"time": "72.36"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "gel",
				"time": "72.66"
			},
			{
				"duration": "0.69",
				"confidence": "0.830",
				"name": ".",
				"time": "73.11"
			},
			{
				"duration": "0.33",
				"confidence": "0.840",
				"name": "Brendan",
				"time": "73.95"
			},
			{
				"duration": "0.56",
				"confidence": "0.750",
				"name": "Miracle's",
				"time": "74.28"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "man",
				"time": "74.85"
			},
			{
				"duration": "0.18",
				"confidence": "0.940",
				"name": "to",
				"time": "75.10"
			},
			{
				"duration": "0.18",
				"confidence": "0.740",
				"name": "the",
				"time": "75.37"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "75.55"
			},
			{
				"duration": "0.48",
				"confidence": "0.330",
				"name": "Artist",
				"time": "76.13"
			},
			{
				"duration": "0.25",
				"confidence": "0.450",
				"name": "Nick",
				"time": "76.79"
			},
			{
				"duration": "0.45",
				"confidence": "0.990",
				"name": "contains",
				"time": "77.10"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "no",
				"time": "77.61"
			},
			{
				"duration": "0.36",
				"confidence": "0.910",
				"name": "sugar",
				"time": "77.79"
			},
			{
				"duration": "0.46",
				"confidence": "0.700",
				"name": "flavors",
				"time": "78.17"
			},
			{
				"duration": "0.18",
				"confidence": "0.890",
				"name": "so",
				"time": "79.35"
			},
			{
				"duration": "0.81",
				"confidence": "0.890",
				"name": "starches",
				"time": "79.55"
			},
			{
				"duration": "0.17",
				"confidence": "0.810",
				"name": ".",
				"time": "81.67"
			},
			{
				"duration": "0.28",
				"confidence": "0.850",
				"name": "Yet",
				"time": "83.35"
			},
			{
				"duration": "0.33",
				"confidence": "0.710",
				"name": "says",
				"time": "83.66"
			},
			{
				"duration": "0.19",
				"confidence": "0.460",
				"name": "his",
				"time": "84.10"
			},
			{
				"duration": "0.30",
				"confidence": "0.990",
				"name": "father",
				"time": "84.30"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "has",
				"time": "84.60"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "84.81"
			},
			{
				"duration": "0.35",
				"confidence": "1.000",
				"name": "temper",
				"time": "84.87"
			},
			{
				"duration": "0.39",
				"confidence": "0.750",
				"name": "resistant",
				"time": "85.25"
			},
			{
				"duration": "0.35",
				"confidence": "0.960",
				"name": "seal",
				"time": "85.64"
			},
			{
				"duration": "0.12",
				"confidence": "0.490",
				"name": "it",
				"time": "85.99"
			},
			{
				"duration": "0.23",
				"confidence": "1.000",
				"name": "must",
				"time": "86.11"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "be",
				"time": "86.34"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "broken",
				"time": "86.46"
			},
			{
				"duration": "0.16",
				"confidence": "0.840",
				"name": "to",
				"time": "86.92"
			},
			{
				"duration": "0.52",
				"confidence": "0.530",
				"name": "dispense",
				"time": "87.09"
			},
			{
				"duration": "0.48",
				"confidence": "0.950",
				"name": "product",
				"time": "87.66"
			},
			{
				"duration": "0.45",
				"confidence": "0.980",
				"name": ".",
				"time": "88.14"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "You",
				"time": "88.59"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "may",
				"time": "88.68"
			},
			{
				"duration": "0.33",
				"confidence": "0.990",
				"name": "notice",
				"time": "88.86"
			},
			{
				"duration": "0.09",
				"confidence": "0.890",
				"name": "a",
				"time": "89.19"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "difference",
				"time": "89.28"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "in",
				"time": "89.79"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "taste",
				"time": "89.94"
			},
			{
				"duration": "0.37",
				"confidence": "1.000",
				"name": "between",
				"time": "90.36"
			},
			{
				"duration": "0.08",
				"confidence": "0.720",
				"name": "the",
				"time": "90.73"
			},
			{
				"duration": "0.23",
				"confidence": "0.820",
				"name": "fruit",
				"time": "90.81"
			},
			{
				"duration": "0.06",
				"confidence": "0.730",
				"name": "of",
				"time": "91.04"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "the",
				"time": "91.11"
			},
			{
				"duration": "0.36",
				"confidence": "0.900",
				"name": "Earth's",
				"time": "91.23"
			},
			{
				"duration": "0.42",
				"confidence": "0.990",
				"name": "cranium",
				"time": "92.01"
			},
			{
				"duration": "0.44",
				"confidence": "0.720",
				"name": "Vergès",
				"time": "92.66"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "and",
				"time": "93.18"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "other",
				"time": "93.33"
			},
			{
				"duration": "0.30",
				"confidence": "0.430",
				"name": "bands",
				"time": "93.60"
			},
			{
				"duration": "0.26",
				"confidence": "0.330",
				"name": "foes",
				"time": "93.91"
			},
			{
				"duration": "0.21",
				"confidence": "0.570",
				"name": "drinks",
				"time": "94.17"
			},
			{
				"duration": "0.42",
				"confidence": "0.970",
				"name": "Elvir",
				"time": "94.41"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "juice",
				"time": "94.83"
			},
			{
				"duration": "0.18",
				"confidence": "0.970",
				"name": "has",
				"time": "95.10"
			},
			{
				"duration": "0.06",
				"confidence": "0.980",
				"name": "a",
				"time": "95.28"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "distinctive",
				"time": "95.34"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "taste",
				"time": "96.09"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "which",
				"time": "96.87"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "may",
				"time": "97.05"
			},
			{
				"duration": "0.15",
				"confidence": "0.980",
				"name": "not",
				"time": "97.20"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "be",
				"time": "97.35"
			},
			{
				"duration": "0.48",
				"confidence": "0.960",
				"name": "president",
				"time": "97.47"
			},
			{
				"duration": "0.42",
				"confidence": "0.970",
				"name": "products",
				"time": "97.95"
			},
			{
				"duration": "0.32",
				"confidence": "0.730",
				"name": "unless",
				"time": "98.40"
			},
			{
				"duration": "0.16",
				"confidence": "0.780",
				"name": "you",
				"time": "98.75"
			},
			{
				"duration": "0.50",
				"confidence": "0.660",
				"name": "curity",
				"time": "98.95"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "99.45"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "Regardless",
				"time": "99.78"
			},
			{
				"duration": "0.14",
				"confidence": "1.000",
				"name": "of",
				"time": "100.41"
			},
			{
				"duration": "0.34",
				"confidence": "0.700",
				"name": "legal",
				"time": "100.56"
			},
			{
				"duration": "0.47",
				"confidence": "0.520",
				"name": "claims",
				"time": "100.94"
			},
			{
				"duration": "1.32",
				"confidence": "0.950",
				"name": ".",
				"time": "101.52"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "So",
				"time": "103.56"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "103.77"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "was",
				"time": "103.86"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "pretty",
				"time": "104.04"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "nervous",
				"time": "104.34"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "to",
				"time": "104.82"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "try",
				"time": "105.72"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "this",
				"time": "106.05"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "106.29"
			},
			{
				"duration": "0.28",
				"confidence": "1.000",
				"name": "couple",
				"time": "106.35"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "months",
				"time": "106.65"
			},
			{
				"duration": "0.44",
				"confidence": "1.000",
				"name": "ago",
				"time": "106.95"
			},
			{
				"duration": "0.62",
				"confidence": "0.520",
				"name": "cause",
				"time": "108.29"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "108.91"
			},
			{
				"duration": "0.27",
				"confidence": "0.980",
				"name": "Like",
				"time": "109.52"
			},
			{
				"duration": "0.34",
				"confidence": "0.920",
				"name": "with",
				"time": "109.80"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "tasting",
				"time": "110.22"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "any",
				"time": "110.70"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "new",
				"time": "110.91"
			},
			{
				"duration": "0.27",
				"confidence": "0.990",
				"name": "thing",
				"time": "111.09"
			},
			{
				"duration": "0.12",
				"confidence": "0.830",
				"name": "I",
				"time": "111.36"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "get",
				"time": "111.48"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "like",
				"time": "111.69"
			},
			{
				"duration": "0.48",
				"confidence": "0.610",
				"name": "dieties",
				"time": "112.35"
			},
			{
				"duration": "0.47",
				"confidence": "1.000",
				"name": "so",
				"time": "112.86"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "113.33"
			},
			{
				"duration": "0.06",
				"confidence": "0.980",
				"name": "I",
				"time": "114.75"
			},
			{
				"duration": "0.27",
				"confidence": "0.940",
				"name": "thought",
				"time": "114.84"
			},
			{
				"duration": "0.36",
				"confidence": "0.980",
				"name": "OK",
				"time": "115.48"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "what",
				"time": "116.46"
			},
			{
				"duration": "0.15",
				"confidence": "0.910",
				"name": "if",
				"time": "116.61"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "this",
				"time": "116.76"
			},
			{
				"duration": "0.24",
				"confidence": "0.950",
				"name": "makes",
				"time": "116.94"
			},
			{
				"duration": "0.12",
				"confidence": "0.940",
				"name": "me",
				"time": "117.18"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "sick",
				"time": "117.30"
			},
			{
				"duration": "0.03",
				"confidence": "0.660",
				"name": ".",
				"time": "117.60"
			},
			{
				"duration": "0.36",
				"confidence": "0.990",
				"name": "But",
				"time": "117.64"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "119.37"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "know",
				"time": "119.49"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "I've",
				"time": "119.79"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "used",
				"time": "120.30"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "this",
				"time": "120.54"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "for",
				"time": "120.81"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "121.02"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "few",
				"time": "121.08"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "years",
				"time": "121.32"
			},
			{
				"duration": "0.23",
				"confidence": "1.000",
				"name": "now",
				"time": "121.62"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "my",
				"time": "121.92"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "hair",
				"time": "122.10"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "sometimes",
				"time": "122.94"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "mixed",
				"time": "123.42"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "with",
				"time": "123.72"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "vinegar",
				"time": "123.84"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "so",
				"time": "124.71"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "125.4"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I've",
				"time": "126.30"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "used",
				"time": "126.45"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "it",
				"time": "126.78"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "like",
				"time": "126.93"
			},
			{
				"duration": "0.12",
				"confidence": "0.890",
				"name": "on",
				"time": "127.17"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "my",
				"time": "127.29"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "skin",
				"time": "127.44"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "and",
				"time": "128.25"
			},
			{
				"duration": "0.36",
				"confidence": "0.970",
				"name": "that",
				"time": "128.37"
			},
			{
				"duration": "0.56",
				"confidence": "1.000",
				"name": "so",
				"time": "128.73"
			},
			{
				"duration": "0.25",
				"confidence": "0.930",
				"name": "yeah",
				"time": "130.19"
			},
			{
				"duration": "0.05",
				"confidence": "0.770",
				"name": ".",
				"time": "130.51"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "So",
				"time": "130.56"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "the",
				"time": "130.77"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "first",
				"time": "130.92"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "time",
				"time": "131.31"
			},
			{
				"duration": "0.15",
				"confidence": "0.880",
				"name": "I",
				"time": "131.70"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "tried",
				"time": "131.85"
			},
			{
				"duration": "0.26",
				"confidence": "1.000",
				"name": "it",
				"time": "132.33"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "132.59"
			},
			{
				"duration": "0.17",
				"confidence": "0.900",
				"name": "I'll",
				"time": "134.18"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "just",
				"time": "134.46"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "say",
				"time": "134.64"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "how",
				"time": "134.82"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "many",
				"time": "134.94"
			},
			{
				"duration": "0.36",
				"confidence": "0.980",
				"name": "litres",
				"time": "135.15"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "this",
				"time": "135.51"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "is",
				"time": "135.75"
			},
			{
				"duration": "1.47",
				"confidence": "0.920",
				"name": ".",
				"time": "136.02"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "Three",
				"time": "137.49"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "point",
				"time": "137.82"
			},
			{
				"duration": "0.32",
				"confidence": "0.520",
				"name": "seventy",
				"time": "138.15"
			},
			{
				"duration": "0.19",
				"confidence": "1.000",
				"name": "eight",
				"time": "138.47"
			},
			{
				"duration": "0.63",
				"confidence": "0.880",
				"name": "litres",
				"time": "138.69"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "139.32"
			},
			{
				"duration": "0.63",
				"confidence": "0.500",
				"name": "Yes",
				"time": "140.28"
			},
			{
				"duration": "0.14",
				"confidence": "0.560",
				"name": ".",
				"time": "140.94"
			},
			{
				"duration": "0.13",
				"confidence": "1.000",
				"name": "The",
				"time": "141.11"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "first",
				"time": "141.24"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "time",
				"time": "141.60"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "141.90"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "tried",
				"time": "141.99"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "it",
				"time": "142.50"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "142.71"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "I",
				"time": "144.21"
			},
			{
				"duration": "0.28",
				"confidence": "1.000",
				"name": "had",
				"time": "145.14"
			},
			{
				"duration": "0.20",
				"confidence": "0.950",
				"name": "it",
				"time": "145.42"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "145.77"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "little",
				"time": "145.86"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "bit",
				"time": "146.07"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "by",
				"time": "146.25"
			},
			{
				"duration": "0.51",
				"confidence": "0.930",
				"name": "itself",
				"time": "146.46"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "and",
				"time": "147.00"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "it",
				"time": "147.09"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "tasted",
				"time": "147.18"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "really",
				"time": "147.63"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "strong",
				"time": "147.99"
			},
			{
				"duration": "0.28",
				"confidence": "0.930",
				"name": "so",
				"time": "149.83"
			},
			{
				"duration": "0.14",
				"confidence": "0.800",
				"name": "that",
				"time": "150.19"
			},
			{
				"duration": "0.12",
				"confidence": "0.720",
				"name": "I",
				"time": "150.36"
			},
			{
				"duration": "0.36",
				"confidence": "0.830",
				"name": "mixed",
				"time": "150.48"
			},
			{
				"duration": "0.39",
				"confidence": "0.920",
				"name": ".",
				"time": "150.84"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "This",
				"time": "151.29"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "is",
				"time": "151.50"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "what",
				"time": "151.62"
			},
			{
				"duration": "0.09",
				"confidence": "0.810",
				"name": "I",
				"time": "151.80"
			},
			{
				"duration": "0.34",
				"confidence": "1.000",
				"name": "get",
				"time": "151.89"
			},
			{
				"duration": "0.03",
				"confidence": "0.720",
				"name": ".",
				"time": "152.23"
			},
			{
				"duration": "0.15",
				"confidence": "0.900",
				"name": "It's",
				"time": "152.34"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "like",
				"time": "152.49"
			},
			{
				"duration": "0.59",
				"confidence": "0.970",
				"name": "99",
				"time": "152.67"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "cents",
				"time": "153.27"
			},
			{
				"duration": "0.09",
				"confidence": "0.980",
				"name": "at",
				"time": "153.57"
			},
			{
				"duration": "0.48",
				"confidence": "0.580",
				"name": "Wal-Mart",
				"time": "153.66"
			},
			{
				"duration": "0.48",
				"confidence": "0.810",
				"name": "Birdie's",
				"time": "154.17"
			},
			{
				"duration": "0.32",
				"confidence": "0.970",
				"name": "apple",
				"time": "154.65"
			},
			{
				"duration": "0.24",
				"confidence": "0.540",
				"name": "juice",
				"time": "154.97"
			},
			{
				"duration": "0.45",
				"confidence": "0.540",
				"name": "is",
				"time": "155.21"
			},
			{
				"duration": "0.24",
				"confidence": "0.930",
				"name": "one",
				"time": "156.03"
			},
			{
				"duration": "0.42",
				"confidence": "0.800",
				"name": "later",
				"time": "156.27"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": ".",
				"time": "156.72"
			},
			{
				"duration": "0.14",
				"confidence": "0.960",
				"name": "So",
				"time": "157.70"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "what",
				"time": "157.86"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I'll",
				"time": "158.01"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "do",
				"time": "158.13"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "is",
				"time": "158.37"
			},
			{
				"duration": "0.09",
				"confidence": "0.620",
				"name": "I'll",
				"time": "158.49"
			},
			{
				"duration": "0.25",
				"confidence": "0.620",
				"name": "miss",
				"time": "158.60"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "158.85"
			},
			{
				"duration": "0.14",
				"confidence": "0.950",
				"name": "bit",
				"time": "158.88"
			},
			{
				"duration": "0.04",
				"confidence": "0.480",
				"name": "of",
				"time": "159.02"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "apple",
				"time": "159.06"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "juice",
				"time": "159.42"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "and",
				"time": "159.87"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "that",
				"time": "159.99"
			},
			{
				"duration": "0.32",
				"confidence": "1.000",
				"name": "helps",
				"time": "160.20"
			},
			{
				"duration": "0.22",
				"confidence": "0.620",
				"name": "soothe",
				"time": "160.52"
			},
			{
				"duration": "0.09",
				"confidence": "0.960",
				"name": "the",
				"time": "160.74"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "taste",
				"time": "160.83"
			},
			{
				"duration": "1.15",
				"confidence": "0.880",
				"name": ".",
				"time": "161.43"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "So",
				"time": "162.84"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "yeah",
				"time": "163.08"
			},
			{
				"duration": "0.15",
				"confidence": "0.960",
				"name": "when",
				"time": "163.26"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "163.41"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "first",
				"time": "163.50"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "tried",
				"time": "164.19"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "it",
				"time": "164.52"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I",
				"time": "164.70"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "thought",
				"time": "164.85"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "wow",
				"time": "165.18"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "this",
				"time": "165.48"
			},
			{
				"duration": "0.13",
				"confidence": "0.930",
				"name": "is",
				"time": "165.83"
			},
			{
				"duration": "0.24",
				"confidence": "0.930",
				"name": "kind",
				"time": "165.96"
			},
			{
				"duration": "0.06",
				"confidence": "0.930",
				"name": "of",
				"time": "166.20"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "like",
				"time": "166.26"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "hair",
				"time": "167.07"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "gel",
				"time": "167.34"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "167.64"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "little",
				"time": "167.67"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "bit",
				"time": "167.97"
			},
			{
				"duration": "0.17",
				"confidence": "0.970",
				"name": "like",
				"time": "168.59"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "I",
				"time": "168.78"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "don't",
				"time": "168.84"
			},
			{
				"duration": "0.13",
				"confidence": "1.000",
				"name": "know",
				"time": "168.96"
			},
			{
				"duration": "0.11",
				"confidence": "0.700",
				"name": "what",
				"time": "169.09"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "hair",
				"time": "169.20"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "gel",
				"time": "169.47"
			},
			{
				"duration": "0.39",
				"confidence": "0.930",
				"name": "tastes",
				"time": "169.71"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "like",
				"time": "170.10"
			},
			{
				"duration": "0.24",
				"confidence": "0.990",
				"name": "but",
				"time": "170.34"
			},
			{
				"duration": "0.20",
				"confidence": "0.510",
				"name": "I",
				"time": "170.83"
			},
			{
				"duration": "0.49",
				"confidence": "0.640",
				"name": "tasted",
				"time": "171.51"
			},
			{
				"duration": "0.22",
				"confidence": "0.790",
				"name": "it",
				"time": "172.02"
			},
			{
				"duration": "0.14",
				"confidence": "0.620",
				"name": ".",
				"time": "172.24"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "I",
				"time": "172.44"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "was",
				"time": "172.86"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "like",
				"time": "173.07"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "this",
				"time": "173.31"
			},
			{
				"duration": "0.45",
				"confidence": "0.920",
				"name": "probably",
				"time": "173.52"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "is",
				"time": "173.97"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "what",
				"time": "174.12"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "hair",
				"time": "174.33"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "gel",
				"time": "174.60"
			},
			{
				"duration": "0.33",
				"confidence": "0.920",
				"name": "tastes",
				"time": "174.90"
			},
			{
				"duration": "0.25",
				"confidence": "1.000",
				"name": "like",
				"time": "175.23"
			},
			{
				"duration": "0.44",
				"confidence": "0.860",
				"name": ".",
				"time": "175.48"
			},
			{
				"duration": "0.11",
				"confidence": "0.560",
				"name": "It",
				"time": "175.96"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "176.07"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "Sounds",
				"time": "176.31"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "weird",
				"time": "176.70"
			},
			{
				"duration": "0.38",
				"confidence": "0.700",
				"name": ".",
				"time": "177.06"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "So",
				"time": "177.60"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "178.89"
			},
			{
				"duration": "0.22",
				"confidence": "0.930",
				"name": "go",
				"time": "178.98"
			},
			{
				"duration": "0.48",
				"confidence": "0.570",
				"name": "servo",
				"time": "179.20"
			},
			{
				"duration": "0.27",
				"confidence": "0.620",
				"name": "to",
				"time": "179.68"
			},
			{
				"duration": "0.24",
				"confidence": "0.820",
				"name": "these",
				"time": "179.97"
			},
			{
				"duration": "0.26",
				"confidence": "0.930",
				"name": "just",
				"time": "180.21"
			},
			{
				"duration": "0.13",
				"confidence": "0.330",
				"name": "that",
				"time": "180.47"
			},
			{
				"duration": "0.31",
				"confidence": "0.880",
				"name": "day",
				"time": "180.60"
			},
			{
				"duration": "0.02",
				"confidence": "0.590",
				"name": ".",
				"time": "180.91"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "This",
				"time": "180.93"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "is",
				"time": "181.14"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "what",
				"time": "181.23"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "it",
				"time": "181.38"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "looks",
				"time": "181.47"
			},
			{
				"duration": "0.19",
				"confidence": "1.000",
				"name": "like",
				"time": "181.71"
			},
			{
				"duration": "0.02",
				"confidence": "0.800",
				"name": ".",
				"time": "181.90"
			},
			{
				"duration": "0.43",
				"confidence": "0.810",
				"name": "Floyd",
				"time": "181.92"
			},
			{
				"duration": "0.18",
				"confidence": "0.760",
				"name": "just",
				"time": "182.35"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "picked",
				"time": "182.55"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "up",
				"time": "182.82"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "another",
				"time": "183.00"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "one",
				"time": "183.33"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "today",
				"time": "183.48"
			},
			{
				"duration": "0.02",
				"confidence": "0.560",
				"name": ".",
				"time": "183.99"
			}
		],
		"format": "1.0"
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports = {
		"job": {
			"lang": "en",
			"user_id": 46548,
			"name": "anxiety.mp3",
			"duration": 185,
			"created_at": "Fri Jul 27 20:11:53 2018",
			"id": 8856515
		},
		"speakers": [
			{
				"duration": "1.13",
				"confidence": null,
				"name": "F1",
				"time": "3.43"
			},
			{
				"duration": "177.77",
				"confidence": null,
				"name": "F2",
				"time": "7.09"
			}
		],
		"words": [
			{
				"duration": "0.21",
				"confidence": "0.470",
				"name": "Wow",
				"time": "3.43"
			},
			{
				"duration": "0.54",
				"confidence": "0.670",
				"name": ".",
				"time": "4.02"
			},
			{
				"duration": "0.18",
				"confidence": "0.900",
				"name": "So",
				"time": "7.09"
			},
			{
				"duration": "0.09",
				"confidence": "0.960",
				"name": "I",
				"time": "8.64"
			},
			{
				"duration": "0.25",
				"confidence": "0.900",
				"name": "really",
				"time": "8.73"
			},
			{
				"duration": "0.27",
				"confidence": "0.500",
				"name": "release",
				"time": "9.30"
			},
			{
				"duration": "0.19",
				"confidence": "0.470",
				"name": "them",
				"time": "9.74"
			},
			{
				"duration": "0.18",
				"confidence": "0.520",
				"name": "my",
				"time": "10.00"
			},
			{
				"duration": "0.31",
				"confidence": "0.990",
				"name": "last",
				"time": "10.22"
			},
			{
				"duration": "0.41",
				"confidence": "0.950",
				"name": "video",
				"time": "10.53"
			},
			{
				"duration": "0.04",
				"confidence": "0.640",
				"name": ".",
				"time": "13.34"
			},
			{
				"duration": "0.61",
				"confidence": "0.880",
				"name": "Pluto",
				"time": "13.76"
			},
			{
				"duration": "0.34",
				"confidence": "0.910",
				"name": "that's",
				"time": "14.39"
			},
			{
				"duration": "0.18",
				"confidence": "0.960",
				"name": "no",
				"time": "14.74"
			},
			{
				"duration": "0.41",
				"confidence": "0.960",
				"name": "different",
				"time": "15.43"
			},
			{
				"duration": "1.11",
				"confidence": "0.740",
				"name": ".",
				"time": "15.85"
			},
			{
				"duration": "0.11",
				"confidence": "0.570",
				"name": "And",
				"time": "16.98"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "17.20"
			},
			{
				"duration": "0.17",
				"confidence": "0.640",
				"name": "can",
				"time": "17.32"
			},
			{
				"duration": "0.46",
				"confidence": "1.000",
				"name": "probably",
				"time": "17.49"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "hear",
				"time": "17.95"
			},
			{
				"duration": "0.15",
				"confidence": "0.680",
				"name": "that",
				"time": "19.94"
			},
			{
				"duration": "0.15",
				"confidence": "0.330",
				"name": ".",
				"time": "20.37"
			},
			{
				"duration": "0.12",
				"confidence": "0.910",
				"name": "But",
				"time": "20.58"
			},
			{
				"duration": "0.28",
				"confidence": "0.920",
				"name": "seeing",
				"time": "20.93"
			},
			{
				"duration": "0.20",
				"confidence": "0.690",
				"name": "that",
				"time": "21.24"
			},
			{
				"duration": "0.33",
				"confidence": "0.210",
				"name": "bronze",
				"time": "21.45"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I'm",
				"time": "21.79"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "sorry",
				"time": "21.88"
			},
			{
				"duration": "0.20",
				"confidence": "0.840",
				"name": "can",
				"time": "22.21"
			},
			{
				"duration": "0.11",
				"confidence": "0.580",
				"name": "you",
				"time": "22.46"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "hear",
				"time": "22.60"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "me",
				"time": "22.81"
			},
			{
				"duration": "0.03",
				"confidence": "0.860",
				"name": ".",
				"time": "23.11"
			},
			{
				"duration": "0.29",
				"confidence": "0.940",
				"name": "But",
				"time": "23.18"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "23.47"
			},
			{
				"duration": "0.21",
				"confidence": "0.470",
				"name": "Life",
				"time": "27.80"
			},
			{
				"duration": "0.14",
				"confidence": "0.300",
				"name": "is",
				"time": "28.29"
			},
			{
				"duration": "0.36",
				"confidence": "0.330",
				"name": "finished",
				"time": "28.55"
			},
			{
				"duration": "0.33",
				"confidence": "0.770",
				"name": ".",
				"time": "29.08"
			},
			{
				"duration": "0.50",
				"confidence": "0.990",
				"name": "We're",
				"time": "29.99"
			},
			{
				"duration": "0.35",
				"confidence": "0.820",
				"name": "running",
				"time": "31.70"
			},
			{
				"duration": "0.41",
				"confidence": "0.590",
				"name": ".",
				"time": "32.67"
			},
			{
				"duration": "0.25",
				"confidence": "0.900",
				"name": "We",
				"time": "33.54"
			},
			{
				"duration": "0.11",
				"confidence": "0.760",
				"name": "are",
				"time": "34.13"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "still",
				"time": "34.34"
			},
			{
				"duration": "0.37",
				"confidence": "0.890",
				"name": "growing",
				"time": "34.70"
			},
			{
				"duration": "0.12",
				"confidence": "0.750",
				"name": "up",
				"time": "35.07"
			},
			{
				"duration": "0.06",
				"confidence": "0.500",
				"name": ".",
				"time": "35.20"
			},
			{
				"duration": "0.19",
				"confidence": "0.300",
				"name": "And",
				"time": "35.43"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "now",
				"time": "35.69"
			},
			{
				"duration": "0.52",
				"confidence": "0.400",
				"name": "realizing",
				"time": "36.06"
			},
			{
				"duration": "0.27",
				"confidence": "0.950",
				"name": "holy",
				"time": "36.64"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "shit",
				"time": "36.92"
			},
			{
				"duration": "0.11",
				"confidence": "0.710",
				"name": "I",
				"time": "37.53"
			},
			{
				"duration": "0.30",
				"confidence": "0.710",
				"name": "don't",
				"time": "37.67"
			},
			{
				"duration": "0.28",
				"confidence": "0.740",
				"name": "now",
				"time": "38.07"
			},
			{
				"duration": "0.14",
				"confidence": "0.910",
				"name": "and",
				"time": "39.22"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "that's",
				"time": "39.41"
			},
			{
				"duration": "0.26",
				"confidence": "0.710",
				"name": "very",
				"time": "39.62"
			},
			{
				"duration": "0.22",
				"confidence": "0.390",
				"name": "weird",
				"time": "39.88"
			},
			{
				"duration": "0.22",
				"confidence": "0.780",
				"name": "for",
				"time": "40.13"
			},
			{
				"duration": "0.11",
				"confidence": "0.810",
				"name": "me",
				"time": "40.35"
			},
			{
				"duration": "0.55",
				"confidence": "0.440",
				"name": ".",
				"time": "40.47"
			},
			{
				"duration": "0.18",
				"confidence": "0.510",
				"name": "For",
				"time": "45.55"
			},
			{
				"duration": "0.16",
				"confidence": "0.530",
				"name": "sure",
				"time": "45.84"
			},
			{
				"duration": "0.07",
				"confidence": "0.890",
				"name": "I",
				"time": "46.05"
			},
			{
				"duration": "0.25",
				"confidence": "0.770",
				"name": "no",
				"time": "46.16"
			},
			{
				"duration": "0.29",
				"confidence": "0.760",
				"name": "longer",
				"time": "46.41"
			},
			{
				"duration": "0.32",
				"confidence": "0.730",
				"name": "do",
				"time": "48.58"
			},
			{
				"duration": "0.10",
				"confidence": "0.450",
				"name": ".",
				"time": "49.46"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "My",
				"time": "49.57"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "boyfriend",
				"time": "49.69"
			},
			{
				"duration": "0.21",
				"confidence": "0.380",
				"name": "just",
				"time": "51.14"
			},
			{
				"duration": "0.33",
				"confidence": "0.880",
				"name": "weird",
				"time": "52.28"
			},
			{
				"duration": "0.23",
				"confidence": "0.620",
				"name": ".",
				"time": "52.67"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "Really",
				"time": "53.08"
			},
			{
				"duration": "0.26",
				"confidence": "0.860",
				"name": "is",
				"time": "53.44"
			},
			{
				"duration": "0.15",
				"confidence": "0.430",
				"name": "been",
				"time": "53.84"
			},
			{
				"duration": "0.14",
				"confidence": "0.440",
				"name": "over",
				"time": "54.05"
			},
			{
				"duration": "0.46",
				"confidence": "0.610",
				"name": "boy",
				"time": "54.21"
			},
			{
				"duration": "0.22",
				"confidence": "0.800",
				"name": "and",
				"time": "55.13"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "boys",
				"time": "55.42"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "are",
				"time": "55.72"
			},
			{
				"duration": "0.27",
				"confidence": "0.380",
				"name": "messy",
				"time": "55.82"
			},
			{
				"duration": "0.14",
				"confidence": "0.700",
				"name": ".",
				"time": "56.17"
			},
			{
				"duration": "0.16",
				"confidence": "0.740",
				"name": "It's",
				"time": "56.44"
			},
			{
				"duration": "0.23",
				"confidence": "0.600",
				"name": "very",
				"time": "56.90"
			},
			{
				"duration": "0.26",
				"confidence": "0.810",
				"name": "very",
				"time": "57.21"
			},
			{
				"duration": "0.35",
				"confidence": "0.600",
				"name": "rare",
				"time": "57.58"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "but",
				"time": "58.18"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "it's",
				"time": "58.39"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "nice",
				"time": "58.57"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "because",
				"time": "58.93"
			},
			{
				"duration": "0.17",
				"confidence": "0.810",
				"name": "other",
				"time": "59.96"
			},
			{
				"duration": "0.42",
				"confidence": "0.990",
				"name": "days",
				"time": "60.46"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "61.54"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "don't",
				"time": "61.87"
			},
			{
				"duration": "0.33",
				"confidence": "0.990",
				"name": "really",
				"time": "62.05"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "see",
				"time": "62.38"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "myself",
				"time": "62.56"
			},
			{
				"duration": "0.24",
				"confidence": "0.960",
				"name": "doing",
				"time": "64.00"
			},
			{
				"duration": "0.11",
				"confidence": "0.900",
				"name": "as",
				"time": "64.27"
			},
			{
				"duration": "0.18",
				"confidence": "0.890",
				"name": "well",
				"time": "64.39"
			},
			{
				"duration": "0.41",
				"confidence": "0.950",
				"name": "alone",
				"time": "64.59"
			},
			{
				"duration": "0.96",
				"confidence": "0.900",
				"name": ".",
				"time": "66.40"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "68.47"
			},
			{
				"duration": "0.24",
				"confidence": "0.980",
				"name": "can't",
				"time": "68.59"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "remember",
				"time": "68.83"
			},
			{
				"duration": "0.09",
				"confidence": "0.460",
				"name": "if",
				"time": "69.22"
			},
			{
				"duration": "0.19",
				"confidence": "0.470",
				"name": "ever",
				"time": "69.34"
			},
			{
				"duration": "0.45",
				"confidence": "0.850",
				"name": "mention",
				"time": "69.56"
			},
			{
				"duration": "0.49",
				"confidence": "0.930",
				"name": "video",
				"time": "71.03"
			},
			{
				"duration": "0.34",
				"confidence": "0.790",
				"name": "I",
				"time": "72.01"
			},
			{
				"duration": "0.26",
				"confidence": "0.700",
				"name": "told",
				"time": "72.49"
			},
			{
				"duration": "0.10",
				"confidence": "0.950",
				"name": "you",
				"time": "72.78"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "guys",
				"time": "72.88"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "about",
				"time": "73.15"
			},
			{
				"duration": "0.46",
				"confidence": "0.530",
				"name": "Xabier",
				"time": "73.70"
			},
			{
				"duration": "0.14",
				"confidence": "0.700",
				"name": "or",
				"time": "74.20"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "not",
				"time": "74.35"
			},
			{
				"duration": "0.20",
				"confidence": "0.550",
				"name": ".",
				"time": "74.62"
			},
			{
				"duration": "0.31",
				"confidence": "0.870",
				"name": "Right",
				"time": "74.96"
			},
			{
				"duration": "0.64",
				"confidence": "0.730",
				"name": ".",
				"time": "75.27"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "I",
				"time": "76.15"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "will",
				"time": "76.36"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "tell",
				"time": "76.54"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "you",
				"time": "76.75"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "about",
				"time": "76.81"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "it",
				"time": "77.08"
			},
			{
				"duration": "0.30",
				"confidence": "0.990",
				"name": "now",
				"time": "77.14"
			},
			{
				"duration": "1.06",
				"confidence": "0.590",
				"name": ".",
				"time": "77.89"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "79.39"
			},
			{
				"duration": "0.18",
				"confidence": "0.980",
				"name": "do",
				"time": "79.48"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "suffer",
				"time": "79.66"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "from",
				"time": "79.96"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "anxiety",
				"time": "80.14"
			},
			{
				"duration": "0.39",
				"confidence": "0.420",
				"name": ".",
				"time": "80.93"
			},
			{
				"duration": "0.15",
				"confidence": "0.790",
				"name": "Right",
				"time": "81.49"
			},
			{
				"duration": "1.10",
				"confidence": "0.750",
				"name": ".",
				"time": "81.79"
			},
			{
				"duration": "0.47",
				"confidence": "0.960",
				"name": "So",
				"time": "83.22"
			},
			{
				"duration": "0.44",
				"confidence": "0.900",
				"name": "that's",
				"time": "83.69"
			},
			{
				"duration": "0.07",
				"confidence": "0.450",
				"name": "a",
				"time": "84.14"
			},
			{
				"duration": "0.31",
				"confidence": "0.940",
				"name": "point",
				"time": "84.22"
			},
			{
				"duration": "0.13",
				"confidence": "0.720",
				"name": "where",
				"time": "84.56"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "85.09"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "can't",
				"time": "85.21"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "focus",
				"time": "85.60"
			},
			{
				"duration": "0.17",
				"confidence": "0.900",
				"name": "for",
				"time": "86.11"
			},
			{
				"duration": "0.27",
				"confidence": "0.890",
				"name": "four",
				"time": "86.29"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "86.56"
			},
			{
				"duration": "0.27",
				"confidence": "0.890",
				"name": "five",
				"time": "86.68"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "days",
				"time": "86.95"
			},
			{
				"duration": "0.57",
				"confidence": "0.540",
				"name": "check",
				"time": "87.90"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "everything",
				"time": "88.48"
			},
			{
				"duration": "0.22",
				"confidence": "0.860",
				"name": "feels",
				"time": "88.99"
			},
			{
				"duration": "0.15",
				"confidence": "0.830",
				"name": "like",
				"time": "89.21"
			},
			{
				"duration": "0.12",
				"confidence": "0.770",
				"name": "a",
				"time": "89.37"
			},
			{
				"duration": "0.43",
				"confidence": "0.460",
				"name": "jillion",
				"time": "89.50"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "89.98"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "me",
				"time": "90.13"
			},
			{
				"duration": "0.27",
				"confidence": "0.800",
				"name": ".",
				"time": "90.31"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "Sometimes",
				"time": "90.64"
			},
			{
				"duration": "0.06",
				"confidence": "0.990",
				"name": "I",
				"time": "91.21"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "can't",
				"time": "91.27"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "remember",
				"time": "91.51"
			},
			{
				"duration": "0.12",
				"confidence": "0.670",
				"name": "what",
				"time": "91.81"
			},
			{
				"duration": "0.18",
				"confidence": "0.980",
				"name": "I'm",
				"time": "91.93"
			},
			{
				"duration": "0.25",
				"confidence": "0.730",
				"name": "saying",
				"time": "92.12"
			},
			{
				"duration": "0.44",
				"confidence": "0.800",
				"name": ".",
				"time": "92.50"
			},
			{
				"duration": "0.46",
				"confidence": "0.990",
				"name": "Continue",
				"time": "93.11"
			},
			{
				"duration": "0.44",
				"confidence": "0.950",
				"name": "talking",
				"time": "93.58"
			},
			{
				"duration": "0.16",
				"confidence": "0.600",
				"name": "and",
				"time": "94.02"
			},
			{
				"duration": "0.41",
				"confidence": "1.000",
				"name": "forget",
				"time": "94.42"
			},
			{
				"duration": "0.23",
				"confidence": "0.970",
				"name": "like",
				"time": "94.84"
			},
			{
				"duration": "0.18",
				"confidence": "0.820",
				"name": "I",
				"time": "95.77"
			},
			{
				"duration": "0.15",
				"confidence": "0.820",
				"name": "am",
				"time": "95.99"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "right",
				"time": "96.16"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "now",
				"time": "96.31"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "I'm",
				"time": "96.79"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "not",
				"time": "97.00"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "as",
				"time": "97.15"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "bad",
				"time": "97.36"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "as",
				"time": "97.93"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "98.11"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "was",
				"time": "98.20"
			},
			{
				"duration": "0.22",
				"confidence": "0.950",
				"name": "and",
				"time": "99.48"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I",
				"time": "99.70"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "also",
				"time": "99.85"
			},
			{
				"duration": "0.39",
				"confidence": "0.990",
				"name": "suffer",
				"time": "100.27"
			},
			{
				"duration": "0.23",
				"confidence": "1.000",
				"name": "from",
				"time": "100.66"
			},
			{
				"duration": "0.28",
				"confidence": "0.590",
				"name": "really",
				"time": "100.93"
			},
			{
				"duration": "0.16",
				"confidence": "0.590",
				"name": "bad",
				"time": "101.21"
			},
			{
				"duration": "0.35",
				"confidence": "0.670",
				"name": "headache",
				"time": "101.57"
			},
			{
				"duration": "1.16",
				"confidence": "0.710",
				"name": ".",
				"time": "102.11"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "I",
				"time": "103.60"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "am",
				"time": "103.90"
			},
			{
				"duration": "0.15",
				"confidence": "0.910",
				"name": "in",
				"time": "104.23"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "a",
				"time": "104.38"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "really",
				"time": "104.98"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "scary",
				"time": "105.49"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "situation",
				"time": "106.00"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": "that",
				"time": "106.51"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "I",
				"time": "106.60"
			},
			{
				"duration": "0.20",
				"confidence": "0.980",
				"name": "think",
				"time": "106.72"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "is",
				"time": "106.93"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "scary",
				"time": "106.99"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "107.38"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "me",
				"time": "107.53"
			},
			{
				"duration": "0.09",
				"confidence": "0.540",
				"name": ".",
				"time": "108.10"
			},
			{
				"duration": "0.08",
				"confidence": "0.910",
				"name": "I",
				"time": "108.59"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "feel",
				"time": "108.67"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "like",
				"time": "108.82"
			},
			{
				"duration": "0.11",
				"confidence": "0.620",
				"name": "I've",
				"time": "109.00"
			},
			{
				"duration": "0.28",
				"confidence": "0.630",
				"name": "been",
				"time": "109.11"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "attacked",
				"time": "109.39"
			},
			{
				"duration": "0.40",
				"confidence": "0.590",
				"name": "my",
				"time": "110.67"
			},
			{
				"duration": "0.12",
				"confidence": "0.650",
				"name": "I",
				"time": "112.37"
			},
			{
				"duration": "0.20",
				"confidence": "0.630",
				"name": "will",
				"time": "112.58"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "literally",
				"time": "112.90"
			},
			{
				"duration": "0.36",
				"confidence": "0.990",
				"name": "freeze",
				"time": "113.38"
			},
			{
				"duration": "0.09",
				"confidence": "0.850",
				"name": "up",
				"time": "113.74"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "for",
				"time": "113.83"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "about",
				"time": "114.01"
			},
			{
				"duration": "0.27",
				"confidence": "0.800",
				"name": "3",
				"time": "115.48"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "seconds",
				"time": "115.75"
			},
			{
				"duration": "0.18",
				"confidence": "0.800",
				"name": "I'll",
				"time": "116.25"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "stop",
				"time": "116.68"
			},
			{
				"duration": "0.47",
				"confidence": "1.000",
				"name": "breathing",
				"time": "116.98"
			},
			{
				"duration": "0.15",
				"confidence": "0.920",
				"name": "all",
				"time": "117.49"
			},
			{
				"duration": "0.20",
				"confidence": "0.910",
				"name": "that",
				"time": "117.64"
			},
			{
				"duration": "0.14",
				"confidence": "0.960",
				"name": "and",
				"time": "117.89"
			},
			{
				"duration": "0.11",
				"confidence": "0.530",
				"name": "then",
				"time": "118.03"
			},
			{
				"duration": "0.11",
				"confidence": "0.840",
				"name": "I'm",
				"time": "118.15"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "not",
				"time": "118.39"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "going",
				"time": "119.14"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "to",
				"time": "119.32"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "walk",
				"time": "119.38"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "out",
				"time": "119.68"
			},
			{
				"duration": "1.59",
				"confidence": "0.800",
				"name": ".",
				"time": "119.95"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "I",
				"time": "121.93"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "will",
				"time": "122.79"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "just",
				"time": "123.31"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "start",
				"time": "123.52"
			},
			{
				"duration": "0.90",
				"confidence": "1.000",
				"name": "hyperventilating",
				"time": "123.73"
			},
			{
				"duration": "0.25",
				"confidence": "0.710",
				"name": "things",
				"time": "125.10"
			},
			{
				"duration": "0.32",
				"confidence": "0.970",
				"name": "straight",
				"time": "125.35"
			},
			{
				"duration": "0.05",
				"confidence": "0.620",
				"name": ".",
				"time": "125.67"
			},
			{
				"duration": "0.42",
				"confidence": "0.980",
				"name": "Can't",
				"time": "125.74"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "talk",
				"time": "126.16"
			},
			{
				"duration": "0.42",
				"confidence": "0.990",
				"name": "straight",
				"time": "126.49"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "can't",
				"time": "127.06"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "do",
				"time": "127.33"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "anything",
				"time": "127.54"
			},
			{
				"duration": "0.39",
				"confidence": "0.520",
				"name": "Istria",
				"time": "127.99"
			},
			{
				"duration": "0.10",
				"confidence": "0.590",
				"name": "I",
				"time": "129.79"
			},
			{
				"duration": "0.44",
				"confidence": "0.940",
				"name": "start",
				"time": "130.14"
			},
			{
				"duration": "0.71",
				"confidence": "0.920",
				"name": "crying",
				"time": "130.58"
			},
			{
				"duration": "0.92",
				"confidence": "0.980",
				"name": "hyperventilating",
				"time": "131.87"
			},
			{
				"duration": "0.09",
				"confidence": "0.590",
				"name": "or",
				"time": "133.02"
			},
			{
				"duration": "0.58",
				"confidence": "0.660",
				"name": "goostrey",
				"time": "133.26"
			},
			{
				"duration": "0.42",
				"confidence": "0.250",
				"name": "speaking",
				"time": "133.90"
			},
			{
				"duration": "1.30",
				"confidence": "0.680",
				"name": ".",
				"time": "134.79"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "138.45"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "feel",
				"time": "138.57"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "like",
				"time": "138.69"
			},
			{
				"duration": "0.09",
				"confidence": "0.980",
				"name": "I'm",
				"time": "138.84"
			},
			{
				"duration": "0.03",
				"confidence": "0.980",
				"name": "a",
				"time": "138.93"
			},
			{
				"duration": "0.34",
				"confidence": "0.510",
				"name": "mess",
				"time": "138.96"
			},
			{
				"duration": "0.87",
				"confidence": "0.800",
				"name": ".",
				"time": "139.50"
			},
			{
				"duration": "0.22",
				"confidence": "0.900",
				"name": "This",
				"time": "140.48"
			},
			{
				"duration": "0.08",
				"confidence": "0.900",
				"name": "is",
				"time": "140.72"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "just",
				"time": "140.85"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "part",
				"time": "141.00"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "141.24"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "my",
				"time": "141.30"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "life",
				"time": "141.45"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "and",
				"time": "141.81"
			},
			{
				"duration": "0.11",
				"confidence": "0.920",
				"name": "I",
				"time": "141.93"
			},
			{
				"duration": "0.13",
				"confidence": "0.900",
				"name": "will",
				"time": "142.04"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "get",
				"time": "142.17"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "through",
				"time": "142.38"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "it",
				"time": "142.68"
			},
			{
				"duration": "0.24",
				"confidence": "0.990",
				"name": "because",
				"time": "143.10"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "143.34"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "believe",
				"time": "143.46"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "143.91"
			},
			{
				"duration": "0.52",
				"confidence": "1.000",
				"name": "can",
				"time": "144.03"
			},
			{
				"duration": "0.21",
				"confidence": "0.850",
				"name": "and",
				"time": "144.60"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "things",
				"time": "145.35"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "will",
				"time": "145.68"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "get",
				"time": "145.86"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "easier",
				"time": "146.04"
			},
			{
				"duration": "0.06",
				"confidence": "0.760",
				"name": ".",
				"time": "146.61"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "Things",
				"time": "146.67"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "will",
				"time": "146.97"
			},
			{
				"duration": "0.15",
				"confidence": "0.880",
				"name": "get",
				"time": "147.09"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "better",
				"time": "147.24"
			},
			{
				"duration": "0.11",
				"confidence": "0.420",
				"name": ".",
				"time": "147.63"
			},
			{
				"duration": "0.23",
				"confidence": "0.950",
				"name": "Just",
				"time": "147.81"
			},
			{
				"duration": "0.19",
				"confidence": "0.870",
				"name": "right",
				"time": "148.03"
			},
			{
				"duration": "0.29",
				"confidence": "0.870",
				"name": "now",
				"time": "148.23"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "things",
				"time": "148.68"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "are",
				"time": "149.19"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "not",
				"time": "149.31"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "150.03"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "way",
				"time": "150.12"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "I",
				"time": "150.27"
			},
			{
				"duration": "0.32",
				"confidence": "0.990",
				"name": "want",
				"time": "150.45"
			},
			{
				"duration": "0.42",
				"confidence": "0.770",
				"name": "them",
				"time": "150.77"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "151.35"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "be",
				"time": "151.47"
			},
			{
				"duration": "0.20",
				"confidence": "0.880",
				"name": ".",
				"time": "151.77"
			},
			{
				"duration": "0.15",
				"confidence": "0.980",
				"name": "I'm",
				"time": "152.97"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "doing",
				"time": "153.12"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "what",
				"time": "153.39"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "153.54"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "can",
				"time": "153.66"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "154.29"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "For",
				"time": "155.31"
			},
			{
				"duration": "0.73",
				"confidence": "0.970",
				"name": "myself",
				"time": "155.55"
			},
			{
				"duration": "0.24",
				"confidence": "0.710",
				"name": "for",
				"time": "156.31"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "156.55"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "What",
				"time": "158.37"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "158.61"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "need",
				"time": "158.73"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "to",
				"time": "158.97"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "do",
				"time": "159.12"
			},
			{
				"duration": "0.30",
				"confidence": "0.710",
				"name": "in",
				"time": "159.54"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "159.84"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "Life",
				"time": "163.44"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "will",
				"time": "163.65"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "get",
				"time": "163.74"
			},
			{
				"duration": "0.32",
				"confidence": "1.000",
				"name": "better",
				"time": "163.89"
			},
			{
				"duration": "0.10",
				"confidence": "0.790",
				"name": "and",
				"time": "164.21"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "just",
				"time": "164.31"
			},
			{
				"duration": "0.33",
				"confidence": "0.960",
				"name": "happy",
				"time": "164.74"
			},
			{
				"duration": "0.35",
				"confidence": "0.880",
				"name": "that",
				"time": "166.25"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "my",
				"time": "167.91"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "parents",
				"time": "168.03"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "are",
				"time": "168.57"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "happy",
				"time": "168.69"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "for",
				"time": "169.02"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "me",
				"time": "169.17"
			},
			{
				"duration": "0.76",
				"confidence": "0.940",
				"name": ".",
				"time": "169.32"
			},
			{
				"duration": "0.06",
				"confidence": "0.990",
				"name": "I",
				"time": "170.13"
			},
			{
				"duration": "0.13",
				"confidence": "0.990",
				"name": "mean",
				"time": "170.19"
			},
			{
				"duration": "0.07",
				"confidence": "0.490",
				"name": "my",
				"time": "170.33"
			},
			{
				"duration": "0.17",
				"confidence": "0.490",
				"name": "mother",
				"time": "170.42"
			},
			{
				"duration": "0.18",
				"confidence": "0.490",
				"name": "was",
				"time": "170.69"
			},
			{
				"duration": "0.41",
				"confidence": "0.970",
				"name": "upset",
				"time": "171.08"
			},
			{
				"duration": "0.12",
				"confidence": "0.540",
				"name": "at",
				"time": "171.87"
			},
			{
				"duration": "0.27",
				"confidence": "0.960",
				"name": "what",
				"time": "172.07"
			},
			{
				"duration": "0.23",
				"confidence": "0.890",
				"name": "Mom",
				"time": "172.34"
			},
			{
				"duration": "0.33",
				"confidence": "0.780",
				"name": "wanted",
				"time": "172.57"
			},
			{
				"duration": "0.13",
				"confidence": "0.380",
				"name": "those",
				"time": "177.55"
			},
			{
				"duration": "0.26",
				"confidence": "0.880",
				"name": "things",
				"time": "177.84"
			},
			{
				"duration": "1.43",
				"confidence": "0.660",
				"name": ".",
				"time": "178.15"
			},
			{
				"duration": "0.21",
				"confidence": "0.960",
				"name": "I",
				"time": "180.11"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "personally",
				"time": "180.35"
			},
			{
				"duration": "0.20",
				"confidence": "0.640",
				"name": "I",
				"time": "181.04"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "like",
				"time": "181.25"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "181.46"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "say",
				"time": "181.61"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I'm",
				"time": "181.85"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "fine",
				"time": "182.00"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "but",
				"time": "183.11"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "I",
				"time": "183.26"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "would",
				"time": "183.68"
			},
			{
				"duration": "0.39",
				"confidence": "0.990",
				"name": "also",
				"time": "183.92"
			},
			{
				"duration": "0.39",
				"confidence": "0.910",
				"name": "say",
				"time": "184.33"
			},
			{
				"duration": "0.10",
				"confidence": "0.510",
				"name": "I'm",
				"time": "184.76"
			},
			{
				"duration": "0.00",
				"confidence": "1.000",
				"name": ".",
				"time": "184.86"
			}
		],
		"format": "1.0"
	};

/***/ },
/* 25 */
/***/ function(module, exports) {

	module.exports = {
		"job": {
			"lang": "en-US",
			"user_id": 46548,
			"name": "dog_adoption_audio.wav",
			"duration": 182,
			"created_at": "Fri Jul 13 17:13:20 2018",
			"id": 8743576
		},
		"speakers": [
			{
				"duration": "171.27",
				"confidence": null,
				"name": "M2",
				"time": "11.44"
			}
		],
		"words": [
			{
				"duration": "0.39",
				"confidence": "0.990",
				"name": "Today's",
				"time": "11.44"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "video",
				"time": "11.83"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "was",
				"time": "12.58"
			},
			{
				"duration": "0.96",
				"confidence": "1.000",
				"name": "requested",
				"time": "12.91"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "and",
				"time": "14.08"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "14.29"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "thought",
				"time": "14.41"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "that",
				"time": "14.65"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "it",
				"time": "14.77"
			},
			{
				"duration": "0.16",
				"confidence": "1.000",
				"name": "was",
				"time": "14.86"
			},
			{
				"duration": "0.19",
				"confidence": "0.780",
				"name": "a",
				"time": "15.03"
			},
			{
				"duration": "0.44",
				"confidence": "0.780",
				"name": "really",
				"time": "15.22"
			},
			{
				"duration": "0.44",
				"confidence": "1.000",
				"name": "great",
				"time": "15.71"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "request",
				"time": "16.18"
			},
			{
				"duration": "0.11",
				"confidence": "0.950",
				"name": "and",
				"time": "17.08"
			},
			{
				"duration": "0.08",
				"confidence": "0.920",
				"name": "I",
				"time": "17.20"
			},
			{
				"duration": "0.09",
				"confidence": "0.710",
				"name": "had",
				"time": "17.28"
			},
			{
				"duration": "0.19",
				"confidence": "1.000",
				"name": "been",
				"time": "17.37"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "asked",
				"time": "17.56"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "to",
				"time": "18.04"
			},
			{
				"duration": "0.12",
				"confidence": "0.570",
				"name": "just",
				"time": "18.28"
			},
			{
				"duration": "0.34",
				"confidence": "1.000",
				"name": "talk",
				"time": "18.48"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "about",
				"time": "18.82"
			},
			{
				"duration": "0.57",
				"confidence": "0.870",
				"name": "Tito's",
				"time": "19.63"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "adoption",
				"time": "20.29"
			},
			{
				"duration": "0.50",
				"confidence": "1.000",
				"name": "story",
				"time": "20.83"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "as",
				"time": "21.40"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "21.58"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "lot",
				"time": "21.61"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "21.85"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "21.97"
			},
			{
				"duration": "0.41",
				"confidence": "0.610",
				"name": "know",
				"time": "22.10"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "I",
				"time": "22.54"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "adopted",
				"time": "22.99"
			},
			{
				"duration": "0.48",
				"confidence": "0.960",
				"name": "Taito",
				"time": "23.71"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "24.19"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "little",
				"time": "24.28"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "while",
				"time": "24.52"
			},
			{
				"duration": "0.38",
				"confidence": "1.000",
				"name": "ago",
				"time": "24.88"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "and",
				"time": "25.30"
			},
			{
				"duration": "0.24",
				"confidence": "0.960",
				"name": "he's",
				"time": "25.48"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "been",
				"time": "25.72"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "so",
				"time": "26.02"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "awesome",
				"time": "26.53"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "27.01"
			},
			{
				"duration": "0.32",
				"confidence": "1.000",
				"name": "have",
				"time": "27.16"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": "and",
				"time": "27.49"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "you've",
				"time": "27.58"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "seen",
				"time": "27.76"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "him",
				"time": "28.00"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": "in",
				"time": "28.21"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "my",
				"time": "28.30"
			},
			{
				"duration": "0.50",
				"confidence": "1.000",
				"name": "videos",
				"time": "28.42"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "but",
				"time": "29.17"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "29.32"
			},
			{
				"duration": "0.20",
				"confidence": "0.550",
				"name": "haven't",
				"time": "29.45"
			},
			{
				"duration": "0.81",
				"confidence": "1.000",
				"name": "really",
				"time": "29.83"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "talked",
				"time": "30.67"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "about",
				"time": "31.21"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "his",
				"time": "32.20"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "adoption",
				"time": "32.35"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "story",
				"time": "32.89"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "and",
				"time": "33.52"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "what",
				"time": "33.91"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "it",
				"time": "34.15"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "was",
				"time": "34.27"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "like",
				"time": "34.51"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "going",
				"time": "35.38"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "through",
				"time": "35.83"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "36.10"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "process",
				"time": "36.19"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "of",
				"time": "37.06"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "adopting",
				"time": "37.45"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "38.50"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "little",
				"time": "38.53"
			},
			{
				"duration": "0.38",
				"confidence": "0.750",
				"name": "dog",
				"time": "38.77"
			},
			{
				"duration": "0.15",
				"confidence": "0.970",
				"name": ".",
				"time": "39.15"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "39.37"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "really",
				"time": "39.46"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "wanted",
				"time": "39.76"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "40.06"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "make",
				"time": "40.21"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "this",
				"time": "40.45"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "video",
				"time": "40.66"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "for",
				"time": "41.29"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "people",
				"time": "41.56"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "who",
				"time": "42.04"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "are",
				"time": "42.31"
			},
			{
				"duration": "0.27",
				"confidence": "0.990",
				"name": "maybe",
				"time": "42.43"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "considering",
				"time": "42.70"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "adopting",
				"time": "43.36"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "or",
				"time": "44.14"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "maybe",
				"time": "44.32"
			},
			{
				"duration": "0.14",
				"confidence": "0.790",
				"name": "you're",
				"time": "44.59"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "just",
				"time": "44.74"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "curious",
				"time": "44.95"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "about",
				"time": "45.52"
			},
			{
				"duration": "0.55",
				"confidence": "0.530",
				"name": "Titos",
				"time": "46.21"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "story",
				"time": "46.78"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "and",
				"time": "47.41"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "how",
				"time": "47.74"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "we",
				"time": "48.04"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "got",
				"time": "48.25"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "to",
				"time": "48.73"
			},
			{
				"duration": "0.36",
				"confidence": "0.970",
				"name": "how",
				"time": "49.21"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "49.63"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "make",
				"time": "49.75"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "this",
				"time": "49.90"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "50.11"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "little",
				"time": "50.17"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "bit",
				"time": "50.41"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "easier",
				"time": "50.59"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "50.92"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "understand",
				"time": "51.04"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "because",
				"time": "51.73"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "there",
				"time": "52.00"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "was",
				"time": "52.15"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "52.39"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "lot",
				"time": "52.48"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "going",
				"time": "52.93"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "on",
				"time": "53.23"
			},
			{
				"duration": "0.03",
				"confidence": "0.860",
				"name": ".",
				"time": "53.53"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I'm",
				"time": "53.56"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "going",
				"time": "53.71"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "53.83"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "break",
				"time": "53.92"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "this",
				"time": "54.37"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "down",
				"time": "54.76"
			},
			{
				"duration": "0.53",
				"confidence": "1.000",
				"name": "into",
				"time": "55.21"
			},
			{
				"duration": "0.19",
				"confidence": "0.480",
				"name": "you",
				"time": "55.74"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "before",
				"time": "55.96"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "during",
				"time": "56.83"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "and",
				"time": "57.34"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "after",
				"time": "57.58"
			},
			{
				"duration": "0.38",
				"confidence": "0.880",
				"name": "Tito's",
				"time": "58.22"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "adoption",
				"time": "58.60"
			},
			{
				"duration": "0.03",
				"confidence": "0.920",
				"name": ".",
				"time": "59.14"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "So",
				"time": "59.17"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "here",
				"time": "59.38"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "we",
				"time": "59.56"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "go",
				"time": "59.65"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": ".",
				"time": "59.89"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "This",
				"time": "59.95"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "is",
				"time": "60.10"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "all",
				"time": "60.31"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "about",
				"time": "60.52"
			},
			{
				"duration": "0.87",
				"confidence": "0.940",
				"name": "Mutato",
				"time": "60.84"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "61.71"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "Adoption",
				"time": "63.17"
			},
			{
				"duration": "0.12",
				"confidence": "0.950",
				"name": "was",
				"time": "63.71"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "something",
				"time": "63.83"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "that",
				"time": "64.22"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "I",
				"time": "64.34"
			},
			{
				"duration": "0.09",
				"confidence": "0.840",
				"name": "had",
				"time": "64.55"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "been",
				"time": "64.64"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "considering",
				"time": "64.82"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "for",
				"time": "65.48"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "65.72"
			},
			{
				"duration": "0.50",
				"confidence": "1.000",
				"name": "while",
				"time": "65.78"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "especially",
				"time": "66.32"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "after",
				"time": "67.07"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "my",
				"time": "67.97"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "mom",
				"time": "68.15"
			},
			{
				"duration": "0.49",
				"confidence": "1.000",
				"name": "took",
				"time": "68.75"
			},
			{
				"duration": "0.50",
				"confidence": "0.970",
				"name": "nugget",
				"time": "69.26"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "full",
				"time": "69.77"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "time",
				"time": "70.07"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "and",
				"time": "70.64"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "to",
				"time": "70.79"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "be",
				"time": "70.97"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "clear",
				"time": "71.12"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "which",
				"time": "71.51"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "71.78"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "think",
				"time": "71.90"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "72.11"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "was",
				"time": "72.20"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "clear",
				"time": "72.35"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "about",
				"time": "72.59"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "this",
				"time": "72.83"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "before",
				"time": "73.10"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "but",
				"time": "73.91"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "I've",
				"time": "74.09"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "seen",
				"time": "74.21"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "comments",
				"time": "74.84"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "from",
				"time": "75.41"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "people",
				"time": "75.59"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "saying",
				"time": "76.22"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "well",
				"time": "76.91"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "you",
				"time": "77.06"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "better",
				"time": "77.15"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "not",
				"time": "77.42"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "get",
				"time": "77.66"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "rid",
				"time": "77.87"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "of",
				"time": "78.05"
			},
			{
				"duration": "0.54",
				"confidence": "0.960",
				"name": "Taito",
				"time": "78.35"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "like",
				"time": "78.89"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": "you",
				"time": "79.10"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "got",
				"time": "79.19"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "rid",
				"time": "79.46"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "79.61"
			},
			{
				"duration": "0.50",
				"confidence": "0.980",
				"name": "nugget",
				"time": "79.73"
			},
			{
				"duration": "0.14",
				"confidence": "0.630",
				"name": ".",
				"time": "80.23"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "That",
				"time": "80.45"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "is",
				"time": "80.63"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "not",
				"time": "80.96"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "what",
				"time": "81.38"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "happened",
				"time": "81.56"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "at",
				"time": "82.28"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "all",
				"time": "82.49"
			},
			{
				"duration": "0.19",
				"confidence": "0.930",
				"name": ".",
				"time": "82.97"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "83.18"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "was",
				"time": "83.30"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "perfectly",
				"time": "83.48"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "capable",
				"time": "84.08"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "of",
				"time": "84.80"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "still",
				"time": "84.95"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "taking",
				"time": "85.25"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "care",
				"time": "85.61"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "of",
				"time": "86.03"
			},
			{
				"duration": "0.58",
				"confidence": "1.000",
				"name": "Nugget",
				"time": "86.24"
			},
			{
				"duration": "0.09",
				"confidence": "0.590",
				"name": ".",
				"time": "86.82"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "But",
				"time": "87.02"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "my",
				"time": "87.32"
			},
			{
				"duration": "0.66",
				"confidence": "0.990",
				"name": "mom",
				"time": "87.53"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "bonded",
				"time": "88.22"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "with",
				"time": "88.94"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "nugget",
				"time": "89.33"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "and",
				"time": "89.78"
			},
			{
				"duration": "0.32",
				"confidence": "0.930",
				"name": "Nugget",
				"time": "89.97"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "bonded",
				"time": "90.32"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "with",
				"time": "91.10"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "her",
				"time": "91.28"
			},
			{
				"duration": "0.02",
				"confidence": "0.510",
				"name": ".",
				"time": "91.70"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "And",
				"time": "92.00"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "because",
				"time": "92.45"
			},
			{
				"duration": "0.24",
				"confidence": "0.980",
				"name": "she's",
				"time": "93.02"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "at",
				"time": "93.26"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "93.38"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "different",
				"time": "93.47"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "place",
				"time": "93.77"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "in",
				"time": "94.10"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "her",
				"time": "94.22"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "life",
				"time": "94.37"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "it",
				"time": "95.00"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "was",
				"time": "95.21"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "something",
				"time": "95.45"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "that",
				"time": "95.87"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "was",
				"time": "95.99"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "really",
				"time": "96.11"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "special",
				"time": "96.38"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "for",
				"time": "96.86"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "her",
				"time": "97.04"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "to",
				"time": "97.28"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "have",
				"time": "97.49"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "an",
				"time": "97.79"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "animal",
				"time": "97.91"
			},
			{
				"duration": "0.03",
				"confidence": "0.900",
				"name": ".",
				"time": "98.48"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "And",
				"time": "98.54"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I",
				"time": "98.69"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "saw",
				"time": "98.84"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "how",
				"time": "99.68"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "much",
				"time": "99.95"
			},
			{
				"duration": "0.47",
				"confidence": "0.440",
				"name": "get",
				"time": "100.43"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "brought",
				"time": "100.94"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "to",
				"time": "101.39"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "her",
				"time": "101.99"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "life",
				"time": "102.56"
			},
			{
				"duration": "0.02",
				"confidence": "0.770",
				"name": ".",
				"time": "103.01"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "And",
				"time": "103.28"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "I",
				"time": "103.94"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "saw",
				"time": "104.51"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "how",
				"time": "104.75"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "happy",
				"time": "104.96"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "he",
				"time": "105.32"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "was",
				"time": "105.47"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "and",
				"time": "105.86"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "106.07"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "wanted",
				"time": "106.16"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "my",
				"time": "106.52"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "mom",
				"time": "106.64"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "106.97"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "be",
				"time": "107.09"
			},
			{
				"duration": "0.41",
				"confidence": "1.000",
				"name": "happy",
				"time": "107.21"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "and",
				"time": "107.63"
			},
			{
				"duration": "0.38",
				"confidence": "0.910",
				"name": "nuggets",
				"time": "107.78"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "be",
				"time": "108.17"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "happy",
				"time": "108.38"
			},
			{
				"duration": "0.03",
				"confidence": "0.890",
				"name": ".",
				"time": "108.83"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "108.89"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "still",
				"time": "108.98"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "get",
				"time": "109.25"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "109.40"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "see",
				"time": "109.55"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "him",
				"time": "109.85"
			},
			{
				"duration": "0.02",
				"confidence": "0.830",
				"name": ".",
				"time": "110.27"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I",
				"time": "110.30"
			},
			{
				"duration": "0.16",
				"confidence": "0.910",
				"name": "still",
				"time": "110.45"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "get",
				"time": "110.63"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "110.78"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "spend",
				"time": "110.90"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "time",
				"time": "111.20"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "with",
				"time": "111.50"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "him",
				"time": "111.65"
			},
			{
				"duration": "0.11",
				"confidence": "0.700",
				"name": "and",
				"time": "112.17"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "because",
				"time": "112.34"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "my",
				"time": "112.76"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "mom",
				"time": "112.88"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "took",
				"time": "113.21"
			},
			{
				"duration": "0.38",
				"confidence": "1.000",
				"name": "nugget",
				"time": "113.64"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "full",
				"time": "114.02"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "time",
				"time": "114.26"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "I",
				"time": "114.92"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "kind",
				"time": "115.25"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "115.43"
			},
			{
				"duration": "0.30",
				"confidence": "0.850",
				"name": "had",
				"time": "115.55"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "this",
				"time": "115.88"
			},
			{
				"duration": "0.45",
				"confidence": "0.920",
				"name": "hole",
				"time": "116.18"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "in",
				"time": "116.63"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "my",
				"time": "116.75"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "life",
				"time": "117.02"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "and",
				"time": "117.47"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "I",
				"time": "117.62"
			},
			{
				"duration": "0.32",
				"confidence": "0.970",
				"name": "wanted",
				"time": "118.22"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "118.55"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "little",
				"time": "118.61"
			},
			{
				"duration": "0.33",
				"confidence": "0.760",
				"name": "body",
				"time": "118.85"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "for",
				"time": "119.18"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "myself",
				"time": "119.36"
			},
			{
				"duration": "0.03",
				"confidence": "0.940",
				"name": ".",
				"time": "119.93"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "120.02"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "was",
				"time": "120.11"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "really",
				"time": "120.26"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "open",
				"time": "120.53"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "to",
				"time": "121.01"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "adopting",
				"time": "121.34"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "a",
				"time": "122.15"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "dog",
				"time": "122.27"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "or",
				"time": "122.84"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "123.26"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "cat",
				"time": "123.35"
			},
			{
				"duration": "0.03",
				"confidence": "0.560",
				"name": ".",
				"time": "124.01"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "And",
				"time": "124.07"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "I",
				"time": "124.82"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "was",
				"time": "125.54"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "125.69"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "little",
				"time": "125.72"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "bit",
				"time": "125.96"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "more",
				"time": "126.32"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "hesitant",
				"time": "126.74"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "about",
				"time": "127.49"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "128.03"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "dog",
				"time": "128.12"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "just",
				"time": "128.69"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "because",
				"time": "128.90"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "I",
				"time": "129.44"
			},
			{
				"duration": "0.53",
				"confidence": "1.000",
				"name": "never",
				"time": "129.66"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "had",
				"time": "130.40"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "130.94"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "dog",
				"time": "131.00"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "ever",
				"time": "131.60"
			},
			{
				"duration": "0.60",
				"confidence": "0.990",
				"name": "before",
				"time": "132.08"
			},
			{
				"duration": "0.03",
				"confidence": "0.940",
				"name": ".",
				"time": "132.68"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I",
				"time": "132.71"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "never",
				"time": "132.86"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "grew",
				"time": "133.10"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "up",
				"time": "133.37"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "with",
				"time": "133.82"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "dogs",
				"time": "134.03"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "in",
				"time": "134.54"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "my",
				"time": "134.69"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "household",
				"time": "134.90"
			},
			{
				"duration": "0.16",
				"confidence": "0.680",
				"name": ".",
				"time": "135.59"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "So",
				"time": "135.83"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "taking",
				"time": "136.37"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "care",
				"time": "136.82"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "of",
				"time": "137.12"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "137.27"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "dog",
				"time": "137.33"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "would",
				"time": "137.81"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "be",
				"time": "137.99"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "something",
				"time": "138.53"
			},
			{
				"duration": "1.08",
				"confidence": "1.000",
				"name": "completely",
				"time": "139.01"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "new",
				"time": "140.33"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "and",
				"time": "140.66"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "different",
				"time": "140.78"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "for",
				"time": "141.26"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "me",
				"time": "141.53"
			},
			{
				"duration": "0.09",
				"confidence": "0.970",
				"name": ".",
				"time": "141.83"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "141.92"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "really",
				"time": "142.04"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "wanted",
				"time": "142.37"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "to",
				"time": "143.03"
			},
			{
				"duration": "0.90",
				"confidence": "1.000",
				"name": "understand",
				"time": "143.45"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "more",
				"time": "144.35"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "what",
				"time": "144.92"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "it",
				"time": "145.22"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "was",
				"time": "145.37"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "like",
				"time": "145.70"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "to",
				"time": "146.15"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "have",
				"time": "146.45"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "146.72"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "dog",
				"time": "146.78"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "and",
				"time": "147.23"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "my",
				"time": "147.68"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "girlfriend",
				"time": "147.86"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "has",
				"time": "148.55"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "had",
				"time": "148.79"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "149.00"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "dog",
				"time": "149.09"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "for",
				"time": "149.78"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "about",
				"time": "150.29"
			},
			{
				"duration": "0.33",
				"confidence": "0.800",
				"name": "three",
				"time": "150.71"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "years",
				"time": "151.04"
			},
			{
				"duration": "0.08",
				"confidence": "0.820",
				"name": ".",
				"time": "151.52"
			},
			{
				"duration": "0.60",
				"confidence": "0.630",
				"name": "Loki",
				"time": "151.61"
			},
			{
				"duration": "0.31",
				"confidence": "1.000",
				"name": "who",
				"time": "152.23"
			},
			{
				"duration": "0.25",
				"confidence": "0.850",
				"name": "you've",
				"time": "152.57"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "also",
				"time": "152.84"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "seen",
				"time": "153.14"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "in",
				"time": "153.38"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "my",
				"time": "153.47"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "videos",
				"time": "153.62"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "and",
				"time": "154.22"
			},
			{
				"duration": "0.51",
				"confidence": "0.800",
				"name": "Loki",
				"time": "154.37"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "is",
				"time": "154.88"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "also",
				"time": "155.09"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "155.66"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "rescue",
				"time": "155.72"
			},
			{
				"duration": "0.09",
				"confidence": "0.730",
				"name": ".",
				"time": "156.44"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "And",
				"time": "156.53"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "156.65"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "more",
				"time": "156.74"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "157.01"
			},
			{
				"duration": "0.30",
				"confidence": "0.880",
				"name": "spent",
				"time": "157.10"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "time",
				"time": "157.40"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "with",
				"time": "157.85"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "my",
				"time": "158.03"
			},
			{
				"duration": "0.67",
				"confidence": "1.000",
				"name": "girlfriend",
				"time": "158.18"
			},
			{
				"duration": "0.14",
				"confidence": "0.960",
				"name": "and",
				"time": "158.91"
			},
			{
				"duration": "0.60",
				"confidence": "0.570",
				"name": "therefore",
				"time": "159.14"
			},
			{
				"duration": "0.57",
				"confidence": "0.870",
				"name": "Loki",
				"time": "159.80"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I",
				"time": "160.40"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "began",
				"time": "160.55"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "160.91"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "understand",
				"time": "161.06"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "161.81"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "little",
				"time": "161.87"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "bit",
				"time": "162.11"
			},
			{
				"duration": "0.37",
				"confidence": "1.000",
				"name": "more",
				"time": "162.29"
			},
			{
				"duration": "0.19",
				"confidence": "1.000",
				"name": "what",
				"time": "162.70"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "it",
				"time": "162.89"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "would",
				"time": "162.98"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "be",
				"time": "163.13"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "like",
				"time": "163.34"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "to",
				"time": "163.70"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "actually",
				"time": "164.00"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "have",
				"time": "164.36"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "my",
				"time": "164.60"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "own",
				"time": "164.84"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "dog",
				"time": "164.99"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "and",
				"time": "165.41"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "then",
				"time": "165.59"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "I",
				"time": "165.98"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "started",
				"time": "166.16"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "to",
				"time": "166.70"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "ask",
				"time": "167.12"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "my",
				"time": "167.42"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "girlfriend",
				"time": "167.57"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "if",
				"time": "168.17"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I",
				"time": "168.35"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "could",
				"time": "168.50"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "take",
				"time": "168.68"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "on",
				"time": "169.01"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "more",
				"time": "169.25"
			},
			{
				"duration": "0.99",
				"confidence": "1.000",
				"name": "responsibilities",
				"time": "169.49"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "with",
				"time": "170.48"
			},
			{
				"duration": "0.42",
				"confidence": "0.310",
				"name": "Loki",
				"time": "170.66"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "so",
				"time": "171.08"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "171.74"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "would",
				"time": "171.86"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "watch",
				"time": "171.98"
			},
			{
				"duration": "0.54",
				"confidence": "0.720",
				"name": "Loki",
				"time": "172.37"
			},
			{
				"duration": "0.04",
				"confidence": "0.590",
				"name": ".",
				"time": "172.93"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "When",
				"time": "172.97"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "my",
				"time": "173.30"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "girlfriend",
				"time": "173.42"
			},
			{
				"duration": "0.41",
				"confidence": "0.950",
				"name": "wasn't",
				"time": "173.90"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "around",
				"time": "174.38"
			},
			{
				"duration": "0.21",
				"confidence": "0.960",
				"name": "or",
				"time": "174.92"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "she",
				"time": "175.13"
			},
			{
				"duration": "0.16",
				"confidence": "1.000",
				"name": "was",
				"time": "175.31"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "doing",
				"time": "175.73"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "something",
				"time": "176.15"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "I",
				"time": "177.08"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "would",
				"time": "177.65"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "offer",
				"time": "178.01"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "178.37"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "take",
				"time": "178.52"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "her",
				"time": "178.79"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "out",
				"time": "178.97"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "on",
				"time": "179.27"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "walks",
				"time": "179.48"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "180.02"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "feed",
				"time": "180.17"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "her",
				"time": "180.59"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "181.13"
			},
			{
				"duration": "0.26",
				"confidence": "0.960",
				"name": "just",
				"time": "181.25"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "do",
				"time": "181.52"
			},
			{
				"duration": "0.13",
				"confidence": "0.850",
				"name": "the",
				"time": "181.88"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "things",
				"time": "182.03"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "that",
				"time": "182.42"
			},
			{
				"duration": "0.17",
				"confidence": "0.870",
				"name": "you",
				"time": "182.54"
			},
			{
				"duration": "0.00",
				"confidence": "1.000",
				"name": ".",
				"time": "182.71"
			}
		],
		"format": "1.0"
	};

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = {
		"job": {
			"lang": "en",
			"user_id": 46548,
			"name": "fit_traveler.mp3",
			"duration": 185,
			"created_at": "Fri Jul 27 20:11:38 2018",
			"id": 8856512
		},
		"speakers": [
			{
				"duration": "183.54",
				"confidence": null,
				"name": "M1",
				"time": "1.12"
			}
		],
		"words": [
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "This",
				"time": "1.12"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "is",
				"time": "1.24"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "episode",
				"time": "1.36"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "number",
				"time": "1.72"
			},
			{
				"duration": "0.75",
				"confidence": "0.860",
				"name": "27",
				"time": "2.01"
			},
			{
				"duration": "0.12",
				"confidence": "0.960",
				"name": "of",
				"time": "2.88"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "3.01"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "fit",
				"time": "3.10"
			},
			{
				"duration": "0.42",
				"confidence": "0.670",
				"name": "traveler",
				"time": "3.31"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "video",
				"time": "3.73"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "blog",
				"time": "4.09"
			},
			{
				"duration": "0.43",
				"confidence": "0.890",
				"name": ".",
				"time": "4.63"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "The",
				"time": "5.11"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "title",
				"time": "5.23"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "5.62"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "today's",
				"time": "5.74"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "session",
				"time": "6.01"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "is",
				"time": "6.40"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "probably",
				"time": "6.49"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "going",
				"time": "6.73"
			},
			{
				"duration": "0.06",
				"confidence": "0.990",
				"name": "to",
				"time": "6.88"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "get",
				"time": "6.94"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "some",
				"time": "7.09"
			},
			{
				"duration": "0.30",
				"confidence": "0.990",
				"name": "people's",
				"time": "7.24"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "attention",
				"time": "7.54"
			},
			{
				"duration": "0.29",
				"confidence": "0.980",
				"name": ".",
				"time": "8.20"
			},
			{
				"duration": "0.18",
				"confidence": "0.970",
				"name": "It's",
				"time": "8.50"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "called",
				"time": "8.68"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "Managing",
				"time": "8.92"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "the",
				"time": "9.55"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "bar",
				"time": "9.70"
			},
			{
				"duration": "0.29",
				"confidence": "0.960",
				"name": "scene",
				"time": "9.94"
			},
			{
				"duration": "0.04",
				"confidence": "0.910",
				"name": ".",
				"time": "10.42"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "And",
				"time": "10.87"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "as",
				"time": "11.08"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "we",
				"time": "11.26"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "know",
				"time": "11.38"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "in",
				"time": "11.59"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "business",
				"time": "11.80"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "the",
				"time": "12.46"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "bar",
				"time": "12.61"
			},
			{
				"duration": "0.39",
				"confidence": "0.980",
				"name": "scene",
				"time": "12.88"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "comes",
				"time": "13.27"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "into",
				"time": "13.60"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "play",
				"time": "13.84"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "on",
				"time": "14.83"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "14.98"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "lot",
				"time": "15.04"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "15.19"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "different",
				"time": "15.31"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "occasions",
				"time": "15.58"
			},
			{
				"duration": "0.03",
				"confidence": "0.990",
				"name": ".",
				"time": "16.22"
			},
			{
				"duration": "0.20",
				"confidence": "0.980",
				"name": "So",
				"time": "16.31"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "first",
				"time": "16.51"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "let",
				"time": "17.05"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "me",
				"time": "17.20"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "tell",
				"time": "17.32"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "you",
				"time": "17.53"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "about",
				"time": "17.62"
			},
			{
				"duration": "0.17",
				"confidence": "0.750",
				"name": "what",
				"time": "17.98"
			},
			{
				"duration": "0.18",
				"confidence": "0.960",
				"name": "we're",
				"time": "18.16"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "not",
				"time": "18.34"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "going",
				"time": "18.85"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": "to",
				"time": "18.97"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "be",
				"time": "19.06"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "addressing",
				"time": "19.18"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "in",
				"time": "20.23"
			},
			{
				"duration": "0.09",
				"confidence": "0.910",
				"name": "this",
				"time": "20.41"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "session",
				"time": "20.50"
			},
			{
				"duration": "0.20",
				"confidence": "0.940",
				"name": ".",
				"time": "21.04"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "Go",
				"time": "21.25"
			},
			{
				"duration": "0.18",
				"confidence": "0.970",
				"name": "ahead",
				"time": "21.43"
			},
			{
				"duration": "0.06",
				"confidence": "0.830",
				"name": ".",
				"time": "21.61"
			},
			{
				"duration": "0.24",
				"confidence": "0.980",
				"name": "Set",
				"time": "21.67"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "21.91"
			},
			{
				"duration": "0.60",
				"confidence": "0.770",
				"name": "expectations",
				"time": "22.00"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "for",
				"time": "22.60"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "you",
				"time": "22.84"
			},
			{
				"duration": "0.35",
				"confidence": "0.900",
				"name": ".",
				"time": "23.05"
			},
			{
				"duration": "0.09",
				"confidence": "0.970",
				"name": "We're",
				"time": "23.44"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "not",
				"time": "23.53"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "talking",
				"time": "23.71"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "about",
				"time": "23.98"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "whether",
				"time": "24.25"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "you",
				"time": "24.55"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "should",
				"time": "24.70"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "or",
				"time": "25.09"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "should",
				"time": "25.24"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "not",
				"time": "25.48"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "drink",
				"time": "25.72"
			},
			{
				"duration": "0.22",
				"confidence": "0.940",
				"name": "that",
				"time": "26.71"
			},
			{
				"duration": "0.11",
				"confidence": "0.520",
				"name": ".",
				"time": "26.97"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "That's",
				"time": "27.19"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "your",
				"time": "27.40"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "business",
				"time": "27.55"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "not",
				"time": "27.97"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "mine",
				"time": "28.21"
			},
			{
				"duration": "0.34",
				"confidence": "0.940",
				"name": ".",
				"time": "28.66"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "We're",
				"time": "29.02"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "also",
				"time": "29.17"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "not",
				"time": "29.50"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "talking",
				"time": "29.80"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "about",
				"time": "30.25"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "if",
				"time": "30.70"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "30.88"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "have",
				"time": "31.00"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "31.12"
			},
			{
				"duration": "0.21",
				"confidence": "0.920",
				"name": "fit",
				"time": "31.18"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "lifestyle",
				"time": "31.39"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "but",
				"time": "32.08"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "32.23"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "like",
				"time": "32.35"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "to",
				"time": "32.50"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "go",
				"time": "32.62"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "out",
				"time": "32.80"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "on",
				"time": "32.92"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "33.01"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "weekends",
				"time": "33.10"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "and",
				"time": "34.61"
			},
			{
				"duration": "0.57",
				"confidence": "0.980",
				"name": "participate",
				"time": "34.90"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "in",
				"time": "35.47"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "35.56"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "bar",
				"time": "35.65"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "scene",
				"time": "35.86"
			},
			{
				"duration": "0.55",
				"confidence": "0.960",
				"name": ".",
				"time": "36.31"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "We're",
				"time": "36.88"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "not",
				"time": "37.09"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "addressing",
				"time": "37.51"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "that",
				"time": "37.96"
			},
			{
				"duration": "0.31",
				"confidence": "0.940",
				"name": "today",
				"time": "38.14"
			},
			{
				"duration": "0.04",
				"confidence": "0.750",
				"name": ".",
				"time": "38.45"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "I'm",
				"time": "38.50"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "38.68"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "last",
				"time": "38.80"
			},
			{
				"duration": "0.29",
				"confidence": "1.000",
				"name": "person",
				"time": "39.13"
			},
			{
				"duration": "0.12",
				"confidence": "0.460",
				"name": "there",
				"time": "39.42"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "should",
				"time": "39.55"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "be",
				"time": "39.73"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "talking",
				"time": "39.82"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "about",
				"time": "40.21"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "that",
				"time": "40.39"
			},
			{
				"duration": "0.03",
				"confidence": "0.930",
				"name": ".",
				"time": "40.60"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "It's",
				"time": "40.63"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "been",
				"time": "40.75"
			},
			{
				"duration": "0.08",
				"confidence": "1.000",
				"name": "a",
				"time": "41.47"
			},
			{
				"duration": "0.19",
				"confidence": "0.680",
				"name": "while",
				"time": "41.55"
			},
			{
				"duration": "0.10",
				"confidence": "0.680",
				"name": "I'm",
				"time": "41.79"
			},
			{
				"duration": "0.41",
				"confidence": "0.670",
				"name": "along",
				"time": "41.89"
			},
			{
				"duration": "0.07",
				"confidence": "0.750",
				"name": "a",
				"time": "42.30"
			},
			{
				"duration": "0.20",
				"confidence": "0.740",
				"name": "lot",
				"time": "42.38"
			},
			{
				"duration": "0.11",
				"confidence": "1.000",
				"name": "a",
				"time": "42.58"
			},
			{
				"duration": "0.22",
				"confidence": "1.000",
				"name": "lot",
				"time": "42.69"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "42.91"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "years",
				"time": "42.97"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "removed",
				"time": "43.27"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "from",
				"time": "43.81"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "that",
				"time": "44.02"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "scene",
				"time": "44.20"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "so",
				"time": "44.53"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "44.89"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "wouldn't",
				"time": "44.98"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "be",
				"time": "45.19"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "I",
				"time": "45.85"
			},
			{
				"duration": "0.17",
				"confidence": "0.520",
				"name": "wouldn't",
				"time": "45.91"
			},
			{
				"duration": "0.16",
				"confidence": "1.000",
				"name": "do",
				"time": "46.08"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "any",
				"time": "46.24"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "good",
				"time": "46.42"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "46.63"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "speak",
				"time": "46.78"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "to",
				"time": "47.02"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "47.08"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "about",
				"time": "47.20"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "that",
				"time": "47.41"
			},
			{
				"duration": "0.22",
				"confidence": "0.890",
				"name": ".",
				"time": "47.68"
			},
			{
				"duration": "0.13",
				"confidence": "0.530",
				"name": "What",
				"time": "48.03"
			},
			{
				"duration": "0.14",
				"confidence": "1.000",
				"name": "we're",
				"time": "48.17"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "talking",
				"time": "48.31"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "about",
				"time": "48.67"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "is",
				"time": "49.03"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "in",
				"time": "49.18"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "49.30"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "business",
				"time": "49.42"
			},
			{
				"duration": "0.59",
				"confidence": "1.000",
				"name": "setting",
				"time": "49.90"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "as",
				"time": "50.50"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "business",
				"time": "50.71"
			},
			{
				"duration": "0.81",
				"confidence": "1.000",
				"name": "professionals",
				"time": "51.07"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "how",
				"time": "52.21"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "you",
				"time": "52.45"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "manage",
				"time": "52.63"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "that",
				"time": "53.02"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "bar",
				"time": "53.26"
			},
			{
				"duration": "0.54",
				"confidence": "0.840",
				"name": "scene",
				"time": "53.53"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "that",
				"time": "54.43"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "comes",
				"time": "54.67"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "up",
				"time": "55.03"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "in",
				"time": "55.30"
			},
			{
				"duration": "0.80",
				"confidence": "0.920",
				"name": "events",
				"time": "56.09"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "pretty",
				"time": "57.19"
			},
			{
				"duration": "0.47",
				"confidence": "0.880",
				"name": "often",
				"time": "57.55"
			},
			{
				"duration": "0.03",
				"confidence": "0.590",
				"name": ".",
				"time": "58.03"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "If",
				"time": "58.09"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "you're",
				"time": "58.27"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "in",
				"time": "58.45"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "any",
				"time": "58.66"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "kind",
				"time": "58.96"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "59.14"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "business",
				"time": "59.23"
			},
			{
				"duration": "0.24",
				"confidence": "0.710",
				"name": "you",
				"time": "60.64"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "likely",
				"time": "60.88"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "come",
				"time": "61.30"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "across",
				"time": "61.54"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "some",
				"time": "62.26"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "sort",
				"time": "62.50"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "of",
				"time": "62.71"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "bar",
				"time": "62.86"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "scene",
				"time": "63.19"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "event",
				"time": "63.61"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "maybe",
				"time": "64.54"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "once",
				"time": "64.78"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "or",
				"time": "64.99"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "twice",
				"time": "65.08"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "65.35"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "month",
				"time": "65.41"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "maybe",
				"time": "66.79"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "less",
				"time": "67.12"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "frequent",
				"time": "67.36"
			},
			{
				"duration": "0.17",
				"confidence": "0.950",
				"name": "just",
				"time": "67.75"
			},
			{
				"duration": "0.24",
				"confidence": "0.410",
				"name": "spinning",
				"time": "67.95"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "on",
				"time": "68.20"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "your",
				"time": "68.32"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "type",
				"time": "68.44"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "68.98"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "business",
				"time": "69.10"
			},
			{
				"duration": "0.27",
				"confidence": "0.690",
				"name": ".",
				"time": "69.64"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "If",
				"time": "70.03"
			},
			{
				"duration": "0.18",
				"confidence": "0.930",
				"name": "you",
				"time": "70.21"
			},
			{
				"duration": "0.12",
				"confidence": "0.930",
				"name": "are",
				"time": "70.39"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "70.51"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "business",
				"time": "70.57"
			},
			{
				"duration": "0.72",
				"confidence": "0.580",
				"name": "traveler",
				"time": "71.02"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "you",
				"time": "72.07"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "probably",
				"time": "72.25"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "come",
				"time": "72.79"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "across",
				"time": "73.00"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "this",
				"time": "73.42"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "multiple",
				"time": "73.75"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "times",
				"time": "74.11"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "each",
				"time": "74.50"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "week",
				"time": "74.74"
			},
			{
				"duration": "0.03",
				"confidence": "0.910",
				"name": ".",
				"time": "75.22"
			},
			{
				"duration": "0.18",
				"confidence": "0.900",
				"name": "It's",
				"time": "75.25"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "just",
				"time": "75.43"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "kind",
				"time": "75.61"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "75.76"
			},
			{
				"duration": "0.06",
				"confidence": "0.550",
				"name": "a",
				"time": "75.85"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "nature",
				"time": "75.91"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "76.27"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "76.39"
			},
			{
				"duration": "0.50",
				"confidence": "1.000",
				"name": "beast",
				"time": "76.48"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "you",
				"time": "77.41"
			},
			{
				"duration": "1.02",
				"confidence": "1.000",
				"name": "are",
				"time": "77.74"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "going",
				"time": "78.94"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "to",
				"time": "79.33"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "a",
				"time": "79.87"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "business",
				"time": "80.35"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "meeting",
				"time": "80.80"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "or",
				"time": "81.19"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "maybe",
				"time": "81.37"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "after",
				"time": "81.67"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "81.97"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "business",
				"time": "82.00"
			},
			{
				"duration": "0.31",
				"confidence": "1.000",
				"name": "meeting",
				"time": "82.36"
			},
			{
				"duration": "0.15",
				"confidence": "0.430",
				"name": "you're",
				"time": "82.71"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "going",
				"time": "82.90"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "to",
				"time": "83.02"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "have",
				"time": "83.08"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "dinner",
				"time": "83.23"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "and",
				"time": "84.16"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "it's",
				"time": "84.43"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "very",
				"time": "84.61"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "common",
				"time": "84.94"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "for",
				"time": "85.39"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "them",
				"time": "85.57"
			},
			{
				"duration": "0.55",
				"confidence": "0.990",
				"name": "for",
				"time": "85.91"
			},
			{
				"duration": "0.18",
				"confidence": "0.720",
				"name": "there",
				"time": "86.52"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "just",
				"time": "86.71"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "86.89"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "be",
				"time": "86.98"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "an",
				"time": "87.10"
			},
			{
				"duration": "0.62",
				"confidence": "1.000",
				"name": "invitation",
				"time": "87.19"
			},
			{
				"duration": "0.17",
				"confidence": "0.680",
				"name": "of",
				"time": "87.88"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "hey",
				"time": "88.33"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "we're",
				"time": "88.51"
			},
			{
				"duration": "0.10",
				"confidence": "0.870",
				"name": "going",
				"time": "88.63"
			},
			{
				"duration": "0.08",
				"confidence": "0.870",
				"name": "to",
				"time": "88.73"
			},
			{
				"duration": "0.12",
				"confidence": "0.930",
				"name": "be",
				"time": "88.81"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "down",
				"time": "88.93"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "at",
				"time": "89.18"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "the",
				"time": "90.22"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "bar",
				"time": "90.34"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "before",
				"time": "90.88"
			},
			{
				"duration": "0.32",
				"confidence": "1.000",
				"name": "dinner",
				"time": "91.27"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "91.63"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "grab",
				"time": "91.78"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "92.02"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "drink",
				"time": "92.05"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "then",
				"time": "93.01"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "you're",
				"time": "93.34"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "at",
				"time": "93.55"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "dinner",
				"time": "93.79"
			},
			{
				"duration": "0.17",
				"confidence": "0.930",
				"name": "and",
				"time": "94.24"
			},
			{
				"duration": "0.15",
				"confidence": "0.690",
				"name": "there",
				"time": "94.41"
			},
			{
				"duration": "0.08",
				"confidence": "0.680",
				"name": "is",
				"time": "94.55"
			},
			{
				"duration": "0.06",
				"confidence": "0.870",
				"name": "a",
				"time": "94.63"
			},
			{
				"duration": "0.38",
				"confidence": "0.850",
				"name": "line",
				"time": "94.70"
			},
			{
				"duration": "0.09",
				"confidence": "0.930",
				"name": "in",
				"time": "95.08"
			},
			{
				"duration": "0.15",
				"confidence": "0.980",
				"name": "their",
				"time": "95.17"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "drinks",
				"time": "95.32"
			},
			{
				"duration": "0.09",
				"confidence": "0.870",
				"name": "and",
				"time": "95.71"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "whatever",
				"time": "95.80"
			},
			{
				"duration": "0.36",
				"confidence": "0.780",
				"name": ".",
				"time": "96.31"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "And",
				"time": "96.67"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "then",
				"time": "96.82"
			},
			{
				"duration": "0.45",
				"confidence": "0.870",
				"name": "there's",
				"time": "97.06"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "after",
				"time": "97.60"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "dinner",
				"time": "98.32"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "there's",
				"time": "98.71"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "98.95"
			},
			{
				"duration": "0.46",
				"confidence": "0.880",
				"name": "nightcap",
				"time": "99.07"
			},
			{
				"duration": "0.08",
				"confidence": "0.640",
				"name": ".",
				"time": "99.53"
			},
			{
				"duration": "0.18",
				"confidence": "0.960",
				"name": "Let's",
				"time": "99.64"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "go",
				"time": "99.82"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "back",
				"time": "99.94"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "100.09"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "100.18"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "bar",
				"time": "100.27"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "for",
				"time": "100.45"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "100.60"
			},
			{
				"duration": "0.49",
				"confidence": "1.000",
				"name": "nightcap",
				"time": "100.63"
			},
			{
				"duration": "0.02",
				"confidence": "0.690",
				"name": ".",
				"time": "101.12"
			},
			{
				"duration": "0.20",
				"confidence": "0.930",
				"name": "Okay",
				"time": "101.17"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "so",
				"time": "101.38"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "these",
				"time": "101.56"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "events",
				"time": "101.92"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "are",
				"time": "103.00"
			},
			{
				"duration": "0.84",
				"confidence": "1.000",
				"name": "regular",
				"time": "103.21"
			},
			{
				"duration": "0.90",
				"confidence": "1.000",
				"name": "occurrences",
				"time": "104.05"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "for",
				"time": "105.04"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "business",
				"time": "105.22"
			},
			{
				"duration": "0.57",
				"confidence": "0.880",
				"name": "travelers",
				"time": "105.58"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "and",
				"time": "106.15"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "business",
				"time": "106.30"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "professionals",
				"time": "106.63"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "in",
				"time": "107.23"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "general",
				"time": "107.35"
			},
			{
				"duration": "0.59",
				"confidence": "0.890",
				"name": ".",
				"time": "107.87"
			},
			{
				"duration": "0.26",
				"confidence": "0.620",
				"name": "At",
				"time": "108.61"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "109.00"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "lot",
				"time": "109.06"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "109.24"
			},
			{
				"duration": "0.87",
				"confidence": "1.000",
				"name": "companies",
				"time": "109.36"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "will",
				"time": "110.50"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "do",
				"time": "110.65"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "some",
				"time": "110.86"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "sort",
				"time": "111.10"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "111.31"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "company",
				"time": "111.43"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "happy",
				"time": "111.79"
			},
			{
				"duration": "0.33",
				"confidence": "0.990",
				"name": "hour",
				"time": "112.15"
			},
			{
				"duration": "0.36",
				"confidence": "0.530",
				"name": "whether",
				"time": "112.48"
			},
			{
				"duration": "0.17",
				"confidence": "0.420",
				"name": "they're",
				"time": "112.91"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "putting",
				"time": "113.14"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "it",
				"time": "113.44"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "on",
				"time": "113.53"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "or",
				"time": "113.92"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "one",
				"time": "114.07"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "114.25"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "their",
				"time": "114.34"
			},
			{
				"duration": "0.38",
				"confidence": "0.880",
				"name": "vendors",
				"time": "114.49"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "putting",
				"time": "114.88"
			},
			{
				"duration": "0.12",
				"confidence": "0.500",
				"name": "it",
				"time": "115.15"
			},
			{
				"duration": "0.30",
				"confidence": "0.950",
				"name": "on",
				"time": "115.27"
			},
			{
				"duration": "0.09",
				"confidence": "0.970",
				"name": "or",
				"time": "115.57"
			},
			{
				"duration": "0.09",
				"confidence": "0.940",
				"name": "a",
				"time": "115.66"
			},
			{
				"duration": "0.36",
				"confidence": "0.980",
				"name": "client",
				"time": "115.75"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "putting",
				"time": "116.11"
			},
			{
				"duration": "0.26",
				"confidence": "1.000",
				"name": "on",
				"time": "116.39"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "or",
				"time": "116.65"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "whatever",
				"time": "116.74"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "it",
				"time": "117.04"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "may",
				"time": "117.13"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "be",
				"time": "117.28"
			},
			{
				"duration": "0.39",
				"confidence": "0.930",
				"name": ".",
				"time": "117.55"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "So",
				"time": "117.97"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "that's",
				"time": "118.18"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "what",
				"time": "118.48"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "we're",
				"time": "118.63"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "talking",
				"time": "118.75"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "about",
				"time": "119.11"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "today",
				"time": "119.29"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "is",
				"time": "119.83"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "as",
				"time": "120.22"
			},
			{
				"duration": "0.09",
				"confidence": "0.950",
				"name": "a",
				"time": "120.67"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "business",
				"time": "120.76"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "professional",
				"time": "121.15"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "who",
				"time": "122.35"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "has",
				"time": "122.53"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "a",
				"time": "123.01"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "fit",
				"time": "123.16"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "lifestyle",
				"time": "123.49"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "or",
				"time": "124.18"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "is",
				"time": "124.39"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "adopting",
				"time": "124.54"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "a",
				"time": "125.17"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "new",
				"time": "125.29"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "healthy",
				"time": "125.50"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "lifestyle",
				"time": "125.80"
			},
			{
				"duration": "0.27",
				"confidence": "0.990",
				"name": ".",
				"time": "126.55"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "How",
				"time": "126.82"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "do",
				"time": "126.94"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "you",
				"time": "127.00"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "manage",
				"time": "127.15"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "127.96"
			},
			{
				"duration": "0.23",
				"confidence": "0.920",
				"name": "bar",
				"time": "128.05"
			},
			{
				"duration": "0.47",
				"confidence": "0.470",
				"name": "scenes",
				"time": "128.30"
			},
			{
				"duration": "0.18",
				"confidence": "0.510",
				"name": "OK",
				"time": "128.82"
			},
			{
				"duration": "0.14",
				"confidence": "0.690",
				"name": ".",
				"time": "129.13"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "So",
				"time": "129.58"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "I'm",
				"time": "129.85"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "going",
				"time": "130.06"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "to",
				"time": "130.33"
			},
			{
				"duration": "0.81",
				"confidence": "1.000",
				"name": "assume",
				"time": "130.51"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "for",
				"time": "131.35"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "131.50"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "purposes",
				"time": "131.62"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "of",
				"time": "132.40"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "this",
				"time": "132.58"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "session",
				"time": "133.15"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "I'm",
				"time": "133.78"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "going",
				"time": "133.96"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "134.23"
			},
			{
				"duration": "0.84",
				"confidence": "1.000",
				"name": "assume",
				"time": "134.38"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "that",
				"time": "135.64"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "you've",
				"time": "135.85"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "chosen",
				"time": "136.03"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "to",
				"time": "136.57"
			},
			{
				"duration": "0.87",
				"confidence": "1.000",
				"name": "participate",
				"time": "136.78"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "in",
				"time": "137.71"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "137.80"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "bar",
				"time": "137.89"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "scene",
				"time": "138.07"
			},
			{
				"duration": "0.02",
				"confidence": "0.830",
				"name": ".",
				"time": "138.31"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "So",
				"time": "138.34"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "when",
				"time": "138.52"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "somebody",
				"time": "138.67"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "says",
				"time": "139.00"
			},
			{
				"duration": "0.09",
				"confidence": "0.980",
				"name": "we're",
				"time": "139.87"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "going",
				"time": "139.96"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "to",
				"time": "140.08"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "go",
				"time": "140.14"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "meet",
				"time": "140.35"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "for",
				"time": "140.53"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "140.68"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "drink",
				"time": "140.77"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "you",
				"time": "141.31"
			},
			{
				"duration": "0.12",
				"confidence": "0.890",
				"name": "are",
				"time": "141.55"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "actually",
				"time": "141.67"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "going",
				"time": "141.91"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "142.03"
			},
			{
				"duration": "0.38",
				"confidence": "1.000",
				"name": "go",
				"time": "142.12"
			},
			{
				"duration": "0.09",
				"confidence": "0.740",
				"name": "and",
				"time": "142.50"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "participate",
				"time": "142.63"
			},
			{
				"duration": "0.25",
				"confidence": "0.610",
				"name": "OK",
				"time": "143.51"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "maybe",
				"time": "144.01"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "you",
				"time": "144.37"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "have",
				"time": "144.67"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "chosen",
				"time": "144.88"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "not",
				"time": "145.33"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "145.54"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "go",
				"time": "145.66"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "or",
				"time": "146.32"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "146.50"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "go",
				"time": "146.65"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "and",
				"time": "146.95"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "not",
				"time": "147.16"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "147.37"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "drink",
				"time": "147.49"
			},
			{
				"duration": "0.03",
				"confidence": "0.630",
				"name": ".",
				"time": "147.88"
			},
			{
				"duration": "0.11",
				"confidence": "0.940",
				"name": "And",
				"time": "147.92"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "that's",
				"time": "148.03"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "all",
				"time": "148.27"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "good",
				"time": "148.54"
			},
			{
				"duration": "0.26",
				"confidence": "0.670",
				"name": ".",
				"time": "149.02"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "We're",
				"time": "149.41"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "talking",
				"time": "149.53"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "about",
				"time": "149.83"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "150.04"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "times",
				"time": "150.13"
			},
			{
				"duration": "0.18",
				"confidence": "0.980",
				"name": "when",
				"time": "150.52"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "you",
				"time": "150.70"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "have",
				"time": "150.91"
			},
			{
				"duration": "0.42",
				"confidence": "0.990",
				"name": "gone",
				"time": "151.15"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "when",
				"time": "151.63"
			},
			{
				"duration": "0.11",
				"confidence": "0.810",
				"name": "you're",
				"time": "151.84"
			},
			{
				"duration": "0.11",
				"confidence": "0.900",
				"name": "going",
				"time": "151.96"
			},
			{
				"duration": "0.10",
				"confidence": "0.900",
				"name": "to",
				"time": "152.07"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "go",
				"time": "152.17"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "and",
				"time": "152.53"
			},
			{
				"duration": "0.12",
				"confidence": "0.920",
				"name": "you're",
				"time": "152.68"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "going",
				"time": "152.80"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "152.92"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "participate",
				"time": "153.01"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "in",
				"time": "153.67"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "154.00"
			},
			{
				"duration": "0.12",
				"confidence": "0.690",
				"name": "bar",
				"time": "154.12"
			},
			{
				"duration": "0.32",
				"confidence": "0.690",
				"name": "scene",
				"time": "154.24"
			},
			{
				"duration": "0.03",
				"confidence": "0.940",
				"name": ".",
				"time": "154.57"
			},
			{
				"duration": "0.22",
				"confidence": "0.900",
				"name": "OK",
				"time": "154.65"
			},
			{
				"duration": "0.33",
				"confidence": "0.710",
				"name": ".",
				"time": "155.03"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "So",
				"time": "155.38"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "that",
				"time": "155.77"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "kind",
				"time": "156.13"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "156.31"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "set",
				"time": "156.40"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "some",
				"time": "156.70"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "context",
				"time": "156.91"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "for",
				"time": "157.98"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "where",
				"time": "158.17"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "we",
				"time": "158.35"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "are",
				"time": "158.56"
			},
			{
				"duration": "0.28",
				"confidence": "0.860",
				"name": "now",
				"time": "159.35"
			},
			{
				"duration": "0.06",
				"confidence": "0.760",
				"name": ".",
				"time": "159.64"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "Let's",
				"time": "159.70"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "paint",
				"time": "161.02"
			},
			{
				"duration": "0.06",
				"confidence": "0.730",
				"name": "the",
				"time": "161.26"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "picture",
				"time": "161.32"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "that",
				"time": "161.71"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "you",
				"time": "161.92"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "have",
				"time": "162.16"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "this",
				"time": "162.46"
			},
			{
				"duration": "0.33",
				"confidence": "0.990",
				"name": "fit",
				"time": "163.15"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "lifestyle",
				"time": "163.48"
			},
			{
				"duration": "0.14",
				"confidence": "0.730",
				"name": "and",
				"time": "164.22"
			},
			{
				"duration": "0.22",
				"confidence": "1.000",
				"name": "it's",
				"time": "164.37"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "already",
				"time": "164.59"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "been",
				"time": "164.83"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "in",
				"time": "165.01"
			},
			{
				"duration": "0.86",
				"confidence": "1.000",
				"name": "existence",
				"time": "165.16"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "and",
				"time": "166.27"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "you",
				"time": "166.60"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "are",
				"time": "166.87"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "eating",
				"time": "167.20"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "healthy",
				"time": "167.50"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "and",
				"time": "167.98"
			},
			{
				"duration": "0.12",
				"confidence": "0.860",
				"name": "you",
				"time": "168.10"
			},
			{
				"duration": "0.18",
				"confidence": "0.700",
				"name": "get",
				"time": "168.22"
			},
			{
				"duration": "0.06",
				"confidence": "0.990",
				"name": "a",
				"time": "168.40"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "good",
				"time": "168.46"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "exercise",
				"time": "168.73"
			},
			{
				"duration": "0.65",
				"confidence": "1.000",
				"name": "routine",
				"time": "169.24"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "but",
				"time": "170.23"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "you",
				"time": "170.35"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "just",
				"time": "170.50"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "can't",
				"time": "170.77"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "figure",
				"time": "171.04"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "out",
				"time": "171.34"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "how",
				"time": "171.46"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "171.58"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "manage",
				"time": "171.85"
			},
			{
				"duration": "0.23",
				"confidence": "0.910",
				"name": "this",
				"time": "172.27"
			},
			{
				"duration": "0.17",
				"confidence": "0.710",
				"name": "bar",
				"time": "172.51"
			},
			{
				"duration": "0.34",
				"confidence": "0.680",
				"name": "scene",
				"time": "172.68"
			},
			{
				"duration": "0.72",
				"confidence": "0.990",
				"name": "correctly",
				"time": "173.02"
			},
			{
				"duration": "0.54",
				"confidence": "0.930",
				"name": ".",
				"time": "173.74"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "Maybe",
				"time": "174.28"
			},
			{
				"duration": "0.12",
				"confidence": "0.960",
				"name": "we've",
				"time": "174.55"
			},
			{
				"duration": "0.15",
				"confidence": "0.980",
				"name": "got",
				"time": "174.67"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "some",
				"time": "174.82"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "tips",
				"time": "174.97"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "for",
				"time": "175.24"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "you",
				"time": "175.42"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "or",
				"time": "175.81"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "you",
				"time": "176.74"
			},
			{
				"duration": "0.30",
				"confidence": "0.520",
				"name": "haven't",
				"time": "176.89"
			},
			{
				"duration": "0.14",
				"confidence": "0.700",
				"name": "been",
				"time": "177.19"
			},
			{
				"duration": "0.13",
				"confidence": "0.970",
				"name": "on",
				"time": "177.39"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "track",
				"time": "177.52"
			},
			{
				"duration": "0.28",
				"confidence": "0.910",
				"name": ".",
				"time": "178.06"
			},
			{
				"duration": "0.17",
				"confidence": "0.910",
				"name": "You're",
				"time": "178.36"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "trying",
				"time": "178.54"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "to",
				"time": "178.96"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "adopt",
				"time": "179.29"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "new",
				"time": "179.89"
			},
			{
				"duration": "0.84",
				"confidence": "1.000",
				"name": "lifestyle",
				"time": "180.49"
			}
		],
		"format": "1.0"
	};

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports = {
		"job": {
			"lang": "en",
			"user_id": 46548,
			"name": "jeff_introduction.mp3",
			"duration": 185,
			"created_at": "Fri Jul 27 20:12:08 2018",
			"id": 8856520
		},
		"speakers": [
			{
				"duration": "119.14",
				"confidence": null,
				"name": "M1",
				"time": "1.66"
			},
			{
				"duration": "64.08",
				"confidence": null,
				"name": "M2",
				"time": "120.84"
			}
		],
		"words": [
			{
				"duration": "0.21",
				"confidence": "0.860",
				"name": "All",
				"time": "1.66"
			},
			{
				"duration": "0.39",
				"confidence": "0.990",
				"name": "right",
				"time": "1.88"
			},
			{
				"duration": "0.38",
				"confidence": "0.980",
				"name": ".",
				"time": "2.27"
			},
			{
				"duration": "0.12",
				"confidence": "0.870",
				"name": "I'd",
				"time": "2.66"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "like",
				"time": "2.78"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "2.99"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "introduce",
				"time": "3.11"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "myself",
				"time": "3.56"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "3.95"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "4.07"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "my",
				"time": "4.19"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "name",
				"time": "4.34"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "is",
				"time": "4.58"
			},
			{
				"duration": "0.54",
				"confidence": "0.900",
				"name": "Jeff",
				"time": "5.26"
			},
			{
				"duration": "0.10",
				"confidence": "0.570",
				"name": ".",
				"time": "5.81"
			},
			{
				"duration": "0.11",
				"confidence": "0.610",
				"name": "The",
				"time": "5.91"
			},
			{
				"duration": "0.25",
				"confidence": "1.000",
				"name": "hip",
				"time": "6.04"
			},
			{
				"duration": "0.20",
				"confidence": "0.940",
				"name": "hop",
				"time": "6.29"
			},
			{
				"duration": "0.31",
				"confidence": "0.900",
				"name": "dating",
				"time": "6.49"
			},
			{
				"duration": "0.51",
				"confidence": "0.990",
				"name": "coach",
				"time": "6.80"
			},
			{
				"duration": "0.20",
				"confidence": "0.580",
				"name": ".",
				"time": "8.02"
			},
			{
				"duration": "0.19",
				"confidence": "0.550",
				"name": "And",
				"time": "8.46"
			},
			{
				"duration": "0.26",
				"confidence": "1.000",
				"name": "this",
				"time": "8.74"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "is",
				"time": "9.14"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "really",
				"time": "9.29"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "10.07"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "just",
				"time": "10.16"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "want",
				"time": "10.34"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "you",
				"time": "10.55"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "10.64"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "get",
				"time": "10.73"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "10.91"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "basic",
				"time": "10.97"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "understanding",
				"time": "11.39"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "11.99"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "who",
				"time": "12.05"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "I",
				"time": "12.26"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "am",
				"time": "12.44"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "what",
				"time": "12.68"
			},
			{
				"duration": "0.12",
				"confidence": "0.940",
				"name": "I'm",
				"time": "12.83"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "about",
				"time": "12.95"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "to",
				"time": "13.22"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "embark",
				"time": "13.28"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "on",
				"time": "13.70"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "I'm",
				"time": "14.42"
			},
			{
				"duration": "0.18",
				"confidence": "0.970",
				"name": "going",
				"time": "14.54"
			},
			{
				"duration": "0.06",
				"confidence": "0.970",
				"name": "to",
				"time": "14.72"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "present",
				"time": "14.78"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "15.59"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "series",
				"time": "15.68"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "16.13"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "videos",
				"time": "16.19"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "17.72"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "help",
				"time": "17.84"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "address",
				"time": "18.11"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "18.74"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "What",
				"time": "19.85"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "I",
				"time": "20.09"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "consider",
				"time": "20.27"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "21.68"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "problem",
				"time": "21.80"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "with",
				"time": "23.09"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "dating",
				"time": "23.81"
			},
			{
				"duration": "0.27",
				"confidence": "0.970",
				"name": "and",
				"time": "24.56"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "my",
				"time": "24.83"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "solutions",
				"time": "25.04"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "to",
				"time": "25.67"
			},
			{
				"duration": "1.02",
				"confidence": "1.000",
				"name": "matrimony",
				"time": "26.72"
			},
			{
				"duration": "0.81",
				"confidence": "1.000",
				"name": "problems",
				"time": "27.77"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "teenage",
				"time": "29.24"
			},
			{
				"duration": "0.96",
				"confidence": "1.000",
				"name": "pregnancy",
				"time": "29.72"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "dating",
				"time": "30.98"
			},
			{
				"duration": "0.87",
				"confidence": "1.000",
				"name": "violence",
				"time": "31.34"
			},
			{
				"duration": "0.12",
				"confidence": "0.930",
				"name": "and",
				"time": "33.35"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "33.47"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "variety",
				"time": "33.50"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "34.07"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "different",
				"time": "34.16"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "things",
				"time": "34.43"
			},
			{
				"duration": "0.07",
				"confidence": "0.770",
				"name": ".",
				"time": "34.82"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "And",
				"time": "34.91"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "35.75"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "call",
				"time": "35.87"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "myself",
				"time": "36.11"
			},
			{
				"duration": "0.04",
				"confidence": "0.740",
				"name": "a",
				"time": "36.64"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "hip",
				"time": "36.68"
			},
			{
				"duration": "0.19",
				"confidence": "0.830",
				"name": "hop",
				"time": "36.89"
			},
			{
				"duration": "0.20",
				"confidence": "0.540",
				"name": "daily",
				"time": "37.08"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "coach",
				"time": "37.28"
			},
			{
				"duration": "0.03",
				"confidence": "0.740",
				"name": ".",
				"time": "37.68"
			},
			{
				"duration": "0.23",
				"confidence": "0.930",
				"name": "That's",
				"time": "37.71"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "because",
				"time": "37.94"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "38.21"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "use",
				"time": "38.30"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "hip",
				"time": "38.96"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "hop",
				"time": "39.20"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "to",
				"time": "39.50"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "address",
				"time": "40.28"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "the",
				"time": "40.88"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "middle",
				"time": "41.06"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "ground",
				"time": "41.36"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "of",
				"time": "42.29"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "42.95"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "People",
				"time": "44.19"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "or",
				"time": "44.82"
			},
			{
				"duration": "0.84",
				"confidence": "1.000",
				"name": "society",
				"time": "44.97"
			},
			{
				"duration": "0.26",
				"confidence": "0.960",
				"name": ".",
				"time": "45.84"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "Hip",
				"time": "46.11"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "hop",
				"time": "46.38"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "was",
				"time": "46.71"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "created",
				"time": "47.13"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "by",
				"time": "48.03"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "48.30"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "variety",
				"time": "48.33"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "of",
				"time": "49.02"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "ethnic",
				"time": "49.17"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "groups",
				"time": "49.53"
			},
			{
				"duration": "0.09",
				"confidence": "0.810",
				"name": "in",
				"time": "49.86"
			},
			{
				"duration": "0.06",
				"confidence": "0.980",
				"name": "the",
				"time": "49.95"
			},
			{
				"duration": "0.81",
				"confidence": "1.000",
				"name": "African-American",
				"time": "50.01"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "community",
				"time": "50.82"
			},
			{
				"duration": "0.87",
				"confidence": "1.000",
				"name": "Europeans",
				"time": "51.75"
			},
			{
				"duration": "0.84",
				"confidence": "1.000",
				"name": "Latinos",
				"time": "52.89"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "and",
				"time": "53.97"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "even",
				"time": "54.12"
			},
			{
				"duration": "0.42",
				"confidence": "0.890",
				"name": "heavily",
				"time": "54.46"
			},
			{
				"duration": "0.33",
				"confidence": "0.430",
				"name": "flu",
				"time": "54.90"
			},
			{
				"duration": "0.42",
				"confidence": "0.980",
				"name": "infused",
				"time": "55.56"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "by",
				"time": "55.98"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "Asian",
				"time": "56.67"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "culture",
				"time": "56.97"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "with",
				"time": "57.42"
			},
			{
				"duration": "0.06",
				"confidence": "0.990",
				"name": "the",
				"time": "57.60"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "martial",
				"time": "57.66"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "arts",
				"time": "58.05"
			},
			{
				"duration": "0.44",
				"confidence": "1.000",
				"name": "movies",
				"time": "58.26"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "of",
				"time": "58.71"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "course",
				"time": "58.86"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "you",
				"time": "59.55"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "know",
				"time": "59.73"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "you",
				"time": "59.91"
			},
			{
				"duration": "0.24",
				"confidence": "0.980",
				"name": "had",
				"time": "60.15"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "the",
				"time": "60.39"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "pioneering",
				"time": "61.47"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "values",
				"time": "62.16"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "love",
				"time": "62.64"
			},
			{
				"duration": "0.24",
				"confidence": "0.790",
				"name": "peace",
				"time": "62.91"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "and",
				"time": "63.15"
			},
			{
				"duration": "0.33",
				"confidence": "0.990",
				"name": "having",
				"time": "63.27"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "fun",
				"time": "63.60"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "and",
				"time": "64.47"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "really",
				"time": "64.98"
			},
			{
				"duration": "0.21",
				"confidence": "0.900",
				"name": "that",
				"time": "65.22"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "just",
				"time": "65.43"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "65.88"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "To",
				"time": "66.51"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "me",
				"time": "66.66"
			},
			{
				"duration": "0.08",
				"confidence": "0.520",
				"name": ".",
				"time": "67.08"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "Hip",
				"time": "67.23"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "hop",
				"time": "67.47"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "is",
				"time": "67.83"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "68.16"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "place",
				"time": "68.25"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "where",
				"time": "68.64"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "race",
				"time": "69.87"
			},
			{
				"duration": "0.57",
				"confidence": "0.980",
				"name": "doesn't",
				"time": "71.04"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "really",
				"time": "71.61"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "matter",
				"time": "72.06"
			},
			{
				"duration": "0.51",
				"confidence": "0.910",
				"name": ".",
				"time": "72.69"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "Culture",
				"time": "73.20"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "is",
				"time": "74.07"
			},
			{
				"duration": "0.64",
				"confidence": "1.000",
				"name": "welcomed",
				"time": "74.34"
			},
			{
				"duration": "0.02",
				"confidence": "0.540",
				"name": ".",
				"time": "74.98"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "So",
				"time": "75.09"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "you",
				"time": "75.27"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "bring",
				"time": "75.45"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "your",
				"time": "75.75"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "cultural",
				"time": "75.93"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "expressions",
				"time": "76.44"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "whether",
				"time": "77.37"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "you're",
				"time": "77.67"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "Arab",
				"time": "78.60"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "you're",
				"time": "79.29"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "Indian",
				"time": "80.19"
			},
			{
				"duration": "0.40",
				"confidence": "0.620",
				"name": "and",
				"time": "81.28"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "Latino",
				"time": "82.71"
			},
			{
				"duration": "0.08",
				"confidence": "0.870",
				"name": ".",
				"time": "83.49"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "We",
				"time": "83.58"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "want",
				"time": "83.82"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "to",
				"time": "84.03"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "hear",
				"time": "84.09"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "how",
				"time": "84.78"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "you",
				"time": "84.96"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "put",
				"time": "85.14"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "your",
				"time": "85.38"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "spin",
				"time": "85.53"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "on",
				"time": "85.98"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "it",
				"time": "86.19"
			},
			{
				"duration": "0.20",
				"confidence": "0.930",
				"name": "so",
				"time": "86.26"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "we",
				"time": "86.46"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "don't",
				"time": "86.64"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "want",
				"time": "86.82"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "you",
				"time": "87.06"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "87.54"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "lose",
				"time": "87.66"
			},
			{
				"duration": "0.12",
				"confidence": "0.930",
				"name": "your",
				"time": "87.96"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "culture",
				"time": "88.08"
			},
			{
				"duration": "0.02",
				"confidence": "0.650",
				"name": ".",
				"time": "88.47"
			},
			{
				"duration": "0.16",
				"confidence": "1.000",
				"name": "We",
				"time": "88.49"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "want",
				"time": "88.65"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "88.86"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "to",
				"time": "88.98"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "bring",
				"time": "89.49"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "your",
				"time": "89.73"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "culture",
				"time": "89.88"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "but",
				"time": "90.54"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "your",
				"time": "90.69"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "culture",
				"time": "90.81"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "is",
				"time": "91.17"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "welcome",
				"time": "91.32"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "and",
				"time": "92.10"
			},
			{
				"duration": "0.24",
				"confidence": "0.980",
				"name": "that's",
				"time": "92.34"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "different",
				"time": "92.58"
			},
			{
				"duration": "0.26",
				"confidence": "0.850",
				"name": "than",
				"time": "93.04"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "93.36"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "lot",
				"time": "93.45"
			},
			{
				"duration": "0.32",
				"confidence": "1.000",
				"name": "of",
				"time": "93.81"
			},
			{
				"duration": "0.84",
				"confidence": "0.830",
				"name": "subgroups",
				"time": "95.52"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "in",
				"time": "96.48"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "America",
				"time": "97.02"
			},
			{
				"duration": "0.39",
				"confidence": "0.870",
				"name": ".",
				"time": "97.74"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "And",
				"time": "98.19"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "98.31"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "say",
				"time": "98.40"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "that",
				"time": "98.64"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "because",
				"time": "98.82"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "our",
				"time": "99.78"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "subgroups",
				"time": "99.93"
			},
			{
				"duration": "0.47",
				"confidence": "0.970",
				"name": "heavily",
				"time": "100.50"
			},
			{
				"duration": "0.66",
				"confidence": "0.660",
				"name": "influence",
				"time": "100.98"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "us",
				"time": "101.64"
			},
			{
				"duration": "0.25",
				"confidence": "0.570",
				"name": ".",
				"time": "101.99"
			},
			{
				"duration": "0.47",
				"confidence": "1.000",
				"name": "And",
				"time": "102.43"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "102.9"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "When",
				"time": "103.74"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "it",
				"time": "103.89"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "comes",
				"time": "103.98"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "104.28"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "dating",
				"time": "104.40"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "105.03"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "We",
				"time": "106.98"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "get",
				"time": "107.16"
			},
			{
				"duration": "0.36",
				"confidence": "0.970",
				"name": "on",
				"time": "107.37"
			},
			{
				"duration": "0.90",
				"confidence": "0.670",
				"name": "main",
				"time": "107.85"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "influences",
				"time": "108.84"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "from",
				"time": "109.80"
			},
			{
				"duration": "0.09",
				"confidence": "0.690",
				"name": "our",
				"time": "110.07"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "religions",
				"time": "110.16"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "and",
				"time": "111.21"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "our",
				"time": "111.36"
			},
			{
				"duration": "0.64",
				"confidence": "1.000",
				"name": "cultures",
				"time": "111.48"
			},
			{
				"duration": "0.16",
				"confidence": "0.640",
				"name": ".",
				"time": "112.14"
			},
			{
				"duration": "0.18",
				"confidence": "0.980",
				"name": "And",
				"time": "112.38"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "many",
				"time": "112.56"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "of",
				"time": "112.83"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "our",
				"time": "112.98"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "cultures",
				"time": "113.07"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "and",
				"time": "113.58"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "religions",
				"time": "113.67"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "don't",
				"time": "114.63"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "more",
				"time": "116.70"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "so",
				"time": "117.09"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "isolate",
				"time": "118.14"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "us",
				"time": "118.71"
			},
			{
				"duration": "0.30",
				"confidence": "0.970",
				"name": "than",
				"time": "119.28"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "unite",
				"time": "119.58"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "us",
				"time": "120.06"
			},
			{
				"duration": "0.35",
				"confidence": "0.900",
				"name": ".",
				"time": "120.45"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "Many",
				"time": "120.84"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "religions",
				"time": "121.17"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "have",
				"time": "122.04"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "within",
				"time": "122.94"
			},
			{
				"duration": "0.15",
				"confidence": "0.910",
				"name": "their",
				"time": "123.36"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "guidelines",
				"time": "123.51"
			},
			{
				"duration": "0.18",
				"confidence": "0.580",
				"name": ".",
				"time": "124.29"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "Muslims",
				"time": "124.47"
			},
			{
				"duration": "0.23",
				"confidence": "0.980",
				"name": "are",
				"time": "125.10"
			},
			{
				"duration": "0.23",
				"confidence": "1.000",
				"name": "to",
				"time": "125.35"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "date",
				"time": "125.58"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "marry",
				"time": "126.03"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "only",
				"time": "126.75"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "Muslims",
				"time": "127.05"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "Jewish",
				"time": "127.65"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "people",
				"time": "128.13"
			},
			{
				"duration": "0.12",
				"confidence": "0.830",
				"name": "are",
				"time": "128.85"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "128.97"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "date",
				"time": "129.12"
			},
			{
				"duration": "0.41",
				"confidence": "1.000",
				"name": "marry",
				"time": "129.82"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "only",
				"time": "130.29"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "Jewish",
				"time": "130.65"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "people",
				"time": "131.04"
			},
			{
				"duration": "0.09",
				"confidence": "0.680",
				"name": "and",
				"time": "131.45"
			},
			{
				"duration": "0.06",
				"confidence": "0.690",
				"name": "the",
				"time": "131.54"
			},
			{
				"duration": "0.28",
				"confidence": "1.000",
				"name": "same",
				"time": "131.60"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "thing",
				"time": "131.88"
			},
			{
				"duration": "0.16",
				"confidence": "1.000",
				"name": "with",
				"time": "132.21"
			},
			{
				"duration": "0.06",
				"confidence": "0.620",
				"name": "the",
				"time": "132.37"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "different",
				"time": "133.02"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "denominations",
				"time": "133.29"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "134.01"
			},
			{
				"duration": "0.81",
				"confidence": "1.000",
				"name": "Christianity",
				"time": "134.13"
			},
			{
				"duration": "0.29",
				"confidence": "0.810",
				"name": ".",
				"time": "134.94"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "And",
				"time": "135.30"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "136.59"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "think",
				"time": "136.68"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "that",
				"time": "136.89"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "is",
				"time": "137.34"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "kind",
				"time": "137.55"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "of",
				"time": "137.82"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "138.15"
			},
			{
				"duration": "0.71",
				"confidence": "1.000",
				"name": "problem",
				"time": "138.24"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "but",
				"time": "139.29"
			},
			{
				"duration": "0.14",
				"confidence": "0.860",
				"name": "it's",
				"time": "139.47"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "only",
				"time": "139.62"
			},
			{
				"duration": "0.22",
				"confidence": "1.000",
				"name": "one",
				"time": "139.89"
			},
			{
				"duration": "0.06",
				"confidence": "0.970",
				"name": "of",
				"time": "140.11"
			},
			{
				"duration": "0.08",
				"confidence": "0.470",
				"name": "our",
				"time": "140.17"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "problems",
				"time": "140.25"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": ".",
				"time": "140.85"
			},
			{
				"duration": "0.08",
				"confidence": "0.920",
				"name": "All",
				"time": "140.94"
			},
			{
				"duration": "0.28",
				"confidence": "0.920",
				"name": "right",
				"time": "141.02"
			},
			{
				"duration": "0.25",
				"confidence": "0.760",
				"name": ".",
				"time": "141.31"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "I",
				"time": "141.63"
			},
			{
				"duration": "0.33",
				"confidence": "0.970",
				"name": "tried",
				"time": "141.84"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "142.17"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "address",
				"time": "142.32"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "that",
				"time": "142.83"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "by",
				"time": "143.46"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "offering",
				"time": "143.79"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "myself",
				"time": "144.27"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "as",
				"time": "144.69"
			},
			{
				"duration": "0.06",
				"confidence": "0.970",
				"name": "a",
				"time": "144.81"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "hip",
				"time": "144.87"
			},
			{
				"duration": "0.17",
				"confidence": "0.920",
				"name": "hop",
				"time": "145.08"
			},
			{
				"duration": "0.28",
				"confidence": "0.920",
				"name": "dating",
				"time": "145.25"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "coach",
				"time": "145.53"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "so",
				"time": "146.13"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "that",
				"time": "146.25"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "way",
				"time": "146.40"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "I'm",
				"time": "147.36"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "going",
				"time": "147.57"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "for",
				"time": "147.84"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "148.17"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "people",
				"time": "148.29"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "who",
				"time": "148.65"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "are",
				"time": "149.46"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "like",
				"time": "149.70"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "most",
				"time": "149.97"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "Americans",
				"time": "150.36"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "see",
				"time": "151.11"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "somebody",
				"time": "151.38"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "they",
				"time": "151.92"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "are",
				"time": "152.16"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "attracted",
				"time": "152.25"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "to",
				"time": "152.73"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "and",
				"time": "153.30"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "would",
				"time": "153.45"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "like",
				"time": "153.63"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "153.84"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "talk",
				"time": "153.96"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "154.26"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "them",
				"time": "154.38"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "and",
				"time": "154.98"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "engage",
				"time": "155.19"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "in",
				"time": "155.73"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "a",
				"time": "155.85"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "premarital",
				"time": "156.24"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "dating",
				"time": "157.02"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "process",
				"time": "157.41"
			},
			{
				"duration": "0.18",
				"confidence": "0.840",
				"name": ".",
				"time": "158.10"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "You",
				"time": "158.31"
			},
			{
				"duration": "0.21",
				"confidence": "0.980",
				"name": "know",
				"time": "158.43"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "158.67"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "don't",
				"time": "158.76"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "think",
				"time": "159.00"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "everybody",
				"time": "159.33"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "goes",
				"time": "159.84"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "out",
				"time": "160.26"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "to",
				"time": "160.92"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "look",
				"time": "161.16"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "for",
				"time": "161.61"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "somebody",
				"time": "162.03"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "162.60"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "marry",
				"time": "162.75"
			},
			{
				"duration": "0.50",
				"confidence": "0.790",
				"name": ".",
				"time": "163.29"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "But",
				"time": "163.95"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "164.49"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "think",
				"time": "164.61"
			},
			{
				"duration": "0.24",
				"confidence": "0.990",
				"name": "that's",
				"time": "164.85"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "also",
				"time": "165.15"
			},
			{
				"duration": "0.11",
				"confidence": "0.880",
				"name": "the",
				"time": "165.58"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "problem",
				"time": "165.69"
			},
			{
				"duration": "0.07",
				"confidence": "0.770",
				"name": ".",
				"time": "166.14"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I",
				"time": "166.23"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "think",
				"time": "166.38"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "that",
				"time": "167.04"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "if",
				"time": "167.31"
			},
			{
				"duration": "0.17",
				"confidence": "0.810",
				"name": "you're",
				"time": "167.58"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "going",
				"time": "167.76"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "to",
				"time": "168.06"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "look",
				"time": "168.24"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "for",
				"time": "168.51"
			},
			{
				"duration": "0.45",
				"confidence": "0.650",
				"name": "booty",
				"time": "168.72"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "or",
				"time": "169.17"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "look",
				"time": "169.29"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "for",
				"time": "169.53"
			},
			{
				"duration": "0.03",
				"confidence": "0.960",
				"name": "a",
				"time": "169.71"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "nice",
				"time": "169.74"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "person",
				"time": "170.10"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "you",
				"time": "171.30"
			},
			{
				"duration": "0.30",
				"confidence": "0.940",
				"name": "need",
				"time": "171.48"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "to",
				"time": "171.78"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "let",
				"time": "171.96"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "marriage",
				"time": "172.74"
			},
			{
				"duration": "0.93",
				"confidence": "1.000",
				"name": "potential",
				"time": "173.49"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "stay",
				"time": "174.60"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "on",
				"time": "174.96"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "175.11"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "table",
				"time": "175.20"
			},
			{
				"duration": "0.11",
				"confidence": "0.660",
				"name": "and",
				"time": "175.96"
			},
			{
				"duration": "0.08",
				"confidence": "1.000",
				"name": "the",
				"time": "176.08"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "moment",
				"time": "176.16"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "that",
				"time": "176.52"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "you",
				"time": "176.73"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "take",
				"time": "176.88"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "that",
				"time": "177.27"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "off",
				"time": "177.63"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "177.87"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "table",
				"time": "177.96"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "it",
				"time": "178.74"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "becomes",
				"time": "178.86"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "179.28"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "problem",
				"time": "179.34"
			},
			{
				"duration": "0.26",
				"confidence": "0.980",
				"name": ".",
				"time": "179.76"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "So",
				"time": "180.03"
			},
			{
				"duration": "0.29",
				"confidence": "0.850",
				"name": "I'm",
				"time": "181.26"
			},
			{
				"duration": "0.06",
				"confidence": "0.720",
				"name": "a",
				"time": "181.56"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "hip",
				"time": "181.62"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "hop",
				"time": "181.83"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "dating",
				"time": "182.01"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "coach",
				"time": "182.31"
			},
			{
				"duration": "0.00",
				"confidence": "1.000",
				"name": ".",
				"time": "184.92"
			}
		],
		"format": "1.0"
	};

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = {
		"job": {
			"lang": "en-US",
			"user_id": 46548,
			"name": "shantanu_trimmed.mp3",
			"duration": 77,
			"created_at": "Wed Oct 24 20:42:53 2018",
			"id": 9695330
		},
		"speakers": [
			{
				"duration": "75.52",
				"confidence": null,
				"name": "M1",
				"time": "0.80"
			}
		],
		"words": [
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "I",
				"time": "0.80"
			},
			{
				"duration": "0.39",
				"confidence": "0.560",
				"name": "realize",
				"time": "0.86"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "today",
				"time": "1.25"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "you",
				"time": "1.55"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "might",
				"time": "1.64"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "be",
				"time": "1.88"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "expecting",
				"time": "2.00"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "me",
				"time": "2.54"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "some",
				"time": "2.78"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "thoughtful",
				"time": "3.02"
			},
			{
				"duration": "0.45",
				"confidence": "0.990",
				"name": "quotes",
				"time": "3.44"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "from",
				"time": "3.89"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "historical",
				"time": "4.13"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "figures",
				"time": "4.76"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "like",
				"time": "5.15"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "Kennedy",
				"time": "5.33"
			},
			{
				"duration": "0.07",
				"confidence": "0.810",
				"name": "or",
				"time": "5.87"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "Twain",
				"time": "5.96"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "or",
				"time": "7.19"
			},
			{
				"duration": "0.36",
				"confidence": "0.930",
				"name": "sudden",
				"time": "7.31"
			},
			{
				"duration": "0.39",
				"confidence": "0.550",
				"name": "Sue",
				"time": "7.67"
			},
			{
				"duration": "0.12",
				"confidence": "0.640",
				"name": "and",
				"time": "8.06"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "The",
				"time": "8.18"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "Art",
				"time": "8.30"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "8.54"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "War",
				"time": "8.60"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "9.08"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "Or",
				"time": "9.71"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "other",
				"time": "9.86"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "great",
				"time": "10.07"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "individuals",
				"time": "10.31"
			},
			{
				"duration": "0.18",
				"confidence": "0.980",
				"name": "whose",
				"time": "11.03"
			},
			{
				"duration": "0.30",
				"confidence": "0.850",
				"name": "quotes",
				"time": "11.21"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "show",
				"time": "11.51"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "up",
				"time": "11.75"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "on",
				"time": "11.96"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "inspirational",
				"time": "12.11"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "posters",
				"time": "12.89"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "with",
				"time": "14.06"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "images",
				"time": "14.24"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "14.69"
			},
			{
				"duration": "0.60",
				"confidence": "0.990",
				"name": "egos",
				"time": "14.81"
			},
			{
				"duration": "0.06",
				"confidence": "0.940",
				"name": "or",
				"time": "15.41"
			},
			{
				"duration": "0.84",
				"confidence": "1.000",
				"name": "mountains",
				"time": "15.47"
			},
			{
				"duration": "0.25",
				"confidence": "0.960",
				"name": "or",
				"time": "17.03"
			},
			{
				"duration": "0.08",
				"confidence": "0.850",
				"name": "a",
				"time": "17.28"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "mountain",
				"time": "17.36"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "climbers",
				"time": "17.78"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "but",
				"time": "18.38"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "18.53"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "know",
				"time": "18.62"
			},
			{
				"duration": "0.27",
				"confidence": "0.990",
				"name": "you've",
				"time": "18.80"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "heard",
				"time": "19.16"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "those",
				"time": "19.46"
			},
			{
				"duration": "0.67",
				"confidence": "0.990",
				"name": "already",
				"time": "19.71"
			},
			{
				"duration": "0.41",
				"confidence": "0.850",
				"name": ".",
				"time": "20.90"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "So",
				"time": "21.38"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "21.59"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "thought",
				"time": "21.71"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "today",
				"time": "21.98"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "it",
				"time": "23.09"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "might",
				"time": "23.18"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "be",
				"time": "23.42"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "better",
				"time": "23.54"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "23.84"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "deconstruct",
				"time": "23.99"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "my",
				"time": "24.62"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "own",
				"time": "24.86"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "life",
				"time": "25.04"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "25.52"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "And",
				"time": "26.06"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "share",
				"time": "26.21"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "some",
				"time": "26.48"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "lessons",
				"time": "26.75"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "with",
				"time": "27.17"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "you",
				"time": "27.38"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "from",
				"time": "28.31"
			},
			{
				"duration": "0.24",
				"confidence": "0.990",
				"name": "one",
				"time": "28.49"
			},
			{
				"duration": "0.27",
				"confidence": "0.210",
				"name": "HA's",
				"time": "28.73"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "grad",
				"time": "29.00"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "to",
				"time": "29.30"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "another",
				"time": "29.48"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "29.84"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "Without",
				"time": "30.53"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "30.86"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "lot",
				"time": "30.92"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "31.10"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "pomp",
				"time": "31.19"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "and",
				"time": "31.79"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "circumstance",
				"time": "31.94"
			},
			{
				"duration": "0.02",
				"confidence": "0.790",
				"name": ".",
				"time": "32.63"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "But",
				"time": "32.66"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "from",
				"time": "32.84"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "33.05"
			},
			{
				"duration": "0.30",
				"confidence": "0.960",
				"name": "heart",
				"time": "33.14"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "33.44"
			},
			{
				"duration": "0.17",
				"confidence": "0.830",
				"name": "There's",
				"time": "35.10"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "one",
				"time": "35.28"
			},
			{
				"duration": "0.24",
				"confidence": "0.980",
				"name": "truth",
				"time": "35.49"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "that",
				"time": "35.73"
			},
			{
				"duration": "0.10",
				"confidence": "0.840",
				"name": "I",
				"time": "35.91"
			},
			{
				"duration": "0.17",
				"confidence": "0.840",
				"name": "have",
				"time": "36.01"
			},
			{
				"duration": "0.39",
				"confidence": "0.980",
				"name": "learned",
				"time": "36.18"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "many",
				"time": "36.75"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "times",
				"time": "37.05"
			},
			{
				"duration": "0.29",
				"confidence": "1.000",
				"name": "over",
				"time": "37.41"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "and",
				"time": "37.74"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "that",
				"time": "37.86"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "is",
				"time": "38.04"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "change",
				"time": "38.19"
			},
			{
				"duration": "0.12",
				"confidence": "0.960",
				"name": "is",
				"time": "38.52"
			},
			{
				"duration": "0.52",
				"confidence": "0.930",
				"name": "constant",
				"time": "38.66"
			},
			{
				"duration": "0.57",
				"confidence": "0.760",
				"name": "industrial",
				"time": "39.63"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "change",
				"time": "40.20"
			},
			{
				"duration": "0.48",
				"confidence": "0.890",
				"name": "personal",
				"time": "40.62"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "change",
				"time": "41.13"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "political",
				"time": "41.58"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "change",
				"time": "42.15"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "technology",
				"time": "42.99"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "change",
				"time": "43.59"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": ".",
				"time": "43.95"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "Think",
				"time": "43.98"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "back",
				"time": "44.22"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "44.46"
			},
			{
				"duration": "0.18",
				"confidence": "0.980",
				"name": "two",
				"time": "44.58"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "years",
				"time": "44.76"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "ago",
				"time": "45.06"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "46.11"
			},
			{
				"duration": "0.06",
				"confidence": "0.900",
				"name": "were",
				"time": "46.23"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "just",
				"time": "46.29"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "receiving",
				"time": "46.50"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": "your",
				"time": "46.98"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "admissions",
				"time": "47.07"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "notification",
				"time": "47.61"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "from",
				"time": "48.39"
			},
			{
				"duration": "0.35",
				"confidence": "0.380",
				"name": "Hamas",
				"time": "48.60"
			},
			{
				"duration": "0.53",
				"confidence": "0.670",
				"name": ".",
				"time": "48.95"
			},
			{
				"duration": "0.42",
				"confidence": "0.960",
				"name": "Tablets",
				"time": "49.65"
			},
			{
				"duration": "0.12",
				"confidence": "0.930",
				"name": "were",
				"time": "50.07"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "starting",
				"time": "50.19"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "50.58"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "gain",
				"time": "50.70"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "ground",
				"time": "50.97"
			},
			{
				"duration": "0.03",
				"confidence": "0.990",
				"name": ".",
				"time": "51.33"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "Instagram",
				"time": "51.36"
			},
			{
				"duration": "0.18",
				"confidence": "0.950",
				"name": "didn't",
				"time": "52.02"
			},
			{
				"duration": "0.58",
				"confidence": "1.000",
				"name": "exist",
				"time": "52.20"
			},
			{
				"duration": "0.53",
				"confidence": "0.830",
				"name": ".",
				"time": "52.80"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "The",
				"time": "53.43"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "Arab",
				"time": "53.61"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "Spring",
				"time": "53.91"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "was",
				"time": "54.27"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "54.45"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "dream",
				"time": "54.51"
			},
			{
				"duration": "0.02",
				"confidence": "0.680",
				"name": ".",
				"time": "54.87"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "But",
				"time": "54.90"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "within",
				"time": "55.02"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "55.32"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "year",
				"time": "55.38"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "Multiple",
				"time": "55.59"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "regimes",
				"time": "56.10"
			},
			{
				"duration": "0.13",
				"confidence": "0.560",
				"name": "were",
				"time": "56.58"
			},
			{
				"duration": "0.53",
				"confidence": "1.000",
				"name": "toppling",
				"time": "56.71"
			},
			{
				"duration": "0.39",
				"confidence": "0.950",
				"name": "China",
				"time": "57.75"
			},
			{
				"duration": "0.50",
				"confidence": "0.930",
				"name": "unseated",
				"time": "58.15"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "Japan",
				"time": "58.65"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "as",
				"time": "59.10"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "59.22"
			},
			{
				"duration": "0.30",
				"confidence": "0.950",
				"name": "world's",
				"time": "59.34"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "second",
				"time": "59.64"
			},
			{
				"duration": "0.48",
				"confidence": "0.990",
				"name": "economy",
				"time": "60.03"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "none",
				"time": "61.88"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "of",
				"time": "62.06"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "us",
				"time": "62.21"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "can",
				"time": "62.39"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "really",
				"time": "62.54"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "know",
				"time": "62.84"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "what",
				"time": "63.29"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "63.50"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "future",
				"time": "63.59"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "has",
				"time": "63.95"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "in",
				"time": "64.22"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "store",
				"time": "64.34"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "and",
				"time": "64.70"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "that",
				"time": "64.79"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "can",
				"time": "64.97"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "be",
				"time": "65.15"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "pretty",
				"time": "65.27"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "scary",
				"time": "65.57"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "as",
				"time": "66.02"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "66.14"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "business",
				"time": "66.20"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "leader",
				"time": "67.01"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "and",
				"time": "67.46"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "as",
				"time": "67.73"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "67.88"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "human",
				"time": "67.94"
			},
			{
				"duration": "0.29",
				"confidence": "1.000",
				"name": "being",
				"time": "68.33"
			},
			{
				"duration": "0.17",
				"confidence": "0.560",
				"name": ".",
				"time": "69.36"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "But",
				"time": "69.73"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "there",
				"time": "69.88"
			},
			{
				"duration": "0.03",
				"confidence": "0.990",
				"name": "are",
				"time": "69.97"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "ways",
				"time": "70.00"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "in",
				"time": "70.30"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "which",
				"time": "70.39"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "you",
				"time": "70.60"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "can",
				"time": "70.69"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "embrace",
				"time": "70.84"
			},
			{
				"duration": "0.12",
				"confidence": "0.950",
				"name": "the",
				"time": "71.26"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "change",
				"time": "71.38"
			},
			{
				"duration": "0.30",
				"confidence": "0.770",
				"name": "roll",
				"time": "71.77"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "with",
				"time": "72.07"
			},
			{
				"duration": "0.15",
				"confidence": "0.640",
				"name": "or",
				"time": "72.28"
			},
			{
				"duration": "0.30",
				"confidence": "0.640",
				"name": "try",
				"time": "72.43"
			},
			{
				"duration": "0.24",
				"confidence": "0.840",
				"name": "with",
				"time": "72.74"
			},
			{
				"duration": "0.17",
				"confidence": "0.770",
				"name": "it",
				"time": "72.98"
			},
			{
				"duration": "0.08",
				"confidence": "0.710",
				"name": ".",
				"time": "73.15"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "If",
				"time": "73.78"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you're",
				"time": "73.90"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "willing",
				"time": "74.02"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "74.32"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "let",
				"time": "74.41"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "go",
				"time": "74.62"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "74.83"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "little",
				"time": "74.89"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "and",
				"time": "75.46"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "pay",
				"time": "75.58"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "attention",
				"time": "75.79"
			},
			{
				"duration": "0.02",
				"confidence": "0.770",
				"name": ".",
				"time": "76.30"
			}
		],
		"format": "1.0"
	};

/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports = {
		"job": {
			"lang": "en",
			"user_id": 46548,
			"name": "sports.mp3",
			"duration": 185,
			"created_at": "Fri Jul 27 20:11:59 2018",
			"id": 8856518
		},
		"speakers": [
			{
				"duration": "43.47",
				"confidence": null,
				"name": "F1",
				"time": "3.72"
			},
			{
				"duration": "59.53",
				"confidence": null,
				"name": "F2",
				"time": "47.35"
			},
			{
				"duration": "77.10",
				"confidence": null,
				"name": "F1",
				"time": "106.90"
			}
		],
		"words": [
			{
				"duration": "0.11",
				"confidence": "0.910",
				"name": "Hi",
				"time": "3.72"
			},
			{
				"duration": "0.19",
				"confidence": "0.550",
				"name": "Creighton",
				"time": "3.83"
			},
			{
				"duration": "0.17",
				"confidence": "0.570",
				"name": "volleyball",
				"time": "4.07"
			},
			{
				"duration": "0.38",
				"confidence": "0.700",
				"name": "fans",
				"time": "4.93"
			},
			{
				"duration": "0.02",
				"confidence": "0.620",
				"name": ".",
				"time": "5.31"
			},
			{
				"duration": "0.16",
				"confidence": "1.000",
				"name": "Hi",
				"time": "5.36"
			},
			{
				"duration": "0.40",
				"confidence": "1.000",
				"name": "Dad",
				"time": "5.52"
			},
			{
				"duration": "0.02",
				"confidence": "0.680",
				"name": ".",
				"time": "5.92"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "Happy",
				"time": "5.94"
			},
			{
				"duration": "0.39",
				"confidence": "0.980",
				"name": "Father's",
				"time": "6.21"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "Day",
				"time": "6.60"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "6.99"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "you",
				"time": "7.14"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "and",
				"time": "7.44"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "all",
				"time": "7.56"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "7.71"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "other",
				"time": "7.80"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "dads",
				"time": "7.98"
			},
			{
				"duration": "0.15",
				"confidence": "0.430",
				"name": "hope you",
				"time": "8.65"
			},
			{
				"duration": "0.11",
				"confidence": "0.770",
				"name": "had",
				"time": "8.88"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "9.00"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "great",
				"time": "9.06"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "day",
				"time": "9.27"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": ".",
				"time": "9.66"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "We",
				"time": "10.14"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "sure",
				"time": "10.29"
			},
			{
				"duration": "0.20",
				"confidence": "0.820",
				"name": "did",
				"time": "10.47"
			},
			{
				"duration": "0.04",
				"confidence": "0.540",
				"name": ".",
				"time": "10.67"
			},
			{
				"duration": "0.12",
				"confidence": "0.900",
				"name": "Over",
				"time": "10.71"
			},
			{
				"duration": "0.14",
				"confidence": "0.820",
				"name": "here",
				"time": "10.83"
			},
			{
				"duration": "0.06",
				"confidence": "0.980",
				"name": "in",
				"time": "10.98"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "Budapest",
				"time": "11.04"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "across",
				"time": "11.58"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "the",
				"time": "11.94"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "world",
				"time": "12.00"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "today",
				"time": "13.32"
			},
			{
				"duration": "0.38",
				"confidence": "1.000",
				"name": "is",
				"time": "13.95"
			},
			{
				"duration": "0.55",
				"confidence": "0.970",
				"name": "day",
				"time": "14.34"
			},
			{
				"duration": "0.04",
				"confidence": "0.630",
				"name": "...",
				"time": "14.91"
			},
			{
				"duration": "0.25",
				"confidence": "0.840",
				"name": "what",
				"time": "14.97"
			},
			{
				"duration": "0.32",
				"confidence": "0.840",
				"name": "day is",
				"time": "15.22"
			},
			{
				"duration": "0.25",
				"confidence": "0.930",
				"name": "it?",
				"time": "15.54"
			},
			{
				"duration": "0.24",
				"confidence": "0.640",
				"name": "day six",
				"time": "15.96"
			},
			{
				"duration": "0.37",
				"confidence": "0.770",
				"name": "day",
				"time": "16.40"
			},
			{
				"duration": "0.40",
				"confidence": "0.410",
				"name": "six",
				"time": "16.77"
			},
			{
				"duration": "0.20",
				"confidence": "0.230",
				"name": "you're",
				"time": "17.19"
			},
			{
				"duration": "0.08",
				"confidence": "0.790",
				"name": "in",
				"time": "17.40"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "Budapest",
				"time": "17.49"
			},
			{
				"duration": "0.16",
				"confidence": "0.560",
				"name": "was",
				"time": "18.67"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "our",
				"time": "18.84"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "first",
				"time": "18.96"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "full",
				"time": "19.23"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "day",
				"time": "19.38"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "here",
				"time": "19.56"
			},
			{
				"duration": "0.48",
				"confidence": "0.990",
				"name": "so",
				"time": "19.80"
			},
			{
				"duration": "0.09",
				"confidence": "0.950",
				"name": "we're",
				"time": "20.67"
			},
			{
				"duration": "0.09",
				"confidence": "0.980",
				"name": "in",
				"time": "20.78"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "20.88"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "beautiful",
				"time": "20.94"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "hotel",
				"time": "21.30"
			},
			{
				"duration": "0.06",
				"confidence": "0.930",
				"name": ".",
				"time": "22.94"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "We",
				"time": "23.07"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "got",
				"time": "23.88"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "up",
				"time": "24.12"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "this",
				"time": "24.21"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "morning",
				"time": "24.42"
			},
			{
				"duration": "0.56",
				"confidence": "1.000",
				"name": "around",
				"time": "24.87"
			},
			{
				"duration": "0.71",
				"confidence": "0.850",
				"name": "830",
				"time": "25.46"
			},
			{
				"duration": "0.15",
				"confidence": "0.840",
				"name": "had",
				"time": "26.45"
			},
			{
				"duration": "0.05",
				"confidence": "0.790",
				"name": "a",
				"time": "26.65"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "breakfast",
				"time": "26.70"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "and",
				"time": "27.48"
			},
			{
				"duration": "0.11",
				"confidence": "0.440",
				"name": "it's",
				"time": "28.13"
			},
			{
				"duration": "0.03",
				"confidence": "0.990",
				"name": "a",
				"time": "28.26"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "little",
				"time": "28.29"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "different",
				"time": "28.47"
			},
			{
				"duration": "0.09",
				"confidence": "0.520",
				"name": "than",
				"time": "28.83"
			},
			{
				"duration": "0.10",
				"confidence": "0.490",
				"name": "all",
				"time": "28.94"
			},
			{
				"duration": "0.09",
				"confidence": "0.710",
				"name": "of",
				"time": "29.04"
			},
			{
				"duration": "0.11",
				"confidence": "0.990",
				"name": "the",
				"time": "29.14"
			},
			{
				"duration": "0.36",
				"confidence": "0.590",
				"name": "breakfast",
				"time": "29.25"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "we've",
				"time": "29.61"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "had",
				"time": "29.79"
			},
			{
				"duration": "0.98",
				"confidence": "0.730",
				"name": ".",
				"time": "30.19"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "There",
				"time": "31.59"
			},
			{
				"duration": "0.09",
				"confidence": "0.960",
				"name": "were",
				"time": "31.71"
			},
			{
				"duration": "0.24",
				"confidence": "0.990",
				"name": "hot",
				"time": "31.80"
			},
			{
				"duration": "0.36",
				"confidence": "0.990",
				"name": "dogs",
				"time": "32.04"
			},
			{
				"duration": "0.09",
				"confidence": "0.850",
				"name": "that",
				"time": "32.43"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "were",
				"time": "32.52"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "served",
				"time": "32.64"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "and",
				"time": "33.09"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "french",
				"time": "33.42"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "fries",
				"time": "33.66"
			},
			{
				"duration": "0.33",
				"confidence": "0.880",
				"name": "and",
				"time": "34.56"
			},
			{
				"duration": "0.04",
				"confidence": "0.750",
				"name": "a",
				"time": "35.25"
			},
			{
				"duration": "0.53",
				"confidence": "0.790",
				"name": "rather",
				"time": "35.35"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "strange",
				"time": "35.94"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "breakfast",
				"time": "36.63"
			},
			{
				"duration": "0.37",
				"confidence": "0.980",
				"name": "foods",
				"time": "37.05"
			},
			{
				"duration": "0.03",
				"confidence": "0.610",
				"name": ".",
				"time": "37.43"
			},
			{
				"duration": "0.23",
				"confidence": "0.970",
				"name": "But",
				"time": "37.49"
			},
			{
				"duration": "0.06",
				"confidence": "0.990",
				"name": "I",
				"time": "39.42"
			},
			{
				"duration": "0.21",
				"confidence": "0.980",
				"name": "tried",
				"time": "39.48"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "39.69"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "give",
				"time": "39.78"
			},
			{
				"duration": "0.21",
				"confidence": "0.400",
				"name": "everything",
				"time": "39.98"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "40.26"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "shot",
				"time": "40.29"
			},
			{
				"duration": "0.03",
				"confidence": "0.980",
				"name": ".",
				"time": "40.59"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "It",
				"time": "40.62"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "was",
				"time": "40.74"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "fun",
				"time": "40.86"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": ".",
				"time": "41.69"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "There",
				"time": "41.79"
			},
			{
				"duration": "0.15",
				"confidence": "0.980",
				"name": "was",
				"time": "41.91"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "their",
				"time": "42.06"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "own",
				"time": "42.24"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "version",
				"time": "42.39"
			},
			{
				"duration": "0.35",
				"confidence": "0.670",
				"name": "Budapest",
				"time": "42.83"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "version",
				"time": "43.26"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "of",
				"time": "43.56"
			},
			{
				"duration": "0.36",
				"confidence": "0.790",
				"name": "cinnamon",
				"time": "44.25"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "toast",
				"time": "44.61"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "crunch",
				"time": "44.85"
			},
			{
				"duration": "0.03",
				"confidence": "0.900",
				"name": ".",
				"time": "45.33"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "So",
				"time": "45.60"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "that",
				"time": "45.72"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "was",
				"time": "45.87"
			},
			{
				"duration": "0.76",
				"confidence": "0.810",
				"name": "interesting",
				"time": "46.02"
			},
			{
				"duration": "0.39",
				"confidence": "0.830",
				"name": ".",
				"time": "46.80"
			},
			{
				"duration": "0.38",
				"confidence": "0.980",
				"name": "And",
				"time": "47.35"
			},
			{
				"duration": "0.21",
				"confidence": "0.920",
				"name": "yeah",
				"time": "49.26"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "after",
				"time": "49.53"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "breakfast",
				"time": "49.77"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "we",
				"time": "50.28"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "loaded",
				"time": "50.79"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "onto",
				"time": "51.51"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "51.78"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "tram",
				"time": "51.87"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "took",
				"time": "52.62"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "52.77"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "tram",
				"time": "52.89"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "down",
				"time": "53.19"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": "to",
				"time": "53.37"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "downtown",
				"time": "53.46"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "Budapest",
				"time": "53.85"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "and",
				"time": "54.93"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "then",
				"time": "55.08"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "we",
				"time": "56.49"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "got",
				"time": "56.67"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "56.79"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "two",
				"time": "56.85"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "hour",
				"time": "57.03"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "tour",
				"time": "57.21"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "guide",
				"time": "57.42"
			},
			{
				"duration": "0.45",
				"confidence": "0.750",
				"name": ".",
				"time": "57.81"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "He",
				"time": "58.41"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "was",
				"time": "58.56"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "hilarious",
				"time": "58.68"
			},
			{
				"duration": "0.10",
				"confidence": "0.880",
				"name": ".",
				"time": "59.86"
			},
			{
				"duration": "0.38",
				"confidence": "1.000",
				"name": "Never",
				"time": "60.06"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "been",
				"time": "60.45"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "60.57"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "60.66"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "United",
				"time": "61.05"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "States",
				"time": "61.35"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "but",
				"time": "61.65"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "knew",
				"time": "61.74"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "more",
				"time": "62.28"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "about",
				"time": "62.61"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "62.79"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "United",
				"time": "62.88"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "States",
				"time": "63.12"
			},
			{
				"duration": "0.14",
				"confidence": "0.860",
				"name": "and",
				"time": "63.52"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "all",
				"time": "63.66"
			},
			{
				"duration": "0.06",
				"confidence": "0.960",
				"name": "of",
				"time": "63.90"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "the",
				"time": "63.96"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "history",
				"time": "64.11"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "around",
				"time": "64.44"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "the",
				"time": "64.65"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "world",
				"time": "64.71"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "than",
				"time": "64.89"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "I",
				"time": "65.01"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "ever",
				"time": "65.34"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "have",
				"time": "65.58"
			},
			{
				"duration": "0.36",
				"confidence": "0.790",
				"name": ".",
				"time": "65.91"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "And",
				"time": "66.36"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "he",
				"time": "68.01"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "gave",
				"time": "68.43"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "us",
				"time": "68.67"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "68.76"
			},
			{
				"duration": "0.18",
				"confidence": "0.870",
				"name": "two",
				"time": "68.82"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "hour",
				"time": "69.00"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "tour",
				"time": "69.18"
			},
			{
				"duration": "0.15",
				"confidence": "0.580",
				"name": "where",
				"time": "69.33"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "we",
				"time": "69.48"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "saw",
				"time": "69.60"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "69.90"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "parliament",
				"time": "70.02"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "building",
				"time": "70.44"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "we",
				"time": "71.31"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "saw",
				"time": "71.49"
			},
			{
				"duration": "0.29",
				"confidence": "0.410",
				"name": "uhm",
				"time": "72.30"
			},
			{
				"duration": "0.78",
				"confidence": "0.820",
				"name": ".",
				"time": "72.62"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "What",
				"time": "73.80"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "else",
				"time": "73.95"
			},
			{
				"duration": "0.15",
				"confidence": "0.980",
				"name": "did",
				"time": "74.13"
			},
			{
				"duration": "0.12",
				"confidence": "0.970",
				"name": "we",
				"time": "74.28"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "see",
				"time": "74.40"
			},
			{
				"duration": "0.03",
				"confidence": "0.980",
				"name": ".",
				"time": "74.76"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "We",
				"time": "75.24"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "saw",
				"time": "75.33"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "75.48"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "Basilica",
				"time": "75.57"
			},
			{
				"duration": "0.23",
				"confidence": "0.620",
				"name": ".",
				"time": "77.03"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "The",
				"time": "77.67"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "Michael",
				"time": "77.82"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "Jackson",
				"time": "78.09"
			},
			{
				"duration": "0.21",
				"confidence": "0.970",
				"name": "tree",
				"time": "78.51"
			},
			{
				"duration": "0.18",
				"confidence": "0.940",
				"name": "that's",
				"time": "78.72"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "famous",
				"time": "78.90"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "here",
				"time": "79.23"
			},
			{
				"duration": "0.36",
				"confidence": "0.630",
				"name": ".",
				"time": "80.61"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "Some",
				"time": "81.39"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "other",
				"time": "81.60"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "World",
				"time": "81.96"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "War",
				"time": "82.23"
			},
			{
				"duration": "0.81",
				"confidence": "1.000",
				"name": "memorials",
				"time": "82.65"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "around",
				"time": "83.55"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "83.79"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "river",
				"time": "83.88"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "and",
				"time": "84.48"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "some",
				"time": "85.32"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "really",
				"time": "85.53"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "cool",
				"time": "85.77"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "historical",
				"time": "85.92"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "stuff",
				"time": "86.37"
			},
			{
				"duration": "0.15",
				"confidence": "0.970",
				"name": "that",
				"time": "86.58"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I",
				"time": "86.73"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "would",
				"time": "86.88"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "have",
				"time": "86.97"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "never",
				"time": "87.09"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "known",
				"time": "87.30"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "about",
				"time": "87.48"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "just",
				"time": "87.66"
			},
			{
				"duration": "0.25",
				"confidence": "1.000",
				"name": "walking",
				"time": "87.81"
			},
			{
				"duration": "0.17",
				"confidence": "0.930",
				"name": "around",
				"time": "88.06"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "88.23"
			},
			{
				"duration": "0.31",
				"confidence": "1.000",
				"name": "city",
				"time": "88.32"
			},
			{
				"duration": "0.02",
				"confidence": "0.590",
				"name": ".",
				"time": "88.63"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "So",
				"time": "88.65"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "it",
				"time": "89.25"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "was",
				"time": "89.34"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "nice",
				"time": "89.49"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "to",
				"time": "89.70"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "have",
				"time": "89.76"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "someone",
				"time": "89.88"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "kind",
				"time": "90.12"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "90.27"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "guide",
				"time": "90.33"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "us",
				"time": "90.60"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "through",
				"time": "90.75"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "for",
				"time": "91.05"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "one",
				"time": "91.23"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "91.38"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "our",
				"time": "91.47"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "days",
				"time": "91.56"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "here",
				"time": "91.83"
			},
			{
				"duration": "0.57",
				"confidence": "0.990",
				"name": "especially",
				"time": "92.01"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "how",
				"time": "92.88"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "famous",
				"time": "93.09"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "Budapest",
				"time": "93.54"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "is",
				"time": "94.08"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "and",
				"time": "94.50"
			},
			{
				"duration": "0.29",
				"confidence": "0.750",
				"name": "what",
				"time": "96.34"
			},
			{
				"duration": "0.18",
				"confidence": "0.570",
				"name": "also",
				"time": "96.84"
			},
			{
				"duration": "0.09",
				"confidence": "0.690",
				"name": "we",
				"time": "97.04"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "do",
				"time": "97.14"
			},
			{
				"duration": "0.27",
				"confidence": "0.970",
				"name": "after",
				"time": "97.65"
			},
			{
				"duration": "0.31",
				"confidence": "0.840",
				"name": "that",
				"time": "97.91"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "we",
				"time": "98.31"
			},
			{
				"duration": "0.85",
				"confidence": "1.000",
				"name": "got",
				"time": "99.00"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "around",
				"time": "100.26"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "noon",
				"time": "100.53"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "we",
				"time": "100.83"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "got",
				"time": "100.95"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "101.22"
			},
			{
				"duration": "0.55",
				"confidence": "1.000",
				"name": "go",
				"time": "101.37"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "kind",
				"time": "101.94"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "102.12"
			},
			{
				"duration": "0.42",
				"confidence": "0.980",
				"name": "explore",
				"time": "102.21"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "Budapest",
				"time": "102.63"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "have",
				"time": "103.23"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "lunch",
				"time": "103.44"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "with",
				"time": "103.80"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "some",
				"time": "103.95"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "friends",
				"time": "104.10"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "and",
				"time": "104.52"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "shop",
				"time": "105.99"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "106.35"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "little",
				"time": "106.38"
			},
			{
				"duration": "0.25",
				"confidence": "1.000",
				"name": "bit",
				"time": "106.59"
			},
			{
				"duration": "0.04",
				"confidence": "0.800",
				"name": ".",
				"time": "106.84"
			},
			{
				"duration": "0.07",
				"confidence": "0.700",
				"name": "I",
				"time": "106.90"
			},
			{
				"duration": "0.18",
				"confidence": "0.980",
				"name": "did",
				"time": "106.98"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "some",
				"time": "107.16"
			},
			{
				"duration": "0.24",
				"confidence": "0.670",
				"name": "shop",
				"time": "107.34"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "sorry",
				"time": "107.61"
			},
			{
				"duration": "0.27",
				"confidence": "0.900",
				"name": "mom",
				"time": "107.92"
			},
			{
				"duration": "0.36",
				"confidence": "0.860",
				"name": "dad",
				"time": "108.38"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "and",
				"time": "110.43"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "we",
				"time": "112.89"
			},
			{
				"duration": "0.37",
				"confidence": "0.980",
				"name": "had",
				"time": "113.04"
			},
			{
				"duration": "0.28",
				"confidence": "0.410",
				"name": "let's",
				"time": "113.49"
			},
			{
				"duration": "0.18",
				"confidence": "0.840",
				"name": "let's",
				"time": "113.90"
			},
			{
				"duration": "0.25",
				"confidence": "0.880",
				"name": "see",
				"time": "114.10"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "I",
				"time": "114.36"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "had",
				"time": "114.48"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "pizza",
				"time": "114.60"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "for",
				"time": "114.93"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "lunch",
				"time": "115.05"
			},
			{
				"duration": "0.43",
				"confidence": "0.960",
				"name": "again",
				"time": "115.29"
			},
			{
				"duration": "0.04",
				"confidence": "0.800",
				"name": ".",
				"time": "115.72"
			},
			{
				"duration": "0.06",
				"confidence": "0.990",
				"name": "I",
				"time": "115.77"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "can't",
				"time": "115.83"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "get",
				"time": "116.04"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "enough",
				"time": "116.13"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "pizza",
				"time": "116.31"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "over",
				"time": "116.55"
			},
			{
				"duration": "0.14",
				"confidence": "1.000",
				"name": "here",
				"time": "116.73"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "it's",
				"time": "116.88"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "so",
				"time": "117.00"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "good",
				"time": "117.27"
			},
			{
				"duration": "0.17",
				"confidence": "0.700",
				"name": ".",
				"time": "117.63"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "They",
				"time": "117.87"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "gave",
				"time": "117.99"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "me",
				"time": "118.17"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "scissors",
				"time": "118.32"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "118.77"
			},
			{
				"duration": "0.19",
				"confidence": "1.000",
				"name": "cut",
				"time": "118.89"
			},
			{
				"duration": "0.08",
				"confidence": "0.720",
				"name": "it",
				"time": "119.08"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "instead",
				"time": "119.16"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "119.43"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "119.52"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "knife",
				"time": "119.55"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "which",
				"time": "119.85"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "was",
				"time": "120.00"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "interesting",
				"time": "120.12"
			},
			{
				"duration": "0.46",
				"confidence": "0.880",
				"name": ".",
				"time": "120.83"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "And",
				"time": "121.47"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "after",
				"time": "123.24"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "lunch",
				"time": "123.51"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "we",
				"time": "123.75"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "all",
				"time": "123.84"
			},
			{
				"duration": "0.18",
				"confidence": "0.980",
				"name": "met",
				"time": "123.93"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "up",
				"time": "124.11"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "and",
				"time": "125.13"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "we",
				"time": "125.58"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "went",
				"time": "126.75"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "back",
				"time": "126.90"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "into",
				"time": "127.14"
			},
			{
				"duration": "0.47",
				"confidence": "1.000",
				"name": "town",
				"time": "127.41"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "took",
				"time": "127.89"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "128.07"
			},
			{
				"duration": "0.30",
				"confidence": "0.940",
				"name": "tram",
				"time": "128.16"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "back",
				"time": "128.46"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "to",
				"time": "128.67"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "129.06"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "hotel",
				"time": "129.15"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "and",
				"time": "129.96"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "then",
				"time": "130.11"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "got",
				"time": "130.50"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "ready",
				"time": "130.71"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "130.95"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "go",
				"time": "131.07"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "131.28"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "our",
				"time": "131.43"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "match",
				"time": "131.55"
			},
			{
				"duration": "0.32",
				"confidence": "0.980",
				"name": "today",
				"time": "132.44"
			},
			{
				"duration": "0.17",
				"confidence": "0.570",
				"name": "verse",
				"time": "132.77"
			},
			{
				"duration": "0.31",
				"confidence": "0.620",
				"name": ".",
				"time": "133.28"
			},
			{
				"duration": "0.13",
				"confidence": "0.980",
				"name": "Was",
				"time": "133.93"
			},
			{
				"duration": "0.07",
				"confidence": "0.350",
				"name": "at",
				"time": "134.09"
			},
			{
				"duration": "0.06",
				"confidence": "0.970",
				"name": "a",
				"time": "134.16"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "Hungarian",
				"time": "134.22"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "club",
				"time": "134.67"
			},
			{
				"duration": "0.33",
				"confidence": "0.980",
				"name": "team",
				"time": "134.88"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "national",
				"time": "135.33"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "team",
				"time": "135.66"
			},
			{
				"duration": "0.83",
				"confidence": "0.770",
				"name": ".",
				"time": "135.93"
			},
			{
				"duration": "0.09",
				"confidence": "0.960",
				"name": "The",
				"time": "137.00"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "Hungarian",
				"time": "137.10"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "club",
				"time": "137.61"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "team",
				"time": "137.85"
			},
			{
				"duration": "0.07",
				"confidence": "0.690",
				"name": ".",
				"time": "138.15"
			},
			{
				"duration": "0.64",
				"confidence": "0.990",
				"name": "And",
				"time": "138.25"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "after",
				"time": "140.55"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "playing",
				"time": "140.79"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "these",
				"time": "141.00"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "girls",
				"time": "141.12"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "we",
				"time": "141.33"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "sat",
				"time": "141.42"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "down",
				"time": "141.63"
			},
			{
				"duration": "0.06",
				"confidence": "0.940",
				"name": "at",
				"time": "141.87"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "141.93"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "nice",
				"time": "142.02"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "dinner",
				"time": "142.26"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "across",
				"time": "142.50"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "the",
				"time": "142.80"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "street",
				"time": "142.86"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "from",
				"time": "143.10"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "our",
				"time": "143.28"
			},
			{
				"duration": "0.42",
				"confidence": "0.990",
				"name": "gym",
				"time": "143.46"
			},
			{
				"duration": "0.39",
				"confidence": "0.990",
				"name": "which",
				"time": "144.18"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "learned",
				"time": "145.50"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "not",
				"time": "145.71"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "145.86"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "judge",
				"time": "145.95"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "146.16"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "book",
				"time": "146.22"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "by",
				"time": "146.40"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "its",
				"time": "146.52"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "cover",
				"time": "146.64"
			},
			{
				"duration": "0.17",
				"confidence": "0.810",
				"name": "because",
				"time": "146.94"
			},
			{
				"duration": "0.30",
				"confidence": "0.620",
				"name": ".",
				"time": "147.90"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "Let",
				"time": "148.74"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "me",
				"time": "148.83"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "tell",
				"time": "148.95"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "you",
				"time": "149.13"
			},
			{
				"duration": "0.23",
				"confidence": "0.680",
				"name": "guys",
				"time": "149.22"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "it",
				"time": "150.33"
			},
			{
				"duration": "0.24",
				"confidence": "0.970",
				"name": "looked",
				"time": "150.48"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "like",
				"time": "150.72"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "150.87"
			},
			{
				"duration": "0.33",
				"confidence": "0.970",
				"name": "dive",
				"time": "150.93"
			},
			{
				"duration": "0.27",
				"confidence": "0.460",
				"name": "gaoli",
				"time": "151.26"
			},
			{
				"duration": "0.33",
				"confidence": "0.920",
				"name": "Winters",
				"time": "151.53"
			},
			{
				"duration": "0.36",
				"confidence": "0.990",
				"name": "said",
				"time": "151.86"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "I",
				"time": "153.33"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "hope",
				"time": "153.96"
			},
			{
				"duration": "0.15",
				"confidence": "0.980",
				"name": "there's",
				"time": "154.17"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "not",
				"time": "154.32"
			},
			{
				"duration": "0.12",
				"confidence": "0.580",
				"name": "a",
				"time": "154.47"
			},
			{
				"duration": "0.16",
				"confidence": "0.660",
				"name": "nail",
				"time": "154.59"
			},
			{
				"duration": "0.35",
				"confidence": "1.000",
				"name": "sticking",
				"time": "154.75"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "out",
				"time": "155.10"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "155.19"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "155.25"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "ground",
				"time": "155.37"
			},
			{
				"duration": "0.42",
				"confidence": "0.630",
				"name": "diving",
				"time": "156.02"
			},
			{
				"duration": "0.30",
				"confidence": "0.960",
				"name": "here",
				"time": "156.74"
			},
			{
				"duration": "0.30",
				"confidence": "0.580",
				"name": ".",
				"time": "157.04"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": "And",
				"time": "157.35"
			},
			{
				"duration": "0.09",
				"confidence": "0.980",
				"name": "then",
				"time": "157.44"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "we",
				"time": "157.53"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "walk",
				"time": "157.65"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "in",
				"time": "157.89"
			},
			{
				"duration": "0.09",
				"confidence": "0.970",
				"name": "and",
				"time": "158.01"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "it's",
				"time": "158.10"
			},
			{
				"duration": "0.65",
				"confidence": "1.000",
				"name": "beautiful",
				"time": "158.28"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "the",
				"time": "158.94"
			},
			{
				"duration": "0.26",
				"confidence": "0.980",
				"name": "floor",
				"time": "159.24"
			},
			{
				"duration": "0.10",
				"confidence": "0.980",
				"name": "is",
				"time": "159.50"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "like",
				"time": "159.60"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "159.78"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "new",
				"time": "159.87"
			},
			{
				"duration": "0.30",
				"confidence": "0.880",
				"name": "Terra",
				"time": "160.05"
			},
			{
				"duration": "0.50",
				"confidence": "0.580",
				"name": "flex",
				"time": "160.35"
			},
			{
				"duration": "0.57",
				"confidence": "0.940",
				"name": ".",
				"time": "161.20"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "There",
				"time": "161.79"
			},
			{
				"duration": "0.06",
				"confidence": "0.950",
				"name": "are",
				"time": "161.97"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "bleachers",
				"time": "162.03"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "that",
				"time": "162.45"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "were",
				"time": "162.57"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "set",
				"time": "162.69"
			},
			{
				"duration": "0.18",
				"confidence": "0.980",
				"name": "out",
				"time": "162.93"
			},
			{
				"duration": "0.03",
				"confidence": "0.850",
				"name": ".",
				"time": "163.11"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "It",
				"time": "163.14"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "was",
				"time": "163.23"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "really",
				"time": "163.38"
			},
			{
				"duration": "0.29",
				"confidence": "1.000",
				"name": "pretty",
				"time": "163.65"
			},
			{
				"duration": "0.09",
				"confidence": "0.450",
				"name": ".",
				"time": "163.94"
			},
			{
				"duration": "0.46",
				"confidence": "0.760",
				"name": "So",
				"time": "164.03"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "it",
				"time": "165.39"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "was",
				"time": "165.45"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "actually",
				"time": "165.60"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "166.29"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "sight",
				"time": "166.32"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "for",
				"time": "166.53"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "sore",
				"time": "166.62"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "eyes",
				"time": "166.86"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "for",
				"time": "167.19"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "some",
				"time": "167.34"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "167.49"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "the",
				"time": "167.55"
			},
			{
				"duration": "0.23",
				"confidence": "0.380",
				"name": "Dimsey",
				"time": "167.61"
			},
			{
				"duration": "0.19",
				"confidence": "0.300",
				"name": "play",
				"time": "167.86"
			},
			{
				"duration": "0.23",
				"confidence": "1.000",
				"name": "and",
				"time": "168.13"
			},
			{
				"duration": "0.14",
				"confidence": "0.980",
				"name": "had",
				"time": "168.37"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "air",
				"time": "168.51"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "conditioning",
				"time": "168.63"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "which",
				"time": "169.11"
			},
			{
				"duration": "0.15",
				"confidence": "0.970",
				"name": "was",
				"time": "169.26"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "awesome",
				"time": "169.41"
			},
			{
				"duration": "0.49",
				"confidence": "0.830",
				"name": "finally",
				"time": "170.19"
			},
			{
				"duration": "0.20",
				"confidence": "0.590",
				"name": ".",
				"time": "170.68"
			},
			{
				"duration": "0.41",
				"confidence": "0.800",
				"name": "So",
				"time": "171.12"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "we",
				"time": "172.62"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "played",
				"time": "172.74"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "five",
				"time": "172.95"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "sets",
				"time": "173.16"
			},
			{
				"duration": "0.12",
				"confidence": "0.900",
				"name": "with",
				"time": "173.37"
			},
			{
				"duration": "0.06",
				"confidence": "0.920",
				"name": "the",
				"time": "173.49"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "Hungarian",
				"time": "173.55"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "team",
				"time": "173.91"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "today",
				"time": "174.06"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "and",
				"time": "174.30"
			},
			{
				"duration": "0.07",
				"confidence": "0.820",
				"name": "then",
				"time": "174.39"
			},
			{
				"duration": "0.07",
				"confidence": "1.000",
				"name": "we",
				"time": "174.47"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "went",
				"time": "174.54"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "across",
				"time": "174.69"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "and",
				"time": "175.02"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "had",
				"time": "175.11"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "dinner",
				"time": "175.23"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "and",
				"time": "176.10"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "Hungarian",
				"time": "177.72"
			},
			{
				"duration": "0.36",
				"confidence": "0.990",
				"name": "or",
				"time": "178.62"
			},
			{
				"duration": "0.08",
				"confidence": "0.840",
				"name": "is",
				"time": "179.28"
			},
			{
				"duration": "0.15",
				"confidence": "0.940",
				"name": "that",
				"time": "179.39"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "the",
				"time": "179.55"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "language",
				"time": "179.61"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "is",
				"time": "180.66"
			},
			{
				"duration": "0.32",
				"confidence": "0.530",
				"name": "harsh",
				"time": "180.84"
			},
			{
				"duration": "0.19",
				"confidence": "0.870",
				"name": ".",
				"time": "181.16"
			},
			{
				"duration": "0.19",
				"confidence": "0.620",
				"name": "It's",
				"time": "181.36"
			},
			{
				"duration": "0.31",
				"confidence": "0.980",
				"name": "very",
				"time": "181.63"
			},
			{
				"duration": "0.45",
				"confidence": "0.990",
				"name": "tricky",
				"time": "181.95"
			},
			{
				"duration": "0.00",
				"confidence": "1.000",
				"name": ".",
				"time": "184.0"
			}
		],
		"format": "1.0"
	};

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = {
		"job": {
			"lang": "en",
			"user_id": 46548,
			"name": "struggling.mp3",
			"duration": 185,
			"created_at": "Fri Jul 27 20:11:48 2018",
			"id": 8856514
		},
		"speakers": [
			{
				"duration": "184.40",
				"confidence": null,
				"name": "M1",
				"time": "0.34"
			}
		],
		"words": [
			{
				"duration": "0.37",
				"confidence": "0.540",
				"name": "Hey",
				"time": "0.34"
			},
			{
				"duration": "0.18",
				"confidence": "0.980",
				"name": "I've",
				"time": "1.56"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "been",
				"time": "1.74"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "struggling",
				"time": "1.92"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "recently",
				"time": "2.31"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I've",
				"time": "3.75"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "been",
				"time": "3.87"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "feeling",
				"time": "4.02"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "anxious",
				"time": "4.74"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "stressed",
				"time": "5.61"
			},
			{
				"duration": "0.20",
				"confidence": "1.000",
				"name": "out",
				"time": "6.03"
			},
			{
				"duration": "0.07",
				"confidence": "0.760",
				"name": ".",
				"time": "6.23"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "It's",
				"time": "6.30"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "been",
				"time": "6.48"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "hard",
				"time": "6.66"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "for",
				"time": "6.87"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "me",
				"time": "6.93"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "to",
				"time": "7.08"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "wake",
				"time": "7.14"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "up",
				"time": "7.41"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "in",
				"time": "7.59"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "the",
				"time": "7.68"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "mornings",
				"time": "7.74"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "and",
				"time": "8.16"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "even",
				"time": "8.76"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "harder",
				"time": "9.03"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "9.27"
			},
			{
				"duration": "0.18",
				"confidence": "0.870",
				"name": "fall",
				"time": "9.39"
			},
			{
				"duration": "0.41",
				"confidence": "0.870",
				"name": "asleep",
				"time": "9.57"
			},
			{
				"duration": "0.15",
				"confidence": "0.950",
				"name": ".",
				"time": "10.57"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "I'm",
				"time": "10.74"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "not",
				"time": "11.16"
			},
			{
				"duration": "0.27",
				"confidence": "0.970",
				"name": "saying",
				"time": "11.34"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "this",
				"time": "11.61"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "because",
				"time": "11.82"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "12.75"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "want",
				"time": "12.84"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "your",
				"time": "12.99"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "pity",
				"time": "13.11"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "or",
				"time": "14.04"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "anything",
				"time": "14.19"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "like",
				"time": "14.52"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "that",
				"time": "14.73"
			},
			{
				"duration": "0.14",
				"confidence": "0.920",
				"name": ".",
				"time": "14.97"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "I'm",
				"time": "15.12"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "doing",
				"time": "15.42"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "pretty",
				"time": "15.72"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "well",
				"time": "15.93"
			},
			{
				"duration": "0.03",
				"confidence": "0.870",
				"name": ".",
				"time": "16.14"
			},
			{
				"duration": "0.09",
				"confidence": "0.980",
				"name": "I'm",
				"time": "16.26"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "taking",
				"time": "16.35"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "care",
				"time": "16.59"
			},
			{
				"duration": "0.06",
				"confidence": "0.990",
				"name": "of",
				"time": "16.74"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "myself",
				"time": "16.80"
			},
			{
				"duration": "0.03",
				"confidence": "0.840",
				"name": ".",
				"time": "17.16"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "But",
				"time": "17.97"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "I",
				"time": "18.90"
			},
			{
				"duration": "0.24",
				"confidence": "0.900",
				"name": "wanted",
				"time": "18.96"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "19.20"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "make",
				"time": "19.32"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "this",
				"time": "19.47"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "video",
				"time": "19.62"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "because",
				"time": "20.04"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "I",
				"time": "20.70"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "think",
				"time": "20.76"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "20.97"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "lot",
				"time": "21.03"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "21.21"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "people",
				"time": "21.27"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "create",
				"time": "21.57"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "unhealthy",
				"time": "22.08"
			},
			{
				"duration": "0.87",
				"confidence": "1.000",
				"name": "perceptions",
				"time": "22.59"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "of",
				"time": "23.46"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "public",
				"time": "23.64"
			},
			{
				"duration": "0.32",
				"confidence": "0.830",
				"name": "figures",
				"time": "24.03"
			},
			{
				"duration": "0.37",
				"confidence": "0.920",
				"name": ".",
				"time": "24.35"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "People",
				"time": "25.98"
			},
			{
				"duration": "0.15",
				"confidence": "0.970",
				"name": "get",
				"time": "26.82"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "these",
				"time": "26.97"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "unrealistic",
				"time": "27.24"
			},
			{
				"duration": "0.99",
				"confidence": "1.000",
				"name": "expectations",
				"time": "27.96"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "that",
				"time": "28.95"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "they",
				"time": "29.10"
			},
			{
				"duration": "0.39",
				"confidence": "0.750",
				"name": "impose",
				"time": "29.19"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "upon",
				"time": "29.58"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "themselves",
				"time": "29.85"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "because",
				"time": "30.45"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "they",
				"time": "31.35"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "see",
				"time": "31.56"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "what",
				"time": "31.80"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "they",
				"time": "31.95"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "think",
				"time": "32.10"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "other",
				"time": "32.88"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "people",
				"time": "33.09"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "are",
				"time": "33.36"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "doing",
				"time": "33.45"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "and",
				"time": "34.38"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "they",
				"time": "34.47"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "try",
				"time": "34.59"
			},
			{
				"duration": "0.09",
				"confidence": "0.950",
				"name": "and",
				"time": "34.77"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "do",
				"time": "34.86"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "it",
				"time": "34.98"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "themselves",
				"time": "35.07"
			},
			{
				"duration": "0.03",
				"confidence": "0.990",
				"name": ".",
				"time": "35.52"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "So",
				"time": "35.58"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "for",
				"time": "35.82"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "example",
				"time": "35.97"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "37.41"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "lot",
				"time": "37.47"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "37.65"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "people",
				"time": "37.71"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "think",
				"time": "37.98"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "that",
				"time": "38.25"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I'm",
				"time": "38.40"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "working",
				"time": "38.55"
			},
			{
				"duration": "0.18",
				"confidence": "0.870",
				"name": "you",
				"time": "39.00"
			},
			{
				"duration": "0.18",
				"confidence": "0.870",
				"name": "know",
				"time": "39.18"
			},
			{
				"duration": "0.99",
				"confidence": "1.000",
				"name": "24/7",
				"time": "39.36"
			},
			{
				"duration": "0.96",
				"confidence": "1.000",
				"name": "365",
				"time": "40.35"
			},
			{
				"duration": "0.13",
				"confidence": "0.970",
				"name": "that",
				"time": "41.48"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I'm",
				"time": "41.61"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "always",
				"time": "41.73"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "attacking",
				"time": "42.78"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "life",
				"time": "43.32"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "and",
				"time": "43.71"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "always",
				"time": "44.04"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "you",
				"time": "44.43"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "know",
				"time": "44.49"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "looking",
				"time": "45.00"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "45.27"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "squeeze",
				"time": "45.39"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "more",
				"time": "45.84"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "productivity",
				"time": "46.05"
			},
			{
				"duration": "0.11",
				"confidence": "0.820",
				"name": "in",
				"time": "46.74"
			},
			{
				"duration": "0.38",
				"confidence": "1.000",
				"name": "growth",
				"time": "46.86"
			},
			{
				"duration": "0.08",
				"confidence": "0.560",
				"name": "out",
				"time": "47.24"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "47.37"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "every",
				"time": "47.46"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "situation",
				"time": "47.67"
			},
			{
				"duration": "0.06",
				"confidence": "0.970",
				"name": ".",
				"time": "48.33"
			},
			{
				"duration": "0.12",
				"confidence": "0.940",
				"name": "And",
				"time": "48.69"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "48.81"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "truth",
				"time": "48.90"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "is",
				"time": "49.20"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "that",
				"time": "49.95"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "50.07"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "do",
				"time": "50.16"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "that",
				"time": "50.31"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "50.49"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "lot",
				"time": "50.55"
			},
			{
				"duration": "0.11",
				"confidence": "0.510",
				"name": ".",
				"time": "50.82"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "My",
				"time": "51.03"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "everyday",
				"time": "51.27"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "life",
				"time": "51.57"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "I",
				"time": "52.50"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "try",
				"time": "52.77"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "and",
				"time": "53.04"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "live",
				"time": "53.16"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "with",
				"time": "53.76"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "passion",
				"time": "53.91"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "and",
				"time": "54.96"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "I",
				"time": "55.65"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "try",
				"time": "55.71"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "to",
				"time": "55.92"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "live",
				"time": "56.10"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "with",
				"time": "56.28"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "intensity",
				"time": "56.43"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "because",
				"time": "57.00"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "you",
				"time": "57.66"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "know",
				"time": "57.75"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "that's",
				"time": "58.05"
			},
			{
				"duration": "0.22",
				"confidence": "0.960",
				"name": "that's",
				"time": "58.76"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "58.98"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "way",
				"time": "59.10"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "that",
				"time": "59.28"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "I",
				"time": "59.91"
			},
			{
				"duration": "0.47",
				"confidence": "1.000",
				"name": "think",
				"time": "60.12"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "I",
				"time": "60.69"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "can",
				"time": "60.84"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "find",
				"time": "60.99"
			},
			{
				"duration": "0.32",
				"confidence": "0.920",
				"name": "happiness",
				"time": "61.23"
			},
			{
				"duration": "0.31",
				"confidence": "0.880",
				"name": ".",
				"time": "61.59"
			},
			{
				"duration": "0.12",
				"confidence": "0.960",
				"name": "And",
				"time": "62.04"
			},
			{
				"duration": "0.15",
				"confidence": "0.800",
				"name": "that's",
				"time": "62.16"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "what",
				"time": "62.31"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "works",
				"time": "62.46"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "for",
				"time": "62.70"
			},
			{
				"duration": "0.13",
				"confidence": "1.000",
				"name": "me",
				"time": "62.85"
			},
			{
				"duration": "0.02",
				"confidence": "0.800",
				"name": ".",
				"time": "62.98"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "But",
				"time": "63.15"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "if",
				"time": "63.60"
			},
			{
				"duration": "0.20",
				"confidence": "0.920",
				"name": "there's",
				"time": "63.75"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "one",
				"time": "63.96"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "thing",
				"time": "64.14"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "that",
				"time": "64.32"
			},
			{
				"duration": "0.14",
				"confidence": "0.920",
				"name": "I've",
				"time": "64.41"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "learned",
				"time": "64.56"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "about",
				"time": "64.74"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "growth",
				"time": "64.98"
			},
			{
				"duration": "0.33",
				"confidence": "0.990",
				"name": "it's",
				"time": "65.76"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "that",
				"time": "66.09"
			},
			{
				"duration": "0.48",
				"confidence": "0.890",
				"name": "rest",
				"time": "66.84"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "is",
				"time": "67.32"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "an",
				"time": "67.56"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "integral",
				"time": "67.65"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "part",
				"time": "68.10"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "68.55"
			},
			{
				"duration": "0.20",
				"confidence": "0.490",
				"name": "growth",
				"time": "68.68"
			},
			{
				"duration": "0.14",
				"confidence": "0.970",
				"name": ".",
				"time": "68.88"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "Let",
				"time": "69.96"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "me",
				"time": "70.08"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "explain",
				"time": "70.17"
			},
			{
				"duration": "0.20",
				"confidence": "0.940",
				"name": "it",
				"time": "70.62"
			},
			{
				"duration": "0.34",
				"confidence": "0.930",
				"name": ".",
				"time": "70.83"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "Imagine",
				"time": "71.22"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": "I'm",
				"time": "71.82"
			},
			{
				"duration": "0.11",
				"confidence": "0.940",
				"name": "going",
				"time": "71.91"
			},
			{
				"duration": "0.16",
				"confidence": "0.940",
				"name": "to",
				"time": "72.02"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "use",
				"time": "72.24"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "a",
				"time": "72.60"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "sports",
				"time": "72.90"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "analogy",
				"time": "73.38"
			},
			{
				"duration": "0.17",
				"confidence": "1.000",
				"name": "here",
				"time": "73.80"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "but",
				"time": "74.01"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "imagine",
				"time": "74.16"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "that",
				"time": "74.97"
			},
			{
				"duration": "0.17",
				"confidence": "0.910",
				"name": "there's",
				"time": "75.51"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "somebody",
				"time": "75.69"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "who",
				"time": "76.14"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "is",
				"time": "76.35"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "lifting",
				"time": "76.62"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "weights",
				"time": "77.01"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "for",
				"time": "77.64"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "12",
				"time": "77.94"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "hours",
				"time": "78.21"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "78.51"
			},
			{
				"duration": "0.23",
				"confidence": "1.000",
				"name": "day",
				"time": "78.57"
			},
			{
				"duration": "0.30",
				"confidence": "0.890",
				"name": "okay",
				"time": "79.55"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "from",
				"time": "79.92"
			},
			{
				"duration": "0.18",
				"confidence": "0.810",
				"name": "8:00",
				"time": "80.46"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "a.m.",
				"time": "80.64"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "80.97"
			},
			{
				"duration": "0.24",
				"confidence": "0.890",
				"name": "8:00",
				"time": "81.09"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "p.m.",
				"time": "81.33"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "just",
				"time": "81.87"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "in",
				"time": "82.08"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "82.20"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "gym",
				"time": "82.29"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "lifting",
				"time": "82.92"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "weights",
				"time": "83.28"
			},
			{
				"duration": "0.49",
				"confidence": "0.990",
				"name": "constantly",
				"time": "83.55"
			},
			{
				"duration": "0.02",
				"confidence": "0.730",
				"name": ".",
				"time": "84.04"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "No",
				"time": "84.06"
			},
			{
				"duration": "0.45",
				"confidence": "0.900",
				"name": "break",
				"time": "84.31"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "nothing",
				"time": "85.05"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "85.35"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "eat",
				"time": "85.50"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "nothing",
				"time": "85.83"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "86.10"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "drink",
				"time": "86.22"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "just",
				"time": "86.94"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "wakes",
				"time": "87.15"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "up",
				"time": "87.51"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "lifts",
				"time": "87.99"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "weights",
				"time": "88.29"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "goes",
				"time": "89.01"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "89.25"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "bed",
				"time": "89.37"
			},
			{
				"duration": "0.75",
				"confidence": "0.900",
				"name": ".",
				"time": "89.57"
			},
			{
				"duration": "0.09",
				"confidence": "0.930",
				"name": "Would",
				"time": "90.42"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "that",
				"time": "90.51"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "guy",
				"time": "90.69"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "be",
				"time": "91.35"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "strong",
				"time": "91.47"
			},
			{
				"duration": "1.41",
				"confidence": "0.980",
				"name": ".",
				"time": "91.89"
			},
			{
				"duration": "0.24",
				"confidence": "0.970",
				"name": "No",
				"time": "93.31"
			},
			{
				"duration": "0.28",
				"confidence": "0.690",
				"name": ".",
				"time": "93.59"
			},
			{
				"duration": "0.20",
				"confidence": "0.520",
				"name": "Then",
				"time": "93.98"
			},
			{
				"duration": "0.11",
				"confidence": "0.600",
				"name": "that",
				"time": "94.17"
			},
			{
				"duration": "0.16",
				"confidence": "0.600",
				"name": "guy",
				"time": "94.28"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "would",
				"time": "94.44"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "be",
				"time": "94.59"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "injured",
				"time": "94.89"
			},
			{
				"duration": "0.56",
				"confidence": "0.990",
				"name": "immediately",
				"time": "95.40"
			},
			{
				"duration": "0.04",
				"confidence": "0.440",
				"name": "and",
				"time": "95.96"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "probably",
				"time": "96.00"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "wouldn't",
				"time": "96.30"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "make",
				"time": "96.48"
			},
			{
				"duration": "0.20",
				"confidence": "1.000",
				"name": "it",
				"time": "96.78"
			},
			{
				"duration": "0.13",
				"confidence": "0.810",
				"name": "like",
				"time": "96.98"
			},
			{
				"duration": "0.21",
				"confidence": "0.960",
				"name": "two",
				"time": "97.14"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "days",
				"time": "97.35"
			},
			{
				"duration": "0.30",
				"confidence": "0.900",
				"name": ".",
				"time": "97.92"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "Nobody",
				"time": "98.25"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "can",
				"time": "98.52"
			},
			{
				"duration": "0.14",
				"confidence": "1.000",
				"name": "do",
				"time": "98.67"
			},
			{
				"duration": "0.07",
				"confidence": "0.640",
				"name": "it",
				"time": "98.81"
			},
			{
				"duration": "1.11",
				"confidence": "0.980",
				"name": ".",
				"time": "98.88"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "It's",
				"time": "100.02"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "an",
				"time": "100.17"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "extreme",
				"time": "100.26"
			},
			{
				"duration": "0.59",
				"confidence": "1.000",
				"name": "example",
				"time": "100.62"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "but",
				"time": "101.46"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "it",
				"time": "101.73"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "goes",
				"time": "102.09"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "102.33"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "show",
				"time": "102.45"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "that",
				"time": "103.44"
			},
			{
				"duration": "0.65",
				"confidence": "0.930",
				"name": "rest",
				"time": "104.02"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "is",
				"time": "104.79"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "what",
				"time": "105.12"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "makes",
				"time": "105.39"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "105.60"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "stronger",
				"time": "105.72"
			},
			{
				"duration": "0.04",
				"confidence": "0.600",
				"name": ".",
				"time": "106.23"
			},
			{
				"duration": "0.15",
				"confidence": "0.940",
				"name": "So",
				"time": "106.56"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "you",
				"time": "106.71"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "get",
				"time": "106.86"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "stronger",
				"time": "107.04"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "when",
				"time": "107.70"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "you're",
				"time": "107.85"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "lifting",
				"time": "107.94"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "weights",
				"time": "108.24"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "by",
				"time": "108.78"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "working out",
				"time": "109.38"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "hard",
				"time": "109.86"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "and",
				"time": "110.52"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "then",
				"time": "110.61"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "resting",
				"time": "110.76"
			},
			{
				"duration": "0.62",
				"confidence": "0.940",
				"name": "afterwards",
				"time": "111.19"
			},
			{
				"duration": "0.22",
				"confidence": "0.670",
				"name": "it's",
				"time": "111.89"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "in",
				"time": "112.11"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "112.23"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "rest",
				"time": "112.35"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "period",
				"time": "112.65"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "that",
				"time": "113.07"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "113.22"
			},
			{
				"duration": "0.25",
				"confidence": "0.540",
				"name": "grow",
				"time": "113.34"
			},
			{
				"duration": "0.16",
				"confidence": "0.720",
				"name": ".",
				"time": "113.63"
			},
			{
				"duration": "0.09",
				"confidence": "0.930",
				"name": "And",
				"time": "114.11"
			},
			{
				"duration": "0.12",
				"confidence": "0.660",
				"name": "I've",
				"time": "114.21"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "found",
				"time": "114.33"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "this",
				"time": "114.57"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "114.75"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "be",
				"time": "114.84"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "true",
				"time": "114.96"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "in",
				"time": "115.20"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "all",
				"time": "115.35"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "aspects",
				"time": "115.53"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "115.98"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "my",
				"time": "116.04"
			},
			{
				"duration": "0.41",
				"confidence": "1.000",
				"name": "life",
				"time": "116.16"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "be",
				"time": "116.58"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "it",
				"time": "116.79"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "in",
				"time": "117.18"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "sports",
				"time": "117.33"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "or",
				"time": "117.87"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "school",
				"time": "118.02"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "or",
				"time": "118.53"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "work",
				"time": "118.74"
			},
			{
				"duration": "0.83",
				"confidence": "0.950",
				"name": ".",
				"time": "119.22"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "It's",
				"time": "120.09"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "not",
				"time": "120.30"
			},
			{
				"duration": "0.17",
				"confidence": "0.970",
				"name": "the",
				"time": "120.78"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "periods",
				"time": "121.17"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "of",
				"time": "121.59"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "intense",
				"time": "121.77"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "activity",
				"time": "122.19"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "where",
				"time": "122.73"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I'm",
				"time": "122.94"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "growing",
				"time": "123.03"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": ".",
				"time": "123.45"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "It's",
				"time": "123.93"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "124.11"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "periods",
				"time": "124.23"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "of",
				"time": "124.59"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "rest",
				"time": "124.74"
			},
			{
				"duration": "0.37",
				"confidence": "0.910",
				"name": "after",
				"time": "125.19"
			},
			{
				"duration": "0.29",
				"confidence": "0.840",
				"name": ".",
				"time": "125.63"
			},
			{
				"duration": "0.14",
				"confidence": "0.680",
				"name": "Now",
				"time": "126.10"
			},
			{
				"duration": "0.03",
				"confidence": "0.960",
				"name": "I",
				"time": "126.36"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "made",
				"time": "126.39"
			},
			{
				"duration": "0.03",
				"confidence": "0.980",
				"name": "a",
				"time": "126.57"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "mistake",
				"time": "126.60"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "this",
				"time": "127.05"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "year",
				"time": "127.26"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "where",
				"time": "127.47"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "128.43"
			},
			{
				"duration": "0.30",
				"confidence": "0.990",
				"name": "didn't",
				"time": "128.52"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "take",
				"time": "128.82"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "any",
				"time": "129.36"
			},
			{
				"duration": "0.62",
				"confidence": "1.000",
				"name": "rest",
				"time": "129.57"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "after",
				"time": "130.38"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "coming",
				"time": "130.68"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "home",
				"time": "130.92"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "from",
				"time": "131.07"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "school",
				"time": "131.25"
			},
			{
				"duration": "0.33",
				"confidence": "0.790",
				"name": ".",
				"time": "131.58"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "I",
				"time": "132.00"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "came",
				"time": "132.06"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "home",
				"time": "132.27"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "from",
				"time": "132.42"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "school",
				"time": "132.60"
			},
			{
				"duration": "0.09",
				"confidence": "0.560",
				"name": "on",
				"time": "133.04"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "Saturday",
				"time": "133.23"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "night",
				"time": "133.68"
			},
			{
				"duration": "0.13",
				"confidence": "0.870",
				"name": "and",
				"time": "134.44"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "took",
				"time": "134.58"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "134.73"
			},
			{
				"duration": "0.39",
				"confidence": "0.800",
				"name": "Sunday",
				"time": "134.82"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "off",
				"time": "135.21"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "and",
				"time": "135.63"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "then",
				"time": "135.78"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "135.93"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "went",
				"time": "136.02"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "right",
				"time": "136.29"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "136.53"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "work",
				"time": "136.65"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "on",
				"time": "137.34"
			},
			{
				"duration": "0.03",
				"confidence": "0.950",
				"name": "a",
				"time": "137.46"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "Monday",
				"time": "137.49"
			},
			{
				"duration": "0.94",
				"confidence": "0.680",
				"name": ".",
				"time": "137.76"
			},
			{
				"duration": "0.24",
				"confidence": "0.990",
				"name": "And",
				"time": "138.72"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "139.71"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "think",
				"time": "139.83"
			},
			{
				"duration": "0.20",
				"confidence": "0.930",
				"name": "that",
				"time": "140.12"
			},
			{
				"duration": "0.11",
				"confidence": "0.780",
				"name": "I",
				"time": "141.12"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "needed",
				"time": "141.30"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "141.66"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "break",
				"time": "141.72"
			},
			{
				"duration": "0.04",
				"confidence": "0.660",
				"name": ".",
				"time": "142.20"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "To",
				"time": "142.26"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "be",
				"time": "142.38"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "honest",
				"time": "142.53"
			},
			{
				"duration": "0.11",
				"confidence": "0.430",
				"name": "I'd",
				"time": "142.86"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "been",
				"time": "142.98"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "going",
				"time": "143.10"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "really",
				"time": "143.37"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "hard",
				"time": "143.61"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "since",
				"time": "143.91"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "since",
				"time": "144.45"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "January",
				"time": "144.75"
			},
			{
				"duration": "0.39",
				"confidence": "0.740",
				"name": ".",
				"time": "145.47"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "And",
				"time": "145.86"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "mentally",
				"time": "146.01"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "146.85"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "was",
				"time": "146.94"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "ready",
				"time": "147.15"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "to",
				"time": "147.45"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "let",
				"time": "147.78"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "that",
				"time": "147.96"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "sink",
				"time": "148.17"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "in",
				"time": "148.47"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": "to",
				"time": "148.86"
			},
			{
				"duration": "0.17",
				"confidence": "0.990",
				"name": "let",
				"time": "148.95"
			},
			{
				"duration": "0.43",
				"confidence": "0.710",
				"name": "that",
				"time": "149.12"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "those",
				"time": "149.91"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "lessons",
				"time": "150.15"
			},
			{
				"duration": "0.09",
				"confidence": "0.940",
				"name": "that",
				"time": "150.63"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "I",
				"time": "150.72"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "was",
				"time": "150.78"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "learning",
				"time": "150.96"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "kind",
				"time": "151.74"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "of",
				"time": "151.92"
			},
			{
				"duration": "0.45",
				"confidence": "0.900",
				"name": "straighten",
				"time": "153.12"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "themselves",
				"time": "153.57"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "out",
				"time": "154.05"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "my",
				"time": "154.20"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "mind",
				"time": "154.38"
			},
			{
				"duration": "0.02",
				"confidence": "0.580",
				"name": ".",
				"time": "154.68"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "And",
				"time": "154.71"
			},
			{
				"duration": "0.34",
				"confidence": "0.910",
				"name": "instead",
				"time": "154.84"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "155.19"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "just",
				"time": "155.28"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "went",
				"time": "155.49"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "right",
				"time": "155.73"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "back",
				"time": "155.94"
			},
			{
				"duration": "0.23",
				"confidence": "0.910",
				"name": "into",
				"time": "156.21"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "intense",
				"time": "156.45"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "activity",
				"time": "156.87"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "and",
				"time": "157.38"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "eventually",
				"time": "157.92"
			},
			{
				"duration": "0.07",
				"confidence": "0.710",
				"name": "I",
				"time": "158.37"
			},
			{
				"duration": "0.28",
				"confidence": "1.000",
				"name": "burned",
				"time": "158.44"
			},
			{
				"duration": "0.15",
				"confidence": "0.610",
				"name": "out",
				"time": "158.72"
			},
			{
				"duration": "0.13",
				"confidence": "0.920",
				"name": ".",
				"time": "158.88"
			},
			{
				"duration": "0.51",
				"confidence": "0.990",
				"name": "That's",
				"time": "159.54"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "where",
				"time": "160.29"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "160.68"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "ended",
				"time": "160.80"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "up",
				"time": "161.04"
			},
			{
				"duration": "0.09",
				"confidence": "0.670",
				"name": ".",
				"time": "161.26"
			},
			{
				"duration": "0.22",
				"confidence": "1.000",
				"name": "I",
				"time": "161.39"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "just",
				"time": "161.61"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "felt",
				"time": "161.88"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "like",
				"time": "162.06"
			},
			{
				"duration": "0.06",
				"confidence": "0.910",
				"name": "I",
				"time": "162.24"
			},
			{
				"duration": "0.24",
				"confidence": "0.990",
				"name": "lost",
				"time": "162.30"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "creativity",
				"time": "162.54"
			},
			{
				"duration": "0.03",
				"confidence": "0.980",
				"name": "I",
				"time": "163.17"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "lost",
				"time": "163.20"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "motivation",
				"time": "163.44"
			},
			{
				"duration": "0.02",
				"confidence": "0.760",
				"name": ".",
				"time": "163.98"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "I",
				"time": "164.01"
			},
			{
				"duration": "0.27",
				"confidence": "0.900",
				"name": "started",
				"time": "164.07"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "feeling",
				"time": "164.34"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "anxious",
				"time": "164.61"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "and",
				"time": "165.06"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "stressed",
				"time": "165.18"
			},
			{
				"duration": "0.12",
				"confidence": "0.890",
				"name": "and",
				"time": "165.60"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "my",
				"time": "166.05"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "mental",
				"time": "166.17"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "health",
				"time": "166.47"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "was",
				"time": "166.71"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "deteriorating",
				"time": "166.89"
			},
			{
				"duration": "0.49",
				"confidence": "0.770",
				"name": ".",
				"time": "167.67"
			},
			{
				"duration": "0.11",
				"confidence": "0.940",
				"name": "And",
				"time": "168.31"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "so",
				"time": "168.42"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "that's",
				"time": "168.54"
			},
			{
				"duration": "0.09",
				"confidence": "0.980",
				"name": "why",
				"time": "168.72"
			},
			{
				"duration": "0.06",
				"confidence": "0.830",
				"name": "I",
				"time": "168.81"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "took",
				"time": "168.87"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "169.02"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "few",
				"time": "169.08"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "weeks",
				"time": "169.26"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "off",
				"time": "169.50"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "from",
				"time": "169.68"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "YouTube",
				"time": "169.86"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "these",
				"time": "170.22"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "past",
				"time": "170.40"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "few",
				"time": "170.61"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "weeks",
				"time": "170.79"
			},
			{
				"duration": "0.24",
				"confidence": "0.670",
				"name": ".",
				"time": "171.18"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "171.54"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "have",
				"time": "171.63"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "not",
				"time": "171.75"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "been",
				"time": "171.96"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "looking",
				"time": "172.35"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "at",
				"time": "172.68"
			},
			{
				"duration": "0.33",
				"confidence": "0.990",
				"name": "YouTube",
				"time": "172.77"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "one",
				"time": "173.16"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "bit",
				"time": "173.43"
			},
			{
				"duration": "0.42",
				"confidence": "0.830",
				"name": "even",
				"time": "174.09"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "checking",
				"time": "174.87"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "my",
				"time": "175.23"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "analytics",
				"time": "175.50"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "or",
				"time": "176.13"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "anything",
				"time": "176.22"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "like",
				"time": "176.55"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "that",
				"time": "176.76"
			},
			{
				"duration": "0.24",
				"confidence": "0.910",
				"name": "I've",
				"time": "177.12"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "just",
				"time": "177.36"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "been",
				"time": "177.60"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "178.11"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "know",
				"time": "178.23"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "cold",
				"time": "178.47"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "turkey",
				"time": "178.77"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "not",
				"time": "179.61"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "worrying",
				"time": "179.82"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "about",
				"time": "180.15"
			},
			{
				"duration": "0.08",
				"confidence": "0.900",
				"name": "it",
				"time": "180.39"
			},
			{
				"duration": "0.03",
				"confidence": "0.770",
				"name": ".",
				"time": "180.47"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": "And",
				"time": "181.85"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "I",
				"time": "181.95"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "think",
				"time": "182.01"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "this",
				"time": "182.19"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "is",
				"time": "182.34"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "182.46"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "useful",
				"time": "182.52"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "lesson",
				"time": "182.91"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "for",
				"time": "184.17"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "everyone",
				"time": "184.32"
			},
			{
				"duration": "0.03",
				"confidence": "0.940",
				"name": ".",
				"time": "184.71"
			}
		],
		"format": "1.0"
	};

/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = {
		"job": {
			"lang": "en",
			"user_id": 46548,
			"name": "video_diary.mp3",
			"duration": 112,
			"created_at": "Fri Jul 27 20:12:19 2018",
			"id": 8856523
		},
		"speakers": [
			{
				"duration": "12.83",
				"confidence": null,
				"name": "M2",
				"time": "2.36"
			},
			{
				"duration": "0.89",
				"confidence": null,
				"name": "M1",
				"time": "16.01"
			},
			{
				"duration": "7.12",
				"confidence": null,
				"name": "F1",
				"time": "18.42"
			},
			{
				"duration": "35.94",
				"confidence": null,
				"name": "M1",
				"time": "26.77"
			},
			{
				"duration": "10.07",
				"confidence": null,
				"name": "F3",
				"time": "65.51"
			},
			{
				"duration": "31.29",
				"confidence": null,
				"name": "M2",
				"time": "78.76"
			}
		],
		"words": [
			{
				"duration": "0.20",
				"confidence": "0.820",
				"name": "I",
				"time": "2.36"
			},
			{
				"duration": "0.14",
				"confidence": "0.360",
				"name": "an",
				"time": "3.32"
			},
			{
				"duration": "0.53",
				"confidence": "0.790",
				"name": "Emsley",
				"time": "3.48"
			},
			{
				"duration": "0.51",
				"confidence": "0.970",
				"name": "26",
				"time": "7.33"
			},
			{
				"duration": "0.21",
				"confidence": "0.970",
				"name": "year",
				"time": "7.84"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "old",
				"time": "8.05"
			},
			{
				"duration": "0.42",
				"confidence": "0.650",
				"name": "they're",
				"time": "10.07"
			},
			{
				"duration": "0.79",
				"confidence": "1.000",
				"name": "starting",
				"time": "11.04"
			},
			{
				"duration": "0.03",
				"confidence": "0.990",
				"name": "a",
				"time": "12.61"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "project",
				"time": "12.64"
			},
			{
				"duration": "0.30",
				"confidence": "0.990",
				"name": "just",
				"time": "13.51"
			},
			{
				"duration": "0.06",
				"confidence": "0.980",
				"name": "to",
				"time": "14.01"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "keep",
				"time": "14.08"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "track",
				"time": "14.80"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "15.19"
			},
			{
				"duration": "0.19",
				"confidence": "0.940",
				"name": "Me",
				"time": "16.01"
			},
			{
				"duration": "0.20",
				"confidence": "0.920",
				"name": "day",
				"time": "16.20"
			},
			{
				"duration": "0.15",
				"confidence": "0.920",
				"name": "to",
				"time": "16.40"
			},
			{
				"duration": "0.31",
				"confidence": "0.930",
				"name": "day",
				"time": "16.55"
			},
			{
				"duration": "0.04",
				"confidence": "0.700",
				"name": ".",
				"time": "16.86"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "Things",
				"time": "18.42"
			},
			{
				"duration": "0.17",
				"confidence": "0.990",
				"name": "that",
				"time": "18.90"
			},
			{
				"duration": "0.09",
				"confidence": "0.700",
				"name": "are",
				"time": "19.07"
			},
			{
				"duration": "0.58",
				"confidence": "0.370",
				"name": "too",
				"time": "19.22"
			},
			{
				"duration": "0.05",
				"confidence": "0.510",
				"name": "I",
				"time": "22.64"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "suffer",
				"time": "22.98"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "from",
				"time": "23.31"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "anxiety",
				"time": "23.85"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "and",
				"time": "24.51"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "depression",
				"time": "24.72"
			},
			{
				"duration": "0.19",
				"confidence": "0.630",
				"name": ".",
				"time": "25.35"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "And",
				"time": "26.77"
			},
			{
				"duration": "0.04",
				"confidence": "0.600",
				"name": "I",
				"time": "29.12"
			},
			{
				"duration": "0.20",
				"confidence": "0.530",
				"name": "thought",
				"time": "29.36"
			},
			{
				"duration": "0.10",
				"confidence": "0.960",
				"name": "it",
				"time": "29.59"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "might",
				"time": "29.69"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "be",
				"time": "29.90"
			},
			{
				"duration": "0.03",
				"confidence": "0.990",
				"name": "a",
				"time": "30.02"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "good",
				"time": "30.08"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "idea",
				"time": "30.29"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "30.71"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "keep",
				"time": "30.83"
			},
			{
				"duration": "0.06",
				"confidence": "0.840",
				"name": "a",
				"time": "31.10"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "video",
				"time": "31.16"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "diary",
				"time": "31.55"
			},
			{
				"duration": "0.07",
				"confidence": "0.650",
				"name": "to",
				"time": "32.21"
			},
			{
				"duration": "0.20",
				"confidence": "0.700",
				"name": "have",
				"time": "32.31"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "32.54"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "little",
				"time": "32.57"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "reflection",
				"time": "32.81"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "on",
				"time": "33.92"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "myself",
				"time": "34.04"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "and",
				"time": "34.79"
			},
			{
				"duration": "0.49",
				"confidence": "0.410",
				"name": "Camilla",
				"time": "35.19"
			},
			{
				"duration": "0.22",
				"confidence": "0.590",
				"name": "and",
				"time": "37.35"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "get",
				"time": "37.72"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "the",
				"time": "37.90"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "message",
				"time": "37.96"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "out",
				"time": "38.41"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "there",
				"time": "38.59"
			},
			{
				"duration": "0.11",
				"confidence": "0.520",
				"name": ".",
				"time": "38.86"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "Make",
				"time": "39.07"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "friends",
				"time": "39.28"
			},
			{
				"duration": "0.29",
				"confidence": "0.830",
				"name": "seek",
				"time": "40.56"
			},
			{
				"duration": "0.47",
				"confidence": "0.970",
				"name": "comfort",
				"time": "40.92"
			},
			{
				"duration": "0.13",
				"confidence": "0.750",
				"name": "in",
				"time": "41.40"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "others",
				"time": "41.53"
			},
			{
				"duration": "0.02",
				"confidence": "0.620",
				"name": ".",
				"time": "42.10"
			},
			{
				"duration": "0.03",
				"confidence": "0.540",
				"name": "I",
				"time": "42.96"
			},
			{
				"duration": "0.32",
				"confidence": "0.910",
				"name": "have",
				"time": "43.19"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "an",
				"time": "44.00"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "amazing",
				"time": "44.12"
			},
			{
				"duration": "0.63",
				"confidence": "0.990",
				"name": "fiancee",
				"time": "44.63"
			},
			{
				"duration": "0.03",
				"confidence": "0.810",
				"name": ".",
				"time": "45.26"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "She",
				"time": "45.87"
			},
			{
				"duration": "0.12",
				"confidence": "0.870",
				"name": "is",
				"time": "47.21"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "always",
				"time": "47.33"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "there",
				"time": "47.60"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "when",
				"time": "47.75"
			},
			{
				"duration": "0.06",
				"confidence": "0.990",
				"name": "I",
				"time": "47.93"
			},
			{
				"duration": "0.30",
				"confidence": "0.980",
				"name": "need",
				"time": "47.99"
			},
			{
				"duration": "0.36",
				"confidence": "0.510",
				"name": "a",
				"time": "48.29"
			},
			{
				"duration": "0.04",
				"confidence": "0.750",
				"name": "I",
				"time": "51.33"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "feel",
				"time": "51.54"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "like",
				"time": "51.72"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "52.41"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "feel",
				"time": "52.50"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "like",
				"time": "52.68"
			},
			{
				"duration": "0.09",
				"confidence": "0.880",
				"name": "I've",
				"time": "52.89"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "just",
				"time": "52.98"
			},
			{
				"duration": "0.21",
				"confidence": "0.930",
				"name": "learned",
				"time": "53.16"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "to",
				"time": "53.37"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "move",
				"time": "53.55"
			},
			{
				"duration": "0.20",
				"confidence": "1.000",
				"name": "from",
				"time": "53.76"
			},
			{
				"duration": "0.19",
				"confidence": "0.710",
				"name": "there",
				"time": "53.96"
			},
			{
				"duration": "0.07",
				"confidence": "0.890",
				"name": ".",
				"time": "54.15"
			},
			{
				"duration": "0.07",
				"confidence": "0.840",
				"name": "I",
				"time": "54.73"
			},
			{
				"duration": "0.18",
				"confidence": "0.770",
				"name": "just",
				"time": "54.80"
			},
			{
				"duration": "0.18",
				"confidence": "0.770",
				"name": "need",
				"time": "54.99"
			},
			{
				"duration": "0.07",
				"confidence": "0.670",
				"name": "a",
				"time": "55.18"
			},
			{
				"duration": "0.53",
				"confidence": "0.990",
				"name": "change",
				"time": "55.26"
			},
			{
				"duration": "0.02",
				"confidence": "0.590",
				"name": ".",
				"time": "55.79"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "And",
				"time": "59.12"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "59.60"
			},
			{
				"duration": "0.27",
				"confidence": "0.990",
				"name": "need",
				"time": "59.69"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "a",
				"time": "59.96"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "way",
				"time": "60.05"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "to",
				"time": "60.29"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "express",
				"time": "60.53"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "myself",
				"time": "60.98"
			},
			{
				"duration": "0.92",
				"confidence": "0.840",
				"name": ".",
				"time": "61.79"
			},
			{
				"duration": "0.39",
				"confidence": "0.350",
				"name": "Mineau",
				"time": "65.51"
			},
			{
				"duration": "0.17",
				"confidence": "0.760",
				"name": "put",
				"time": "67.59"
			},
			{
				"duration": "0.07",
				"confidence": "0.460",
				"name": "it",
				"time": "67.84"
			},
			{
				"duration": "0.19",
				"confidence": "1.000",
				"name": "on",
				"time": "67.97"
			},
			{
				"duration": "0.18",
				"confidence": "0.750",
				"name": "other",
				"time": "68.17"
			},
			{
				"duration": "0.50",
				"confidence": "1.000",
				"name": "people",
				"time": "68.36"
			},
			{
				"duration": "0.30",
				"confidence": "0.990",
				"name": "people",
				"time": "71.02"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "want",
				"time": "71.32"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "71.47"
			},
			{
				"duration": "0.26",
				"confidence": "1.000",
				"name": "watch",
				"time": "71.56"
			},
			{
				"duration": "0.28",
				"confidence": "0.990",
				"name": "video",
				"time": "71.83"
			},
			{
				"duration": "0.14",
				"confidence": "0.950",
				"name": "or",
				"time": "72.11"
			},
			{
				"duration": "0.10",
				"confidence": "0.420",
				"name": "they",
				"time": "72.25"
			},
			{
				"duration": "0.24",
				"confidence": "0.910",
				"name": "want",
				"time": "72.34"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "to",
				"time": "72.58"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "watch",
				"time": "72.64"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "it",
				"time": "72.94"
			},
			{
				"duration": "0.32",
				"confidence": "0.710",
				"name": "and",
				"time": "73.92"
			},
			{
				"duration": "0.11",
				"confidence": "0.920",
				"name": "they",
				"time": "74.31"
			},
			{
				"duration": "0.15",
				"confidence": "0.500",
				"name": "could",
				"time": "74.44"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "stop",
				"time": "74.59"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "whenever",
				"time": "74.86"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "they",
				"time": "75.10"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "want",
				"time": "75.22"
			},
			{
				"duration": "0.03",
				"confidence": "0.930",
				"name": ".",
				"time": "75.55"
			},
			{
				"duration": "0.06",
				"confidence": "0.600",
				"name": "You",
				"time": "78.76"
			},
			{
				"duration": "0.26",
				"confidence": "0.600",
				"name": "know",
				"time": "79.23"
			},
			{
				"duration": "0.20",
				"confidence": "0.620",
				"name": "this",
				"time": "79.96"
			},
			{
				"duration": "0.11",
				"confidence": "1.000",
				"name": "if",
				"time": "80.27"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "you",
				"time": "80.38"
			},
			{
				"duration": "0.21",
				"confidence": "0.940",
				"name": "tell",
				"time": "80.44"
			},
			{
				"duration": "0.26",
				"confidence": "1.000",
				"name": "someone",
				"time": "80.65"
			},
			{
				"duration": "0.10",
				"confidence": "0.500",
				"name": "in",
				"time": "80.91"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "person",
				"time": "81.01"
			},
			{
				"duration": "0.08",
				"confidence": "0.970",
				"name": "they",
				"time": "81.46"
			},
			{
				"duration": "0.23",
				"confidence": "0.530",
				"name": "kind",
				"time": "81.54"
			},
			{
				"duration": "0.09",
				"confidence": "0.530",
				"name": "of",
				"time": "81.81"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "go",
				"time": "82.15"
			},
			{
				"duration": "0.17",
				"confidence": "0.850",
				"name": "hey",
				"time": "82.45"
			},
			{
				"duration": "0.30",
				"confidence": "0.940",
				"name": "will",
				"time": "82.63"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "stop",
				"time": "82.93"
			},
			{
				"duration": "0.06",
				"confidence": "0.590",
				"name": ".",
				"time": "83.23"
			},
			{
				"duration": "0.09",
				"confidence": "0.980",
				"name": "You",
				"time": "83.32"
			},
			{
				"duration": "0.22",
				"confidence": "0.750",
				"name": "tell",
				"time": "83.41"
			},
			{
				"duration": "0.20",
				"confidence": "1.000",
				"name": "me",
				"time": "83.63"
			},
			{
				"duration": "0.18",
				"confidence": "0.960",
				"name": "too",
				"time": "83.83"
			},
			{
				"duration": "0.45",
				"confidence": "0.960",
				"name": "much",
				"time": "84.01"
			},
			{
				"duration": "0.46",
				"confidence": "0.540",
				"name": ".",
				"time": "84.46"
			},
			{
				"duration": "0.50",
				"confidence": "0.980",
				"name": "And",
				"time": "85.46"
			},
			{
				"duration": "0.04",
				"confidence": "0.670",
				"name": "at",
				"time": "87.07"
			},
			{
				"duration": "0.22",
				"confidence": "0.690",
				"name": "least",
				"time": "87.21"
			},
			{
				"duration": "0.10",
				"confidence": "0.610",
				"name": "for",
				"time": "87.46"
			},
			{
				"duration": "0.14",
				"confidence": "0.640",
				"name": "the",
				"time": "87.60"
			},
			{
				"duration": "0.52",
				"confidence": "0.930",
				"name": "video",
				"time": "87.74"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "you",
				"time": "89.49"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "get",
				"time": "89.61"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "sick",
				"time": "89.85"
			},
			{
				"duration": "0.29",
				"confidence": "0.950",
				"name": "even",
				"time": "90.33"
			},
			{
				"duration": "0.15",
				"confidence": "0.360",
				"name": "those",
				"time": "90.62"
			},
			{
				"duration": "0.36",
				"confidence": "0.440",
				"name": "dumb",
				"time": "90.79"
			},
			{
				"duration": "0.35",
				"confidence": "0.710",
				"name": "pulls",
				"time": "91.32"
			},
			{
				"duration": "0.13",
				"confidence": "0.730",
				"name": "it",
				"time": "91.68"
			},
			{
				"duration": "0.21",
				"confidence": "0.540",
				"name": "out",
				"time": "91.82"
			},
			{
				"duration": "0.08",
				"confidence": "0.780",
				"name": ".",
				"time": "92.04"
			},
			{
				"duration": "0.48",
				"confidence": "0.850",
				"name": "Hopefully",
				"time": "94.56"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "this",
				"time": "95.10"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "will",
				"time": "95.34"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "be",
				"time": "95.46"
			},
			{
				"duration": "0.03",
				"confidence": "0.990",
				"name": "a",
				"time": "96.63"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "good",
				"time": "96.66"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "opportunity",
				"time": "96.90"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "97.50"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "find",
				"time": "97.59"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "out",
				"time": "97.92"
			},
			{
				"duration": "0.22",
				"confidence": "0.920",
				"name": "more",
				"time": "98.04"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "about",
				"time": "99.00"
			},
			{
				"duration": "0.48",
				"confidence": "0.990",
				"name": "myself",
				"time": "99.27"
			},
			{
				"duration": "0.03",
				"confidence": "0.930",
				"name": ".",
				"time": "99.75"
			},
			{
				"duration": "0.09",
				"confidence": "0.710",
				"name": "And",
				"time": "100.92"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "101.18"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "learn",
				"time": "101.30"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "how",
				"time": "102.14"
			},
			{
				"duration": "0.17",
				"confidence": "0.910",
				"name": "other",
				"time": "102.41"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "people",
				"time": "102.59"
			},
			{
				"duration": "0.27",
				"confidence": "0.860",
				"name": "see",
				"time": "103.01"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "me",
				"time": "103.28"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "103.55"
			},
			{
				"duration": "0.47",
				"confidence": "0.580",
				"name": "Or",
				"time": "108.39"
			},
			{
				"duration": "0.24",
				"confidence": "0.920",
				"name": "is",
				"time": "108.98"
			},
			{
				"duration": "0.15",
				"confidence": "0.950",
				"name": "the",
				"time": "109.22"
			},
			{
				"duration": "0.49",
				"confidence": "0.990",
				"name": "future",
				"time": "109.37"
			},
			{
				"duration": "0.19",
				"confidence": "0.580",
				"name": ".",
				"time": "109.86"
			}
		],
		"format": "1.0"
	};

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = {
		"job": {
			"lang": "en",
			"user_id": 46548,
			"name": "vlog_competition.mp3",
			"duration": 90,
			"created_at": "Fri Jul 27 20:12:03 2018",
			"id": 8856519
		},
		"speakers": [
			{
				"duration": "17.51",
				"confidence": null,
				"name": "F1",
				"time": "0.15"
			},
			{
				"duration": "7.75",
				"confidence": null,
				"name": "F2",
				"time": "18.01"
			},
			{
				"duration": "63.92",
				"confidence": null,
				"name": "F1",
				"time": "26.00"
			}
		],
		"words": [
			{
				"duration": "0.19",
				"confidence": "1.000",
				"name": "Hey",
				"time": "0.15"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "guys",
				"time": "0.36"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "doing",
				"time": "1.53"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "1.74"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "blog",
				"time": "1.80"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "today",
				"time": "2.10"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "for",
				"time": "2.37"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "you",
				"time": "2.58"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "for",
				"time": "2.82"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "3.15"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "contest",
				"time": "3.21"
			},
			{
				"duration": "0.38",
				"confidence": "0.530",
				"name": ".",
				"time": "3.90"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "Shrinking",
				"time": "4.62"
			},
			{
				"duration": "0.27",
				"confidence": "0.930",
				"name": "jeans",
				"time": "5.13"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "is",
				"time": "5.40"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "having",
				"time": "5.52"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "5.76"
			},
			{
				"duration": "0.30",
				"confidence": "0.610",
				"name": "heart",
				"time": "5.82"
			},
			{
				"duration": "0.09",
				"confidence": "0.950",
				"name": "a",
				"time": "6.12"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "blogging",
				"time": "6.21"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "contest",
				"time": "6.63"
			},
			{
				"duration": "0.36",
				"confidence": "0.990",
				"name": "and",
				"time": "7.32"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "we're",
				"time": "7.68"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "supposed",
				"time": "7.80"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "8.07"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "share",
				"time": "8.19"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "our",
				"time": "8.58"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "favorite",
				"time": "8.73"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "holiday",
				"time": "9.78"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "tradition",
				"time": "10.20"
			},
			{
				"duration": "0.26",
				"confidence": "0.730",
				"name": ".",
				"time": "11.00"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "And",
				"time": "11.37"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "one",
				"time": "11.85"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "12.00"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "my",
				"time": "12.06"
			},
			{
				"duration": "0.33",
				"confidence": "0.990",
				"name": "favorite",
				"time": "12.24"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "traditions",
				"time": "12.57"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "is",
				"time": "13.29"
			},
			{
				"duration": "0.24",
				"confidence": "0.670",
				"name": "Pany",
				"time": "13.83"
			},
			{
				"duration": "0.12",
				"confidence": "0.900",
				"name": "of",
				"time": "14.07"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "14.19"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "Christmas",
				"time": "14.28"
			},
			{
				"duration": "0.17",
				"confidence": "0.940",
				"name": "tree",
				"time": "14.64"
			},
			{
				"duration": "0.04",
				"confidence": "0.590",
				"name": "at",
				"time": "14.81"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "Christmas",
				"time": "14.85"
			},
			{
				"duration": "0.39",
				"confidence": "0.770",
				"name": ".",
				"time": "15.51"
			},
			{
				"duration": "0.21",
				"confidence": "0.630",
				"name": "And",
				"time": "15.98"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "this",
				"time": "16.20"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "is",
				"time": "16.35"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "our",
				"time": "16.59"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "Christmas",
				"time": "16.86"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "tree",
				"time": "17.25"
			},
			{
				"duration": "0.08",
				"confidence": "0.880",
				"name": ".",
				"time": "17.58"
			},
			{
				"duration": "0.11",
				"confidence": "0.940",
				"name": "And",
				"time": "18.01"
			},
			{
				"duration": "0.10",
				"confidence": "1.000",
				"name": "I",
				"time": "18.14"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "thought",
				"time": "18.24"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "I",
				"time": "18.45"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "would",
				"time": "18.51"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "share",
				"time": "18.66"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "with",
				"time": "18.87"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "you",
				"time": "18.99"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "guys",
				"time": "19.08"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "one",
				"time": "19.80"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "19.95"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "my",
				"time": "20.01"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "favorite",
				"time": "20.13"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "ornaments",
				"time": "20.46"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "this",
				"time": "22.13"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "was",
				"time": "22.55"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "actually",
				"time": "22.76"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "made",
				"time": "23.12"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "for",
				"time": "23.33"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "me",
				"time": "23.48"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "by",
				"time": "23.66"
			},
			{
				"duration": "0.52",
				"confidence": "0.350",
				"name": "Trena",
				"time": "23.87"
			},
			{
				"duration": "0.05",
				"confidence": "0.940",
				"name": ".",
				"time": "24.39"
			},
			{
				"duration": "0.15",
				"confidence": "0.980",
				"name": "Hey",
				"time": "24.59"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "Dana",
				"time": "24.74"
			},
			{
				"duration": "0.42",
				"confidence": "0.640",
				"name": ".",
				"time": "25.34"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "And",
				"time": "26.00"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "we",
				"time": "26.66"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "went",
				"time": "26.81"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "26.93"
			},
			{
				"duration": "0.18",
				"confidence": "0.970",
				"name": "see",
				"time": "27.02"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "New",
				"time": "27.20"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "Moon",
				"time": "27.41"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "together",
				"time": "27.65"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "last",
				"time": "28.04"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "year",
				"time": "28.43"
			},
			{
				"duration": "0.03",
				"confidence": "0.770",
				"name": ".",
				"time": "28.55"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "And",
				"time": "28.58"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "so",
				"time": "28.76"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "she",
				"time": "28.91"
			},
			{
				"duration": "0.27",
				"confidence": "0.980",
				"name": "had",
				"time": "29.15"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "painted",
				"time": "29.42"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "this",
				"time": "30.59"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "ornament",
				"time": "30.80"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "and",
				"time": "31.43"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "31.58"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "think",
				"time": "31.67"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "it's",
				"time": "31.82"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "gorgeous",
				"time": "32.00"
			},
			{
				"duration": "0.03",
				"confidence": "0.840",
				"name": ".",
				"time": "32.51"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "And",
				"time": "32.54"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "32.66"
			},
			{
				"duration": "0.18",
				"confidence": "0.870",
				"name": "kept",
				"time": "32.75"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "telling",
				"time": "32.93"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "her",
				"time": "33.20"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "she",
				"time": "33.32"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "should",
				"time": "33.47"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "go",
				"time": "33.65"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "into",
				"time": "33.77"
			},
			{
				"duration": "0.31",
				"confidence": "1.000",
				"name": "business",
				"time": "33.95"
			},
			{
				"duration": "0.03",
				"confidence": "0.800",
				"name": ".",
				"time": "34.26"
			},
			{
				"duration": "0.13",
				"confidence": "0.950",
				"name": "But",
				"time": "34.32"
			},
			{
				"duration": "0.40",
				"confidence": "0.610",
				"name": "Anyways",
				"time": "34.51"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "that's",
				"time": "35.84"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "my",
				"time": "36.17"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "favorite",
				"time": "36.56"
			},
			{
				"duration": "0.33",
				"confidence": "0.980",
				"name": "holiday",
				"time": "36.98"
			},
			{
				"duration": "0.62",
				"confidence": "1.000",
				"name": "tradition",
				"time": "37.31"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "and",
				"time": "38.21"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "my",
				"time": "38.75"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "favorite",
				"time": "38.99"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "recipe",
				"time": "39.38"
			},
			{
				"duration": "0.09",
				"confidence": "0.520",
				"name": "they're",
				"time": "39.90"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "going",
				"time": "40.01"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "to",
				"time": "40.13"
			},
			{
				"duration": "0.23",
				"confidence": "0.920",
				"name": "share",
				"time": "40.19"
			},
			{
				"duration": "0.08",
				"confidence": "0.660",
				"name": "if",
				"time": "40.43"
			},
			{
				"duration": "0.10",
				"confidence": "0.810",
				"name": "you",
				"time": "40.51"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "guys",
				"time": "40.61"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "is",
				"time": "41.57"
			},
			{
				"duration": "0.28",
				"confidence": "1.000",
				"name": "fruit",
				"time": "42.40"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "salad",
				"time": "42.68"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "and",
				"time": "43.40"
			},
			{
				"duration": "0.17",
				"confidence": "0.630",
				"name": "this",
				"time": "43.55"
			},
			{
				"duration": "0.38",
				"confidence": "0.860",
				"name": "actually",
				"time": "43.72"
			},
			{
				"duration": "0.06",
				"confidence": "0.610",
				"name": "is",
				"time": "44.11"
			},
			{
				"duration": "0.34",
				"confidence": "0.900",
				"name": "something",
				"time": "44.23"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "that",
				"time": "44.57"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "I",
				"time": "44.69"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "got",
				"time": "44.75"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "from",
				"time": "44.99"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "my",
				"time": "45.14"
			},
			{
				"duration": "0.31",
				"confidence": "1.000",
				"name": "mother",
				"time": "45.59"
			},
			{
				"duration": "0.45",
				"confidence": "0.590",
				"name": "Kathy",
				"time": "46.08"
			},
			{
				"duration": "0.42",
				"confidence": "0.700",
				"name": ".",
				"time": "46.56"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "And",
				"time": "47.12"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "you",
				"time": "47.51"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "can",
				"time": "47.66"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "use",
				"time": "47.84"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "any",
				"time": "48.14"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "kind",
				"time": "48.38"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "48.59"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "fruit",
				"time": "48.68"
			},
			{
				"duration": "0.75",
				"confidence": "0.710",
				"name": "combinations",
				"time": "48.92"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "so",
				"time": "49.67"
			},
			{
				"duration": "0.35",
				"confidence": "0.810",
				"name": "not",
				"time": "51.38"
			},
			{
				"duration": "0.30",
				"confidence": "0.920",
				"name": "not",
				"time": "51.89"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "52.19"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "real",
				"time": "52.25"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "true",
				"time": "52.58"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "recipe",
				"time": "52.85"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "I",
				"time": "53.30"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "guess",
				"time": "53.36"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "because",
				"time": "53.57"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "it's",
				"time": "53.75"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "something",
				"time": "53.99"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "you",
				"time": "54.35"
			},
			{
				"duration": "0.12",
				"confidence": "0.960",
				"name": "do",
				"time": "54.44"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "yourself",
				"time": "54.56"
			},
			{
				"duration": "0.10",
				"confidence": "0.840",
				"name": ".",
				"time": "55.19"
			},
			{
				"duration": "0.20",
				"confidence": "0.810",
				"name": "But",
				"time": "55.64"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "57.68"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "think",
				"time": "57.77"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "we",
				"time": "58.19"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "normally",
				"time": "58.34"
			},
			{
				"duration": "0.19",
				"confidence": "0.840",
				"name": "put",
				"time": "58.85"
			},
			{
				"duration": "1.14",
				"confidence": "1.000",
				"name": "pineapple",
				"time": "59.33"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "and",
				"time": "60.56"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "grapes",
				"time": "61.01"
			},
			{
				"duration": "0.54",
				"confidence": "0.990",
				"name": "and",
				"time": "61.79"
			},
			{
				"duration": "0.90",
				"confidence": "1.000",
				"name": "apples",
				"time": "62.33"
			},
			{
				"duration": "0.27",
				"confidence": "0.880",
				"name": "cut",
				"time": "63.26"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "up",
				"time": "63.53"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "and",
				"time": "64.39"
			},
			{
				"duration": "0.09",
				"confidence": "0.960",
				"name": "you",
				"time": "64.52"
			},
			{
				"duration": "0.12",
				"confidence": "0.820",
				"name": "just",
				"time": "64.61"
			},
			{
				"duration": "0.19",
				"confidence": "1.000",
				"name": "put",
				"time": "64.75"
			},
			{
				"duration": "0.09",
				"confidence": "0.960",
				"name": "in",
				"time": "64.94"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "whatever",
				"time": "65.03"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "65.39"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "want",
				"time": "65.51"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "whatever",
				"time": "65.84"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "66.14"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "like",
				"time": "66.26"
			},
			{
				"duration": "0.03",
				"confidence": "0.850",
				"name": ".",
				"time": "66.53"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "It's",
				"time": "66.56"
			},
			{
				"duration": "0.06",
				"confidence": "0.920",
				"name": "a",
				"time": "67.20"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "truly",
				"time": "67.28"
			},
			{
				"duration": "0.48",
				"confidence": "0.290",
				"name": "coz",
				"time": "67.67"
			},
			{
				"duration": "0.68",
				"confidence": "0.710",
				"name": "cousin",
				"time": "68.19"
			},
			{
				"duration": "0.38",
				"confidence": "0.620",
				"name": "because",
				"time": "69.10"
			},
			{
				"duration": "0.52",
				"confidence": "1.000",
				"name": "whatever",
				"time": "69.73"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "you",
				"time": "70.46"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "can",
				"time": "70.55"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "customize",
				"time": "70.67"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "it",
				"time": "71.27"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "and",
				"time": "72.02"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "throw",
				"time": "72.44"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "in",
				"time": "72.65"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "some",
				"time": "72.77"
			},
			{
				"duration": "0.61",
				"confidence": "1.000",
				"name": "nuts",
				"time": "72.95"
			},
			{
				"duration": "0.26",
				"confidence": "1.000",
				"name": "or",
				"time": "73.59"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "whatever",
				"time": "73.85"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "else",
				"time": "74.33"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "74.63"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "want",
				"time": "74.75"
			},
			{
				"duration": "0.45",
				"confidence": "0.960",
				"name": "to",
				"time": "74.93"
			},
			{
				"duration": "0.39",
				"confidence": "0.830",
				"name": ".",
				"time": "75.39"
			},
			{
				"duration": "0.18",
				"confidence": "0.930",
				"name": "But",
				"time": "76.00"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "anyways",
				"time": "76.19"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "that's",
				"time": "77.18"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "77.39"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "good",
				"time": "77.45"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "thing",
				"time": "77.69"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "to",
				"time": "77.93"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "have",
				"time": "77.99"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "around",
				"time": "78.29"
			},
			{
				"duration": "0.03",
				"confidence": "0.610",
				"name": ".",
				"time": "78.71"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "And",
				"time": "78.74"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "we",
				"time": "78.98"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "have",
				"time": "79.16"
			},
			{
				"duration": "0.18",
				"confidence": "0.760",
				"name": "a",
				"time": "79.37"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "more",
				"time": "79.73"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "than",
				"time": "79.97"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "just",
				"time": "80.12"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "holidays",
				"time": "80.39"
			},
			{
				"duration": "0.08",
				"confidence": "0.530",
				"name": ".",
				"time": "81.28"
			},
			{
				"duration": "0.10",
				"confidence": "0.640",
				"name": "I've",
				"time": "81.48"
			},
			{
				"duration": "0.26",
				"confidence": "0.830",
				"name": "had",
				"time": "81.78"
			},
			{
				"duration": "0.12",
				"confidence": "0.730",
				"name": "it",
				"time": "82.04"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "random",
				"time": "82.19"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "times",
				"time": "82.70"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "83.06"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "83.15"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "year",
				"time": "83.24"
			},
			{
				"duration": "0.32",
				"confidence": "0.990",
				"name": "too",
				"time": "83.42"
			},
			{
				"duration": "0.17",
				"confidence": "0.860",
				"name": "but",
				"time": "84.11"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "it's",
				"time": "84.29"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "something",
				"time": "84.44"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "that",
				"time": "85.43"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "is",
				"time": "85.79"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "can",
				"time": "86.33"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "be",
				"time": "86.51"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "kind",
				"time": "86.63"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "86.81"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "sweet",
				"time": "86.90"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "and",
				"time": "87.92"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "it",
				"time": "88.13"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "gets",
				"time": "88.19"
			},
			{
				"duration": "0.06",
				"confidence": "0.560",
				"name": "in",
				"time": "88.40"
			},
			{
				"duration": "0.09",
				"confidence": "0.790",
				"name": "your",
				"time": "88.49"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "fruit",
				"time": "88.58"
			},
			{
				"duration": "0.65",
				"confidence": "0.990",
				"name": "servings",
				"time": "89.21"
			},
			{
				"duration": "0.06",
				"confidence": "0.580",
				"name": "in",
				"time": "89.86"
			},
			{
				"duration": "0.00",
				"confidence": "1.000",
				"name": ".",
				"time": "89.92"
			}
		],
		"format": "1.0"
	};

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = {
		"job": {
			"lang": "en",
			"user_id": 46548,
			"name": "yoga_vibe.mp3",
			"duration": 185,
			"created_at": "Fri Jul 27 20:11:42 2018",
			"id": 8856513
		},
		"speakers": [
			{
				"duration": "57.29",
				"confidence": null,
				"name": "M2",
				"time": "1.75"
			},
			{
				"duration": "5.46",
				"confidence": null,
				"name": "M3",
				"time": "59.31"
			},
			{
				"duration": "43.36",
				"confidence": null,
				"name": "M2",
				"time": "64.87"
			},
			{
				"duration": "11.63",
				"confidence": null,
				"name": "M3",
				"time": "108.28"
			},
			{
				"duration": "19.62",
				"confidence": null,
				"name": "M2",
				"time": "120.01"
			},
			{
				"duration": "4.80",
				"confidence": null,
				"name": "M3",
				"time": "140.41"
			},
			{
				"duration": "34.41",
				"confidence": null,
				"name": "F2",
				"time": "145.72"
			},
			{
				"duration": "3.05",
				"confidence": null,
				"name": "M2",
				"time": "181.90"
			}
		],
		"words": [
			{
				"duration": "0.90",
				"confidence": "1.000",
				"name": "Hey",
				"time": "1.75"
			},
			{
				"duration": "0.77",
				"confidence": "0.970",
				"name": "everybody",
				"time": "2.69"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "how's",
				"time": "3.49"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "it",
				"time": "3.70"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "going",
				"time": "3.76"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": ".",
				"time": "4.45"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "Happy",
				"time": "4.48"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "Saturday",
				"time": "4.93"
			},
			{
				"duration": "0.17",
				"confidence": "1.000",
				"name": "to",
				"time": "5.47"
			},
			{
				"duration": "0.28",
				"confidence": "0.940",
				"name": "you",
				"time": "5.64"
			},
			{
				"duration": "0.14",
				"confidence": "0.950",
				"name": "it's",
				"time": "5.92"
			},
			{
				"duration": "0.33",
				"confidence": "0.720",
				"name": "Maria",
				"time": "6.07"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "Triano",
				"time": "6.40"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "from",
				"time": "7.09"
			},
			{
				"duration": "0.16",
				"confidence": "0.870",
				"name": "a",
				"time": "7.68"
			},
			{
				"duration": "0.30",
				"confidence": "0.970",
				"name": "dance",
				"time": "7.84"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "network",
				"time": "8.14"
			},
			{
				"duration": "0.03",
				"confidence": "0.620",
				"name": ".",
				"time": "8.58"
			},
			{
				"duration": "0.19",
				"confidence": "0.930",
				"name": "And",
				"time": "8.61"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "happy",
				"time": "8.80"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "healthy",
				"time": "9.16"
			},
			{
				"duration": "0.18",
				"confidence": "0.540",
				"name": "whole",
				"time": "9.44"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "essential",
				"time": "9.64"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "oils",
				"time": "10.06"
			},
			{
				"duration": "0.51",
				"confidence": "0.940",
				"name": ".",
				"time": "10.63"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "11.17"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "hope",
				"time": "11.29"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "you",
				"time": "11.47"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "guys",
				"time": "11.53"
			},
			{
				"duration": "0.06",
				"confidence": "0.890",
				"name": "are",
				"time": "11.71"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "having",
				"time": "11.77"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "12.04"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "really",
				"time": "12.10"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "nice",
				"time": "12.31"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "weekend",
				"time": "12.58"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": ".",
				"time": "14.10"
			},
			{
				"duration": "0.20",
				"confidence": "0.850",
				"name": "I",
				"time": "14.19"
			},
			{
				"duration": "0.22",
				"confidence": "0.850",
				"name": "am",
				"time": "14.40"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "here",
				"time": "14.62"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "in",
				"time": "15.19"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "my",
				"time": "15.37"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "backyard",
				"time": "15.49"
			},
			{
				"duration": "0.35",
				"confidence": "0.960",
				"name": "bringing",
				"time": "16.90"
			},
			{
				"duration": "0.29",
				"confidence": "0.790",
				"name": "to",
				"time": "17.29"
			},
			{
				"duration": "0.57",
				"confidence": "0.520",
				"name": "live",
				"time": "17.65"
			},
			{
				"duration": "0.39",
				"confidence": "0.990",
				"name": "our",
				"time": "18.25"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "daily",
				"time": "18.67"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "diary",
				"time": "19.03"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "for",
				"time": "19.57"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "19.72"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "month",
				"time": "19.84"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "of",
				"time": "20.38"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "June",
				"time": "20.53"
			},
			{
				"duration": "0.09",
				"confidence": "0.970",
				"name": ".",
				"time": "21.01"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "21.10"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "wanted",
				"time": "21.22"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "to",
				"time": "21.52"
			},
			{
				"duration": "0.29",
				"confidence": "1.000",
				"name": "share",
				"time": "21.70"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "with",
				"time": "22.00"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "you",
				"time": "22.24"
			},
			{
				"duration": "0.47",
				"confidence": "1.000",
				"name": "how",
				"time": "22.49"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I",
				"time": "22.96"
			},
			{
				"duration": "0.29",
				"confidence": "0.720",
				"name": "use",
				"time": "23.08"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "oils",
				"time": "23.50"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "on",
				"time": "24.49"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "24.64"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "daily",
				"time": "24.70"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "basis",
				"time": "25.03"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "26.05"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "get",
				"time": "26.20"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "me",
				"time": "26.41"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "through",
				"time": "26.56"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "all",
				"time": "27.07"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "of",
				"time": "27.37"
			},
			{
				"duration": "0.57",
				"confidence": "0.990",
				"name": "life's",
				"time": "27.52"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "joyful",
				"time": "28.96"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "challenges",
				"time": "29.80"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "and",
				"time": "30.61"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "difficult",
				"time": "31.15"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "challenges",
				"time": "31.63"
			},
			{
				"duration": "0.37",
				"confidence": "1.000",
				"name": "and",
				"time": "33.25"
			},
			{
				"duration": "0.19",
				"confidence": "0.740",
				"name": "just",
				"time": "33.62"
			},
			{
				"duration": "0.18",
				"confidence": "0.820",
				"name": "to",
				"time": "33.89"
			},
			{
				"duration": "0.49",
				"confidence": "0.960",
				"name": "really",
				"time": "34.09"
			},
			{
				"duration": "0.41",
				"confidence": "0.980",
				"name": "explain",
				"time": "34.93"
			},
			{
				"duration": "0.28",
				"confidence": "1.000",
				"name": "to",
				"time": "35.35"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "35.80"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "little",
				"time": "35.86"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "bit",
				"time": "36.07"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "about",
				"time": "36.25"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "how",
				"time": "36.55"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "36.76"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "can",
				"time": "36.88"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "use",
				"time": "37.06"
			},
			{
				"duration": "0.15",
				"confidence": "0.980",
				"name": "the",
				"time": "37.24"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "oils",
				"time": "37.39"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "in",
				"time": "37.81"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "your",
				"time": "37.96"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "everyday",
				"time": "38.17"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "life",
				"time": "38.65"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "to",
				"time": "40.18"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "assist",
				"time": "40.48"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "you",
				"time": "40.90"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "with",
				"time": "41.56"
			},
			{
				"duration": "0.04",
				"confidence": "0.670",
				"name": "the",
				"time": "41.99"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "things",
				"time": "42.07"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "that",
				"time": "42.37"
			},
			{
				"duration": "0.14",
				"confidence": "0.940",
				"name": "you're",
				"time": "42.49"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "going",
				"time": "42.64"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "through",
				"time": "42.97"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "your",
				"time": "44.02"
			},
			{
				"duration": "0.81",
				"confidence": "1.000",
				"name": "emotions",
				"time": "44.17"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "your",
				"time": "45.04"
			},
			{
				"duration": "0.84",
				"confidence": "1.000",
				"name": "physical",
				"time": "45.91"
			},
			{
				"duration": "0.78",
				"confidence": "1.000",
				"name": "concerns",
				"time": "46.90"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "your",
				"time": "47.68"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "any",
				"time": "49.48"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "49.72"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "your",
				"time": "49.81"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "spiritual",
				"time": "49.93"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "things",
				"time": "50.47"
			},
			{
				"duration": "0.09",
				"confidence": "0.980",
				"name": "and",
				"time": "51.25"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "just",
				"time": "51.34"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "sort",
				"time": "51.52"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "of",
				"time": "51.70"
			},
			{
				"duration": "0.54",
				"confidence": "0.960",
				"name": "explain",
				"time": "51.79"
			},
			{
				"duration": "0.32",
				"confidence": "1.000",
				"name": "to",
				"time": "52.33"
			},
			{
				"duration": "0.24",
				"confidence": "0.650",
				"name": "you",
				"time": "52.65"
			},
			{
				"duration": "0.11",
				"confidence": "0.700",
				"name": "and",
				"time": "52.89"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "give",
				"time": "53.05"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "you",
				"time": "53.26"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "just",
				"time": "53.41"
			},
			{
				"duration": "0.20",
				"confidence": "0.940",
				"name": "some",
				"time": "53.69"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "little",
				"time": "53.89"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "daily",
				"time": "54.79"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "diary",
				"time": "55.09"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "tips",
				"time": "55.57"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "on",
				"time": "56.02"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "how",
				"time": "56.23"
			},
			{
				"duration": "0.21",
				"confidence": "0.990",
				"name": "I",
				"time": "57.25"
			},
			{
				"duration": "0.27",
				"confidence": "0.990",
				"name": "use",
				"time": "57.46"
			},
			{
				"duration": "0.12",
				"confidence": "0.970",
				"name": "the",
				"time": "57.73"
			},
			{
				"duration": "0.42",
				"confidence": "0.960",
				"name": "oils",
				"time": "57.85"
			},
			{
				"duration": "0.58",
				"confidence": "0.790",
				"name": "everyday",
				"time": "58.34"
			},
			{
				"duration": "0.12",
				"confidence": "0.590",
				"name": ".",
				"time": "58.92"
			},
			{
				"duration": "0.38",
				"confidence": "0.770",
				"name": "Okay",
				"time": "59.31"
			},
			{
				"duration": "0.03",
				"confidence": "0.680",
				"name": ".",
				"time": "59.80"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "And",
				"time": "59.92"
			},
			{
				"duration": "0.33",
				"confidence": "0.410",
				"name": "everything",
				"time": "60.97"
			},
			{
				"duration": "0.11",
				"confidence": "0.950",
				"name": "is",
				"time": "61.31"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "going",
				"time": "61.42"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "to",
				"time": "61.54"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "be",
				"time": "61.60"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "different",
				"time": "61.69"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "because",
				"time": "62.11"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "as",
				"time": "62.68"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "we",
				"time": "62.83"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "know",
				"time": "62.92"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "each",
				"time": "63.16"
			},
			{
				"duration": "0.35",
				"confidence": "1.000",
				"name": "moment",
				"time": "63.37"
			},
			{
				"duration": "0.15",
				"confidence": "0.850",
				"name": "is",
				"time": "63.73"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "different",
				"time": "63.88"
			},
			{
				"duration": "0.44",
				"confidence": "0.820",
				"name": ".",
				"time": "64.33"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "Today",
				"time": "64.87"
			},
			{
				"duration": "0.17",
				"confidence": "0.800",
				"name": "I",
				"time": "65.46"
			},
			{
				"duration": "0.25",
				"confidence": "0.800",
				"name": "am",
				"time": "65.64"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "breathing",
				"time": "65.89"
			},
			{
				"duration": "0.12",
				"confidence": "0.990",
				"name": "and",
				"time": "66.37"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "taking",
				"time": "66.49"
			},
			{
				"duration": "0.59",
				"confidence": "0.760",
				"name": "five",
				"time": "66.91"
			},
			{
				"duration": "0.20",
				"confidence": "0.550",
				"name": "out",
				"time": "68.35"
			},
			{
				"duration": "0.37",
				"confidence": "1.000",
				"name": "here",
				"time": "68.58"
			},
			{
				"duration": "0.12",
				"confidence": "0.680",
				"name": "I'm",
				"time": "68.97"
			},
			{
				"duration": "0.18",
				"confidence": "0.970",
				"name": "in",
				"time": "69.19"
			},
			{
				"duration": "0.43",
				"confidence": "0.990",
				"name": "my",
				"time": "69.42"
			},
			{
				"duration": "0.31",
				"confidence": "1.000",
				"name": "yoga",
				"time": "70.36"
			},
			{
				"duration": "0.18",
				"confidence": "0.890",
				"name": "that",
				"time": "71.17"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "my",
				"time": "71.38"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "husband",
				"time": "71.53"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "built",
				"time": "71.86"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "me",
				"time": "72.10"
			},
			{
				"duration": "0.33",
				"confidence": "0.500",
				"name": "and",
				"time": "72.56"
			},
			{
				"duration": "0.18",
				"confidence": "0.450",
				"name": "two",
				"time": "73.17"
			},
			{
				"duration": "0.35",
				"confidence": "0.840",
				"name": "fans",
				"time": "73.44"
			},
			{
				"duration": "0.08",
				"confidence": "0.950",
				"name": "are",
				"time": "73.79"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "back",
				"time": "73.87"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "here",
				"time": "74.14"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "you",
				"time": "74.29"
			},
			{
				"duration": "0.24",
				"confidence": "0.990",
				"name": "might",
				"time": "74.38"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "hear",
				"time": "74.62"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "some",
				"time": "74.83"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "frogs",
				"time": "75.07"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "singing",
				"time": "76.51"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "to",
				"time": "76.93"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "us",
				"time": "77.17"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "which",
				"time": "77.65"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "is",
				"time": "77.86"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "really",
				"time": "78.04"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "awesome",
				"time": "78.43"
			},
			{
				"duration": "0.14",
				"confidence": "0.950",
				"name": ".",
				"time": "79.80"
			},
			{
				"duration": "0.14",
				"confidence": "0.960",
				"name": "And",
				"time": "79.94"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "you",
				"time": "80.08"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "also",
				"time": "80.14"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "might",
				"time": "80.38"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "hear",
				"time": "80.53"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "some",
				"time": "80.68"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "traffic",
				"time": "80.83"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "going",
				"time": "81.19"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "by",
				"time": "81.43"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "because",
				"time": "81.64"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "we",
				"time": "81.88"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "live",
				"time": "82.00"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "on",
				"time": "83.17"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "83.32"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "side",
				"time": "83.38"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "road",
				"time": "83.71"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "but",
				"time": "83.98"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "it",
				"time": "84.31"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "does",
				"time": "84.40"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "get",
				"time": "84.64"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "84.79"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "little",
				"time": "84.85"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "noisy",
				"time": "85.09"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "from",
				"time": "85.48"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "time",
				"time": "85.63"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "85.90"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "time",
				"time": "85.99"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "but",
				"time": "86.77"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I'm",
				"time": "86.95"
			},
			{
				"duration": "0.25",
				"confidence": "1.000",
				"name": "back",
				"time": "87.04"
			},
			{
				"duration": "0.10",
				"confidence": "0.600",
				"name": "here",
				"time": "87.29"
			},
			{
				"duration": "0.06",
				"confidence": "0.770",
				"name": "in",
				"time": "87.43"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "my",
				"time": "87.49"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "little",
				"time": "87.64"
			},
			{
				"duration": "0.81",
				"confidence": "1.000",
				"name": "sanctuary",
				"time": "87.88"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "where",
				"time": "88.69"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "88.84"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "teach",
				"time": "88.93"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "89.17"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "lot",
				"time": "89.23"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "89.56"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "my",
				"time": "89.68"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "yoga",
				"time": "90.37"
			},
			{
				"duration": "0.60",
				"confidence": "0.990",
				"name": "retreats",
				"time": "90.76"
			},
			{
				"duration": "0.15",
				"confidence": "0.880",
				"name": "my",
				"time": "91.36"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "yoga",
				"time": "91.51"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "classes",
				"time": "91.78"
			},
			{
				"duration": "0.18",
				"confidence": "0.970",
				"name": "my",
				"time": "93.23"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "different",
				"time": "93.43"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "Reiki",
				"time": "93.76"
			},
			{
				"duration": "0.51",
				"confidence": "0.980",
				"name": "retreats",
				"time": "94.81"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "meditation",
				"time": "95.32"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "courses",
				"time": "95.92"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "all",
				"time": "97.42"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "kinds",
				"time": "97.57"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "97.81"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "stuff",
				"time": "97.87"
			},
			{
				"duration": "0.02",
				"confidence": "0.770",
				"name": ".",
				"time": "98.17"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "So",
				"time": "98.20"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "I'm",
				"time": "98.44"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "back",
				"time": "98.56"
			},
			{
				"duration": "0.36",
				"confidence": "0.990",
				"name": "here",
				"time": "98.83"
			},
			{
				"duration": "0.30",
				"confidence": "0.750",
				"name": ".",
				"time": "99.19"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "This",
				"time": "99.58"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "is",
				"time": "99.79"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "my",
				"time": "99.94"
			},
			{
				"duration": "0.30",
				"confidence": "0.980",
				"name": "zen",
				"time": "100.15"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "space",
				"time": "100.45"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "where",
				"time": "100.81"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "100.93"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "go",
				"time": "101.02"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "101.74"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "just",
				"time": "101.89"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "reconnect",
				"time": "102.10"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "with",
				"time": "102.70"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "nature",
				"time": "102.85"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "which",
				"time": "103.27"
			},
			{
				"duration": "0.12",
				"confidence": "0.980",
				"name": "is",
				"time": "103.51"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "really",
				"time": "103.63"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "the",
				"time": "104.05"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "topic",
				"time": "104.23"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "about",
				"time": "104.71"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "what",
				"time": "106.27"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "106.45"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "wanted",
				"time": "106.54"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "to",
				"time": "106.75"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "share",
				"time": "106.84"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "with",
				"time": "107.05"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "you",
				"time": "107.26"
			},
			{
				"duration": "0.76",
				"confidence": "0.940",
				"name": ".",
				"time": "107.47"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "I",
				"time": "108.28"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "just",
				"time": "108.37"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "finished",
				"time": "108.64"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "doing",
				"time": "109.36"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "some",
				"time": "109.72"
			},
			{
				"duration": "0.42",
				"confidence": "0.990",
				"name": "office",
				"time": "109.99"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "work",
				"time": "110.41"
			},
			{
				"duration": "0.09",
				"confidence": "0.980",
				"name": ".",
				"time": "110.74"
			},
			{
				"duration": "0.27",
				"confidence": "0.980",
				"name": "It's",
				"time": "110.83"
			},
			{
				"duration": "0.09",
				"confidence": "0.980",
				"name": "a",
				"time": "111.19"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "hot",
				"time": "111.28"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "humid",
				"time": "111.61"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "day",
				"time": "111.91"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "here",
				"time": "112.21"
			},
			{
				"duration": "0.09",
				"confidence": "0.980",
				"name": "in",
				"time": "112.39"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "112.48"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "Poconos",
				"time": "112.57"
			},
			{
				"duration": "0.23",
				"confidence": "0.510",
				"name": ".",
				"time": "113.23"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "And",
				"time": "113.68"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "nature",
				"time": "114.94"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "is",
				"time": "115.39"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "a",
				"time": "115.57"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "really",
				"time": "115.63"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "good",
				"time": "115.96"
			},
			{
				"duration": "0.30",
				"confidence": "0.990",
				"name": "way",
				"time": "116.17"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "to",
				"time": "116.47"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "cleanse",
				"time": "116.77"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "and",
				"time": "117.16"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "clear",
				"time": "117.28"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "your",
				"time": "117.64"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "energy",
				"time": "117.85"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "118.39"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "help",
				"time": "118.54"
			},
			{
				"duration": "0.12",
				"confidence": "0.950",
				"name": "you",
				"time": "118.78"
			},
			{
				"duration": "0.13",
				"confidence": "0.830",
				"name": "go",
				"time": "118.90"
			},
			{
				"duration": "0.52",
				"confidence": "0.810",
				"name": "around",
				"time": "119.02"
			},
			{
				"duration": "0.37",
				"confidence": "0.760",
				"name": ".",
				"time": "119.54"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "And",
				"time": "120.01"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "again",
				"time": "120.19"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "these",
				"time": "120.76"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "little",
				"time": "121.30"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "videos",
				"time": "121.78"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "I'm",
				"time": "122.26"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "doing",
				"time": "122.41"
			},
			{
				"duration": "0.18",
				"confidence": "0.990",
				"name": "are",
				"time": "122.77"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "teaching",
				"time": "122.95"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "you",
				"time": "123.37"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "ways",
				"time": "123.46"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "to",
				"time": "123.88"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "take",
				"time": "124.03"
			},
			{
				"duration": "0.60",
				"confidence": "0.680",
				"name": "five",
				"time": "124.36"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "and",
				"time": "124.96"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "breathe",
				"time": "125.14"
			},
			{
				"duration": "0.31",
				"confidence": "0.560",
				"name": "instead",
				"time": "125.98"
			},
			{
				"duration": "0.09",
				"confidence": "0.530",
				"name": "of",
				"time": "126.29"
			},
			{
				"duration": "0.22",
				"confidence": "1.000",
				"name": "just",
				"time": "126.45"
			},
			{
				"duration": "0.28",
				"confidence": "0.750",
				"name": "going",
				"time": "126.90"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "through",
				"time": "127.18"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "everything",
				"time": "127.39"
			},
			{
				"duration": "0.54",
				"confidence": "0.690",
				"name": ".",
				"time": "127.96"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "We",
				"time": "128.50"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "really",
				"time": "128.74"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "need",
				"time": "129.07"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "these",
				"time": "129.34"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "little",
				"time": "129.58"
			},
			{
				"duration": "0.57",
				"confidence": "0.980",
				"name": "resets",
				"time": "129.94"
			},
			{
				"duration": "0.09",
				"confidence": "0.990",
				"name": "and",
				"time": "130.51"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "little",
				"time": "130.60"
			},
			{
				"duration": "0.54",
				"confidence": "0.990",
				"name": "reboots",
				"time": "130.84"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "as",
				"time": "131.38"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "we",
				"time": "131.56"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "go",
				"time": "131.74"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "on",
				"time": "131.98"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "throughout",
				"time": "132.64"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "each",
				"time": "133.54"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "of",
				"time": "133.87"
			},
			{
				"duration": "0.42",
				"confidence": "1.000",
				"name": "our",
				"time": "134.14"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "lovely",
				"time": "134.89"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "lives",
				"time": "135.22"
			},
			{
				"duration": "0.03",
				"confidence": "0.990",
				"name": ".",
				"time": "136.18"
			},
			{
				"duration": "0.06",
				"confidence": "0.990",
				"name": "It",
				"time": "136.80"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "really",
				"time": "136.87"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "helps",
				"time": "137.20"
			},
			{
				"duration": "0.25",
				"confidence": "1.000",
				"name": "to",
				"time": "137.62"
			},
			{
				"duration": "0.63",
				"confidence": "1.000",
				"name": "clear",
				"time": "138.01"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "your",
				"time": "138.88"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "mind",
				"time": "139.03"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "139.63"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "And",
				"time": "140.41"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "to",
				"time": "140.71"
			},
			{
				"duration": "0.21",
				"confidence": "0.980",
				"name": "just",
				"time": "140.83"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "step",
				"time": "141.13"
			},
			{
				"duration": "0.60",
				"confidence": "1.000",
				"name": "forward",
				"time": "141.43"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "in",
				"time": "142.03"
			},
			{
				"duration": "0.03",
				"confidence": "1.000",
				"name": "a",
				"time": "142.21"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "fresh",
				"time": "142.24"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "new",
				"time": "142.60"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "beginning",
				"time": "142.75"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "which",
				"time": "143.14"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "we",
				"time": "143.35"
			},
			{
				"duration": "0.33",
				"confidence": "1.000",
				"name": "really",
				"time": "143.53"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "can",
				"time": "143.86"
			},
			{
				"duration": "0.42",
				"confidence": "0.970",
				"name": "choose",
				"time": "144.04"
			},
			{
				"duration": "0.15",
				"confidence": "0.990",
				"name": "in",
				"time": "144.46"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "every",
				"time": "144.61"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "moment",
				"time": "144.88"
			},
			{
				"duration": "0.03",
				"confidence": "0.920",
				"name": ".",
				"time": "145.18"
			},
			{
				"duration": "0.66",
				"confidence": "1.000",
				"name": "So",
				"time": "145.72"
			},
			{
				"duration": "0.27",
				"confidence": "0.990",
				"name": "here's",
				"time": "146.77"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "where",
				"time": "147.04"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "I",
				"time": "147.25"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "am",
				"time": "147.46"
			},
			{
				"duration": "0.48",
				"confidence": "0.990",
				"name": "today",
				"time": "147.70"
			},
			{
				"duration": "0.33",
				"confidence": "0.640",
				"name": ".",
				"time": "148.18"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "I",
				"time": "148.69"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "am",
				"time": "148.93"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "in",
				"time": "149.11"
			},
			{
				"duration": "0.36",
				"confidence": "1.000",
				"name": "need",
				"time": "149.23"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "of",
				"time": "149.65"
			},
			{
				"duration": "0.71",
				"confidence": "1.000",
				"name": "definitely",
				"time": "149.98"
			},
			{
				"duration": "0.98",
				"confidence": "0.850",
				"name": "peppermint",
				"time": "151.09"
			},
			{
				"duration": "0.77",
				"confidence": "0.730",
				"name": ".",
				"time": "152.08"
			},
			{
				"duration": "0.35",
				"confidence": "0.940",
				"name": "There's",
				"time": "153.10"
			},
			{
				"duration": "0.08",
				"confidence": "0.870",
				"name": "the",
				"time": "153.46"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "peppermint",
				"time": "153.55"
			},
			{
				"duration": "0.62",
				"confidence": "0.530",
				"name": ".",
				"time": "154.06"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "I'm",
				"time": "154.90"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "in",
				"time": "155.11"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "need",
				"time": "155.23"
			},
			{
				"duration": "0.06",
				"confidence": "1.000",
				"name": "of",
				"time": "155.44"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "some",
				"time": "155.50"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "peppermint",
				"time": "155.68"
			},
			{
				"duration": "0.09",
				"confidence": "0.950",
				"name": ".",
				"time": "156.19"
			},
			{
				"duration": "0.54",
				"confidence": "0.990",
				"name": "Why",
				"time": "156.28"
			},
			{
				"duration": "0.06",
				"confidence": "0.920",
				"name": ".",
				"time": "156.82"
			},
			{
				"duration": "0.75",
				"confidence": "1.000",
				"name": "Because",
				"time": "156.88"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "it",
				"time": "157.69"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "is",
				"time": "158.02"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "humid",
				"time": "158.74"
			},
			{
				"duration": "0.18",
				"confidence": "0.890",
				"name": "and",
				"time": "159.76"
			},
			{
				"duration": "0.13",
				"confidence": "0.930",
				"name": "it's",
				"time": "159.96"
			},
			{
				"duration": "0.56",
				"confidence": "1.000",
				"name": "sticky",
				"time": "160.09"
			},
			{
				"duration": "0.24",
				"confidence": "0.990",
				"name": "and",
				"time": "161.14"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "when",
				"time": "161.38"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "you",
				"time": "161.56"
			},
			{
				"duration": "0.35",
				"confidence": "0.910",
				"name": "place",
				"time": "161.68"
			},
			{
				"duration": "0.37",
				"confidence": "1.000",
				"name": "some",
				"time": "162.03"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "drops",
				"time": "162.40"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "162.79"
			},
			{
				"duration": "0.57",
				"confidence": "1.000",
				"name": "peppermint",
				"time": "162.91"
			},
			{
				"duration": "0.45",
				"confidence": "1.000",
				"name": "on",
				"time": "163.48"
			},
			{
				"duration": "0.09",
				"confidence": "1.000",
				"name": "the",
				"time": "164.38"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "back",
				"time": "164.47"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "of",
				"time": "164.74"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "your",
				"time": "164.86"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "neck",
				"time": "165.01"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "165.4"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "You",
				"time": "167.80"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "will",
				"time": "168.04"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "feel",
				"time": "168.28"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "168.79"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "Just",
				"time": "169.75"
			},
			{
				"duration": "0.87",
				"confidence": "1.000",
				"name": "sensational",
				"time": "170.05"
			},
			{
				"duration": "0.12",
				"confidence": "0.800",
				"name": "and",
				"time": "170.97"
			},
			{
				"duration": "0.12",
				"confidence": "0.780",
				"name": "up",
				"time": "171.17"
			},
			{
				"duration": "0.18",
				"confidence": "0.450",
				"name": "two",
				"time": "171.34"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "seconds",
				"time": "171.52"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "your",
				"time": "172.96"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "whole",
				"time": "173.14"
			},
			{
				"duration": "0.39",
				"confidence": "1.000",
				"name": "body",
				"time": "173.35"
			},
			{
				"duration": "0.21",
				"confidence": "1.000",
				"name": "will",
				"time": "173.74"
			},
			{
				"duration": "0.39",
				"confidence": "0.610",
				"name": "fall",
				"time": "173.95"
			},
			{
				"duration": "0.48",
				"confidence": "1.000",
				"name": "down",
				"time": "174.34"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "and",
				"time": "175.36"
			},
			{
				"duration": "0.24",
				"confidence": "0.970",
				"name": "you'll",
				"time": "176.68"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "be",
				"time": "176.92"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "able",
				"time": "177.10"
			},
			{
				"duration": "0.18",
				"confidence": "1.000",
				"name": "to",
				"time": "177.40"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "just",
				"time": "177.58"
			},
			{
				"duration": "0.54",
				"confidence": "1.000",
				"name": "feel",
				"time": "177.88"
			},
			{
				"duration": "0.24",
				"confidence": "1.000",
				"name": "like",
				"time": "178.69"
			},
			{
				"duration": "0.30",
				"confidence": "1.000",
				"name": "this",
				"time": "178.93"
			},
			{
				"duration": "0.69",
				"confidence": "1.000",
				"name": "warm",
				"time": "179.44"
			},
			{
				"duration": "0",
				"confidence": "1.000",
				"name": ".",
				"time": "180.13"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "Cooling",
				"time": "181.90"
			},
			{
				"duration": "0.72",
				"confidence": "1.000",
				"name": "effect",
				"time": "182.41"
			},
			{
				"duration": "0.27",
				"confidence": "1.000",
				"name": "on",
				"time": "183.37"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "the",
				"time": "183.64"
			},
			{
				"duration": "0.51",
				"confidence": "1.000",
				"name": "skin",
				"time": "183.76"
			},
			{
				"duration": "0.15",
				"confidence": "1.000",
				"name": "and",
				"time": "184.36"
			},
			{
				"duration": "0.12",
				"confidence": "1.000",
				"name": "it",
				"time": "184.51"
			},
			{
				"duration": "0.17",
				"confidence": "0.930",
				"name": "it",
				"time": "184.78"
			},
			{
				"duration": "0.00",
				"confidence": "1.000",
				"name": ".",
				"time": "184.95"
			}
		],
		"format": "1.0"
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.14.3
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var css = getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
	}
	
	function getWindowSizes() {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && parent.nodeName === 'HTML') {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  return isFixed(getParentNode(element));
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  boundaries.left += padding;
	  boundaries.top += padding;
	  boundaries.right -= padding;
	  boundaries.bottom -= padding;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var styles = getComputedStyle(element);
	  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
	  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroy the popper
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger onUpdate callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  // Avoid blurry text by using full pixel integers.
	  // For pixel-perfect positioning, top/bottom prefers rounded
	  // values, while left/right prefers floored values.
	  var offsets = {
	    left: Math.floor(popper.left),
	    top: Math.round(popper.top),
	    bottom: Math.round(popper.bottom),
	    right: Math.floor(popper.right)
	  };
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    top = -offsetParentRect.height + offsets.bottom;
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    left = -offsetParentRect.width + offsets.right;
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjuction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-right` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unitless, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the height.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * An scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper this makes sure the popper has always a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier, can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near eachothers
	   * without leaving any gap between the two. Expecially useful when the arrow is
	   * enabled and you want to assure it to point to its reference element.
	   * It cares only about the first axis, you can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjuction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations).
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position,
	     * the popper will never be placed outside of the defined boundaries
	     * (except if keepTogether is enabled)
	     */
	    boundariesElement: 'viewport'
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define you own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the informations used by Popper.js
	 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overriden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass as 3rd argument an object with the same
	 * structure of this object, example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated, this callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Create a new Popper.js instance
	   * @class Popper
	   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
	   * @param {HTMLElement} popper - The HTML element used as popper.
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedule an update, it will run on the next UI update available
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(2);
	var invariant = __webpack_require__(3);
	var ReactPropTypesSecret = __webpack_require__(37);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(35)();
	}


/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.4.1
	 * react-dom.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(3),ba=__webpack_require__(1),m=__webpack_require__(17),p=__webpack_require__(4),v=__webpack_require__(2),da=__webpack_require__(19),ea=__webpack_require__(22),fa=__webpack_require__(18),ha=__webpack_require__(5);
	function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
	function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
	var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
	B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
	function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
	function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
	var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
	function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
	function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
	function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
	return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
	function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
	function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
	function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
	function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
	var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
	var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
	function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
	function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
	var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
	p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
	destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
	function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
	var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
	function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
	function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
	var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
	f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
	function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
	var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
	function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
	var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
	60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
	function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
	a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
	var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},zc={};function Ac(a){if(zc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return zc[a]=!0;xc[a]=!0;return!1}
	function Bc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Cc(a,b,c,d){if(null===b||"undefined"===typeof b||Bc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
	function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});
	[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});
	"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});
	["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Dc=/[\-:]([a-z])/g;function Ec(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Dc,
	Ec);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
	function Fc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Cc(b,c,e,d)&&(c=null),d||null===e?Ac(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function Gc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Hc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ic(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Jc(a,b){b=b.checked;null!=b&&Fc(a,"checked",b,!1)}
	function Kc(a,b){Jc(a,b);var c=Ic(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Lc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Lc(a,b.type,Ic(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Mc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Lc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
	function Ic(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Nc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Oc(a,b,c){a=H.getPooled(Nc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Pc=null,Qc=null;function Rc(a){Ia(a,!1)}function Sc(a){var b=Oa(a);if(dc(b))return a}
	function Tc(a,b){if("change"===a)return b}var Uc=!1;m.canUseDOM&&(Uc=$b("input")&&(!document.documentMode||9<document.documentMode));function Vc(){Pc&&(Pc.detachEvent("onpropertychange",Wc),Qc=Pc=null)}function Wc(a){"value"===a.propertyName&&Sc(Qc)&&(a=Oc(Qc,a,Zb(a)),Wb(Rc,a))}function Xc(a,b,c){"focus"===a?(Vc(),Pc=b,Qc=c,Pc.attachEvent("onpropertychange",Wc)):"blur"===a&&Vc()}function Yc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Sc(Qc)}
	function Zc(a,b){if("click"===a)return Sc(b)}function $c(a,b){if("input"===a||"change"===a)return Sc(b)}
	var ad={eventTypes:Nc,_isInputEventSupported:Uc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Tc:Yb(e)?Uc?f=$c:(f=Yc,g=Xc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Zc);if(f&&(f=f(a,b)))return Oc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Lc(e,"number",e.value)}},bd=H.extend({view:null,detail:null}),cd={Alt:"altKey",
	Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}
	var fd=bd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),gd=fd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),hd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
	mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},id={eventTypes:hd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
	e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=fd,h=hd.mouseLeave,k=hd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=gd,h=hd.pointerLeave,k=hd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
	c,f,b);return[h,c]}};function jd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function kd(a){2!==jd(a)?A("188"):void 0}
	function ld(a){var b=a.alternate;if(!b)return b=jd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return kd(e),a;if(g===d)return kd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function md(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function nd(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var od=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=bd.extend({relatedTarget:null});
	function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=bd.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===
	a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=fd.extend({dataTransfer:null}),wd=bd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed}),xd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=fd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
	["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
	["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
	[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
	["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
	var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=fd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case fb:case gb:case hb:a=od;break;case ib:a=xd;break;case "scroll":a=bd;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=gd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
	Fd=[];function Gd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Hd=!0;function Id(a){Hd=!!a}function K(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!1)}
	function Md(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!0)}function Kd(a,b){Tb(Ld,a,b)}function Ld(a,b){if(Hd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===jd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}
	var Nd={get _enabled(){return Hd},setEnabled:Id,isEnabled:function(){return Hd},trapBubbledEvent:K,trapCapturedEvent:Md,dispatchEvent:Ld},Od={},Pd=0,Qd="_reactListenersID"+(""+Math.random()).slice(2);function Rd(a){Object.prototype.hasOwnProperty.call(a,Qd)||(a[Qd]=Pd++,Od[a[Qd]]={});return Od[a[Qd]]}function Sd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Td(a,b){var c=Sd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Sd(c)}}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	var Vd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
	function ae(a,b){if($d||null==Xd||Xd!==da())return null;var c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Zd&&ea(Zd,c)?null:(Zd=c,a=H.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ya(a),a)}
	var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Rd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
	case "keydown":case "keyup":return ae(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:id,ChangeEventPlugin:ad,SelectEventPlugin:be,BeforeInputEventPlugin:Ib});
	var ce="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,de=Date,ee=setTimeout,fe=clearTimeout,ge=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var he=performance;ge=function(){return he.now()}}else ge=function(){return de.now()};var ie=void 0,je=void 0;
	if(m.canUseDOM){var ke="function"===typeof ce?ce:function(){A("276")},L=null,le=null,me=-1,ne=!1,oe=!1,pe=0,qe=33,re=33,se={didTimeout:!1,timeRemaining:function(){var a=pe-ge();return 0<a?a:0}},ue=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{je(a),d||(ne=!0,window.postMessage(te,"*"))}},te="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===te&&(ne=!1,null!==L)){if(null!==L){var b=ge();if(!(-1===
	me||me>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(se.didTimeout=!0,b=0,d=c.length;b<d;b++)ue(c[b],se);me=a}}for(a=ge();0<pe-a&&null!==L;)a=L,se.didTimeout=!1,ue(a,se),a=ge();null===L||oe||(oe=!0,ke(ve))}},!1);var ve=function(a){oe=!1;var b=a-pe+re;b<re&&qe<re?(8>b&&(b=8),re=b<qe?qe:b):qe=b;pe=a+re;ne||(ne=!0,window.postMessage(te,"*"))};ie=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=ge()+
	b.timeout);if(-1===me||-1!==c&&c<me)me=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=le,null!==b&&(b.next=a));le=a;oe||(oe=!0,ke(ve));return a};je=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,le=c):le=L=null}}}else{var we=new Map;ie=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=ee(function(){a({timeRemaining:function(){return Infinity},
	didTimeout:!1})});we.set(a,c);return b};je=function(a){var b=we.get(a.scheduledCallback);we.delete(a);fe(b)}}function xe(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ye(a,b){a=p({children:void 0},b);if(b=xe(b.children))a.children=b;return a}
	function ze(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ae(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Be(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
	function De(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function He(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Ie=void 0,Je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Fe.svg||"innerHTML"in a)a.innerHTML=b;else{Ie=Ie||document.createElement("div");Ie.innerHTML="<svg>"+b+"</svg>";for(b=Ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var Le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
	stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Me=["Webkit","ms","Moz","O"];Object.keys(Le).forEach(function(a){Me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Le[b]=Le[a]})});
	function Ne(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Le.hasOwnProperty(e)&&Le[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Oe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function Pe(a,b,c){b&&(Oe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
	function Qe(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Re=v.thatReturns("");
	function Se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Rd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Md("scroll",a);break;case "focus":case "blur":Md("focus",a);Md("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Md(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
	function Te(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Fe.html&&(d=Ge(a));d===Fe.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ue(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
	function Ve(a,b,c,d){var e=Qe(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Hc(a,c);f=Gc(a,c);K("invalid",a);Se(d,"onChange");break;case "option":f=ye(a,c);break;case "select":Ae(a,c);f=p({},c,{value:void 0});
	K("invalid",a);Se(d,"onChange");break;case "textarea":Ce(a,c);f=Be(a,c);K("invalid",a);Se(d,"onChange");break;default:f=c}Pe(b,f,Re);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Ne(a,k,Re):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Je(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ke(a,k):"number"===typeof k&&Ke(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Se(d,
	h):null!=k&&Fc(a,h,k,e))}switch(b){case "input":cc(a);Mc(a,c,!1);break;case "textarea":cc(a);Ee(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ze(a,!!c.multiple,b,!1):null!=c.defaultValue&&ze(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
	function We(a,b,c,d,e){var f=null;switch(b){case "input":c=Gc(a,c);d=Gc(a,d);f=[];break;case "option":c=ye(a,c);d=ye(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Be(a,c);d=Be(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Pe(b,d,Re);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
	(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
	g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Se(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
	function Xe(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Jc(a,e);Qe(c,d);d=Qe(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Ne(a,h,Re):"dangerouslySetInnerHTML"===g?Je(a,h):"children"===g?Ke(a,h):Fc(a,g,h,d)}switch(c){case "input":Kc(a,e);break;case "textarea":De(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ze(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
	ze(a,!!e.multiple,e.defaultValue,!0):ze(a,!!e.multiple,e.multiple?[]:"",!1))}}
	function Ye(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Hc(a,c);K("invalid",a);Se(e,"onChange");break;case "select":Ae(a,c);K("invalid",a);Se(e,"onChange");break;case "textarea":Ce(a,c),K("invalid",a),Se(e,"onChange")}Pe(b,
	c,Re);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Se(e,f)}switch(b){case "input":cc(a);Mc(a,c,!0);break;case "textarea":cc(a);Ee(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ze(a,b){return a.nodeValue!==b}
	var $e={createElement:Te,createTextNode:Ue,setInitialProperties:Ve,diffProperties:We,updateProperties:Xe,diffHydratedProperties:Ye,diffHydratedText:Ze,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Kc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
	c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Kc(d,e)}}}break;case "textarea":De(a,c);break;case "select":b=c.value,null!=b&&ze(a,!!c.multiple,b,!1)}}},af=null,bf=null;function cf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function df(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ef=ge,ff=ie,gf=je;function hf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function jf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var kf=[],lf=-1;function mf(a){return{current:a}}
	function M(a){0>lf||(a.current=kf[lf],kf[lf]=null,lf--)}function N(a,b){lf++;kf[lf]=a.current;a.current=b}var nf=mf(ha),O=mf(!1),of=ha;function pf(a){return qf(a)?of:nf.current}
	function rf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function qf(a){return 2===a.tag&&null!=a.type.childContextTypes}function sf(a){qf(a)&&(M(O,a),M(nf,a))}function tf(a){M(O,a);M(nf,a)}
	function uf(a,b,c){nf.current!==ha?A("168"):void 0;N(nf,b,a);N(O,c,a)}function vf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function wf(a){if(!qf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;of=nf.current;N(nf,b,a);N(O,O.current,a);return!0}
	function xf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=vf(a,of);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(nf,a);N(nf,d,a)}else M(O,a);N(O,b,a)}
	function yf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
	function zf(a,b,c){var d=a.alternate;null===d?(d=new yf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
	function Af(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Bf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new yf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
	d:typeof d,"")}f=void 0}}b=new yf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Bf(a,b,c,d){a=new yf(10,a,d,b);a.expirationTime=c;return a}function Cf(a,b,c){a=new yf(6,a,null,b);a.expirationTime=c;return a}function Df(a,b,c){b=new yf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function Ef(a,b,c){b=new yf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Ff=null,Gf=null;function Hf(a){return function(b){try{return a(b)}catch(c){}}}
	function If(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ff=Hf(function(a){return b.onCommitFiberRoot(c,a)});Gf=Hf(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Jf(a){"function"===typeof Ff&&Ff(a)}function Kf(a){"function"===typeof Gf&&Gf(a)}var Lf=!1;
	function Mf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Nf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function Of(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Pf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
	function Qf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Mf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Mf(a.memoizedState),f=d.updateQueue=Mf(d.memoizedState)):e=a.updateQueue=Nf(f):null===f&&(f=d.updateQueue=Nf(e));null===f||e===f?Pf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Pf(e,b,c),Pf(f,b,c)):(Pf(e,b,c),f.lastUpdate=b)}
	function Rf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Mf(a.memoizedState):Sf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Sf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Nf(b));return b}
	function Tf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Lf=!0}return d}
	function Uf(a,b,c,d,e){Lf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Sf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
	g&&(f=n)),0===h||h>w)h=w}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
	function Vf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
	function Wf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Vf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Vf(b,c)),a=a.nextEffect}
	function Xf(a,b){return{value:a,source:b,stack:vc(b)}}var Yf=mf(null),Zf=mf(null),$f=mf(0);function ag(a){var b=a.type._context;N($f,b._changedBits,a);N(Zf,b._currentValue,a);N(Yf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function bg(a){var b=$f.current,c=Zf.current;M(Yf,a);M(Zf,a);M($f,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var cg={},dg=mf(cg),eg=mf(cg),fg=mf(cg);function gg(a){a===cg?A("174"):void 0;return a}
	function ig(a,b){N(fg,b,a);N(eg,a,a);N(dg,cg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:He(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=He(b,c)}M(dg,a);N(dg,b,a)}function jg(a){M(dg,a);M(eg,a);M(fg,a)}function kg(a){eg.current===a&&(M(dg,a),M(eg,a))}function lg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
	var pg={isMounted:function(a){return(a=a._reactInternalFiber)?2===jd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=mg();c=ng(c,a);var d=Of(c);d.tag=2;void 0!==
	b&&null!==b&&(d.callback=b);Qf(a,d,c);og(a,c)}};function qg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
	function rg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&pg.enqueueReplaceState(b,b.state,null)}
	function sg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=pf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=rf(a,f);f=a.updateQueue;null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(lg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
	d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&pg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var tg=Array.isArray;
	function ug(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
	function vg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function wg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=zf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Cf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=ug(a,b,c),d.return=a,d;d=Af(c,a.mode,d);d.ref=ug(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
	Df(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Bf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Cf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Af(b,a.mode,c),c.ref=ug(a,null,b),c.return=a,c;case hc:return b=Df(b,a.mode,c),b.return=a,b}if(tg(b)||tc(b))return b=Bf(b,a.mode,c,null),b.return=
	a,b;vg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(tg(c)||tc(c))return null!==e?null:r(a,b,c,d,null);vg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
	if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(tg(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);vg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
	t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
	g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
	t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=ug(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Bf(f.props.children,
	a.mode,h,f.key),d.return=a,a=d):(h=Af(f,a.mode,h),h.ref=ug(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Df(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
	a,a=d):(c(a,d),d=Cf(f,a.mode,h),d.return=a,a=d),g(a);if(tg(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&vg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var xg=wg(!0),yg=wg(!1),zg=null,Ag=null,Bg=!1;function Cg(a,b){var c=new yf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Dg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Eg(a){if(Bg){var b=Ag;if(b){var c=b;if(!Dg(a,b)){b=hf(c);if(!b||!Dg(a,b)){a.effectTag|=2;Bg=!1;zg=a;return}Cg(zg,c)}zg=a;Ag=jf(b)}else a.effectTag|=2,Bg=!1,zg=a}}
	function Fg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;zg=a}function Gg(a){if(a!==zg)return!1;if(!Bg)return Fg(a),Bg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!df(b,a.memoizedProps))for(b=Ag;b;)Cg(a,b),b=hf(b);Fg(a);Ag=zg?hf(a.stateNode):null;return!0}function Hg(){Ag=zg=null;Bg=!1}function Q(a,b,c){Ig(a,b,c,b.expirationTime)}function Ig(a,b,c,d){b.child=null===a?yg(b,null,c,d):xg(b,a.child,c,d)}
	function Jg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Kg(a,b,c,d,e){Jg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&xf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Ig(a,b,null,e),b.child=null);Ig(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&xf(b,!0);return b.child}
	function Lg(a){var b=a.stateNode;b.pendingContext?uf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&uf(a,b.context,!1);ig(a,b.containerInfo)}
	function Mg(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
	e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
	function Qg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,ag(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
	h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b)}else Mg(b,d,h,c)}b.stateNode=h;ag(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=zf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=zf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
	function Rg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Lg(b);break;case 2:wf(b);break;case 4:ig(b,b.stateNode.containerInfo);break;case 13:ag(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=pf(b);f=rf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
	typeof f&&lg(b,f,e),e=wf(b),d.updater=pg,b.stateNode=d,d._reactInternalFiber=b,sg(b,c),a=Kg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=pf(b),d=rf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=wf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=pf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?rf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
	g.state&&void 0!==g.state?g.state:null;g.updater=pg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);sg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=pf(b);g=rf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
	(k!==f||n!==g)&&rg(b,d,f,g);Lf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Uf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Lf?("function"===typeof r&&(lg(b,r,f),n=b.memoizedState),(k=Lf||qg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
	(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=pf(b),g=rf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
	(f!==k||n!==g)&&rg(b,d,k,g),Lf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Uf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Lf?("function"===typeof r&&(lg(b,r,k),w=b.memoizedState),(r=Lf||qg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
	(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
	f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Kg(a,b,d,e,c);case 3:Lg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Uf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Hg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Ag=jf(b.stateNode.containerInfo),zg=b,d=Bg=!0;d?(b.effectTag|=2,b.child=yg(b,null,e,c)):(Hg(),Q(a,b,e));a=b.child}else Hg(),a=R(a,b);return a;case 5:a:{gg(fg.current);e=gg(dg.current);d=He(e,
	b.type);e!==d&&(N(eg,b,b),N(dg,d,b));null===a&&Eg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;df(e,d)?k=null:f&&df(e,f)&&(b.effectTag|=16);Jg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Eg(b),b.memoizedProps=b.pendingProps,
	null;case 16:return null;case 4:return ig(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=xg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
	b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Qg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Mg(b,d,g,c);else if(k===f){a=
	R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Sg(a){a.effectTag|=4}var Tg=void 0,Ug=void 0,Vg=void 0;Tg=function(){};Ug=function(a,b,c){(b.updateQueue=c)&&Sg(b)};Vg=function(a,b,c,d){c!==d&&Sg(b)};
	function Wg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return sf(b),null;case 3:jg(b);tf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Gg(b),b.effectTag&=-3;Tg(b);return null;case 5:kg(b);d=gg(fg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=gg(dg.current);g=We(g,e,f,c,d);Ug(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
	A("166"):void 0,null;a=gg(dg.current);if(Gg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ye(c,e,f,a,d),b.updateQueue=d,null!==d&&Sg(b);else{a=Te(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Ve(a,e,c,d);cf(e,c)&&Sg(b);b.stateNode=
	a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Vg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=gg(fg.current);gg(dg.current);Gg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ze(d,c)&&Sg(b)):(d=Ue(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return jg(b),Tg(b),null;case 13:return bg(b),null;case 12:return null;case 0:A("167");
	default:A("156")}}function Xg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Yg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Zg(a,c)}else b.current=null}
	function $g(a){"function"===typeof Kf&&Kf(a);switch(a.tag){case 2:Yg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Zg(a,c)}break;case 5:Yg(a);break;case 4:ah(a)}}function bh(a){return 5===a.tag||3===a.tag||4===a.tag}
	function ch(a){a:{for(var b=a.return;null!==b;){if(bh(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||bh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
	e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function ah(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if($g(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
	(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:$g(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
	function dh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Xe(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function eh(a,b,c){c=Of(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){fh(d);Xg(a,b)};return c}
	function gh(a,b,c){c=Of(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===hh?hh=new Set([this]):hh.add(this);var c=b.value,d=b.stack;Xg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
	function ih(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Xf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=eh(a,d,f);Rf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===hh||!hh.has(c))){a.effectTag|=1024;d=gh(a,b,f);Rf(a,d,f);return}}a=a.return}while(null!==a)}
	function jh(a){switch(a.tag){case 2:sf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return jg(a),tf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return kg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return jg(a),null;case 13:return bg(a),null;default:return null}}var kh=ef(),lh=2,mh=kh,nh=0,oh=0,ph=!1,S=null,qh=null,T=0,rh=-1,sh=!1,U=null,th=!1,uh=!1,hh=null;
	function vh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:sf(b);break;case 3:jg(b);tf(b);break;case 5:kg(b);break;case 4:jg(b);break;case 13:bg(b)}a=a.return}qh=null;T=0;rh=-1;sh=!1;S=null;uh=!1}
	function wh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Wg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
	(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{uh=!0;break}}else{a=jh(a,sh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
	function xh(a){var b=Rg(a.alternate,a,T);null===b&&(b=wh(a));ec.current=null;return b}
	function yh(a,b,c){ph?A("243"):void 0;ph=!0;if(b!==T||a!==qh||null===S)vh(),qh=a,T=b,rh=-1,S=zf(qh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;sh=!c||T<=lh;do{try{if(c)for(;null!==S&&!zh();)S=xh(S);else for(;null!==S;)S=xh(S)}catch(f){if(null===S)d=!0,fh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;fh(f);break}ih(a,e,c,f,sh,T,mh);S=wh(c)}}break}while(1);ph=!1;if(d)return null;if(null===S){if(uh)return a.pendingCommitExpirationTime=b,a.current.alternate;sh?A("262"):
	void 0;0<=rh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Ah(a,b)},rh);Bh(a.current.expirationTime)}return null}
	function Zg(a,b){var c;a:{ph&&!th?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===hh||!hh.has(d))){a=Xf(b,a);a=gh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}break;case 3:a=Xf(b,a);a=eh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Xf(b,a),c=eh(a,c,1),Qf(a,c,1),og(a,1));c=void 0}return c}
	function Ch(){var a=2+25*(((mg()-2+500)/25|0)+1);a<=nh&&(a=nh+1);return nh=a}function ng(a,b){a=0!==oh?oh:ph?th?1:T:b.mode&1?Dh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Dh&&(0===Eh||a>Eh)&&(Eh=a);return a}
	function og(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!ph&&0!==T&&b<T&&vh();var d=c.current.expirationTime;ph&&!th&&qh===c||Ah(c,d);Fh>Gh&&A("185")}else break;a=a.return}}function mg(){mh=ef()-kh;return lh=(mh/10|0)+2}
	function Hh(a){var b=oh;oh=2+25*(((mg()-2+500)/25|0)+1);try{return a()}finally{oh=b}}function Ih(a,b,c,d,e){var f=oh;oh=1;try{return a(b,c,d,e)}finally{oh=f}}var Jh=null,V=null,Kh=0,Lh=void 0,W=!1,X=null,Y=0,Eh=0,Mh=!1,Nh=!1,Oh=null,Ph=null,Z=!1,Qh=!1,Dh=!1,Rh=null,Gh=1E3,Fh=0,Sh=1;function Th(a){if(0!==Kh){if(a>Kh)return;null!==Lh&&gf(Lh)}var b=ef()-kh;Kh=a;Lh=ff(Uh,{timeout:10*(a-2)-b})}
	function Ah(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Jh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Jh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Qh&&(X=a,Y=1,Vh(a,1,!1)):1===b?Wh():Th(b))}
	function Xh(){var a=0,b=null;if(null!==V)for(var c=V,d=Jh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Jh=V=d.nextScheduledRoot=null;break}else if(d===Jh)Jh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Jh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
	c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Fh++:Fh=0;X=b;Y=a}function Uh(a){Yh(0,!0,a)}function Wh(){Yh(1,!1,null)}function Yh(a,b,c){Ph=c;Xh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Mh||mg()>=Y);)mg(),Vh(X,Y,!Mh),Xh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Vh(X,Y,!1),Xh();null!==Ph&&(Kh=0,Lh=null);0!==Y&&Th(Y);Ph=null;Mh=!1;Zh()}function $h(a,b){W?A("253"):void 0;X=a;Y=b;Vh(a,b,!1);Wh();Zh()}
	function Zh(){Fh=0;if(null!==Rh){var a=Rh;Rh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Nh||(Nh=!0,Oh=d)}}}if(Nh)throw a=Oh,Oh=null,Nh=!1,a;}function Vh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!0),null!==c&&(zh()?a.finishedWork=c:ai(a,c,b)))):(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!1),null!==c&&ai(a,c,b)));W=!1}
	function ai(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Rh?Rh=[d]:Rh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;th=ph=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;mg();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;af=Hd;var f=da();if(Ud(f)){if("selectionStart"in
	f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
	++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;bf={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var mi=ja.getSnapshotBeforeUpdate(y,
	D);ja.__reactInternalSnapshotBeforeUpdate=mi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Zg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ke(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:ch(U);U.effectTag&=-3;break;case 6:ch(U);U.effectTag&=-3;dh(U.alternate,
	U);break;case 4:dh(U.alternate,U);break;case 8:D=U,ah(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Zg(U,y),null!==U&&(U=U.nextEffect))}l=bf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Ud(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
	y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Td(q,l),D=Td(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
	top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}bf=null;Id(af);af=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var hg=U.effectTag;if(hg&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var wi=oc.memoizedProps,xi=oc.memoizedState;ca.props=l.memoizedProps;
	ca.state=l.memoizedState;ca.componentDidUpdate(wi,xi,ca.__reactInternalSnapshotBeforeUpdate)}var Ng=l.updateQueue;null!==Ng&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Wf(l,Ng,ca,u));break;case 3:var Og=l.updateQueue;if(null!==Og){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Wf(l,Og,y,u)}break;case 5:var yi=l.stateNode;null===oc&&l.effectTag&4&&cf(l.type,l.memoizedProps)&&yi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
	default:A("163")}}if(hg&128){l=void 0;var yc=U.ref;if(null!==yc){var Pg=U.stateNode;switch(U.tag){case 5:l=Pg;break;default:l=Pg}"function"===typeof yc?yc(l):yc.current=l}}var zi=U.nextEffect;U.nextEffect=null;U=zi}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Zg(U,q),null!==U&&(U=U.nextEffect))}ph=th=!1;"function"===typeof Jf&&Jf(b.stateNode);b=c.current.expirationTime;0===b&&(hh=null);a.remainingExpirationTime=b}function zh(){return null===Ph||Ph.timeRemaining()>Sh?!1:Mh=!0}
	function fh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Nh||(Nh=!0,Oh=a)}function Bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function bi(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Wh()}}function ci(a,b){if(Z&&!Qh){Qh=!0;try{return a(b)}finally{Qh=!1}}return a(b)}function di(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Ih(a,b)}finally{Z=c,Wh()}}
	function ei(a,b,c){if(Dh)return a(b,c);Z||W||0===Eh||(Yh(Eh,!1,null),Eh=0);var d=Dh,e=Z;Z=Dh=!0;try{return a(b,c)}finally{Dh=d,(Z=e)||W||Wh()}}function fi(a){var b=Z;Z=!0;try{Ih(a)}finally{(Z=b)||W||Yh(1,!1,null)}}
	function gi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===jd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(qf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=qf(c)?vf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Of(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Qf(f,e,d);og(f,d);return d}
	function hi(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=md(b);return null===a?null:a.stateNode}function ii(a,b,c,d){var e=b.current,f=mg();e=ng(f,e);return gi(a,b,c,e,d)}function ji(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
	function ki(a){var b=a.findFiberByHostInstance;return If(p({},a,{findHostInstanceByFiber:function(a){a=md(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
	var li={updateContainerAtExpirationTime:gi,createContainer:function(a,b,c){return Ef(a,b,c)},updateContainer:ii,flushRoot:$h,requestWork:Ah,computeUniqueAsyncExpiration:Ch,batchedUpdates:bi,unbatchedUpdates:ci,deferredUpdates:Hh,syncUpdates:Ih,interactiveUpdates:ei,flushInteractiveUpdates:function(){W||0===Eh||(Yh(Eh,!1,null),Eh=0)},flushControlled:fi,flushSync:di,getPublicRootInstance:ji,findHostInstance:hi,findHostInstanceWithNoPortals:function(a){a=nd(a);return null===a?null:a.stateNode},injectIntoDevTools:ki};
	function ni(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent($e);function oi(a){this._expirationTime=Ch();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
	oi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new pi;gi(a,b,null,c,d._onCommit);return d};oi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	oi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;$h(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
	null,this._defer=!1};oi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function pi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}pi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	pi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function qi(a,b,c){this._internalRoot=Ef(a,b,c)}qi.prototype.render=function(a,b){var c=this._internalRoot,d=new pi;b=void 0===b?null:b;null!==b&&d.then(b);ii(a,c,null,d._onCommit);return d};
	qi.prototype.unmount=function(a){var b=this._internalRoot,c=new pi;a=void 0===a?null:a;null!==a&&c.then(a);ii(null,b,null,c._onCommit);return c};qi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new pi;c=void 0===c?null:c;null!==c&&e.then(c);ii(b,d,a,e._onCommit);return e};
	qi.prototype.createBatch=function(){var a=new oi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ri(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=li.batchedUpdates;Tb=li.interactiveUpdates;Ub=li.flushInteractiveUpdates;
	function si(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qi(a,!1,b)}
	function ti(a,b,c,d,e){ri(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ji(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=si(c,d);if("function"===typeof e){var h=e;e=function(){var a=ji(f._internalRoot);h.call(a)}}ci(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ji(f._internalRoot)}
	function ui(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ri(b)?void 0:A("200");return ni(a,b,null,c)}
	var vi={createPortal:ui,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:hi(a)},hydrate:function(a,b,c){return ti(null,a,b,!0,c)},render:function(a,b,c){return ti(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ti(a,b,c,!1,d)},unmountComponentAtNode:function(a){ri(a)?void 0:A("40");return a._reactRootContainer?(ci(function(){ti(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return ui.apply(void 0,
	arguments)},unstable_batchedUpdates:bi,unstable_deferredUpdates:Hh,unstable_interactiveUpdates:ei,flushSync:di,unstable_flushControlled:fi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Nd},unstable_createRoot:function(a,b){return new qi(a,!0,null!=b&&!0===b.hydrate)}};ki({findFiberByHostInstance:Na,bundleType:0,version:"16.4.1",rendererPackageName:"react-dom"});
	var Ai={default:vi},Bi=Ai&&vi||Ai;module.exports=Bi.default?Bi.default:Bi;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(41).enable();
	  window.Promise = __webpack_require__(40);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(42);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(4);


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(8);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(8);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 42 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 43 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	
	    return event || !!ele.getAttribute('data-event');
	  };
	
	  /* Bind listener for custom event */
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _state = this.state,
	        event = _state.event,
	        eventOff = _state.eventOff;
	
	    var dataEvent = ele.getAttribute('data-event') || event;
	    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
	
	    dataEvent.split(' ').forEach(function (event) {
	      ele.removeEventListener(event, customListeners.get(ele, event));
	      var customListener = checkStatus.bind(_this, dataEventOff);
	      customListeners.set(ele, event, customListener);
	      ele.addEventListener(event, customListener, false);
	    });
	    if (dataEventOff) {
	      dataEventOff.split(' ').forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	
	  /* Unbind listener for custom event */
	  target.prototype.customUnbindListener = function (ele) {
	    var _state2 = this.state,
	        event = _state2.event,
	        eventOff = _state2.eventOff;
	
	    var dataEvent = event || ele.getAttribute('data-event');
	    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
	
	    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	};
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	
	  var dataIsCapture = e.currentTarget.getAttribute('data-iscapture');
	  var isCapture = dataIsCapture && dataIsCapture === 'true' || this.props.isCapture;
	  var currentItem = e.currentTarget.getAttribute('currentItem');
	
	  if (!isCapture) e.stopPropagation();
	  if (show && currentItem === 'true') {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute('currentItem', 'true');
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute('currentItem', 'false');
	    } else {
	      targetArray[i].setAttribute('currentItem', 'true');
	    }
	  }
	};
	
	var customListeners = {
	  id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
	  set: function set(target, event, listener) {
	    if (this.id in target) {
	      var map = target[this.id];
	      map[event] = listener;
	    } else {
	      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
	      Object.defineProperty(target, this.id, {
	        configurable: true,
	        value: _defineProperty({}, event, listener)
	      });
	    }
	  },
	  get: function get(target, event) {
	    var map = target[this.id];
	    if (map !== undefined) {
	      return map[event];
	    }
	  }
	};

/***/ },
/* 44 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute('data-effect');
	    return dataEffect || this.props.effect || 'float';
	  };
	};

/***/ },
/* 45 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
	  };
	};

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
	  };
	
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	  target.rebuild = function () {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
	  };
	
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	  target.show = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      var e = { currentTarget: event.detail.target };
	      this.showTooltip(e, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
	    }
	  };
	};
	
	var _constant = __webpack_require__(9);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatibale with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  var event = void 0;
	
	  if (typeof window.CustomEvent === 'function') {
	    event = new window.CustomEvent(eventName, { detail: opts });
	  } else {
	    event = document.createEvent('Event');
	    event.initEvent(eventName, false, true);
	    event.detail = opts;
	  }
	
	  window.dispatchEvent(event);
	}; /**
	    * Static methods for react-tooltip
	    */

/***/ },
/* 47 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	
	    var observer = new MutationObserver(function (mutations) {
	      for (var m1 = 0; m1 < mutations.length; m1++) {
	        var mutation = mutations[m1];
	        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
	          var element = mutation.removedNodes[m2];
	          if (element === _this.state.currentTarget) {
	            _this.hideTooltip();
	            return;
	          }
	        }
	      }
	    });
	
	    observer.observe(window.document, { childList: true, subtree: true });
	
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	};
	
	/**
	 * Tracking target removing from DOM.
	 * It's nessesary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);
	
	    // ReactTooltip.rebuild
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);
	
	    // ReactTooltip.show
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);
	
	    // Resize
	    if (resizeHide) {
	      window.removeEventListener('resize', this.onWindowResize);
	      window.addEventListener('resize', this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener('resize', this.onWindowResize);
	  };
	
	  /**
	   * invoked by resize event of window
	   */
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	};
	
	var _constant = __webpack_require__(9);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	/* Decoraters */
	
	
	/* Utils */
	
	
	/* CSS */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(36);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _staticMethods = __webpack_require__(46);
	
	var _staticMethods2 = _interopRequireDefault(_staticMethods);
	
	var _windowListener = __webpack_require__(48);
	
	var _windowListener2 = _interopRequireDefault(_windowListener);
	
	var _customEvent = __webpack_require__(43);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	var _isCapture = __webpack_require__(45);
	
	var _isCapture2 = _interopRequireDefault(_isCapture);
	
	var _getEffect = __webpack_require__(44);
	
	var _getEffect2 = _interopRequireDefault(_getEffect);
	
	var _trackRemoval = __webpack_require__(47);
	
	var _trackRemoval2 = _interopRequireDefault(_trackRemoval);
	
	var _getPosition = __webpack_require__(52);
	
	var _getPosition2 = _interopRequireDefault(_getPosition);
	
	var _getTipContent = __webpack_require__(53);
	
	var _getTipContent2 = _interopRequireDefault(_getTipContent);
	
	var _aria = __webpack_require__(51);
	
	var _nodeListToArray = __webpack_require__(54);
	
	var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);
	
	var _style = __webpack_require__(50);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ReactTooltip, _React$Component);
	
	  function ReactTooltip(props) {
	    _classCallCheck(this, ReactTooltip);
	
	    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));
	
	    _this.state = {
	      place: 'top', // Direction of tooltip
	      type: 'dark', // Color theme of tooltip
	      effect: 'float', // float or fixed
	      show: false,
	      border: false,
	      offset: {},
	      extraClass: '',
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null, // Current mouse event
	      currentTarget: null, // Current target of mouse event
	      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
	      isEmptyTip: false,
	      disable: false,
	      originTooltip: null,
	      isMultiline: false
	    };
	
	    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize']);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: 'bind',
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          insecure = _props.insecure,
	          resizeHide = _props.resizeHide;
	
	      if (insecure) {
	        this.setStyleHeader(); // Set the style to the <link>
	      }
	      this.bindListener(); // Bind listener for tooltip
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var ariaProps = this.state.ariaProps;
	
	      var newAriaProps = (0, _aria.parseAria)(props);
	
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	      if (isChanged) {
	        this.setState({ ariaProps: newAriaProps });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mount = false;
	
	      this.clearTimer();
	
	      this.unbindListener();
	      this.removeScrollListener();
	      this.unbindWindowEvents();
	    }
	
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: 'getTargetArray',
	    value: function getTargetArray(id) {
	      var targetArray = void 0;
	      if (!id) {
	        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
	      } else {
	        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
	        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
	      }
	      // targetArray is a NodeList, convert it to a real array
	      return (0, _nodeListToArray2.default)(targetArray);
	    }
	
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: 'bindListener',
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          globalEventOff = _props2.globalEventOff;
	
	      var targetArray = this.getTargetArray(id);
	
	      targetArray.forEach(function (target) {
	        var isCaptureMode = _this3.isCapture(target);
	        var effect = _this3.getEffect(target);
	        if (target.getAttribute('currentItem') === null) {
	          target.setAttribute('currentItem', 'false');
	        }
	        _this3.unbindBasicListener(target);
	
	        if (_this3.isCustomEvent(target)) {
	          _this3.customBindListener(target);
	          return;
	        }
	
	        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
	        if (effect === 'float') {
	          target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
	        }
	        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
	      });
	
	      // Global event to hide tooltip
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, false);
	      }
	
	      // Track removal of targetArray elements from DOM
	      this.bindRemovalTracker();
	    }
	
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: 'unbindListener',
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          id = _props3.id,
	          globalEventOff = _props3.globalEventOff;
	
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        _this4.unbindBasicListener(target);
	        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	      });
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	
	    /**
	     * Invoke this before bind listener and ummount the compont
	     * it is necessary to invloke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: 'unbindBasicListener',
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
	      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
	      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'getTooltipContent',
	    value: function getTooltipContent() {
	      var _props4 = this.props,
	          getContent = _props4.getContent,
	          children = _props4.children;
	
	      // Generate tooltip content
	
	      var content = void 0;
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0](this.state.originTooltip);
	        } else {
	          content = getContent(this.state.originTooltip);
	        }
	      }
	
	      return (0, _getTipContent2.default)(this.state.originTooltip, children, content, this.state.isMultiline);
	    }
	  }, {
	    key: 'isEmptyTip',
	    value: function isEmptyTip(placeholder) {
	      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
	    }
	
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip(e, isGlobalCall) {
	      var _this5 = this;
	
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement) return;
	      }
	      // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	      var _props5 = this.props,
	          multiline = _props5.multiline,
	          getContent = _props5.getContent;
	
	      var originTooltip = e.currentTarget.getAttribute('data-tip');
	      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
	
	      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
	
	      // if it needs to skip adding hide listener to scroll
	      var scrollHide = true;
	      if (e.currentTarget.getAttribute('data-scroll-hide')) {
	        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      }
	
	      // To prevent previously created timers from triggering
	      this.clearTimer();
	
	      this.setState({
	        originTooltip: originTooltip,
	        isMultiline: isMultiline,
	        desiredPlace: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
	        place: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
	        type: e.currentTarget.getAttribute('data-type') || this.props.type || 'dark',
	        effect: switchToSolid && 'solid' || this.getEffect(e.currentTarget),
	        offset: e.currentTarget.getAttribute('data-offset') || this.props.offset || {},
	        html: e.currentTarget.getAttribute('data-html') ? e.currentTarget.getAttribute('data-html') === 'true' : this.props.html || false,
	        delayShow: e.currentTarget.getAttribute('data-delay-show') || this.props.delayShow || 0,
	        delayHide: e.currentTarget.getAttribute('data-delay-hide') || this.props.delayHide || 0,
	        border: e.currentTarget.getAttribute('data-border') ? e.currentTarget.getAttribute('data-border') === 'true' : this.props.border || false,
	        extraClass: e.currentTarget.getAttribute('data-class') || this.props.class || this.props.className || '',
	        disable: e.currentTarget.getAttribute('data-tip-disable') ? e.currentTarget.getAttribute('data-tip-disable') === 'true' : this.props.disable || false,
	        currentTarget: e.currentTarget
	      }, function () {
	        if (scrollHide) _this5.addScrollListener(_this5.state.currentTarget);
	        _this5.updateTooltip(e);
	
	        if (getContent && Array.isArray(getContent)) {
	          _this5.intervalUpdateContent = setInterval(function () {
	            if (_this5.mount) {
	              var _getContent = _this5.props.getContent;
	
	              var placeholder = (0, _getTipContent2.default)(originTooltip, '', _getContent[0](), isMultiline);
	              var isEmptyTip = _this5.isEmptyTip(placeholder);
	              _this5.setState({
	                isEmptyTip: isEmptyTip
	              });
	              _this5.updatePosition();
	            }
	          }, getContent[1]);
	        }
	      });
	    }
	
	    /**
	     * When mouse hover, updatetooltip
	     */
	
	  }, {
	    key: 'updateTooltip',
	    value: function updateTooltip(e) {
	      var _this6 = this;
	
	      var _state = this.state,
	          delayShow = _state.delayShow,
	          show = _state.show,
	          disable = _state.disable;
	      var afterShow = this.props.afterShow;
	
	      var placeholder = this.getTooltipContent();
	      var delayTime = show ? 0 : parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget || e.target;
	
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          var isInvisible = !_this6.state.show;
	          _this6.setState({
	            currentEvent: e,
	            currentTarget: eventTarget,
	            show: true
	          }, function () {
	            _this6.updatePosition();
	            if (isInvisible && afterShow) afterShow();
	          });
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip(e, hasTarget) {
	      var _this7 = this;
	
	      var _state2 = this.state,
	          delayHide = _state2.delayHide,
	          disable = _state2.disable;
	      var afterHide = this.props.afterHide;
	
	      var placeholder = this.getTooltipContent();
	      if (!this.mount) return;
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	      var resetState = function resetState() {
	        var isVisible = _this7.state.show;
	        _this7.setState({
	          show: false
	        }, function () {
	          _this7.removeScrollListener();
	          if (isVisible && afterHide) afterHide();
	        });
	      };
	
	      this.clearTimer();
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	
	    /**
	     * Add scroll eventlistener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: 'addScrollListener',
	    value: function addScrollListener(currentTarget) {
	      var isCaptureMode = this.isCapture(currentTarget);
	      window.addEventListener('scroll', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'removeScrollListener',
	    value: function removeScrollListener() {
	      window.removeEventListener('scroll', this.hideTooltip);
	    }
	
	    // Calculation the position
	
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var _this8 = this;
	
	      var _state3 = this.state,
	          currentEvent = _state3.currentEvent,
	          currentTarget = _state3.currentTarget,
	          place = _state3.place,
	          desiredPlace = _state3.desiredPlace,
	          effect = _state3.effect,
	          offset = _state3.offset;
	
	      var node = _reactDom2.default.findDOMNode(this);
	      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this8.updatePosition();
	        });
	      }
	      // Set tooltip position
	      node.style.left = result.position.left + 'px';
	      node.style.top = result.position.top + 'px';
	    }
	
	    /**
	     * Set style tag in header
	     * in this way we can insert default css
	     */
	
	  }, {
	    key: 'setStyleHeader',
	    value: function setStyleHeader() {
	      var head = document.getElementsByTagName('head')[0];
	      if (!head.querySelector('style[id="react-tooltip"]')) {
	        var tag = document.createElement('style');
	        tag.id = 'react-tooltip';
	        tag.innerHTML = _style2.default;
	        head.insertBefore(tag, head.firstChild);
	      }
	    }
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: 'clearTimer',
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state4 = this.state,
	          extraClass = _state4.extraClass,
	          html = _state4.html,
	          ariaProps = _state4.ariaProps,
	          disable = _state4.disable;
	
	      var placeholder = this.getTooltipContent();
	      var isEmptyTip = this.isEmptyTip(placeholder);
	      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' });
	
	      var Wrapper = this.props.wrapper;
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	
	      if (html) {
	        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass,
	          id: this.props.id
	        }, ariaProps, {
	          'data-id': 'tooltip',
	          dangerouslySetInnerHTML: { __html: placeholder } }));
	      } else {
	        return _react2.default.createElement(
	          Wrapper,
	          _extends({ className: tooltipClass + ' ' + extraClass,
	            id: this.props.id
	          }, ariaProps, {
	            'data-id': 'tooltip' }),
	          placeholder
	        );
	      }
	    }
	  }]);
	
	  return ReactTooltip;
	}(_react2.default.Component), _class2.propTypes = {
	  children: _propTypes2.default.any,
	  place: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  effect: _propTypes2.default.string,
	  offset: _propTypes2.default.object,
	  multiline: _propTypes2.default.bool,
	  border: _propTypes2.default.bool,
	  insecure: _propTypes2.default.bool,
	  class: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  html: _propTypes2.default.bool,
	  delayHide: _propTypes2.default.number,
	  delayShow: _propTypes2.default.number,
	  event: _propTypes2.default.string,
	  eventOff: _propTypes2.default.string,
	  watchWindow: _propTypes2.default.bool,
	  isCapture: _propTypes2.default.bool,
	  globalEventOff: _propTypes2.default.string,
	  getContent: _propTypes2.default.any,
	  afterShow: _propTypes2.default.func,
	  afterHide: _propTypes2.default.func,
	  disable: _propTypes2.default.bool,
	  scrollHide: _propTypes2.default.bool,
	  resizeHide: _propTypes2.default.bool,
	  wrapper: _propTypes2.default.string
	}, _class2.defaultProps = {
	  insecure: true,
	  resizeHide: true,
	  wrapper: 'div'
	}, _class2.supportedWrappers = ['div', 'span'], _class2.displayName = 'ReactTooltip', _temp)) || _class) || _class) || _class) || _class) || _class) || _class;
	
	/* export default not fit for standalone, it will exports {default:...} */
	
	
	module.exports = ReactTooltip;

/***/ },
/* 50 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ },
/* 51 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseAria = parseAria;
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return (/(^aria-\w+$|^role$)/.test(prop)
	    );
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	
	  return ariaObj;
	}

/***/ },
/* 52 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (e, target, node, place, desiredPlace, effect, offset) {
	  var _getDimensions = getDimensions(node),
	      tipWidth = _getDimensions.width,
	      tipHeight = _getDimensions.height;
	
	  var _getDimensions2 = getDimensions(target),
	      targetWidth = _getDimensions2.width,
	      targetHeight = _getDimensions2.height;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffset_X = _calculateOffset.extraOffset_X,
	      extraOffset_Y = _calculateOffset.extraOffset_Y;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft;
	
	  // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offset_X = defaultOffset[place].l;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offset_X = defaultOffset[place].r;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offset_Y = defaultOffset[place].t;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offset_Y = defaultOffset[place].b;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	
	  // Judge if the tooltip has over the window(screen)
	  var outsideVertical = function outsideVertical() {
	    var result = false;
	    var newPlace = void 0;
	    if (getTipOffsetTop('left') < 0 && getTipOffsetBottom('left') <= windowHeight && getTipOffsetBottom('bottom') <= windowHeight) {
	      result = true;
	      newPlace = 'bottom';
	    } else if (getTipOffsetBottom('left') > windowHeight && getTipOffsetTop('left') >= 0 && getTipOffsetTop('top') >= 0) {
	      result = true;
	      newPlace = 'top';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideLeft = function outsideLeft() {
	    var _outsideVertical = outsideVertical(),
	        result = _outsideVertical.result,
	        newPlace = _outsideVertical.newPlace; // Deal with vertical as first priority
	
	
	    if (result && outsideHorizontal().result) {
	      return { result: false // No need to change, if change to vertical will out of space
	      };
	    }
	    if (!result && getTipOffsetLeft('left') < 0 && getTipOffsetRight('right') <= windowWidth) {
	      result = true; // If vertical ok, but let out of side and right won't out of side
	      newPlace = 'right';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideRight = function outsideRight() {
	    var _outsideVertical2 = outsideVertical(),
	        result = _outsideVertical2.result,
	        newPlace = _outsideVertical2.newPlace;
	
	    if (result && outsideHorizontal().result) {
	      return { result: false // No need to change, if change to vertical will out of space
	      };
	    }
	    if (!result && getTipOffsetRight('right') > windowWidth && getTipOffsetLeft('left') >= 0) {
	      result = true;
	      newPlace = 'left';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	
	  var outsideHorizontal = function outsideHorizontal() {
	    var result = false;
	    var newPlace = void 0;
	    if (getTipOffsetLeft('top') < 0 && getTipOffsetRight('top') <= windowWidth && getTipOffsetRight('right') <= windowWidth) {
	      result = true;
	      newPlace = 'right';
	    } else if (getTipOffsetRight('top') > windowWidth && getTipOffsetLeft('top') >= 0 && getTipOffsetLeft('left') >= 0) {
	      result = true;
	      newPlace = 'left';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideTop = function outsideTop() {
	    var _outsideHorizontal = outsideHorizontal(),
	        result = _outsideHorizontal.result,
	        newPlace = _outsideHorizontal.newPlace;
	
	    if (result && outsideVertical().result) {
	      return { result: false };
	    }
	    if (!result && getTipOffsetTop('top') < 0 && getTipOffsetBottom('bottom') <= windowHeight) {
	      result = true;
	      newPlace = 'bottom';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideBottom = function outsideBottom() {
	    var _outsideHorizontal2 = outsideHorizontal(),
	        result = _outsideHorizontal2.result,
	        newPlace = _outsideHorizontal2.newPlace;
	
	    if (result && outsideVertical().result) {
	      return { result: false };
	    }
	    if (!result && getTipOffsetBottom('bottom') > windowHeight && getTipOffsetTop('top') >= 0) {
	      result = true;
	      newPlace = 'top';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	
	  // Return new state to change the placement to the reverse if possible
	  var outsideLeftResult = outsideLeft();
	  var outsideRightResult = outsideRight();
	  var outsideTopResult = outsideTop();
	  var outsideBottomResult = outsideBottom();
	
	  if (place === 'left' && outsideLeftResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideLeftResult.newPlace }
	    };
	  } else if (place === 'right' && outsideRightResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideRightResult.newPlace }
	    };
	  } else if (place === 'top' && outsideTopResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideTopResult.newPlace }
	    };
	  } else if (place === 'bottom' && outsideBottomResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideBottomResult.newPlace }
	    };
	  }
	
	  // Change back to original place if possible
	  if (place !== desiredPlace) {
	    if (desiredPlace === 'top' && !outsideTopResult.result) {
	      return {
	        isNewState: true,
	        newState: { place: 'top' }
	      };
	    } else if (desiredPlace === 'left' && !outsideLeftResult.result) {
	      return {
	        isNewState: true,
	        newState: { place: 'left' }
	      };
	    } else if (desiredPlace === 'right' && !outsideRightResult.result) {
	      return {
	        isNewState: true,
	        newState: { place: 'right' }
	      };
	    } else if (desiredPlace === 'bottom' && !outsideBottomResult.result) {
	      return {
	        isNewState: true,
	        newState: { place: 'bottom' }
	      };
	    }
	  }
	
	  // Return tooltip offset position
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	};
	
	var getDimensions = function getDimensions(node) {
	  var _node$getBoundingClie = node.getBoundingClientRect(),
	      height = _node$getBoundingClie.height,
	      width = _node$getBoundingClie.width;
	
	  return {
	    height: parseInt(height, 10),
	    width: parseInt(width, 10)
	  };
	};
	
	// Get current mouse offset
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {OBject} {left: {Number}, top: {Number}}
	 */
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	
	  var _getDimensions3 = getDimensions(currentTarget),
	      targetWidth = _getDimensions3.width,
	      targetHeight = _getDimensions3.height;
	
	  if (effect === 'float') {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	};
	
	// List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top = void 0;
	  var right = void 0;
	  var bottom = void 0;
	  var left = void 0;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === 'float') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === 'solid') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return { top: top, bottom: bottom, left: left, right: right };
	};
	
	// Consider additional offset into position calculation
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffset_X = 0;
	  var extraOffset_Y = 0;
	
	  if (Object.prototype.toString.apply(offset) === '[object String]') {
	    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
	  }
	  for (var key in offset) {
	    if (key === 'top') {
	      extraOffset_Y -= parseInt(offset[key], 10);
	    } else if (key === 'bottom') {
	      extraOffset_Y += parseInt(offset[key], 10);
	    } else if (key === 'left') {
	      extraOffset_X -= parseInt(offset[key], 10);
	    } else if (key === 'right') {
	      extraOffset_X += parseInt(offset[key], 10);
	    }
	  }
	
	  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
	};
	
	// Get the offset of the parent elements
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	  while (currentParent) {
	    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	
	  return { parentTop: parentTop, parentLeft: parentLeft };
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	  if (getContent === null) return null; // Tip not exist and childern is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  }
	
	  // Multiline tooltip content
	  return tip.split(regexp).map(function (d, i) {
	    return _react2.default.createElement(
	      'span',
	      { key: i, className: 'multi-line' },
	      d
	    );
	  });
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 54 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (nodeList) {
	  var length = nodeList.length;
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.4.1
	 * react.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(4),n=__webpack_require__(3),p=__webpack_require__(5),q=__webpack_require__(2),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
	r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
	var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
	G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
	function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
	h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
	function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
	var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
	_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
	b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.1",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
	assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(57);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var Modal = (function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal(props) {
	    _classCallCheck(this, Modal);
	
	    _get(Object.getPrototypeOf(Modal.prototype), 'constructor', this).call(this);
	    this.hideOnOuterClick = this.hideOnOuterClick.bind(this);
	    this.fadeIn = this.fadeIn.bind(this);
	    this.fadeOut = this.fadeOut.bind(this);
	
	    var opacity = 0,
	        display = 'block',
	        visibility = 'hidden';
	
	    if (props.show) {
	      opacity = 1;
	      display = 'block';
	      visibility = 'visible';
	    }
	
	    this.state = {
	      opacity: opacity,
	      display: display,
	      visibility: visibility,
	      show: props.show
	    };
	  }
	
	  _createClass(Modal, [{
	    key: 'hideOnOuterClick',
	    value: function hideOnOuterClick(event) {
	      if (this.props.closeOnOuterClick === false) return;
	      if (event.target.dataset.modal && this.props.onClose instanceof Function) this.props.onClose(event);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (this.props.show != props.show) {
	        if (this.props.transitionSpeed) {
	          if (props.show == true) this.fadeIn();else this.fadeOut();
	        } else this.setState({ show: props.show });
	      }
	    }
	  }, {
	    key: 'fadeIn',
	    value: function fadeIn() {
	      var _this = this;
	
	      this.setState({
	        display: 'block',
	        visibility: 'visible',
	        show: true
	      }, function () {
	        setTimeout(function () {
	          _this.setState({ opacity: 1 });
	        }, 10);
	      });
	    }
	  }, {
	    key: 'fadeOut',
	    value: function fadeOut() {
	      var _this2 = this;
	
	      this.setState({ opacity: 0 }, function () {
	        setTimeout(function () {
	          _this2.setState({ show: false });
	        }, _this2.props.transitionSpeed);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.show) return null;
	      var modalStyle = undefined,
	          containerStyle = undefined;
	      //completely overwrite if they use a class
	      if (this.props.className) {
	        modalStyle = this.props.style;
	        containerStyle = this.props.containerStyle;
	      } else {
	        modalStyle = _extends({}, _styles2['default'].modal, this.props.style);
	        containerStyle = _extends({}, _styles2['default'].container, this.props.containerStyle);
	      }
	      if (this.props.transitionSpeed) modalStyle = _extends({}, this.state, modalStyle);
	
	      return _react2['default'].createElement(
	        'div',
	        _extends({}, _filteredProps(this.props), { style: modalStyle, onClick: this.hideOnOuterClick, 'data-modal': 'true' }),
	        _react2['default'].createElement(
	          'div',
	          { className: this.props.containerClassName, style: containerStyle },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Modal;
	})(_react2['default'].Component);
	
	exports['default'] = Modal;
	
	function _filteredProps(props) {
	  var filtered = _extends({}, props);
	  ['containerStyle', 'containerClassName', 'closeOnOuterClick', 'show', 'onClose', 'transitionSpeed'].map(function (p) {
	    delete filtered[p];
	  });
	  return filtered;
	}
	
	var closeStyle = _styles2['default'].close;
	exports.closeStyle = closeStyle;

/***/ },
/* 57 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var modal = {
	  position: 'fixed',
	  fontFamily: 'Arial, Helvetica, sans-serif',
	  top: 0,
	  right: 0,
	  bottom: 0,
	  left: 0,
	  background: 'rgba(0, 0, 0, 0.8)',
	  zIndex: 99999,
	  transition: 'opacity 1s ease-in',
	  pointerEvents: 'auto',
	  overflowY: 'auto'
	};
	
	var container = {
	  width: '400px',
	  position: 'relative',
	  margin: '10% auto',
	  padding: '5px 20px 13px 20px',
	  background: '#fff'
	};
	
	var close = {
	  background: '#606061',
	  color: '#FFFFFF',
	  lineHeight: '25px',
	  position: 'absolute',
	  right: '-12px',
	  textAlign: 'center',
	  top: '-10px',
	  width: '24px',
	  textDecoration: 'none',
	  fontWeight: 'bold',
	  borderRadius: '12px',
	  boxShadow: '1px 1px 3px #000',
	  cursor: 'pointer'
	};
	
	exports['default'] = {
	  modal: modal,
	  container: container,
	  close: close
	};
	module.exports = exports['default'];

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.2b0d75c4.js